/* assets/configurator-base-lib.js */

(function (global) {
  'use strict';

  var VERSION = 'roof-v125';

  /* BoQ codes for the pad-foundation post-base hardware.
     PIER_CAP_CODE and PIER_BOLT_CODE are placeholders — replace with your
     real SKUs. */
  var PIER_ANCHOR_CODE = 'HPB00001';   /* U saddle anchor (single-axis piers) */
  var PIER_CAP_CODE    = 'HPB00002';   /* flat post cap (multi-axis joints: corner/T/cross) */
  var PIER_BOLT_CODE   = 'FAT00006';
  /* Timber-frame extras shared by piers / precast / screws (PLACEHOLDER SKUs). */
  var TIMBER_FASTENER_CODE = 'FAT00008';   /* angle brackets / screws for beam-to-beam joints (pcs) */
  var TIMBER_DPC_CODE      = 'FFS00003';   /* DPC / bitumen pad between steel anchor and timber (pcs) */
  var TIMBER_COAT_CODE     = 'FWP00001';   /* timber impregnation / protective coat (m²) */

  var DEFAULT_POLYGON = [
    [-5.0, -4.0],
    [ 5.0, -4.0],
    [ 5.0,  4.0],
    [-5.0,  4.0]
  ];

//test

  var STATE = {
    variant: 1,
    lvl: 1,
    isMetric: true,
    view: '2d',
    opacity2D: 0.15,
    vizStage: 0,
    assemblyStep: 0,
    roofPitchDeg: 22,
    roofMonoPitchDeg: 10,
    roofOverhangM: 0.30,
    roofWallH: 2.40,
    roofStructure: 'truss',
    trussSpacingM: 0.61,
    trussPanels: 3,
    slopeDeg: 0,
    slopeActive: false,
    mapLocked: false,
    dispoLocked: false,   /* disposition (footprint shape) edit lock */
    masterLinked: false,  /* seeded/linked from the master house canvas */
    polygon: JSON.parse(JSON.stringify(DEFAULT_POLYGON))
  };

  var DEFAULTS = JSON.parse(JSON.stringify(STATE));

  var MIN_DIM = 1.0;
  var MAX_COORD = 30.0;
  var SNAP_M = 0.050;
  /* 2 inches expressed in metres (0.0508 m) — snap step in imperial
     mode. 6 × 2″ = 1 ft, so values land on whole feet boundaries just
     like 20 × 5 cm = 1 m in metric. */
  var FT_STEP_M = 2 * 0.0254;

  var VARIANT_DEFAULTS = {
    slab: {
      slabThicknessM:    0.150,
      gravelDepthM:      0.100,
      excavationDepthM:  0.250,
      bitumenCoverage:   1.05,
      meshOverlap:       1.10,
      meshSheetLM:       3.000,
      meshSheetWM:       2.000,
      meshOverlapM:      0.200,
      meshLayers:        1,
      formworkExtraM:    0.40
    },
    strip: {
      slabThicknessM:    0.150,
      stripWidthM:       0.300,
      stripDepthM:       0.800,
      stripExcavWidthM:  0.500,
      hollowBlockH:      0.250,
      hollowBlockL:      0.500,
      uBlockH:           0.300,
      uBlockL:           0.250,
      bitumenCoverage:   1.05,
      meshOverlap:       1.10,
      meshSheetLM:       3.000,
      meshSheetWM:       2.000,
      meshOverlapM:      0.200,
      meshLayers:        1,
      rebarDiameterM:    0.014,
      rebarSpacingM:     0.500,
      rebarSlabOverlapM: 0.075,
      stirrupSpacingM:   0.250,
      formworkExtraM:    0.40
    },
    piers: {
      pierSideM:         0.300,
      pierDepthM:        0.800,
      pierSpacingM:      2.000,
      beamProfileCode:   'KVH10060',
      beamWidthM:        0.060,
      beamHeightM:       0.100,
      gravelLayerM:      0.100,
      rebarPerPierM:     3.500,
      anchorRodLenM:     0.500,
      mortarPerPierM3:   0.005
    },
    precast: {
      blockBaseM:        0.400,
      blockTopM:         0.250,
      blockHeightM:      0.300,
      blockSpacingM:     1.500,
      gravelLayerM:      0.100,
      gravelExtraM:      0.100,
      excavationDepthM:  0.300,
      anchorPlateHM:     0.110,
      anchorPlateWM:     0.090,
      anchorPlateTM:     0.004,
      anchorEmbedM:      0.025,
      anchorGapM:        0.040
    },
    screws: {
      screwLenM:         1.200,
      screwSpacingM:     1.500,
      screwDiameterMm:   76
    }
  };

  var VARIANT_LVL_OVERRIDES = {
    slab: {
      2: { slabThicknessM: 0.180, gravelDepthM: 0.150, excavationDepthM: 0.330, meshLayers: 1 },
      3: { slabThicknessM: 0.220, gravelDepthM: 0.200, excavationDepthM: 0.420, meshLayers: 2 }
    },
    strip: {
      2: { slabThicknessM: 0.180, stripWidthM: 0.400, stripDepthM: 1.000, stripExcavWidthM: 0.600,
           rebarDiameterM: 0.016, stirrupSpacingM: 0.200, meshLayers: 1 },
      3: { slabThicknessM: 0.220, stripWidthM: 0.500, stripDepthM: 1.200, stripExcavWidthM: 0.700,
           rebarDiameterM: 0.020, stirrupSpacingM: 0.150, meshLayers: 2 }
    },
    piers: {
      2: { pierSideM: 0.400, pierDepthM: 1.000, pierSpacingM: 1.500,
           beamProfileCode: 'KVH16080', beamWidthM: 0.080, beamHeightM: 0.160,
           rebarPerPierM: 5.000, anchorRodLenM: 0.600 },
      3: { pierSideM: 0.500, pierDepthM: 1.200, pierSpacingM: 1.200,
           beamProfileCode: 'KVH10200', beamWidthM: 0.100, beamHeightM: 0.200,
           rebarPerPierM: 7.000, anchorRodLenM: 0.700 }
    },
    precast: {
      2: { blockBaseM: 0.500, blockTopM: 0.300, blockHeightM: 0.400, blockSpacingM: 1.200, gravelLayerM: 0.150, excavationDepthM: 0.400 },
      3: { blockBaseM: 0.600, blockTopM: 0.350, blockHeightM: 0.500, blockSpacingM: 1.000, gravelLayerM: 0.200, excavationDepthM: 0.500 }
    },
    screws: {
      2: { screwLenM: 1.600, screwSpacingM: 1.200, screwDiameterMm: 102 },
      3: { screwLenM: 2.000, screwSpacingM: 1.000, screwDiameterMm: 140 }
    }
  };

  function getVariantDefaults(variantKey, lvl) {
    var base = VARIANT_DEFAULTS[variantKey];
    if (!base) return {};
    var merged = {};
    for (var k in base) if (base.hasOwnProperty(k)) merged[k] = base[k];
    var ov = VARIANT_LVL_OVERRIDES[variantKey] && VARIANT_LVL_OVERRIDES[variantKey][lvl];
    if (ov) {
      for (var k2 in ov) if (ov.hasOwnProperty(k2)) merged[k2] = ov[k2];
    }
    return merged;
  }

  function _dbg(msg) {
    if (global.Configurator && global.Configurator.log && global.Configurator.log.log) {
      global.Configurator.log.log('[base-lib] ' + msg);
    }
  }

  function snap(v) {
    /* In metric mode snap to SNAP_M (5 cm). In imperial mode snap to
       0.1 ft (≈ 3.05 cm) so the displayed length stays a round 1-decimal
       ft value as the user drags. */
    if (STATE.isMetric) {
      return Math.round(v / SNAP_M) * SNAP_M;
    }
    return Math.round(v / FT_STEP_M) * FT_STEP_M;
  }

  function clamp(v, lo, hi) {
    return Math.max(lo, Math.min(hi, v));
  }

  function fmtLen(meters, opts) {
    opts = opts || {};
    var precision = (opts.precision == null) ? 2 : opts.precision;
    if (STATE.isMetric) {
      return meters.toFixed(precision);
    }
    var feet = meters * 3.28084;
    return feet.toFixed(precision);
  }

  /* Architectural dimension formatting (for on-model kóty, drag handles,
     dimension overlays — NOT for BoQ totals which stay decimal m/ft).
       metric  → millimetres with thin-space thousands separator + " mm"
                 e.g.  3700 → "3 700 mm",  250 → "250 mm"
       imperial → feet-inches with hyphen + ASCII feet/inch marks
                 e.g.  3.658 m → 12'-0",   2.0 m → "6'-7"
                 (with 2″ snap step the inch part is always whole inches) */
  function fmtDim(meters) {
    if (STATE.isMetric) {
      var mm = Math.round(meters * 1000);
      return mm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' mm';
    }
    var t = Math.round(meters / 0.0254);
    var ft = Math.floor(t / 12);
    var inch = t - ft * 12;
    return ft + "'-" + inch + '"';
  }

  function unitLabel() {
    return STATE.isMetric ? 'm' : 'ft';
  }

  /* Imperial conversion convention for BoQ quantities (matching the pool config):
       length  m  → ft   ×3.28084
       area    m² → ft²  ×10.7639
       volume  m³ → yd³  ×1.30795   (cubic YARDS, not cubic feet)
       mass    kg → lb   ×2.20462
     Volume is expressed in cubic yards in imperial — concrete/gravel/excavation
     are quoted in yd³, never ft³. */
  function volUnitLabel() {
    return STATE.isMetric ? 'm³' : 'yd³';
  }

  function getFootprintPolygon() {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return [];
    var out = new Array(poly.length);
    for (var i = 0; i < poly.length; i++) {
      out[i] = [poly[i][0], poly[i][1]];
    }
    return out;
  }

  function getBBox() {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return { L: 0, W: 0 };
    var xMin =  Infinity, xMax = -Infinity;
    var zMin =  Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var x = poly[i][0], z = poly[i][1];
      if (x < xMin) xMin = x;
      if (x > xMax) xMax = x;
      if (z < zMin) zMin = z;
      if (z > zMax) zMax = z;
    }
    return { L: xMax - xMin, W: zMax - zMin };
  }

  function computeArea() {
    var poly = getFootprintPolygon();
    var a = 0;
    for (var i = 0; i < poly.length; i++) {
      var j = (i + 1) % poly.length;
      a += poly[i][0] * poly[j][1];
      a -= poly[j][0] * poly[i][1];
    }
    return Math.abs(a) / 2;
  }

  function computePerimeter() {
    var poly = getFootprintPolygon();
    var p = 0;
    for (var i = 0; i < poly.length; i++) {
      var j = (i + 1) % poly.length;
      var dx = poly[j][0] - poly[i][0];
      var dy = poly[j][1] - poly[i][1];
      p += Math.sqrt(dx*dx + dy*dy);
    }
    return p;
  }

  function computeStripLength() {
    return computePerimeter();
  }

  function _pointInPolygonOrBoundary(x, z, poly) {
    var n = poly.length;
    var EPS = 0.001;
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      var lenSq = dx * dx + dz * dz;
      if (lenSq < 1e-9) continue;
      var t = ((x - a[0]) * dx + (z - a[1]) * dz) / lenSq;
      var tc = t < 0 ? 0 : (t > 1 ? 1 : t);
      var px = a[0] + tc * dx;
      var pz = a[1] + tc * dz;
      if (Math.hypot(x - px, z - pz) < EPS) return true;
    }
    var inside = false;
    for (var i = 0, j = n - 1; i < n; j = i++) {
      var xi = poly[i][0], zi = poly[i][1];
      var xj = poly[j][0], zj = poly[j][1];
      if ((zi > z) !== (zj > z) &&
          x < (xj - xi) * (z - zi) / (zj - zi) + xi) {
        inside = !inside;
      }
    }
    return inside;
  }

  function _distanceToPolygonPerimeter(x, z, poly) {
    var minD = Infinity;
    var n = poly.length;
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      var lenSq = dx * dx + dz * dz;
      var px, pz;
      if (lenSq < 1e-9) {
        px = a[0]; pz = a[1];
      } else {
        var t = ((x - a[0]) * dx + (z - a[1]) * dz) / lenSq;
        if (t < 0) t = 0;
        if (t > 1) t = 1;
        px = a[0] + t * dx;
        pz = a[1] + t * dz;
      }
      var d = Math.hypot(x - px, z - pz);
      if (d < minD) minD = d;
    }
    return minD;
  }

  /* ──────────────────────────────────────────────────────────────────
     Rectilinear polygon decomposition.

     For orthogonal polygons (all edges axis-aligned), decompose the
     polygon into a small set of axis-aligned rectangles that cover the
     interior exactly, preferring:
       • rectangles whose sides lie on the polygon boundary (= "natural"
         rectangles like the spine of a T or the legs of a U)
       • larger rectangles over smaller ones
       • squarer aspect ratios as a tie-break

     Algorithm:
       1. Collect all unique vertex x and z coordinates → grid lines.
       2. Build the cell grid; each cell is inside or outside polygon.
       3. Greedy: find the highest-scoring axis-aligned rectangle of
          unmarked inside cells; mark them taken; repeat.

     Scoring: onBoundary * 100 + area * 1.0 + aspect * 5
       onBoundary = how many of the rectangle's 4 sides coincide with
                    a polygon edge along their full length
       area       = w × h (prefers large rectangles)
       aspect     = min(w,h) / max(w,h)  (tie-break toward square)
     ────────────────────────────────────────────────────────────────── */
  function _segmentOnPolygonBoundary(ax, az, bx, bz, poly) {
    /* Sample N+1 points along the segment; each must lie on a polygon
       edge. Used to test if a candidate rectangle side coincides with
       the polygon boundary. */
    var N = 6;
    for (var s = 0; s <= N; s++) {
      var t = s / N;
      var sx = ax + (bx - ax) * t;
      var sz = az + (bz - az) * t;
      var onEdge = false;
      for (var i = 0; i < poly.length; i++) {
        var pa = poly[i], pb = poly[(i + 1) % poly.length];
        var ex = pb[0] - pa[0], ez = pb[1] - pa[1];
        var L2 = ex * ex + ez * ez;
        if (L2 < 1e-9) continue;
        var tt = ((sx - pa[0]) * ex + (sz - pa[1]) * ez) / L2;
        if (tt < -0.001 || tt > 1.001) continue;
        var px = pa[0] + ex * tt, pz = pa[1] + ez * tt;
        if (Math.hypot(sx - px, sz - pz) < 0.01) { onEdge = true; break; }
      }
      if (!onEdge) return false;
    }
    return true;
  }

  function _decomposePolygonToRects(poly) {
    if (!poly || poly.length < 4) return [];
    /* Collect unique x and z coordinates from vertices. */
    var xs = [], zs = [];
    function uniq(arr, v) {
      for (var i = 0; i < arr.length; i++) {
        if (Math.abs(arr[i] - v) < 0.001) return;
      }
      arr.push(v);
    }
    for (var pi = 0; pi < poly.length; pi++) {
      uniq(xs, poly[pi][0]);
      uniq(zs, poly[pi][1]);
    }
    xs.sort(function (a, b) { return a - b; });
    zs.sort(function (a, b) { return a - b; });
    if (xs.length < 2 || zs.length < 2) return [];

    /* Build cell grid. */
    var nx = xs.length - 1, nz = zs.length - 1;
    var cells = [], taken = [];
    for (var i = 0; i < nx; i++) {
      cells[i] = [];
      taken[i] = [];
      for (var j = 0; j < nz; j++) {
        var cx = (xs[i] + xs[i + 1]) / 2;
        var cz = (zs[j] + zs[j + 1]) / 2;
        cells[i][j] = _pointInPolygonOrBoundary(cx, cz, poly);
        taken[i][j] = false;
      }
    }

    function canExpand(i0, j0, i1, j1) {
      for (var i = i0; i <= i1; i++) {
        for (var j = j0; j <= j1; j++) {
          if (!cells[i][j] || taken[i][j]) return false;
        }
      }
      return true;
    }

    function rectScore(i0, j0, i1, j1) {
      var x0 = xs[i0], x1 = xs[i1 + 1];
      var z0 = zs[j0], z1 = zs[j1 + 1];
      var w = x1 - x0, h = z1 - z0;
      var onB = 0;
      if (_segmentOnPolygonBoundary(x0, z0, x1, z0, poly)) onB++;
      if (_segmentOnPolygonBoundary(x1, z0, x1, z1, poly)) onB++;
      if (_segmentOnPolygonBoundary(x1, z1, x0, z1, poly)) onB++;
      if (_segmentOnPolygonBoundary(x0, z1, x0, z0, poly)) onB++;
      var aspect = Math.min(w, h) / Math.max(w, h);
      var area = w * h;
      return onB * 100 + area * 1.0 + aspect * 5;
    }

    function findBest() {
      var best = null, bestScore = -Infinity;
      for (var i0 = 0; i0 < nx; i0++) {
        for (var j0 = 0; j0 < nz; j0++) {
          if (!cells[i0][j0] || taken[i0][j0]) continue;
          var maxI = i0;
          while (maxI + 1 < nx && canExpand(i0, j0, maxI + 1, j0)) maxI++;
          for (var i1 = i0; i1 <= maxI; i1++) {
            var maxJ = j0;
            while (maxJ + 1 < nz && canExpand(i0, j0, i1, maxJ + 1)) maxJ++;
            for (var j1 = j0; j1 <= maxJ; j1++) {
              var sc = rectScore(i0, j0, i1, j1);
              if (sc > bestScore) {
                bestScore = sc;
                best = { i0: i0, j0: j0, i1: i1, j1: j1 };
              }
            }
          }
        }
      }
      return best;
    }

    var rects = [];
    while (true) {
      var r = findBest();
      if (!r) break;
      for (var i = r.i0; i <= r.i1; i++) {
        for (var j = r.j0; j <= r.j1; j++) taken[i][j] = true;
      }
      rects.push({
        x0: xs[r.i0], x1: xs[r.i1 + 1],
        z0: zs[r.j0], z1: zs[r.j1 + 1]
      });
    }
    return rects;
  }

  /* ──────────────────────────────────────────────────────────────────
     Timber raster v4 — rectangle-decomposition based.

     For each sub-rectangle of the decomposed polygon:
       • joists run parallel to the SHORTER side (= span across short
         dimension; standard timber framing practice)
       • joist spacing = short / round(short / targetSpacing), so it
         lands between ~1.3 and ~1.8 m for targetSpacing=1.5
       • perimeter piers on each rectangle side, placed at every joist
         line that crosses it, with corners always anchored

     Interior piers will be added in a later step.

     Returns: { axis: null, beams: [...], rimJoist: [...], piers: [...], rects: [...] }
     ────────────────────────────────────────────────────────────────── */
  function _computeTimberRaster(poly, targetSpacing) {
    var EMPTY = { axis: null, beams: [], rimJoist: [], piers: [], rects: [] };
    if (!poly || poly.length < 3) return EMPTY;
    if (!(targetSpacing > 0)) targetSpacing = 1.5;

    /* Rim joist = each polygon edge (visualization only). */
    var rimJoist = [];
    for (var ri = 0; ri < poly.length; ri++) {
      var ra = poly[ri], rb = poly[(ri + 1) % poly.length];
      rimJoist.push({ a: [ra[0], ra[1]], b: [rb[0], rb[1]] });
    }

    var rects = _decomposePolygonToRects(poly);
    var beams = [];
    var piers = [];
    var DEDUP_TOL = targetSpacing * 0.45;

    function addPier(x, z, role) {
      for (var p = 0; p < piers.length; p++) {
        if (Math.hypot(piers[p].x - x, piers[p].z - z) < DEDUP_TOL) {
          var prio = { corner: 3, perimeter: 2, interior: 1 };
          if (prio[role] > prio[piers[p].role]) piers[p].role = role;
          return piers[p];
        }
      }
      var pier = { x: x, z: z, role: role };
      piers.push(pier);
      return pier;
    }

    /* Vertex piers — every polygon vertex is a mandatory pier. */
    for (var vi = 0; vi < poly.length; vi++) {
      addPier(poly[vi][0], poly[vi][1], 'corner');
    }

    /* Process each sub-rectangle. For each rect we compute:
         • xGrid: x-positions of grid lines (perpendicular to long
                  bbox side) = round(W / target) evenly spaced
         • zGrid: z-positions of grid lines = round(H / target) evenly
                  spaced
       These positions define BOTH:
         • Perimeter piers — placed at every grid line crossing on the
           4 rectangle sides. Because the same x/z values are used for
           top+bottom and left+right, the perimeter piers mirror across
           opposite sides automatically.
         • Interior piers — placed at every (x, z) intersection of the
           two grids, provided the point lies inside the polygon.
         • Joists — run parallel to the LONGER rectangle side. One
           joist per perp-axis grid line. */
    for (var ri2 = 0; ri2 < rects.length; ri2++) {
      var r = rects[ri2];
      var w = r.x1 - r.x0;
      var h = r.z1 - r.z0;
      var nX = Math.max(1, Math.round(w / targetSpacing));
      var nZ = Math.max(1, Math.round(h / targetSpacing));
      var xGrid = [];
      var zGrid = [];
      for (var xi = 0; xi <= nX; xi++) xGrid.push(r.x0 + (xi * w) / nX);
      for (var zi = 0; zi <= nZ; zi++) zGrid.push(r.z0 + (zi * h) / nZ);

      /* Perimeter piers on the rectangle's 4 sides. */
      /* Top + bottom: vary x, z fixed */
      for (var xi2 = 0; xi2 < xGrid.length; xi2++) {
        addPier(xGrid[xi2], r.z0, 'perimeter');
        addPier(xGrid[xi2], r.z1, 'perimeter');
      }
      /* Left + right: x fixed, vary z */
      for (var zi2 = 0; zi2 < zGrid.length; zi2++) {
        addPier(r.x0, zGrid[zi2], 'perimeter');
        addPier(r.x1, zGrid[zi2], 'perimeter');
      }

      /* Interior piers — at every (xGrid, zGrid) intersection,
         excluding the perimeter (those are already added). The point
         must lie inside the original polygon (sub-rect may be in a
         shape where a corner is shared with another sub-rect; an
         intersection on the shared edge is perimeter, not interior). */
      for (var xi3 = 1; xi3 < xGrid.length - 1; xi3++) {
        for (var zi3 = 1; zi3 < zGrid.length - 1; zi3++) {
          var ix = xGrid[xi3], iz = zGrid[zi3];
          if (!_pointInPolygonOrBoundary(ix, iz, poly)) continue;
          addPier(ix, iz, 'interior');
        }
      }

      /* Perimeter frame — 4 beams around each sub-rectangle. Even
         shared edges between sub-rectangles get a beam from BOTH
         neighbours, but visually they overlap and the frame is
         self-consistent (each rect is independently framed). */
      beams.push({ a: [r.x0, r.z0], b: [r.x1, r.z0] });   /* bottom */
      beams.push({ a: [r.x0, r.z1], b: [r.x1, r.z1] });   /* top */
      beams.push({ a: [r.x0, r.z0], b: [r.x0, r.z1] });   /* left */
      beams.push({ a: [r.x1, r.z0], b: [r.x1, r.z1] });   /* right */

      /* Joists — run parallel to the SHORTER side of the rectangle.
         Their length equals the short side; they span the short
         dimension and rest on the two LONG-side walls. Standard
         framing: minimize unsupported span by spanning the shorter
         direction.
         One joist per grid line perpendicular to joist direction
         (= per long-axis grid line).
         Exception: if the short side is shorter than target spacing,
         no interior joists — only perimeter frame. */
      if (w >= h) {
        /* w is long (horizontal), h is short (vertical).
           Joists run parallel to short side → joist is VERTICAL,
           parallel to z axis. One joist per x-line (interior only,
           skipping endpoints which are perimeter frame already). */
        if (h >= targetSpacing) {
          for (var xi4 = 1; xi4 < xGrid.length - 1; xi4++) {
            beams.push({ a: [xGrid[xi4], r.z0], b: [xGrid[xi4], r.z1] });
          }
        }
      } else {
        /* h is long (vertical), w is short (horizontal).
           Joists run parallel to short side → joist is HORIZONTAL,
           parallel to x axis. One joist per z-line (interior only). */
        if (w >= targetSpacing) {
          for (var zi4 = 1; zi4 < zGrid.length - 1; zi4++) {
            beams.push({ a: [r.x0, zGrid[zi4]], b: [r.x1, zGrid[zi4]] });
          }
        }
      }
    }

    /* Final pass: piers added by sub-rectangle perimeter logic are
       sufficient — no extra fill-in. */

    return {
      axis:     null,
      beams:    beams,
      rimJoist: rimJoist,
      piers:    piers,
      rects:    rects
    };
  }

  function distributePoints(spacing) {
    var poly = getFootprintPolygon();
    if (!poly.length || spacing <= 0) return [];
    var n = poly.length;

    var pts = [];
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      var elen = Math.hypot(dx, dz);
      var segs = Math.max(1, Math.ceil(elen / spacing));
      for (var k = 0; k < segs; k++) {
        var t = k / segs;
        pts.push({ x: a[0] + t * dx, z: a[1] + t * dz });
      }
    }

    var xMin =  Infinity, xMax = -Infinity;
    var zMin =  Infinity, zMax = -Infinity;
    for (var i = 0; i < n; i++) {
      var px = poly[i][0], pz = poly[i][1];
      if (px < xMin) xMin = px;
      if (px > xMax) xMax = px;
      if (pz < zMin) zMin = pz;
      if (pz > zMax) zMax = pz;
    }
    var L = xMax - xMin;
    var W = zMax - zMin;
    if (L < 0.5 || W < 0.5) return pts;

    var nX = Math.max(1, Math.ceil(L / spacing));
    var nZ = Math.max(1, Math.ceil(W / spacing));
    var sx = L / nX;
    var sz = W / nZ;
    var minStep = Math.min(sx, sz);
    var perimMargin = minStep * 0.45;
    var dedupTol   = minStep * 0.45;

    for (var i = 1; i < nX; i++) {
      for (var j = 1; j < nZ; j++) {
        var x = xMin + i * sx;
        var z = zMin + j * sz;
        if (!_pointInPolygonOrBoundary(x, z, poly)) continue;
        if (_distanceToPolygonPerimeter(x, z, poly) < perimMargin) continue;
        var skip = false;
        for (var m = 0; m < pts.length; m++) {
          if (Math.hypot(pts[m].x - x, pts[m].z - z) < dedupTol) {
            skip = true; break;
          }
        }
        if (!skip) pts.push({ x: x, z: z });
      }
    }

    return pts;
  }

  function _polygonBBoxIntersectsRect(poly, x0, z0, x1, z1) {
    var polyX0 =  Infinity, polyX1 = -Infinity;
    var polyZ0 =  Infinity, polyZ1 = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var p = poly[i];
      if (p[0] < polyX0) polyX0 = p[0];
      if (p[0] > polyX1) polyX1 = p[0];
      if (p[1] < polyZ0) polyZ0 = p[1];
      if (p[1] > polyZ1) polyZ1 = p[1];
    }
    if (x1 < polyX0 || x0 > polyX1) return false;
    if (z1 < polyZ0 || z0 > polyZ1) return false;
    return true;
  }

  function _clipSegmentToPolygon(x1, z1, x2, z2, poly) {
    var dx = x2 - x1, dz = z2 - z1;
    var tList = [0, 1];
    var n = poly.length;
    for (var i = 0; i < n; i++) {
      var pa = poly[i], pb = poly[(i + 1) % n];
      var ex = pb[0] - pa[0], ez = pb[1] - pa[1];
      var denom = dx * ez - dz * ex;
      if (Math.abs(denom) < 1e-12) continue;
      var s = ((pa[0] - x1) * ez - (pa[1] - z1) * ex) / denom;
      var t = ((pa[0] - x1) * dz - (pa[1] - z1) * dx) / denom;
      if (s > 1e-9 && s < 1 - 1e-9 && t > 1e-9 && t < 1 - 1e-9) {
        tList.push(s);
      }
    }
    tList.sort(function (a, b) { return a - b; });
    var segments = [];
    for (var i = 0; i < tList.length - 1; i++) {
      var t0 = tList[i], t1 = tList[i + 1];
      if (t1 - t0 < 1e-6) continue;
      var midT = (t0 + t1) / 2;
      var mx = x1 + dx * midT;
      var mz = z1 + dz * midT;
      if (_pointInPolygonOrBoundary(mx, mz, poly)) {
        segments.push({
          x1: x1 + dx * t0, z1: z1 + dz * t0,
          x2: x1 + dx * t1, z2: z1 + dz * t1
        });
      }
    }
    return segments;
  }

  /* Polygon inset (shrink polygon inward by `inset` along each edge's
     inward normal). Used to give rebar / mesh a real "concrete cover"
     so wires never reach the slab edge and can never visually extend
     past the foundation mass when the polygon is concave (L / step
     shapes). Bisector-based; handles convex AND re-entrant corners
     for typical foundation footprints. */
  function _insetPolygon(poly, inset) {
    if (!poly || poly.length < 3 || !(inset > 0)) return poly;
    var n = poly.length;
    var signedArea = 0;
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      signedArea += a[0] * b[1] - b[0] * a[1];
    }
    var ccw = signedArea > 0;
    var lines = [];
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      var len = Math.sqrt(dx * dx + dz * dz);
      if (len < 1e-9) continue;
      var nx, nz;
      if (ccw) { nx = -dz / len; nz =  dx / len; }
      else     { nx =  dz / len; nz = -dx / len; }
      lines.push({
        ax: a[0] + nx * inset, az: a[1] + nz * inset,
        bx: b[0] + nx * inset, bz: b[1] + nz * inset
      });
    }
    if (lines.length < 3) return poly;
    var out = [];
    for (var i = 0; i < lines.length; i++) {
      var L1 = lines[i], L2 = lines[(i + 1) % lines.length];
      var x1 = L1.ax, y1 = L1.az, x2 = L1.bx, y2 = L1.bz;
      var x3 = L2.ax, y3 = L2.az, x4 = L2.bx, y4 = L2.bz;
      var den = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
      if (Math.abs(den) < 1e-9) {
        out.push([L1.bx, L1.bz]);
      } else {
        var t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / den;
        out.push([x1 + t * (x2 - x1), y1 + t * (y2 - y1)]);
      }
    }
    return out;
  }

  function distributeMeshSheets(sheetL, sheetW, overlap) {
    var poly = getFootprintPolygon();
    if (!poly.length) return [];
    var xMin =  Infinity, xMax = -Infinity;
    var zMin =  Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var p = poly[i];
      if (p[0] < xMin) xMin = p[0];
      if (p[0] > xMax) xMax = p[0];
      if (p[1] < zMin) zMin = p[1];
      if (p[1] > zMax) zMax = p[1];
    }
    var L = xMax - xMin;
    var W = zMax - zMin;
    if (L < 0.1 || W < 0.1) return [];
    var stepX = sheetL - overlap;
    var stepZ = sheetW - overlap;
    if (stepX <= 0 || stepZ <= 0) return [];
    var sheets = [];
    var idx = 0;
    var x = xMin;
    while (x < xMax) {
      var z = zMin;
      while (z < zMax) {
        var x0 = x, x1 = x + sheetL;
        var z0 = z, z1 = z + sheetW;
        if (_polygonBBoxIntersectsRect(poly, x0, z0, x1, z1)) {
          if (_sheetCoversPolygonArea(x0, z0, x1, z1, poly)) {
            sheets.push({ x: (x0 + x1) / 2, z: (z0 + z1) / 2, L: sheetL, W: sheetW, index: idx });
            idx++;
          }
        }
        z += stepZ;
      }
      x += stepX;
    }
    return sheets;
  }

  function _sheetCoversPolygonArea(x0, z0, x1, z1, poly) {
    if (_pointInPolygonOrBoundary((x0 + x1) / 2, (z0 + z1) / 2, poly)) return true;
    var corners = [[x0, z0], [x1, z0], [x1, z1], [x0, z1]];
    for (var i = 0; i < 4; i++) {
      if (_pointInPolygonOrBoundary(corners[i][0], corners[i][1], poly)) return true;
    }
    for (var i = 0; i < poly.length; i++) {
      var p = poly[i];
      if (p[0] >= x0 && p[0] <= x1 && p[1] >= z0 && p[1] <= z1) return true;
    }
    return false;
  }



  var SHELTER_SPECS = {
    carport: {
      clearHeight: 2.40,
      pitchDeg:    22, pultPitchDeg: 10,
      overhangM:   0.30,
      post:    { w: 0.16, h: 0.16, code: 'KVH16160' },
      beam:    { w: 0.16, h: 0.24, code: 'KVH16240' },
      ridge:   { w: 0.16, h: 0.24, code: 'KVH16240' },
      rafter:  { w: 0.06, h: 0.16, code: 'KVH60160', spacing: 0.90 },
      batten:  { w: 0.05, h: 0.03, code: 'KVR50031', spacing: 0.35 },
      footing: { dia: 0.40, depth: 0.80, code: 'PBW00001' },
      truss:   { chord: { w: 0.06, h: 0.16, code: 'KVH60160' },   /* 2x6 top + bottom chords */
                 web:   { w: 0.06, h: 0.12, code: 'KVH60120' },   /* 2x5 webs (nearest stocked to 2x4) */
                 ridge: { w: 0.06, h: 0.20, code: 'KVH60200' },   /* 2x8 ridge board */
                 plate:    { len: 0.30, wid: 0.15, t: 0.012, code: 'FSP00001' },
                 plateWeb: { len: 0.18, wid: 0.10, t: 0.012, code: 'FSP00001' },
                 panels: 3, spacing: 0.61 }
    }
  };

  function _carportBBox(poly) {
    var xMin = Infinity, xMax = -Infinity, zMin = Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var x = poly[i][0], z = poly[i][1];
      if (x < xMin) xMin = x; if (x > xMax) xMax = x;
      if (z < zMin) zMin = z; if (z > zMax) zMax = z;
    }
    return { xMin: xMin, xMax: xMax, zMin: zMin, zMax: zMax,
             cx: (xMin + xMax) / 2, cz: (zMin + zMax) / 2,
             L: xMax - xMin, W: zMax - zMin };
  }

  function _carportRotPt(x, z, ang) {
    var c = Math.cos(ang), s = Math.sin(ang);
    return [x * c - z * s, x * s + z * c];
  }

  function _carportPrincipalAngle(poly) {
    var best = -1, bi = 0;
    for (var i = 0; i < poly.length; i++) {
      var a = poly[i], b = poly[(i + 1) % poly.length];
      var L = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (L > best) { best = L; bi = i; }
    }
    var a = poly[bi], b = poly[(bi + 1) % poly.length];
    return Math.atan2(b[1] - a[1], b[0] - a[0]);
  }

  function _carportPtInPoly(x, z, poly) {
    var inside = false, nn = poly.length;
    for (var i = 0, j = nn - 1; i < nn; j = i++) {
      var xi = poly[i][0], zi = poly[i][1], xj = poly[j][0], zj = poly[j][1];
      if (((zi > z) !== (zj > z)) && (x < (xj - xi) * (z - zi) / ((zj - zi) || 1e-9) + xi)) inside = !inside;
    }
    return inside;
  }

  function _carportMakeWing(s, eaveY, ov, u0, u1, v0, v1, th, Hforce, forceAlong) {
    var du = u1 - u0, dv = v1 - v0;
    var alongU = (forceAlong === 'u') ? true : (forceAlong === 'v') ? false : (du >= dv);
    var width = alongU ? dv : du;
    var coreLen = alongU ? du : dv;
    var half = width / 2 + ov;
    var rise = (Hforce != null) ? Hforce : half * Math.tan(s.pitchDeg * Math.PI / 180);
    var ridgeY = eaveY + rise;
    var rafterSlope = Math.hypot(half, rise);
    var aL, bL, dU, dV;
    if (alongU) { var vm = (v0 + v1) / 2; aL = [u0, vm]; bL = [u1, vm]; dU = [1, 0]; dV = [0, 1]; }
    else        { var um = (u0 + u1) / 2; aL = [um, v0]; bL = [um, v1]; dU = [0, 1]; dV = [1, 0]; }
    var A = _carportRotPt(aL[0], aL[1], th), B = _carportRotPt(bL[0], bL[1], th);
    var DU = _carportRotPt(dU[0], dU[1], th), DV = _carportRotPt(dV[0], dV[1], th);
    return {
      ax: { x: A[0], z: A[1] }, bx: { x: B[0], z: B[1] },
      dirU: { x: DU[0], z: DU[1] }, dirV: { x: DV[0], z: DV[1] },
      half: half, coreLen: coreLen, rise: rise, rafterSlope: rafterSlope,
      eaveY: eaveY, ridgeY: ridgeY, overhang: ov,
      rafterPairs: Math.max(2, Math.ceil(coreLen / s.rafter.spacing) + 1),
      battenRuns:  Math.max(2, Math.ceil(rafterSlope / s.batten.spacing) + 1)
    };
  }

  /* General rectilinear footprint -> list of rectangle specs (slab + merge).
     Returns [] if the polygon is not rectilinear (caller falls back to bbox). */
  function _carportRectilinearSpecs(lp) {
    var n = lp.length, AX = 1e-3;
    for (var e = 0; e < n; e++) {
      var a = lp[e], b = lp[(e + 1) % n];
      if (Math.abs(a[0] - b[0]) > 0.05 && Math.abs(a[1] - b[1]) > 0.05) return [];   /* not rectilinear */
    }
    function uniqSort(arr) {
      arr = arr.slice().sort(function (x, y) { return x - y; });
      var o = [];
      for (var i = 0; i < arr.length; i++) if (!o.length || Math.abs(arr[i] - o[o.length - 1]) > 1e-4) o.push(arr[i]);
      return o;
    }
    function rectsAlong(axis) {
      var oth = 1 - axis, cuts = uniqSort(lp.map(function (p) { return p[axis]; })), rects = [];
      for (var i = 0; i < cuts.length - 1; i++) {
        var c0 = cuts[i], c1 = cuts[i + 1], cm = (c0 + c1) / 2, xs = [];
        for (var e2 = 0; e2 < n; e2++) {
          var a2 = lp[e2], b2 = lp[(e2 + 1) % n];
          if ((a2[axis] - cm) * (b2[axis] - cm) < 0)
            xs.push(a2[oth] + (b2[oth] - a2[oth]) * (cm - a2[axis]) / (b2[axis] - a2[axis]));
        }
        xs.sort(function (x, y) { return x - y; });
        for (var j = 0; j + 1 < xs.length; j += 2) {
          var lo = xs[j], hi = xs[j + 1];
          if (hi - lo < AX) continue;
          rects.push(axis === 0 ? { u0: c0, u1: c1, v0: lo, v1: hi } : { u0: lo, u1: hi, v0: c0, v1: c1 });
        }
      }
      var keyf = (axis === 0)
        ? function (r) { return Math.round(r.v0 * 1e3) + ':' + Math.round(r.v1 * 1e3); }
        : function (r) { return Math.round(r.u0 * 1e3) + ':' + Math.round(r.u1 * 1e3); };
      var groups = {};
      rects.forEach(function (r) { (groups[keyf(r)] = groups[keyf(r)] || []).push(r); });
      var out = [];
      Object.keys(groups).forEach(function (k) {
        var grp = groups[k].sort(function (a, b) { return axis === 0 ? a.u0 - b.u0 : a.v0 - b.v0; });
        var cur = { u0: grp[0].u0, u1: grp[0].u1, v0: grp[0].v0, v1: grp[0].v1 };
        for (var gi = 1; gi < grp.length; gi++) {
          var r = grp[gi];
          if (axis === 0 ? Math.abs(r.u0 - cur.u1) < 1e-3 : Math.abs(r.v0 - cur.v1) < 1e-3) {
            if (axis === 0) cur.u1 = r.u1; else cur.v1 = r.v1;
          } else { out.push(cur); cur = { u0: r.u0, u1: r.u1, v0: r.v0, v1: r.v1 }; }
        }
        out.push(cur);
      });
      return out;
    }
    var rU = rectsAlong(0), rV = rectsAlong(1);
    var rects = (rU.length <= rV.length) ? rU : rV;
    return rects.map(function (r) { return { r: [r.u0, r.u1, r.v0, r.v1], along: null }; });
  }

  function _carportWings(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    var th = _carportPrincipalAngle(poly);

    var lp = [], luMin = Infinity, luMax = -Infinity, lvMin = Infinity, lvMax = -Infinity;
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push(q);
      if (q[0] < luMin) luMin = q[0]; if (q[0] > luMax) luMax = q[0];
      if (q[1] < lvMin) lvMin = q[1]; if (q[1] > lvMax) lvMax = q[1];
    }

    var specs = null;
    var tol = 0.08, recti = (n === 4 || n === 6);
    if (recti) {
      for (var e = 0; e < n; e++) {
        var p = lp[e], r = lp[(e + 1) % n];
        if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) { recti = false; break; }
      }
    }
    if (recti && n === 4) specs = [{ r: [luMin, luMax, lvMin, lvMax], along: null }];
    else if (recti && n === 6) {
      var area = 0;
      for (var k = 0; k < n; k++) { var a1 = lp[k], a2 = lp[(k + 1) % n]; area += a1[0] * a2[1] - a2[0] * a1[1]; }
      var ccw = area > 0, reflex = -1;
      for (var k2 = 0; k2 < n; k2++) {
        var pa = lp[(k2 + n - 1) % n], pb = lp[k2], pc = lp[(k2 + 1) % n];
        var cr = (pb[0] - pa[0]) * (pc[1] - pb[1]) - (pb[1] - pa[1]) * (pc[0] - pb[0]);
        if (!(ccw ? (cr > 0) : (cr < 0))) { reflex = k2; break; }
      }
      if (reflex >= 0) {
        var rfx = lp[reflex][0], rfz = lp[reflex][1];
        var eps = Math.min(luMax - luMin, lvMax - lvMin) * 0.05 + 0.02;
        var corners = [[luMin, lvMin], [luMax, lvMin], [luMax, lvMax], [luMin, lvMax]];
        var nU = null, nV = null;
        for (var c2 = 0; c2 < 4; c2++) {
          var cu = corners[c2][0], cv = corners[c2][1];
          var tx = cu + (cu === luMin ? eps : -eps), tz = cv + (cv === lvMin ? eps : -eps);
          var wpt = _carportRotPt(tx, tz, th);
          if (!_carportPtInPoly(wpt[0], wpt[1], poly)) { nU = cu; nV = cv; break; }
        }
        if (nU !== null) {
          
          var aV0 = (nV === lvMax) ? lvMin : rfz;
          var aV1 = (nV === lvMax) ? rfz   : lvMax;
          var cvA = (aV0 + aV1) / 2;
          var bU0 = (nU === luMax) ? luMin : rfx;
          var bU1 = (nU === luMax) ? rfx   : luMax;
          var bV0 = (nV === lvMax) ? cvA : lvMin;
          var bV1 = (nV === lvMax) ? lvMax : cvA;
          specs = [
            { r: [luMin, luMax, aV0, aV1], along: 'u' },
            { r: [bU0, bU1, bV0, bV1],     along: 'v' }
          ];
        }
      }
    }
    if (!specs) {
      var _gen = _carportRectilinearSpecs(lp);
      specs = (_gen && _gen.length) ? _gen : [{ r: [luMin, luMax, lvMin, lvMax], along: null }];
    }

    var maxHalf = 0;
    for (var si = 0; si < specs.length; si++) {
      var sp = specs[si], du2 = sp.r[1] - sp.r[0], dv2 = sp.r[3] - sp.r[2];
      var aU = (sp.along === 'u') ? true : (sp.along === 'v') ? false : (du2 >= dv2);
      var hh = (aU ? dv2 : du2) / 2 + ov;
      if (hh > maxHalf) maxHalf = hh;
    }
    var H = maxHalf * Math.tan(pitch0);

    var wings = [];
    for (var sj = 0; sj < specs.length; sj++) {
      var sc = specs[sj];
      wings.push(_carportMakeWing(s, eaveY, ov, sc.r[0], sc.r[1], sc.r[2], sc.r[3], th, H, sc.along));
    }
    return wings;
  }

  function _carportLParams(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    if (n !== 6) return null;
    var th = _carportPrincipalAngle(poly);

    var lp = [], luMin = Infinity, luMax = -Infinity, lvMin = Infinity, lvMax = -Infinity;
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push(q);
      if (q[0] < luMin) luMin = q[0]; if (q[0] > luMax) luMax = q[0];
      if (q[1] < lvMin) lvMin = q[1]; if (q[1] > lvMax) lvMax = q[1];
    }

    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }

    var area = 0;
    for (var k = 0; k < n; k++) { var a1 = lp[k], a2 = lp[(k + 1) % n]; area += a1[0] * a2[1] - a2[0] * a1[1]; }
    var ccw = area > 0, reflex = -1;
    for (var k2 = 0; k2 < n; k2++) {
      var pa = lp[(k2 + n - 1) % n], pb = lp[k2], pc = lp[(k2 + 1) % n];
      var cr = (pb[0] - pa[0]) * (pc[1] - pb[1]) - (pb[1] - pa[1]) * (pc[0] - pb[0]);
      if (!(ccw ? (cr > 0) : (cr < 0))) { reflex = k2; break; }
    }
    if (reflex < 0) return null;

    var rfx = lp[reflex][0], rfz = lp[reflex][1];
    var eps = Math.min(luMax - luMin, lvMax - lvMin) * 0.05 + 0.02;
    var corners = [[luMin, lvMin], [luMax, lvMin], [luMax, lvMax], [luMin, lvMax]];
    var nU = null, nV = null;
    for (var c2 = 0; c2 < 4; c2++) {
      var cu = corners[c2][0], cv = corners[c2][1];
      var tx = cu + (cu === luMin ? eps : -eps), tz = cv + (cv === lvMin ? eps : -eps);
      var wpt = _carportRotPt(tx, tz, th);
      if (!_carportPtInPoly(wpt[0], wpt[1], poly)) { nU = cu; nV = cv; break; }
    }
    if (nU === null) return null;

    var U = luMax - luMin, V = lvMax - lvMin;
    var a = (nU === luMax) ? (rfx - luMin) : (luMax - rfx);
    var b = (nV === lvMax) ? (rfz - lvMin) : (lvMax - rfz);
    if (a < 0.2 || b < 0.2 || a > U - 0.2 || b > V - 0.2) return null;

    var halfH = b / 2 + ov, halfV = a / 2 + ov;
    var H = Math.max(halfH, halfV) * Math.tan(pitch0);
    var yR = eaveY + H, yE = eaveY;

    function toW(cu, cv, y) {
      var lu = (nU === luMax) ? (luMin + cu) : (luMax - cu);
      var lv = (nV === lvMax) ? (lvMin + cv) : (lvMax - cv);
      var w = _carportRotPt(lu, lv, th);
      return [w[0], y, w[1]];
    }

    return { U: U, V: V, a: a, b: b, ov: ov, yR: yR, yE: yE, eaveY: eaveY, toW: toW };
  }

  function _carportTeeParams(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    if (n !== 8) return null;
    var th = _carportPrincipalAngle(poly);
    var lp = [], luMin = Infinity, luMax = -Infinity, lvMin = Infinity, lvMax = -Infinity;
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push(q);
      if (q[0] < luMin) luMin = q[0]; if (q[0] > luMax) luMax = q[0];
      if (q[1] < lvMin) lvMin = q[1]; if (q[1] > lvMax) lvMax = q[1];
    }
    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }
    var W = luMax - luMin, V = lvMax - lvMin;
    if (W < 1 || V < 1) return null;
    function inL(lu, lv) { var w = _carportRotPt(lu, lv, th); return _carportPtInPoly(w[0], w[1], poly); }
    function widthAtV(lv) {
      var lo = Infinity, hi = -Infinity, steps = 80;
      for (var k = 0; k <= steps; k++) { var lu = luMin + W * k / steps; if (inL(lu, lv)) { if (lu < lo) lo = lu; if (lu > hi) hi = lu; } }
      return hi > lo ? (hi - lo) : 0;
    }
    var eps = Math.min(W, V) * 0.04 + 0.02;
    var wMin = widthAtV(lvMin + eps), wMax = widthAtV(lvMax - eps);
    var frontAtMin = wMin >= wMax;
    var frontLV = frontAtMin ? lvMin : lvMax;
    var dir = frontAtMin ? 1 : -1;
    var frontW = frontAtMin ? wMin : wMax;
    if (frontW < W * 0.9) return null;
    function depthAt(lu) {
      var steps = 140, dmax = 0;
      for (var k = 0; k <= steps; k++) { var d = V * k / steps; if (inL(lu, frontLV + dir * d)) dmax = d; }
      return dmax;
    }
    var su = 90, prof = [];
    for (var k = 0; k <= su; k++) { var lu2 = luMin + W * k / su; prof.push([lu2, depthAt(lu2)]); }
    var dmaxAll = 0; for (var k2 = 0; k2 < prof.length; k2++) dmaxAll = Math.max(dmaxAll, prof[k2][1]);
    if (dmaxAll < 0.5) return null;
    var thr = dmaxAll - Math.min(W, V) * 0.06 - 0.05;
    var su0 = null, su1 = null;
    for (var k3 = 0; k3 < prof.length; k3++) { if (prof[k3][1] >= thr) { if (su0 === null) su0 = prof[k3][0]; su1 = prof[k3][0]; } }
    if (su0 === null) return null;
    if (su0 <= luMin + 0.15 || su1 >= luMax - 0.15) return null;
    function runDepth(uLo, uHi) {
      var vals = [];
      for (var k = 0; k < prof.length; k++) if (prof[k][0] > uLo + 0.05 && prof[k][0] < uHi - 0.05) vals.push(prof[k][1]);
      if (!vals.length) return 0;
      vals.sort(function (a, b) { return a - b; });
      return vals[Math.floor(vals.length / 2)];
    }
    var DL = runDepth(luMin, su0), DR = runDepth(su1, luMax), DS = dmaxAll;
    if (DL < 0.2 || DR < 0.2) return null;
    if (DS < Math.max(DL, DR) + 0.2) return null;
    var Dn = Math.min(DL, DR), R = Dn / 2;
    if (R < 0.2) return null;
    var H = eaveY + (R + ov) * Math.tan(pitch0);
    var cx = (su0 + su1) / 2;
    function P(lu, d, y) { var w = _carportRotPt(lu, frontLV + dir * d, th); return [w[0], y, w[1]]; }
    return { P: P, eaveY: eaveY, H: H, R: R, ov: ov, luMin: luMin, luMax: luMax, su0: su0, su1: su1, cx: cx, DL: DL, DR: DR, DS: DS };
  }

  function _carportUParams(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    if (n !== 8) return null;
    var th = _carportPrincipalAngle(poly);
    var lp = [];
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push([q[0], q[1]]);
    }
    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }
    function attempt(sw) {
      var pts = lp.map(function (p) { return sw ? [p[1], p[0]] : [p[0], p[1]]; });
      var xs = pts.map(function (p) { return p[0]; }), zs = pts.map(function (p) { return p[1]; });
      var xmin = Math.min.apply(0, xs), xmax = Math.max.apply(0, xs);
      var zmin = Math.min.apply(0, zs), zmax = Math.max.apply(0, zs);
      var W = xmax - xmin, V = zmax - zmin;
      if (W < 1 || V < 0.6) return null;
      function inLoc(x, z) {
        var lx = sw ? z : x, lz = sw ? x : z;
        var w = _carportRotPt(lx, lz, th);
        return _carportPtInPoly(w[0], w[1], poly);
      }
      var eps = Math.min(W, V) * 0.04 + 0.02;
      function fullRow(zc) {
        for (var t2 = 0; t2 < 20; t2++) {
          var x = xmin + W * (t2 + 0.5) / 20;
          if (!inLoc(x, zc)) return false;
        }
        return true;
      }
      var frontAtMin = fullRow(zmin + eps), frontAtMax = fullRow(zmax - eps);
      if (!frontAtMin && !frontAtMax) return null;
      var dir = frontAtMin ? 1 : -1;
      var frontZ = frontAtMin ? zmin : zmax;
      function depthAt(u) {
        var steps = 140, dm = 0;
        for (var k = 0; k <= steps; k++) {
          var d = V * k / steps;
          if (inLoc(xmin + u, frontZ + dir * d)) dm = d;
        }
        return dm;
      }
      var su = 110, prof = [], insU = Math.min(0.06, W * 0.005);
      for (var k2 = 0; k2 <= su; k2++) {
        var uu = insU + (W - 2 * insU) * k2 / su;
        prof.push([uu, depthAt(uu)]);
      }
      var dmin = Infinity, dmax = 0;
      for (var k3 = 1; k3 < prof.length - 1; k3++) {
        if (prof[k3][1] < dmin) dmin = prof[k3][1];
        if (prof[k3][1] > dmax) dmax = prof[k3][1];
      }
      if (!(dmax > dmin + 0.3)) return null;
      var thr = dmin + Math.max(0.25, (dmax - dmin) * 0.35);
      if (prof[0][1] < thr || prof[prof.length - 1][1] < thr) return null;
      var li = 0;
      while (li < prof.length && prof[li][1] >= thr) li++;
      var ri = prof.length - 1;
      while (ri >= 0 && prof[ri][1] >= thr) ri--;
      if (li <= 0 || ri >= prof.length - 1 || li > ri) return null;
      var AL = prof[li - 1][0], ARu = prof[ri + 1][0];
      var AR = W - ARu;
      function med(vals) {
        if (!vals.length) return 0;
        vals.sort(function (a, b) { return a - b; });
        return vals[Math.floor(vals.length / 2)];
      }
      var midVals = [], lVals = [], rVals = [];
      for (var k4 = 0; k4 < prof.length; k4++) {
        var u4 = prof[k4][0], d4 = prof[k4][1];
        if (u4 > AL + 0.05 && u4 < ARu - 0.05) midVals.push(d4);
        if (u4 < AL - 0.05) lVals.push(d4);
        if (u4 > ARu + 0.05) rVals.push(d4);
      }
      var B = med(midVals), VL = med(lVals), VR = med(rVals);
      function snapTo(v, arr, maxd) {
        var best = v, bd = maxd;
        for (var si = 0; si < arr.length; si++) {
          var dd = Math.abs(arr[si] - v);
          if (dd < bd) { bd = dd; best = arr[si]; }
        }
        return best;
      }
      var uCoords = xs.map(function (x) { return x - xmin; });
      var dCoords = zs.map(function (z) { return dir > 0 ? (z - zmin) : (zmax - z); });
      AL = snapTo(AL, uCoords, 0.25);
      ARu = snapTo(ARu, uCoords, 0.25);
      AR = W - ARu;
      B = snapTo(B, dCoords, 0.25);
      VL = snapTo(VL, dCoords, 0.25);
      VR = snapTo(VR, dCoords, 0.25);
      if (AL < 0.2 || AR < 0.2 || AL + AR > W - 0.3) return null;
      if (B < 0.2 || VL < B + 0.2 || VR < B + 0.2) return null;
      var half = Math.max(B / 2, AL / 2, AR / 2);
      var yR = eaveY + (half + ov) * Math.tan(pitch0);
      function P(u, d, y) {
        var x = xmin + u, z = frontZ + dir * d;
        var lx = sw ? z : x, lz = sw ? x : z;
        var w = _carportRotPt(lx, lz, th);
        return [w[0], y, w[1]];
      }
      return { P: P, eaveY: eaveY, yR: yR, ov: ov, W: W, B: B, AL: AL, AR: AR, VL: VL, VR: VR };
    }
    return attempt(false) || attempt(true);
  }

  function _carportHParams(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    if (n !== 12) return null;
    var th = _carportPrincipalAngle(poly);
    var lp = [];
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push([q[0], q[1]]);
    }
    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }
    function attempt(sw) {
      var pts = lp.map(function (p) { return sw ? [p[1], p[0]] : [p[0], p[1]]; });
      var xs = pts.map(function (p) { return p[0]; }), zs = pts.map(function (p) { return p[1]; });
      var xmin = Math.min.apply(0, xs), xmax = Math.max.apply(0, xs);
      var zmin = Math.min.apply(0, zs), zmax = Math.max.apply(0, zs);
      var W = xmax - xmin, V = zmax - zmin;
      if (W < 1 || V < 1) return null;
      function inLoc(x, z) {
        var lx = sw ? z : x, lz = sw ? x : z;
        var w = _carportRotPt(lx, lz, th);
        return _carportPtInPoly(w[0], w[1], poly);
      }
      var su = 110, sv = 160, insU = Math.min(0.06, W * 0.005), insV = Math.min(0.05, V * 0.004);
      var cols = [];
      for (var k = 0; k <= su; k++) {
        var u = insU + (W - 2 * insU) * k / su;
        var lo = null, hi = null;
        for (var j = 0; j <= sv; j++) {
          var d = insV + (V - 2 * insV) * j / sv;
          if (inLoc(xmin + u, zmin + d)) {
            if (lo === null) lo = d;
            hi = d;
          }
        }
        if (lo === null) return null;
        cols.push([u, lo, hi]);
      }
      var simTol = 0.3;
      function sim(a, b) { return Math.abs(a[1] - b[1]) <= simTol && Math.abs(a[2] - b[2]) <= simTol; }
      var li = 1;
      while (li < cols.length && sim(cols[li], cols[0])) li++;
      var ri = cols.length - 2;
      while (ri >= 0 && sim(cols[ri], cols[cols.length - 1])) ri--;
      if (li > ri) return null;
      function med(vals) {
        if (!vals.length) return null;
        vals.sort(function (a, b) { return a - b; });
        return vals[Math.floor(vals.length / 2)];
      }
      var uLB = cols[li - 1][0], uRB = cols[ri + 1][0];
      var L0a = [], L1a = [], R0a = [], R1a = [], c0a = [], c1a = [];
      for (var k2 = 0; k2 < cols.length; k2++) {
        var cu = cols[k2][0];
        if (cu < uLB - 0.05) { L0a.push(cols[k2][1]); L1a.push(cols[k2][2]); }
        else if (cu > uRB + 0.05) { R0a.push(cols[k2][1]); R1a.push(cols[k2][2]); }
      }
      var L0 = med(L0a), L1 = med(L1a), R0 = med(R0a), R1 = med(R1a);
      if (L0 === null || R0 === null) return null;
      for (var k3 = 0; k3 < cols.length; k3++) {
        var cu3 = cols[k3][0];
        if (cu3 > uLB + 0.05 && cu3 < uRB - 0.05) {
          if (cols[k3][1] <= Math.max(L0, R0) + 0.1 && cols[k3][2] >= Math.min(L1, R1) - 0.1) continue;
          c0a.push(cols[k3][1]);
          c1a.push(cols[k3][2]);
        }
      }
      var c0 = med(c0a), c1 = med(c1a);
      if (c0 === null || c1 === null) return null;
      function rowFromLeft(zp) {
        var last = null;
        for (var kk = 0; kk <= su; kk++) {
          var xx = insU + (W - 2 * insU) * kk / su;
          if (inLoc(xmin + xx, zmin + zp)) last = xx;
          else if (last !== null) break;
        }
        return last;
      }
      function rowFromRight(zp) {
        var first = null;
        for (var kk = su; kk >= 0; kk--) {
          var xx = insU + (W - 2 * insU) * kk / su;
          if (inLoc(xmin + xx, zmin + zp)) first = xx;
          else if (first !== null) break;
        }
        return first;
      }
      var zLn = (L0 + c0) / 2, zLs = (c1 + L1) / 2;
      var zRn = (R0 + c0) / 2, zRs = (c1 + R1) / 2;
      var ALn = rowFromLeft(zLn), ALs = rowFromLeft(zLs);
      var ARnX = rowFromRight(zRn), ARsX = rowFromRight(zRs);
      if (ALn === null || ALs === null || ARnX === null || ARsX === null) return null;

      function snapTo(v, arr, maxd) {
        var best = v, bd = maxd;
        for (var si = 0; si < arr.length; si++) {
          var dd = Math.abs(arr[si] - v);
          if (dd < bd) { bd = dd; best = arr[si]; }
        }
        return best;
      }
      var uCoords = xs.map(function (x) { return x - xmin; });
      var dCoords = zs.map(function (z) { return z - zmin; });
      ALn = snapTo(ALn, uCoords, 0.25); ALs = snapTo(ALs, uCoords, 0.25);
      ARnX = snapTo(ARnX, uCoords, 0.25); ARsX = snapTo(ARsX, uCoords, 0.25);
      var ARn = W - ARnX, ARs = W - ARsX;
      L0 = snapTo(L0, dCoords, 0.25); L1 = snapTo(L1, dCoords, 0.25);
      R0 = snapTo(R0, dCoords, 0.25); R1 = snapTo(R1, dCoords, 0.25);
      c0 = snapTo(c0, dCoords, 0.25); c1 = snapTo(c1, dCoords, 0.25);
      if (ALn < 0.2 || ALs < 0.2 || ARn < 0.2 || ARs < 0.2) return null;
      if (Math.max(ALn, ALs) + Math.max(ARn, ARs) > W - 0.3) return null;
      if (!(L1 > L0 + 0.4) || !(R1 > R0 + 0.4) || !(c1 > c0 + 0.2)) return null;
      if (c0 < Math.max(L0, R0) + 0.05 || c1 > Math.min(L1, R1) - 0.05) return null;
      var tanP = Math.tan(pitch0);
      var minL = Math.min(ALn, ALs), minR = Math.min(ARn, ARs);
      var minAll = Math.min(minL, minR);
      var cxL = minL / 2, cxR = W - minR / 2;
      var yC = eaveY + (minAll / 2 + ov) * tanP;
      var yRL = yC, yRR = yC;
      function P(u, d, y) {
        var x = xmin + u, z = zmin + d;
        var lx = sw ? z : x, lz = sw ? x : z;
        var w = _carportRotPt(lx, lz, th);
        return [w[0], y, w[1]];
      }
      return { P: P, eaveY: eaveY, ov: ov, W: W, L0: L0, L1: L1, R0: R0, R1: R1, c0: c0, c1: c1, ALn: ALn, ALs: ALs, ARn: ARn, ARs: ARs, cxL: cxL, cxR: cxR, yRL: yRL, yRR: yRR };
    }
    return attempt(false) || attempt(true);
  }

  function _carportRectParams(poly) {
    var s = SHELTER_SPECS.carport;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    if (poly.length !== 4) return null;
    var th = _carportPrincipalAngle(poly);
    var lp = [];
    for (var i = 0; i < 4; i++) lp.push(_carportRotPt(poly[i][0], poly[i][1], -th));
    var tol = 0.08;
    for (var e = 0; e < 4; e++) {
      var p = lp[e], r = lp[(e + 1) % 4];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }
    var xs = lp.map(function (q) { return q[0]; }), zs = lp.map(function (q) { return q[1]; });
    var xmin = Math.min.apply(0, xs), xmax = Math.max.apply(0, xs);
    var zmin = Math.min.apply(0, zs), zmax = Math.max.apply(0, zs);
    var W = xmax - xmin, D = zmax - zmin;
    if (W < 0.6 || D < 0.6) return null;
    var swap2 = D > W;
    var L = swap2 ? D : W, S = swap2 ? W : D;
    function P(u, v, y) {
      var lx = swap2 ? (xmin + v) : (xmin + u);
      var lz = swap2 ? (zmin + u) : (zmin + v);
      var w = _carportRotPt(lx, lz, th);
      return [w[0], y, w[1]];
    }
    return { P: P, eaveY: eaveY, ov: ov, L: L, S: S };
  }

  function _carportPolyTris(poly) {
    var pts = poly.map(function (p) { return [p[0], p[1]]; });
    var a2 = 0;
    for (var i = 0; i < pts.length; i++) { var q = pts[i], r = pts[(i + 1) % pts.length]; a2 += q[0] * r[1] - r[0] * q[1]; }
    if (a2 < 0) pts.reverse();
    var idx = []; for (var k = 0; k < pts.length; k++) idx.push(k);
    var tris = [], guard = 0;
    while (idx.length > 3 && guard++ < 999) {
      var done = false;
      for (var ii = 0; ii < idx.length; ii++) {
        var i0 = idx[(ii + idx.length - 1) % idx.length], i1 = idx[ii], i2 = idx[(ii + 1) % idx.length];
        var ax = pts[i0][0], ay = pts[i0][1], bx = pts[i1][0], by = pts[i1][1], cx = pts[i2][0], cy = pts[i2][1];
        var cr = (bx - ax) * (cy - ay) - (by - ay) * (cx - ax);
        if (cr <= 1e-9) continue;
        var ok = true;
        for (var jj = 0; jj < idx.length; jj++) {
          var ij = idx[jj];
          if (ij === i0 || ij === i1 || ij === i2) continue;
          var px = pts[ij][0], py = pts[ij][1];
          var d1 = (bx - ax) * (py - ay) - (by - ay) * (px - ax);
          var d2 = (cx - bx) * (py - by) - (cy - by) * (px - bx);
          var d3 = (ax - cx) * (py - cy) - (ay - cy) * (px - cx);
          if (d1 >= 0 && d2 >= 0 && d3 >= 0) { ok = false; break; }
        }
        if (!ok) continue;
        tris.push([pts[i0], pts[i1], pts[i2]]);
        idx.splice(ii, 1); done = true; break;
      }
      if (!done) break;
    }
    if (idx.length === 3) tris.push([pts[idx[0]], pts[idx[1]], pts[idx[2]]]);
    return tris;
  }

  function _carportSlabIntervals(lp, vline) {
    var xs = [], n = lp.length;
    for (var i = 0; i < n; i++) {
      var a = lp[i], b = lp[(i + 1) % n], v0 = a[1], v1 = b[1];
      if ((v0 <= vline && v1 > vline) || (v1 <= vline && v0 > vline)) {
        var t = (vline - v0) / (v1 - v0);
        xs.push(a[0] + t * (b[0] - a[0]));
      }
    }
    xs.sort(function (p, q) { return p - q; });
    var iv = [];
    for (var k = 0; k + 1 < xs.length; k += 2) iv.push([xs[k], xs[k + 1]]);
    return iv;
  }

  function _carportSpineFor(poly, th) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM, lift = 0.14;
    var n = poly.length;
    if (n < 6) return null;

    var lp = [], luMin = Infinity, luMax = -Infinity, lvMin = Infinity, lvMax = -Infinity;
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push(q);
      if (q[0] < luMin) luMin = q[0]; if (q[0] > luMax) luMax = q[0];
      if (q[1] < lvMin) lvMin = q[1]; if (q[1] > lvMax) lvMax = q[1];
    }
    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }

    var area = 0;
    for (var k = 0; k < n; k++) { var a1 = lp[k], a2 = lp[(k + 1) % n]; area += a1[0] * a2[1] - a2[0] * a1[1]; }
    var ccw = area > 0, reflexV = null;
    for (var k2 = 0; k2 < n; k2++) {
      var pa = lp[(k2 + n - 1) % n], pb = lp[k2], pc = lp[(k2 + 1) % n];
      var cr = (pb[0] - pa[0]) * (pc[1] - pb[1]) - (pb[1] - pa[1]) * (pc[0] - pb[0]);
      if (!(ccw ? (cr > 0) : (cr < 0))) {
        if (reflexV === null) reflexV = pb[1];
        else if (Math.abs(pb[1] - reflexV) > tol) return null;
      }
    }
    if (reflexV === null) return null;

    var W = luMax - luMin, Vh = lvMax - lvMin;
    var eps = Math.min(W, Vh) * 0.02 + 0.01;
    function ptIn(u, v) { var w = _carportRotPt(u, v, th); return _carportPtInPoly(w[0], w[1], poly); }
    var bottomFull = ptIn((luMin + luMax) / 2, lvMin + eps) && ptIn(luMin + eps, lvMin + eps) && ptIn(luMax - eps, lvMin + eps);
    var topFull = ptIn((luMin + luMax) / 2, lvMax - eps) && ptIn(luMin + eps, lvMax - eps) && ptIn(luMax - eps, lvMax - eps);
    var up;
    if (bottomFull && !topFull) up = true;
    else if (topFull && !bottomFull) up = false;
    else return null;

    var Bc = up ? (reflexV - lvMin) : (lvMax - reflexV);
    if (Bc < 0.2 || Bc > Vh - 0.2) return null;

    var spineSlab = up ? (reflexV - eps) : (reflexV + eps);
    var ivSpine = _carportSlabIntervals(lp, spineSlab);
    if (ivSpine.length !== 1) return null;
    if (Math.abs(ivSpine[0][0] - luMin) > 3 * eps || Math.abs(ivSpine[0][1] - luMax) > 3 * eps) return null;

    var branchSlab = up ? (reflexV + eps) : (reflexV - eps);
    var ivB = _carportSlabIntervals(lp, branchSlab);
    if (ivB.length < 1) return null;
    var branches = [];
    for (var bi = 0; bi < ivB.length; bi++) {
      var c0 = ivB[bi][0] - luMin, c1 = ivB[bi][1] - luMin;
      if (c1 - c0 < 0.2) return null;
      branches.push({ u0: c0, u1: c1, ridgeU: (c0 + c1) / 2, half: (c1 - c0) / 2 + ov,
        hipL: Math.abs(c0) < 3 * eps, hipR: Math.abs(c1 - W) < 3 * eps });
    }
    branches.sort(function (p2, q2) { return p2.u0 - q2.u0; });

    var maxHalf = Bc / 2 + ov;
    for (var mb = 0; mb < branches.length; mb++) if (branches[mb].half > maxHalf) maxHalf = branches[mb].half;
    var H = maxHalf * Math.tan(pitch0);
    var yR = eaveY + H, yE = eaveY, fyR = yR + lift, fyE = yE + lift;
    var rv2 = Bc / 2, Bcov = Bc + ov;

    function toW(cu, cv, y) {
      var lu = luMin + cu, lv = up ? (lvMin + cv) : (lvMax - cv);
      var w = _carportRotPt(lu, lv, th);
      return [w[0], y, w[1]];
    }
    var faces = [], beams = [];
    function F(a, b, c, d) { faces.push([toW(a[0], a[1], a[2]), toW(b[0], b[1], b[2]), toW(c[0], c[1], c[2]), toW(d[0], d[1], d[2])]); }
    function RID(a, b) { beams.push({ a: toW(a[0], a[1], a[2]), b: toW(b[0], b[1], b[2]), ridge: true }); }
    function RAF(a, b) { beams.push({ a: toW(a[0], a[1], a[2]), b: toW(b[0], b[1], b[2]), ridge: false }); }

    var flushL = branches[0].hipL, flushR = branches[branches.length - 1].hipR;
    var leftTopU = flushL ? branches[0].ridgeU : -ov;
    var rightTopU = flushR ? branches[branches.length - 1].ridgeU : W + ov;

    F([-ov, -ov, fyE], [W + ov, -ov, fyE], [rightTopU, rv2, fyR], [leftTopU, rv2, fyR]);
    RID([leftTopU, rv2, yR], [rightTopU, rv2, yR]);

    var hsp = s.rafter.spacing;
    var sn = Math.max(1, Math.ceil((rightTopU - leftTopU) / hsp));
    for (var si = 0; si <= sn; si++) {
      var scu = leftTopU + (rightTopU - leftTopU) * si / sn;
      RAF([scu, rv2, yR], [scu, -ov, yE]);
    }

    function northGap(eL, eR, jLU, jRU) {
      F([eL, Bcov, fyE], [eR, Bcov, fyE], [jRU, rv2, fyR], [jLU, rv2, fyR]);
      var gn = Math.max(1, Math.ceil((eR - eL) / hsp));
      for (var gi = 0; gi <= gn; gi++) {
        var gcu = eL + (eR - eL) * gi / gn;
        RAF([gcu, rv2, yR], [gcu, Bcov, yE]);
      }
    }
    if (!flushL) northGap(-ov, branches[0].u0 - ov, -ov, branches[0].ridgeU);
    for (var gj = 0; gj < branches.length - 1; gj++) {
      northGap(branches[gj].u1 + ov, branches[gj + 1].u0 - ov, branches[gj].ridgeU, branches[gj + 1].ridgeU);
    }
    if (!flushR) {
      var lb = branches[branches.length - 1];
      northGap(lb.u1 + ov, W + ov, lb.ridgeU, W + ov);
    }

    for (var b3 = 0; b3 < branches.length; b3++) {
      var br = branches[b3], ru = br.ridgeU, tipV = Vh + ov;
      RID([ru, rv2, yR], [ru, tipV, yR]);
      var wEave = br.hipL ? -ov : (br.u0 - ov), wBase = br.hipL ? -ov : Bcov;
      var eEave = br.hipR ? (W + ov) : (br.u1 + ov), eBase = br.hipR ? -ov : Bcov;
      F([ru, rv2, fyR], [ru, tipV, fyR], [wEave, tipV, fyE], [wEave, wBase, fyE]);
      F([ru, rv2, fyR], [ru, tipV, fyR], [eEave, tipV, fyE], [eEave, eBase, fyE]);
      RAF([ru, rv2, yR], [wEave, wBase, yE]);
      RAF([ru, rv2, yR], [eEave, eBase, yE]);
      var bn2 = Math.max(1, Math.ceil((tipV - Bc) / hsp));
      for (var bj = 1; bj <= bn2; bj++) {
        var bcv = Bc + (tipV - Bc) * bj / bn2;
        RAF([ru, bcv, yR], [wEave, bcv, yE]);
        RAF([ru, bcv, yR], [eEave, bcv, yE]);
      }
    }

    return { faces: faces, beams: beams, Bc: Bc, W: W, th: th };
  }

  function _carportSpinePlanes(poly) {
    var th0 = _carportPrincipalAngle(poly);
    var cands = [];
    var A = _carportSpineFor(poly, th0);            if (A) cands.push(A);
    var B = _carportSpineFor(poly, th0 + Math.PI/2); if (B) cands.push(B);
    if (!cands.length) return null;
    cands.sort(function (p, q) { return (Math.abs(q.Bc - p.Bc) > 0.01) ? (q.Bc - p.Bc) : (q.W - p.W); });
    return cands[0];
  }

  function _carportRoofComb(poly) {
    var s = SHELTER_SPECS.carport, pitch = s.pitchDeg * Math.PI / 180, eaveY = s.clearHeight + s.beam.h, ov = s.overhangM;
    function area(p){var a=0;for(var i=0;i<p.length;i++){var q=p[i],r=p[(i+1)%p.length];a+=q[0]*r[1]-r[0]*q[1];}return a/2;}
    function pin(x,z,pp){var c=false,N=pp.length;for(var i=0,j=N-1;i<N;j=i++){var A=pp[i],B=pp[j];if(((A[1]>z)!=(B[1]>z))&&(x<(B[0]-A[0])*(z-A[1])/(B[1]-A[1])+A[0]))c=!c;}return c;}
    function uniq(a){a=a.slice().sort(function(x,y){return x-y;});var u=[a[0]];for(var i=1;i<a.length;i++)if(a[i]-a[i-1]>1e-6)u.push(a[i]);return u;}
    function band(U,full){var bw=-1,ba=null,bb=null,ca=null;for(var i=0;i+1<U.length;i++){var mid=(U[i]+U[i+1])/2;if(full(mid)){if(ca===null)ca=U[i];}else{if(ca!==null){var w=U[i]-ca;if(w>bw){bw=w;ba=ca;bb=U[i];}ca=null;}}}if(ca!==null){var w2=U[U.length-1]-ca;if(w2>bw){bw=w2;ba=ca;bb=U[U.length-1];}}return bw<0?null:{a:ba,b:bb,w:bw};}
    var n = poly.length, th = _carportPrincipalAngle(poly), tol = 0.08;
    var lp = []; for (var i = 0; i < n; i++) { var q = _carportRotPt(poly[i][0], poly[i][1], -th); lp.push([q[0], q[1]]); }
    for (var e = 0; e < n; e++) { var P = lp[e], Q = lp[(e + 1) % n]; if (Math.abs(P[0] - Q[0]) > tol && Math.abs(P[1] - Q[1]) > tol) return null; }
    if (area(lp) < 0) lp.reverse();
    var xs = lp.map(function (p) { return p[0]; }), zs = lp.map(function (p) { return p[1]; });
    var xmin = Math.min.apply(0, xs), xmax = Math.max.apply(0, xs), zmin = Math.min.apply(0, zs), zmax = Math.max.apply(0, zs);
    var UX = uniq(xs), UZ = uniq(zs);
    function rowF(zc){for(var t=0;t<20;t++){var x=xmin+(xmax-xmin)*(t+0.5)/20;if(!pin(x,zc,lp))return false;}return true;}
    function colF(xc){for(var t=0;t<20;t++){var z=zmin+(zmax-zmin)*(t+0.5)/20;if(!pin(xc,z,lp))return false;}return true;}
    var hBand = band(UZ, rowF), vBand = band(UX, colF);
    if (!hBand && !vBand) return null;
    var hw = hBand ? hBand.w : -1, vw = vBand ? vBand.w : -1;
    var hBr = hBand && (hBand.w < (zmax - zmin) - tol), vBr = vBand && (vBand.w < (xmax - xmin) - tol);
    var swap;
    if (!hBr && !vBr) swap = ((xmax - xmin) >= (zmax - zmin)) ? false : true;
    else if (hBr && !vBr) swap = false;
    else if (vBr && !hBr) swap = true;
    else swap = (Math.abs(hw - vw) <= tol) ? (((xmax - xmin) >= (zmax - zmin)) ? false : true) : ((hw >= vw) ? false : true);
    var wp = lp.map(function (p) { return swap ? [p[1], p[0]] : [p[0], p[1]]; });
    if (area(wp) < 0) wp.reverse();
    var wxs = wp.map(function (p) { return p[0]; }), wzs = wp.map(function (p) { return p[1]; });
    var Wxmin = Math.min.apply(0, wxs), Wxmax = Math.max.apply(0, wxs), Wzmin = Math.min.apply(0, wzs), Wzmax = Math.max.apply(0, wzs);
    var WUX = uniq(wxs), WUZ = uniq(wzs);
    function wIn(x, z) { return pin(x, z, wp); }
    function wrowF(zc){for(var t=0;t<20;t++){var x=Wxmin+(Wxmax-Wxmin)*(t+0.5)/20;if(!pin(x,zc,wp))return false;}return true;}
    var mb = band(WUZ, wrowF); if (!mb) return null;
    var mz0 = mb.a, mz1 = mb.b, zm = (mz0 + mz1) / 2, halfMain = (mz1 - mz0) / 2;
    var H = (halfMain + ov) * Math.tan(pitch), yR = eaveY + H, X0 = Wxmin, X1 = Wxmax;
    function findBr(side) {
      var brs = [], ca = null;
      for (var i = 0; i + 1 < WUX.length; i++) { var xmid = (WUX[i] + WUX[i + 1]) / 2; var probe = side < 0 ? mz0 - 1e-3 : mz1 + 1e-3; if (wIn(xmid, probe)) { if (ca === null) ca = WUX[i]; } else { if (ca !== null) { brs.push([ca, WUX[i]]); ca = null; } } }
      if (ca !== null) brs.push([ca, WUX[WUX.length - 1]]);
      return brs.map(function (b) { var xmid = (b[0] + b[1]) / 2, far; if (side < 0) { far = mz0; for (var z = mz0; z > Wzmin - 1; z -= 0.05) { if (wIn(xmid, z - 1e-3)) far = z - 0.05; else break; } far = Math.max(far, Wzmin); } else { far = mz1; for (var z = mz1; z < Wzmax + 1; z += 0.05) { if (wIn(xmid, z + 1e-3)) far = z + 0.05; else break; } far = Math.min(far, Wzmax); } var best = far, bd = 1e9; WUZ.forEach(function (zz) { if (Math.abs(zz - far) < bd) { bd = Math.abs(zz - far); best = zz; } }); return { x0: b[0], x1: b[1], side: side, far: best }; });
    }
    var branches = findBr(-1).concat(findBr(1));
    var rateM = H / (halfMain + ov);
    function toW(x, z, y) { var lx = swap ? z : x, lz = swap ? x : z; var w = _carportRotPt(lx, lz, th); return [w[0], y, w[1]]; }
    var faces = [], beams = [];
    function FACE(pp) { faces.push(pp.map(function (p) { return toW(p[0], p[1], p[2]); })); }
    function BEAM(a, b, ridge) { beams.push({ a: toW(a[0], a[1], a[2]), b: toW(b[0], b[1], b[2]), ridge: !!ridge }); }
    var south = branches.filter(function (b) { return b.side < 0; }).sort(function (a, b) { return a.x0 - b.x0; });
    var north = branches.filter(function (b) { return b.side > 0; }).sort(function (a, b) { return a.x0 - b.x0; });
    BEAM([X0 - ov, zm, yR], [X1 + ov, zm, yR], true);
    (function () { var pts = []; pts.push([X0 - ov, zm, yR]); pts.push([X0 - ov, mz0 - ov, eaveY]); for (var i = 0; i < south.length; i++) { var b = south[i], xm = (b.x0 + b.x1) / 2; pts.push([b.x0 - ov, mz0 - ov, eaveY]); pts.push([xm, zm, yR]); pts.push([b.x1 + ov, mz0 - ov, eaveY]); } pts.push([X1 + ov, mz0 - ov, eaveY]); pts.push([X1 + ov, zm, yR]); FACE(pts); })();
    (function () { var pts = []; pts.push([X1 + ov, zm, yR]); pts.push([X1 + ov, mz1 + ov, eaveY]); for (var i = north.length - 1; i >= 0; i--) { var b = north[i], xm = (b.x0 + b.x1) / 2; pts.push([b.x1 + ov, mz1 + ov, eaveY]); pts.push([xm, zm, yR]); pts.push([b.x0 - ov, mz1 + ov, eaveY]); } pts.push([X0 - ov, mz1 + ov, eaveY]); pts.push([X0 - ov, zm, yR]); FACE(pts); })();
    branches.forEach(function (b) {
      var xm = (b.x0 + b.x1) / 2, hb = (b.x1 - b.x0) / 2, n_ = b.side > 0;
      var zEaveEdge = n_ ? mz1 + ov : mz0 - ov, zGable = n_ ? b.far + ov : b.far - ov;
      var wEave = b.x0 - ov, eEave = b.x1 + ov;
      var westInterior = (b.x0 > X0 + 1e-3), eastInterior = (b.x1 < X1 - 1e-3);
      BEAM([xm, zGable, yR], [xm, zm, yR], true);
      if (westInterior) BEAM([xm, zm, yR], [wEave, zEaveEdge, eaveY], true);
      if (eastInterior) BEAM([xm, zm, yR], [eEave, zEaveEdge, eaveY], true);
      FACE([[wEave, zGable, eaveY], [xm, zGable, yR], [xm, zm, yR], [wEave, zEaveEdge, eaveY]]);
      FACE([[eEave, zGable, eaveY], [xm, zGable, yR], [xm, zm, yR], [eEave, zEaveEdge, eaveY]]);
    });
    var hsp = s.rafter.spacing, nM = Math.max(1, Math.round((X1 - X0) / hsp));
    for (var i2 = 0; i2 <= nM; i2++) { var x = X0 + (X1 - X0) * i2 / nM; BEAM([x, mz0 - ov, eaveY], [x, zm, yR], false); BEAM([x, mz1 + ov, eaveY], [x, zm, yR], false); }
    branches.forEach(function (b) { var xm = (b.x0 + b.x1) / 2, n_ = b.side > 0; var zJ = zm, zG = (n_ ? b.far + ov : b.far - ov); var z0 = Math.min(zJ, zG), z1 = Math.max(zJ, zG); var nb = Math.max(1, Math.round((z1 - z0) / hsp)); var wEave = b.x0 - ov, eEave = b.x1 + ov; for (var i = 0; i <= nb; i++) { var z = z0 + (z1 - z0) * i / nb; BEAM([wEave, z, eaveY], [xm, z, yR], false); BEAM([eEave, z, eaveY], [xm, z, yR], false); } });
    var skin = [];
    for (var fi = 0; fi < faces.length; fi++) { var f = faces[fi]; var A = f[0], B = f[1], C = f[2]; var ux = B[0] - A[0], uy = B[1] - A[1], uz = B[2] - A[2], vx = C[0] - A[0], vy = C[1] - A[1], vz = C[2] - A[2]; var nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx, NL = Math.hypot(nx, ny, nz); nx /= NL; ny /= NL; nz /= NL; var ex = ux, ey = uy, ez = uz, EL = Math.hypot(ex, ey, ez); ex /= EL; ey /= EL; ez /= EL; var gx = ny * ez - nz * ey, gy = nz * ex - nx * ez, gz = nx * ey - ny * ex; var p2 = f.map(function (p) { return [(p[0] - A[0]) * ex + (p[1] - A[1]) * ey + (p[2] - A[2]) * ez, (p[0] - A[0]) * gx + (p[1] - A[1]) * gy + (p[2] - A[2]) * gz]; }); var idx = []; for (var k = 0; k < p2.length; k++) idx.push(k); var a2 = 0; for (var k2 = 0; k2 < p2.length; k2++) { var q1 = p2[k2], q2 = p2[(k2 + 1) % p2.length]; a2 += q1[0] * q2[1] - q2[0] * q1[1]; } if (a2 < 0) idx.reverse(); var guard = 0; while (idx.length > 3 && guard++ < 999) { var done = false; for (var ii = 0; ii < idx.length; ii++) { var i0 = idx[(ii + idx.length - 1) % idx.length], i1 = idx[ii], iq = idx[(ii + 1) % idx.length]; var ax = p2[i0][0], ay = p2[i0][1], bx = p2[i1][0], by = p2[i1][1], cx = p2[iq][0], cy = p2[iq][1]; var cr = (bx - ax) * (cy - ay) - (by - ay) * (cx - ax); if (cr <= 1e-9) continue; var ok = true; for (var jj = 0; jj < idx.length; jj++) { var ij = idx[jj]; if (ij === i0 || ij === i1 || ij === iq) continue; var px = p2[ij][0], py = p2[ij][1]; var d1 = (bx - ax) * (py - ay) - (by - ay) * (px - ax); var d2 = (cx - bx) * (py - by) - (cy - by) * (px - bx); var d3 = (ax - cx) * (py - cy) - (ay - cy) * (px - cx); if (d1 >= 0 && d2 >= 0 && d3 >= 0) { ok = false; break; } } if (!ok) continue; skin.push([f[i0], f[i1], f[iq]]); idx.splice(ii, 1); done = true; break; } if (!done) break; } if (idx.length === 3) skin.push([f[idx[0]], f[idx[1]], f[idx[2]]]); }
    return { skin: skin, beams: beams };
  }

  function _carportGeom() {
    var s    = SHELTER_SPECS.carport;
    var poly = getFootprintPolygon();
    var n = poly.length, perim = 0;
    for (var i = 0; i < n; i++) { var a = poly[i], b = poly[(i + 1) % n]; perim += Math.hypot(b[0] - a[0], b[1] - a[1]); }
    var eaveY = s.clearHeight + s.beam.h;
    var wings = [];
    try { wings = _carportWings(poly); } catch (e) { wings = []; }
    if (!wings || !wings.length) {
      var bb = _carportBBox(poly), ax = (bb.L >= bb.W);
      var half = (ax ? bb.W : bb.L) / 2 + s.overhangM;
      var pitch = s.pitchDeg * Math.PI / 180, rise = half * Math.tan(pitch);
      wings = [{
        ax: { x: ax ? bb.xMin : bb.cx, z: ax ? bb.cz : bb.zMin },
        bx: { x: ax ? bb.xMax : bb.cx, z: ax ? bb.cz : bb.zMax },
        dirU: { x: ax ? 1 : 0, z: ax ? 0 : 1 }, dirV: { x: ax ? 0 : 1, z: ax ? 1 : 0 },
        half: half, coreLen: (ax ? bb.L : bb.W), rise: rise, rafterSlope: Math.hypot(half, rise),
        eaveY: eaveY, ridgeY: eaveY + rise, overhang: s.overhangM,
        rafterPairs: Math.max(2, Math.ceil((ax ? bb.L : bb.W) / s.rafter.spacing) + 1),
        battenRuns:  Math.max(2, Math.ceil(Math.hypot(half, rise) / s.batten.spacing) + 1)
      }];
    }
    var ridgeLen = 0, roofArea = 0, rafterTotal = 0, battenTotal = 0, ridgeYmax = eaveY;
    for (var w = 0; w < wings.length; w++) {
      var wg = wings[w];
      ridgeLen    += wg.coreLen;
      roofArea    += 2 * (wg.coreLen + 2 * wg.overhang) * wg.rafterSlope;
      rafterTotal += wg.rafterPairs * 2 * wg.rafterSlope;
      battenTotal += wg.battenRuns * (wg.coreLen + 2 * wg.overhang);
      if (wg.ridgeY > ridgeYmax) ridgeYmax = wg.ridgeY;
    }
    return {
      s: s, poly: poly, corners: n, perim: perim, wings: wings,
      ridgeLen: ridgeLen, roofAreaM2: roofArea, rafterTotalLen: rafterTotal,
      battenTotalLen: battenTotal, eaveY: eaveY, ridgeY: ridgeYmax
    };
  }

  /* Shared Fink/fan truss descriptor in the truss plane (across p, height y).
     Used by both the 3D renderer and the BoQ so member lengths and plate
     counts never drift. Apex at p=0,y=ridgeY; eaves at p=±hWall,y=eaveY. */
  var CHORD_EAVE_CUT = 0.05;   /* trim rafter tails back from the gutter */

  function _finkTruss(hWall, eaveY, ridgeY, nPanel) {
    nPanel = Math.max(2, nPanel | 0);
    var rise = ridgeY - eaveY;
    function TCy(p) { return eaveY + (1 - Math.abs(p) / hWall) * rise; }
    var members = [], nodes = [];
    function M(p1, y1, p2, y2, kind) { members.push({ p1: p1, y1: y1, p2: p2, y2: y2, kind: kind }); }
    function N(p, y, dp, dy) {
      var L = Math.hypot(dp, dy) || 1;
      nodes.push({ p: p, y: y, dp: dp / L, dy: dy / L });
    }
    /* rafter (top-chord) unit direction at a node of given sign */
    function rdir(sign) { return { dp: -sign * hWall, dy: rise }; }

    /* chords — top-chord eave ends trimmed back along the rafter so the rafter
       tail does not reach into the gutter (CHORD_EAVE_CUT, tunable) */
    var _slopeLen = Math.hypot(hWall, rise) || 1;
    var _cut = (typeof CHORD_EAVE_CUT === 'number') ? CHORD_EAVE_CUT : 0;
    var _cdp = _cut * hWall / _slopeLen;      /* inboard p reduction */
    var _cdy = _cut * rise / _slopeLen;       /* lift in y */
    M(-(hWall - _cdp), eaveY + _cdy, 0, ridgeY, 'chord');   /* top chord left  */
    M( (hWall - _cdp), eaveY + _cdy, 0, ridgeY, 'chord');   /* top chord right */
    M(-hWall, eaveY, hWall, eaveY, 'tie');    /* bottom chord / tie (full span) */
    M(0, eaveY, 0, ridgeY, 'post');           /* king post */

    /* nodes (one gusset each): bottom-chord nodes lie along the tie (horizontal),
       apex + top-chord nodes lie along the rafter */
    N(-hWall, eaveY, 1, 0); N(hWall, eaveY, 1, 0); N(0, eaveY, 1, 0); N(0, ridgeY, 1, 0);

    for (var sgn = -1; sgn <= 1; sgn += 2) {
      for (var i = 1; i < nPanel; i++) {
        var p = sgn * (i / nPanel) * hWall;
        var ty = TCy(p);
        M(p, eaveY, p, ty, 'web');              /* vertical post up to top chord */
        M(p, eaveY, (i === 1 ? 0 : sgn * ((i - 1) / nPanel) * hWall), (i === 1 ? ridgeY : TCy(sgn * ((i - 1) / nPanel) * hWall)), 'web'); /* fan diagonal */
        N(p, eaveY, 1, 0);                       /* bottom node along tie */
        var rd = rdir(sgn);
        N(p, ty, rd.dp, rd.dy);                  /* top-chord node along rafter */
      }
    }
    function _k(p, y) { return Math.round(p * 1000) + ':' + Math.round(y * 1000); }
    var cnt = {};
    for (var mc = 0; mc < members.length; mc++) {
      var mk = members[mc];
      if (mk.kind === 'web' || mk.kind === 'post') {
        var k1 = _k(mk.p1, mk.y1), k2 = _k(mk.p2, mk.y2);
        cnt[k1] = (cnt[k1] || 0) + 1;
        cnt[k2] = (cnt[k2] || 0) + 1;
      }
    }
    for (var nc = 0; nc < nodes.length; nc++) {
      nodes[nc].multi = (cnt[_k(nodes[nc].p, nodes[nc].y)] || 0) >= 2;
      nodes[nc].heel = (Math.abs(Math.abs(nodes[nc].p) - hWall) < 1e-6) && (Math.abs(nodes[nc].y - eaveY) < 1e-6);
    }
    return { members: members, nodes: nodes, key: _k, conn: cnt };
  }

  var BRACKET_PROFILE = [[-0.17,0.11],[-0.0058,0.11],[-0.0026,0.0906],[-0.0022,0.0804],[-0.0007,0.0704],[0.002,0.0607],[0.0057,0.0513],[0.0105,0.0424],[0.0163,0.0341],[0.0229,0.0265],[0.0304,0.0197],[0.0386,0.0138],[0.0474,0.0089],[0.0567,0.005],[0.0664,0.0022],[0.0763,0.0005],[0.0864,-0.0001],[0.0965,0.0005],[0.1064,0.0022],[0.1161,0.005],[0.1254,0.0089],[0.1342,0.0138],[0.1424,0.0197],[0.1499,0.0265],[0.1565,0.0341],[0.1623,0.0424],[0.1671,0.0513],[0.1708,0.0607],[0.1735,0.0704],[0.175,0.0804],[0.1754,0.0906],[0.1794,0.0904],[0.179,0.08],[0.1774,0.0696],[0.1746,0.0594],[0.1707,0.0496],[0.1657,0.0403],[0.1597,0.0316],[0.1527,0.0237],[0.1449,0.0166],[0.1364,0.0105],[0.1272,0.0053],[0.1174,0.0012],[0.1073,-0.0017],[0.0969,-0.0035],[0.0864,-0.0041],[0.0759,-0.0035],[0.0655,-0.0017],[0.0554,0.0012],[0.0456,0.0053],[0.0364,0.0105],[0.0279,0.0166],[0.0201,0.0237],[0.0131,0.0316],[0.0071,0.0403],[0.0021,0.0496],[-0.0018,0.0594],[-0.0046,0.0696],[-0.0062,0.08],[-0.0066,0.0904],[-0.0062,0.106],[-0.17,0.106]];

  var GUTTER_PROFILE = [[0.003,0.078],[0.0038,0.0673],[0.006,0.0569],[0.0098,0.0468],[0.0149,0.0375],[0.0213,0.0289],[0.0289,0.0213],[0.0375,0.0149],[0.0468,0.0098],[0.0569,0.006],[0.0673,0.0038],[0.078,0.003],[0.0887,0.0038],[0.0991,0.006],[0.1092,0.0098],[0.1185,0.0149],[0.1271,0.0213],[0.1347,0.0289],[0.1411,0.0375],[0.1462,0.0468],[0.15,0.0569],[0.1522,0.0673],[0.153,0.078],[0.1531,0.0801],[0.1536,0.0822],[0.1543,0.0842],[0.1553,0.086],[0.1566,0.0877],[0.1581,0.0892],[0.1597,0.0905],[0.1616,0.0916],[0.1635,0.0923],[0.1656,0.0928],[0.1677,0.093],[0.1698,0.0929],[0.1719,0.0925],[0.1739,0.0918],[0.1758,0.0908],[0.1775,0.0896],[0.179,0.0882],[0.1804,0.0865],[0.1814,0.0847],[0.1822,0.0827],[0.1828,0.0807],[0.183,0.0786],[0.1829,0.0765],[0.1826,0.0744],[0.1819,0.0724],[0.181,0.0705],[0.1798,0.0687],[0.1784,0.0672],[0.1767,0.0658],[0.1749,0.0647],[0.173,0.0639],[0.172,0.0667],[0.1736,0.0674],[0.175,0.0683],[0.1763,0.0693],[0.1774,0.0706],[0.1784,0.072],[0.1791,0.0735],[0.1796,0.0751],[0.1799,0.0768],[0.18,0.0785],[0.1798,0.0801],[0.1794,0.0818],[0.1787,0.0834],[0.1779,0.0848],[0.1768,0.0861],[0.1756,0.0873],[0.1742,0.0883],[0.1727,0.089],[0.1711,0.0896],[0.1695,0.0899],[0.1678,0.09],[0.1661,0.0898],[0.1644,0.0895],[0.1629,0.0888],[0.1614,0.088],[0.16,0.087],[0.1589,0.0858],[0.1579,0.0844],[0.1571,0.0829],[0.1565,0.0813],[0.1561,0.0797],[0.156,0.078],[0.1552,0.0669],[0.1528,0.056],[0.149,0.0456],[0.1436,0.0358],[0.1369,0.0269],[0.1291,0.0191],[0.1202,0.0124],[0.1104,0.007],[0.1,0.0032],[0.0891,0.0008],[0.078,0],[0.0669,0.0008],[0.056,0.0032],[0.0456,0.007],[0.0358,0.0124],[0.0269,0.0191],[0.0191,0.0269],[0.0124,0.0358],[0.007,0.0456],[0.0032,0.056],[0.0008,0.0669],[0,0.078],[0,0.098],[0.003,0.098],[0.003,0.078]];

  var GABLE_PROFILE = [[0.0897,0.1023],[0.0897,0.0544],[0.0899,0.0525],[0.0905,0.0506],[0.0914,0.0489],[0.0927,0.0474],[0.0939,0.0462],[0.0951,0.0446],[0.0961,0.0429],[0.0966,0.041],[0.0968,0.0391],[0.0968,0.003],[0.0968,0.0028],[0.0968,0.0026],[0.0967,0.0025],[0.0966,0.0023],[0.0965,0.0022],[0.0963,0.0021],[0.0961,0.0021],[0.096,0.002],[0.0958,0.002],[0.0956,0.002],[0.0955,0.0021],[0.0953,0.0021],[0.0952,0.0023],[0.095,0.0024],[0.0949,0.0025],[0.0949,0.0027],[0.0948,0.0029],[0.0897,0.0406],[0.0878,0.0404],[0.0929,0.0026],[0.093,0.0021],[0.0932,0.0016],[0.0935,0.0011],[0.0938,0.0008],[0.0943,0.0004],[0.0947,0.0002],[0.0952,0.0001],[0.0958,0],[0.0963,0],[0.0968,0.0002],[0.0973,0.0004],[0.0977,0.0007],[0.0981,0.001],[0.0984,0.0015],[0.0986,0.002],[0.0988,0.0025],[0.0988,0.003],[0.0988,0.0391],[0.0986,0.0414],[0.0979,0.0437],[0.0968,0.0458],[0.0953,0.0476],[0.0941,0.0488],[0.0931,0.05],[0.0924,0.0514],[0.0919,0.0529],[0.0917,0.0544],[0.0917,0.1028],[0.0877,0.1099],[0.0595,0.1099],[0.057,0.1045],[0.0519,0.0629],[0.0517,0.0624],[0.0515,0.0619],[0.0512,0.0614],[0.0509,0.0611],[0.0504,0.0607],[0.0499,0.0605],[0.0494,0.0603],[0.0489,0.0603],[0,0.0603],[0,0.0583],[0.0489,0.0583],[0.0498,0.0584],[0.0507,0.0586],[0.0515,0.059],[0.0522,0.0596],[0.0528,0.0602],[0.0533,0.061],[0.0537,0.0618],[0.0538,0.0627],[0.0589,0.104],[0.0608,0.1079],[0.0865,0.1079],[0.0897,0.1023]];

  function _roofTypeForVariant() {
    switch (STATE.variant | 0) {
      case 2:  return 'valba';
      case 3:  return 'atika';
      case 4:  return 'pult';
      case 5:  return 'sedlo';
      default: return 'sedlo';
    }
  }

  function variantKey() {
    return ['slab', 'strip', 'piers', 'precast', 'screws'][STATE.variant - 1];
  }

  function computeBoQ_Slab() {
    var area  = computeArea();
    var perim = computePerimeter();
    var d = getVariantDefaults('slab', STATE.lvl);

    var slopeExtra = _avgSlopeExtraOverPolygon();
    var excavationM3   = area * (d.excavationDepthM + slopeExtra);
    var gravelM3       = area * d.gravelDepthM;
    var membraneM2     = area;
    var concreteM3     = area * d.slabThicknessM;
    var meshSheets     = distributeMeshSheets(d.meshSheetLM, d.meshSheetWM, d.meshOverlapM).length * (d.meshLayers || 1);
    var bitumenM2      = area * d.bitumenCoverage;
    var spacers        = Math.ceil(area * 4);
    var formworkLS     = 1;

    return [
      ['FEE00001', excavationM3,  excavationM3  * 1.30795],
      ['FFG00001', gravelM3,      gravelM3      * 1.30795],
      ['FFS00001', membraneM2,    membraneM2    * 10.7639],
      ['FFR30001', meshSheets,    meshSheets],
      ['FFM00001', concreteM3,    concreteM3    * 1.30795],
      ['FFM00004', spacers,       spacers],
      ['FFM00005', bitumenM2,     bitumenM2     * 10.7639],
      ['FFF00002', formworkLS,    formworkLS]
    ];
  }

  function computeBoQ_Strip() {
    var area  = computeArea();
    var perim = computePerimeter();
    var d = getVariantDefaults('strip', STATE.lvl);

    var poly = STATE.polygon;
    var stripPerEdgeSum = 0;
    if (poly && poly.length >= 3) {
      for (var pi = 0; pi < poly.length; pi++) {
        var a = poly[pi], b = poly[(pi + 1) % poly.length];
        var dx = b[0] - a[0], dz = b[1] - a[1];
        var edgeLen = Math.sqrt(dx * dx + dz * dz);
        var edgeMidX = (a[0] + b[0]) / 2;
        var edgeMidZ = (a[1] + b[1]) / 2;
        stripPerEdgeSum += edgeLen * _padSlopeExtra(edgeMidX, edgeMidZ);
      }
    }
    var slabSlopeExtra = _avgSlopeExtraOverPolygon();
    var stripExcavM3   = perim * d.stripExcavWidthM * d.stripDepthM + d.stripExcavWidthM * stripPerEdgeSum;
    var slabExcavM3    = area * (0.250 + slabSlopeExtra);
    var excavationM3   = stripExcavM3 + slabExcavM3;
    var gravelM3       = area * 0.100;

    var stripCourses   = Math.ceil(d.stripDepthM / d.hollowBlockH);
    var blocksPerLinM  = 1 / d.hollowBlockL;
    var hollowBlocks   = Math.ceil(perim * blocksPerLinM * stripCourses);

    var uBlocksPerLinM = 1 / d.uBlockL;
    var uBlocks        = Math.ceil(perim * uBlocksPerLinM);

    var blockFillM3    = perim * d.stripWidthM * d.stripDepthM * 0.6;
    var slabConcreteM3 = area * d.slabThicknessM;
    var concreteM3     = blockFillM3 + slabConcreteM3;

    var meshSheets     = distributeMeshSheets(d.meshSheetLM, d.meshSheetWM, d.meshOverlapM).length * (d.meshLayers || 1);

    var longitudinalLenM = perim * 4;
    var coverM = 0.050;
    var stirrupSpacing = 0.250;
    var stirrupPerimM  = 2 * ((d.stripWidthM - 2 * coverM) + (d.stripDepthM - 2 * coverM));
    var stirrupCount   = Math.ceil(perim / stirrupSpacing);
    var stirrupTotalM  = stirrupCount * stirrupPerimM;
    /* L-shaped corner anchor bars at each convex corner (4 anchors per
       corner: top-outer, top-inner, bot-outer, bot-inner), each anchor
       has 2 legs of length 1.5 × stripWidth. Matches the 3D model. */
    var convexCornerCount = 0;
    for (var ci = 0; ci < poly.length; ci++) {
      var pPrev = poly[(ci - 1 + poly.length) % poly.length];
      var pCur  = poly[ci];
      var pNext = poly[(ci + 1) % poly.length];
      var ix = pCur[0] - pPrev[0], iz = pCur[1] - pPrev[1];
      var ox = pNext[0] - pCur[0], oz = pNext[1] - pCur[1];
      var crossC = ix * oz - iz * ox;
      if (crossC > 0) convexCornerCount++;   /* CCW polygon → positive = convex */
    }
    var cornerAnchorsLenM = convexCornerCount * 4 * 2 * (d.stripWidthM * 0.85);
    var rebarLenM      = longitudinalLenM + stirrupTotalM + cornerAnchorsLenM;
    var rebarLenFt     = rebarLenM * 3.28084;

    var membraneM2     = area;
    var bitumenM2      = area * d.bitumenCoverage;
    var spacers        = Math.ceil(area * 4);
    var formworkLS     = 1;

    return [
      ['FEE00001', excavationM3,  excavationM3  * 1.30795],
      ['FFG00001', gravelM3,      gravelM3      * 1.30795],
      ['FFS00001', membraneM2,    membraneM2    * 10.7639],
      ['FFM00002', hollowBlocks,  hollowBlocks],
      ['FFM00003', uBlocks,       uBlocks],
      ['FCO00003', rebarLenM,     rebarLenFt],
      ['FFR30001', meshSheets,    meshSheets],
      ['FFM00001', concreteM3,    concreteM3    * 1.30795],
      ['FFM00004', spacers,       spacers],
      ['FFM00005', bitumenM2,     bitumenM2     * 10.7639],
      ['FFF00002', formworkLS,    formworkLS]
    ];
  }

  function _angDiff(a, b) {
    var d = a - b;
    while (d >  Math.PI) d -= 2 * Math.PI;
    while (d < -Math.PI) d += 2 * Math.PI;
    return d;
  }

  /* Beam "arms" radiating from a pier: distinct directions of beam
     material touching the pier. Straight pass-through = 2 (opposite),
     corner = 2 (perpendicular), T-joint = 3, cross = 4. One L-bracket
     is placed per arm. */
  function _armAnglesAtPier(px, pz, segs, beamW) {
    var arms = [];
    function addArm(a) {
      for (var k = 0; k < arms.length; k++) {
        if (Math.abs(_angDiff(arms[k], a)) < 0.20) return;
      }
      arms.push(a);
    }
    var tol = beamW * 1.5;
    for (var si = 0; si < segs.length; si++) {
      var s = segs[si];
      var ax = s.a[0], az = s.a[1], bx = s.b[0], bz = s.b[1];
      var ddx = bx - ax, ddz = bz - az;
      var L2 = ddx * ddx + ddz * ddz;
      if (L2 < 1e-9) continue;
      var t = ((px - ax) * ddx + (pz - az) * ddz) / L2;
      var tc = t < 0 ? 0 : t > 1 ? 1 : t;
      var qx = ax + tc * ddx, qz = az + tc * ddz;
      if (Math.hypot(px - qx, pz - qz) > tol) continue;
      var segAng = Math.atan2(ddz, ddx);
      var dA = Math.hypot(px - ax, pz - az);
      var dB = Math.hypot(px - bx, pz - bz);
      if (dA <= tol)      { addArm(segAng + Math.PI); }
      else if (dB <= tol) { addArm(segAng); }
      else                { addArm(segAng); addArm(segAng + Math.PI); }
    }
    return arms;
  }

  function _countPierArms(raster, beamW) {
    var segs = raster.rimJoist.concat(raster.beams);
    var total = 0;
    for (var i = 0; i < raster.piers.length; i++) {
      total += _armAnglesAtPier(raster.piers[i].x, raster.piers[i].z, segs, beamW).length;
    }
    return total;
  }

  /* Distinct beam axes at a pier (collinear arms = 1 axis). 1 axis = straight
     run / end (U saddle fits), 2+ axes = corner/T/cross (needs a flat cap so
     crossing beams don't hit upturned saddle plates). */
  function _pierAxisCount(px, pz, segs, beamW) {
    var arms = _armAnglesAtPier(px, pz, segs, beamW);
    var axes = [];
    for (var i = 0; i < arms.length; i++) {
      var found = false;
      for (var k = 0; k < axes.length; k++) {
        var dd = Math.abs(_angDiff(arms[i], axes[k]));
        if (dd < 0.20 || Math.abs(dd - Math.PI) < 0.20) { found = true; break; }
      }
      if (!found) axes.push(arms[i]);
    }
    return axes.length;
  }

  /* Shared builder: post-base anchors (U saddle on single-axis supports,
     flat post cap on corner/T/cross joints) + timber beam frame, sitting on
     top of any support type at p.baseTopY. Used by both the cast-pier and
     precast-block variants so the joint logic stays identical. */
  function _buildSupportsTopFrame(T, mats, eng, p) {
    var raster   = p.raster;
    var allSegs  = raster.rimJoist.concat(raster.beams);
    var beamW    = p.beamW, beamH = p.beamH;
    var padTopY  = p.baseTopY + p.basePlateT;
    var beamBottomY = padTopY + p.stemH + p.floorT;
    var beamY    = beamBottomY + beamH / 2;

    function steelMesh(geom, note, code) {
      var mat = mats.steel.clone();
      mat.transparent = false; mat.opacity = 1.0; mat.depthWrite = true;
      var mesh = new T.Mesh(geom, mat);
      mesh.userData = { assetType: 'post-base', boqCode: code, category: 'hardware', length: 1, note: note };
      return mesh;
    }
    function boltMesh(vertical, note) {
      var g = new T.CylinderGeometry(p.boltR, p.boltR, p.boltH, 10);
      if (!vertical) g.rotateX(Math.PI / 2);
      var mat = mats.screwHead.clone();
      mat.transparent = false; mat.opacity = 1.0; mat.depthWrite = true;
      var mesh = new T.Mesh(g, mat);
      mesh.userData = { assetType: 'post-base', boqCode: p.boltCode, category: 'hardware', length: 1, note: note };
      return mesh;
    }
    function dominantAngle(px, pz) {
      var arms = _armAnglesAtPier(px, pz, allSegs, beamW);
      if (!arms.length) return 0;
      for (var i = 0; i < arms.length; i++) {
        for (var j = i + 1; j < arms.length; j++) {
          if (Math.abs(Math.abs(_angDiff(arms[i], arms[j])) - Math.PI) < 0.3) return arms[i];
        }
      }
      return arms[0];
    }
    function addAnchor(px, pz) {
      var isCap = _pierAxisCount(px, pz, allSegs, beamW) >= 2;
      var code  = isCap ? p.capCode : p.anchorCode;
      var th  = dominantAngle(px, pz);
      var ux  = Math.cos(th), uz = Math.sin(th);
      var pxp = -uz, pzp = ux;
      var W = function (along, perp) {
        return { x: px + ux * along + pxp * perp, z: pz + uz * along + pzp * perp };
      };

      var base = steelMesh(new T.BoxGeometry(p.baseSide, p.basePlateT, p.baseSide), 'anchor-base', code);
      base.position.set(px, p.baseTopY + p.basePlateT / 2, pz);
      eng.sceneGroup.add(base);

      var stem = steelMesh(new T.CylinderGeometry(p.stemR, p.stemR, p.stemH, 12), 'anchor-stem', code);
      stem.position.set(px, padTopY + p.stemH / 2, pz);
      eng.sceneGroup.add(stem);

      if (!isCap) {
        var floor = steelMesh(new T.BoxGeometry(p.saddleL, p.floorT, beamW + 2 * p.plateT), 'anchor-floor', code);
        floor.position.set(px, beamBottomY - p.floorT / 2, pz);
        floor.rotation.y = -th;
        eng.sceneGroup.add(floor);

        for (var s = 0; s < 2; s++) {
          var sgn = s === 0 ? -1 : 1;
          var plate = steelMesh(new T.BoxGeometry(p.saddleL, p.saddleH, p.plateT), 'anchor-saddle', code);
          var pw = W(0, sgn * (beamW / 2 + p.plateT / 2));
          plate.position.set(pw.x, beamBottomY + p.saddleH / 2, pw.z);
          plate.rotation.y = -th;
          eng.sceneGroup.add(plate);

          var sbolt = boltMesh(false, 'anchor-saddle-bolt');
          var bw = W(0, sgn * (beamW / 2 + p.plateT + p.boltH / 2));
          sbolt.position.set(bw.x, beamBottomY + p.saddleH * 0.5, bw.z);
          sbolt.rotation.y = -th;
          eng.sceneGroup.add(sbolt);
        }
      } else {
        var cap = steelMesh(new T.BoxGeometry(p.baseSide, p.floorT, p.baseSide), 'anchor-cap', code);
        cap.position.set(px, beamBottomY - p.floorT / 2, pz);
        eng.sceneGroup.add(cap);

        var cbb = p.baseSide * 0.34;
        var capCorners = [[-cbb, cbb], [cbb, -cbb]];
        for (var cc = 0; cc < capCorners.length; cc++) {
          var cbolt = boltMesh(true, 'anchor-cap-bolt');
          cbolt.position.set(px + capCorners[cc][0], beamBottomY + p.boltH / 2, pz + capCorners[cc][1]);
          eng.sceneGroup.add(cbolt);
        }
      }

      var bb = p.baseSide * 0.32;
      var corners = [[-bb, -bb], [bb, -bb], [bb, bb], [-bb, bb]];
      for (var c = 0; c < corners.length; c++) {
        var bbolt = boltMesh(true, 'anchor-base-bolt');
        bbolt.position.set(px + corners[c][0], padTopY + p.boltH / 2, pz + corners[c][1]);
        eng.sceneGroup.add(bbolt);
      }
    }

    for (var i = 0; i < raster.piers.length; i++) {
      addAnchor(raster.piers[i].x, raster.piers[i].z);
    }

    /* timber frame (rim + interior joists), end-lapped for tight corners */
    var BEAM_OVERLAP = beamW;
    function addBeamMesh(ax, az, bx, bz, role) {
      var dx = bx - ax, dz = bz - az;
      var len = Math.hypot(dx, dz);
      if (len < 0.05) return;
      var renderLen = len + BEAM_OVERLAP;
      var cx = (ax + bx) / 2, cz = (az + bz) / 2;
      var ang = Math.atan2(dz, dx);
      var bmat = mats.timber.clone();
      bmat.transparent = false; bmat.opacity = 1.0; bmat.depthWrite = true;
      var bm = new T.Mesh(new T.BoxGeometry(renderLen, beamH, beamW), bmat);
      bm.position.set(cx, beamY, cz);
      bm.rotation.y = -ang;
      bm.userData = { assetType: 'timber-beam', boqCode: p.beamCode, category: 'timber', length: len, note: role };
      eng.sceneGroup.add(bm);
    }
    for (var ri = 0; ri < raster.rimJoist.length; ri++) {
      var rj = raster.rimJoist[ri];
      addBeamMesh(rj.a[0], rj.a[1], rj.b[0], rj.b[1], 'rim');
    }
    for (var bi = 0; bi < raster.beams.length; bi++) {
      var b2 = raster.beams[bi];
      addBeamMesh(b2.a[0], b2.a[1], b2.b[0], b2.b[1], 'joist');
    }
  }

  /* Shared BoQ rows for the timber rim/joist frame carried by piers, precast
     blocks and ground screws: post-base anchors (U saddle / flat cap), bolts,
     beam-to-beam carpentry fasteners, DPC pads between steel and timber, the
     timber itself and a protective impregnation coat. beamW/beamH drive the
     coated surface area; beamCode is the timber SKU. */
  function _timberFrameBoQ(raster, beamW, beamH, beamCode) {
    var supports = raster.piers.length;

    var timberLenM = 0;
    for (var ri = 0; ri < raster.rimJoist.length; ri++) {
      var rj = raster.rimJoist[ri];
      timberLenM += Math.hypot(rj.b[0] - rj.a[0], rj.b[1] - rj.a[1]);
    }
    for (var bi = 0; bi < raster.beams.length; bi++) {
      var bm = raster.beams[bi];
      timberLenM += Math.hypot(bm.b[0] - bm.a[0], bm.b[1] - bm.a[1]);
    }

    /* carpentry joints: one per rim corner lap + two per interior joist (both ends) */
    var jointCount = raster.rimJoist.length + raster.beams.length * 2;
    /* coated surface = all four exposed beam faces along the full timber run */
    var coatM2 = timberLenM * 2 * (beamW + beamH);

    var segsB = raster.rimJoist.concat(raster.beams);
    var nCap = 0;
    for (var pj = 0; pj < raster.piers.length; pj++) {
      if (_pierAxisCount(raster.piers[pj].x, raster.piers[pj].z, segsB, beamW) >= 2) nCap++;
    }
    var nSaddle = supports - nCap;
    var boltCount = 6 * supports;

    var rows = [];
    if (nSaddle > 0) rows.push([PIER_ANCHOR_CODE, nSaddle, nSaddle]);
    if (nCap > 0)    rows.push([PIER_CAP_CODE,    nCap,    nCap]);
    rows.push([PIER_BOLT_CODE,       boltCount,  boltCount]);
    rows.push([TIMBER_FASTENER_CODE, jointCount, jointCount]);
    rows.push([TIMBER_DPC_CODE,      supports,   supports]);
    rows.push([beamCode,             timberLenM, timberLenM * 3.28084]);
    rows.push([TIMBER_COAT_CODE,     coatM2,     coatM2 * 10.7639]);
    return rows;
  }

  function computeBoQ_Piers() {
    var perim = computePerimeter();
    var d = getVariantDefaults('piers', STATE.lvl);
    var poly = STATE.polygon;
    var raster = _computeTimberRaster(poly, 1.5);

    var pierCount      = raster.piers.length;
    var pierPositions  = raster.piers.map(function (p) { return { x: p.x, z: p.z }; });

    /* Timber beam length: rim + interior */
    var timberLenM = 0;
    for (var ri = 0; ri < raster.rimJoist.length; ri++) {
      var rj = raster.rimJoist[ri];
      timberLenM += Math.hypot(rj.b[0] - rj.a[0], rj.b[1] - rj.a[1]);
    }
    for (var bi = 0; bi < raster.beams.length; bi++) {
      var bm = raster.beams[bi];
      timberLenM += Math.hypot(bm.b[0] - bm.a[0], bm.b[1] - bm.a[1]);
    }

    var slopeExtraSum  = _sumPadSlopeExtras(pierPositions);
    var pierFootprint  = d.pierSideM * d.pierSideM;
    var gravelSide     = d.pierSideM;             /* gravel bed flush with the footing */
    var gravelFootprint = gravelSide * gravelSide;
    var concreteM3     = pierCount * pierFootprint * d.pierDepthM + pierFootprint * slopeExtraSum;
    var gravelM3       = pierCount * gravelFootprint * d.gravelLayerM;
    var excavationM3   = (pierCount * pierFootprint * (d.pierDepthM + d.gravelLayerM) + pierFootprint * slopeExtraSum) * 1.3;
    var rebarM         = pierCount * d.rebarPerPierM;
    var anchorRodM     = pierCount * d.anchorRodLenM;
    var mortarM3       = pierCount * d.mortarPerPierM3;
    var uAnchors       = pierCount;
    var hAnchors       = 0;
    var formworkLS     = 1;
    var beamCode       = d.beamProfileCode || 'KVH10060';

    var anchorBoltCount = 6 * pierCount;         /* 4 base bolts + 2 saddle/cap bolts per pier */

    var rows = [
      ['FEE00001', excavationM3,  excavationM3  * 1.30795],
      ['FFG00001', gravelM3,      gravelM3      * 1.30795],
      ['FCO00002', concreteM3,    concreteM3    * 1.30795],
      ['FCO00003', rebarM,        rebarM        * 3.28084],
      ['FCO00004', uAnchors,      uAnchors],
      ['FCO00005', anchorRodM,    anchorRodM    * 3.28084],
      ['FCO00006', mortarM3,      mortarM3      * 1.30795],
      ['FCO00007', formworkLS,    formworkLS]
    ];
    return rows.concat(_timberFrameBoQ(raster, d.beamWidthM || 0.060, d.beamHeightM || 0.100, beamCode));
  }

  function computeBoQ_Screws() {
    var d = getVariantDefaults('screws', STATE.lvl);
    var raster = _computeTimberRaster(STATE.polygon, d.screwSpacingM);
    var screwCount = raster.piers.length;

    var rows = [
      ['FGR00001', screwCount, screwCount]
    ];
    return rows.concat(_timberFrameBoQ(raster, 0.080, 0.160, 'KVH16080'));
  }

  function computeBoQ_Precast() {
    var d = getVariantDefaults('precast', STATE.lvl);
    var raster = _computeTimberRaster(STATE.polygon, d.blockSpacingM);
    var blockCount = raster.piers.length;
    var positions = raster.piers.map(function (p) { return { x: p.x, z: p.z }; });

    var slopeExtraSum   = _sumPadSlopeExtras(positions);
    var blockFootprintM2 = d.blockBaseM * d.blockBaseM;
    var footprintM2     = blockCount * blockFootprintM2;
    var excavationM3    = (footprintM2 * d.excavationDepthM + blockFootprintM2 * slopeExtraSum) * 1.3;
    var gravelM3        = footprintM2 * (d.gravelLayerM + d.gravelExtraM);

    var rows = [
      ['FEE00001', excavationM3, excavationM3 * 1.30795],
      ['FFG00001', gravelM3,     gravelM3     * 1.30795],
      ['FCO00008', blockCount,   blockCount]
    ];
    return rows.concat(_timberFrameBoQ(raster, 0.080, 0.160, 'KVH16080'));
  }

  function _roofTrussShapeOK() {
    var poly = STATE.polygon;
    if (!poly || poly.length < 3) return false;
    if (_roofTypeForVariant() !== 'sedlo') return false;
    return !_carportLParams(poly) && !_carportUParams(poly) && !_carportTeeParams(poly) && !_carportHParams(poly);
  }

  function computeBoQ_RoofTruss() {
    var poly = STATE.polygon;
    var spec = SHELTER_SPECS.carport;
    spec.pitchDeg    = (typeof STATE.roofPitchDeg === 'number' && STATE.roofPitchDeg > 0) ? STATE.roofPitchDeg : 22;
    spec.overhangM   = (typeof STATE.roofOverhangM === 'number') ? STATE.roofOverhangM : 0.30;
    spec.clearHeight = (typeof STATE.roofWallH === 'number' && STATE.roofWallH > 0) ? STATE.roofWallH : 2.40;
    var ts = spec.truss;
    ts.spacing = (typeof STATE.trussSpacingM === 'number' && STATE.trussSpacingM > 0) ? STATE.trussSpacingM : 0.80;
    ts.panels  = (typeof STATE.trussPanels === 'number' && STATE.trussPanels >= 2) ? (STATE.trussPanels | 0) : 3;

    var wings = _carportWings(poly);
    var spec2 = spec;
    var BT2 = spec2.batten || { spacing: 0.35, code: 'KVR50031' };
    var chordLen = 0, webLen = 0, battenLen = 0, gutterLen = 0, rakeFlashLen = 0, plateCount = 0, skinAreaM2 = 0;
    var bracketCount = 0, endCapCount = 0;

    for (var wi = 0; wi < wings.length; wi++) {
      var wg = wings[wi];
      var hWall = wg.half, eY = wg.eaveY, rY = wg.ridgeY, L = wg.coreLen, ov = wg.overhang;
      var nT = Math.max(2, Math.ceil(L / ts.spacing) + 1);
      var tr = _finkTruss(hWall, eY, rY, ts.panels);

      var chordOne = 0, webOne = 0;
      for (var mi = 0; mi < tr.members.length; mi++) {
        var m = tr.members[mi];
        var Lm = Math.hypot(m.p2 - m.p1, m.y2 - m.y1);
        if (m.kind === 'chord' || m.kind === 'tie') chordOne += Lm; else webOne += Lm;
      }
      var multiNodes = 0, singleEnds = 0, heelNodes = 0, mi2;
      for (mi2 = 0; mi2 < tr.nodes.length; mi2++) {
        if (tr.nodes[mi2].multi) multiNodes++;
        else if (tr.nodes[mi2].heel) heelNodes++;
      }
      for (mi2 = 0; mi2 < tr.members.length; mi2++) {
        var mw2 = tr.members[mi2];
        if (mw2.kind !== 'web' && mw2.kind !== 'post') continue;
        if ((tr.conn[tr.key(mw2.p1, mw2.y1)] || 0) < 2) singleEnds++;
        if ((tr.conn[tr.key(mw2.p2, mw2.y2)] || 0) < 2) singleEnds++;
      }
      chordLen   += nT * chordOne;
      webLen     += nT * webOne;
      plateCount += nT * (multiNodes + singleEnds + heelNodes) * 2;   /* front + back */
      /* battens: (2*nB + 1) length-wise runs over both slopes */
      var slopeLen2 = Math.hypot(wg.half, rY - eY) || 1;
      var nB2 = Math.max(2, Math.ceil(slopeLen2 / BT2.spacing));
      battenLen += (2 * nB2 + 1) * (L + 2 * ov);
      /* eave gutter (2 long runs) */
      gutterLen    += 2 * (L + 2 * ov);
      /* gable flashing: 4 rake runs */
      rakeFlashLen += 4 * Math.hypot(wg.half, rY - eY);
      /* gutter system per eave run (2 runs): one bracket per truss */
      var sp = (spec.truss && spec.truss.spacing) || 0.61;
      var nTbq = Math.max(2, Math.ceil(L / sp) + 1);
      bracketCount += 2 * nTbq;                      /* one per truss x 2 eaves */
      endCapCount  += 2 * 2;                        /* 2 ends x 2 runs */
      /* two roof planes, each (coreLen+2ov) x rafterSlope */
      skinAreaM2 += 2 * (L + 2 * ov) * wg.rafterSlope;
    }

    var chordRound  = Math.round(chordLen * 10) / 10;
    var webRound    = Math.round(webLen * 10) / 10;
    var battenRound    = Math.round(battenLen * 10) / 10;
    var gutterRound    = Math.round(gutterLen * 10) / 10;
    var rakeFlashRound = Math.round(rakeFlashLen * 10) / 10;
    var skinRound      = Math.round(skinAreaM2 * 10) / 10;

    return [
      [ts.chord.code || 'KVH60160', chordRound,     Math.round(chordRound * 1.10 * 10) / 10],
      [ts.web.code   || 'KVH60120', webRound,       Math.round(webRound * 1.10 * 10) / 10],
      [BT2.code      || 'KVR50031', battenRound,    Math.round(battenRound * 1.10 * 10) / 10],
      ['ROG01251',                  gutterRound,    Math.round(gutterRound * 1.05 * 10) / 10],
      ['ROA01251',                  bracketCount,   bracketCount],
      ['ROG00001',                  endCapCount,    endCapCount],
      ['ROD06030',                  rakeFlashRound, Math.round(rakeFlashRound * 1.05 * 10) / 10],
      [ts.plate.code || 'FSP00001', plateCount,     plateCount],
      ['ROR00001',                  skinRound,      Math.round(skinRound * 1.10 * 10) / 10]
    ];
  }

  function computeBoQ() {
    if (STATE.variant === 1 && STATE.roofStructure === 'truss' && _roofTrussShapeOK()) {
      return computeBoQ_RoofTruss();
    }
    switch (STATE.variant) {
      case 1: return computeBoQ_Slab();
      case 2: return computeBoQ_Strip();
      case 3: return computeBoQ_Piers();
      case 4: return computeBoQ_Precast();
      case 5: return computeBoQ_Screws();
      default: return [];
    }
  }

  var _publishTimer = null;
  function publishBoQToBudget() {
    var rows = computeBoQ();
    var variantData = [[], []];
    for (var i = 0; i < rows.length; i++) {
      variantData.push(rows[i]);
    }
    global.ConfiguratorBoQ = {
      source: 'roof',
      variantData: variantData
    };
    if (typeof global.loadVariantCSV === 'function') global.loadVariantCSV();
  }

  function _debouncedPublishBoQ() {
    if (_publishTimer) clearTimeout(_publishTimer);
    _publishTimer = setTimeout(publishBoQToBudget, 400);
  }

  function getCountForInfoBar() {
    if (STATE.variant === 3) {
      return _computeTimberRaster(STATE.polygon, 1.5).piers.length;
    }
    if (STATE.variant === 4) {
      return _computeTimberRaster(STATE.polygon, getVariantDefaults('precast', STATE.lvl).blockSpacingM).piers.length;
    }
    if (STATE.variant === 5) {
      return _computeTimberRaster(STATE.polygon, getVariantDefaults('screws', STATE.lvl).screwSpacingM).piers.length;
    }
    return null;
  }

  function getCountLabel() {
    var boot = global.BASE_BOOT || {};
    var i18n = boot.i18n || {};
    if (STATE.variant === 3) return i18n.base_count_piers   || 'Pads';
    if (STATE.variant === 4) return i18n.base_count_precast || 'Precast pads';
    if (STATE.variant === 5) return i18n.base_count_screws  || 'Screws';
    return '';
  }

  function refreshInfoBar() {
    var area  = computeArea();
    var perim = computePerimeter();
    var count = getCountForInfoBar();
    var bb    = getBBox();

    var elL = document.getElementById('cf-stat-l');
    var elW = document.getElementById('cf-stat-w');
    var elU = document.getElementById('cf-stat-unit');
    if (elL) elL.textContent = fmtDim(bb.L);
    if (elW) elW.textContent = fmtDim(bb.W);
    /* fmtDim already carries the unit ("mm" or '"') — leave the
       separate unit label empty to avoid double-printing ("3 700 mm m"). */
    if (elU) elU.textContent = '';

    var elA = document.getElementById('cf-stat-area');
    var elP = document.getElementById('cf-stat-perim');
    var elC = document.getElementById('cf-stat-count');
    var elAu = document.getElementById('cf-stat-area-unit');
    var elPu = document.getElementById('cf-stat-perim-unit');
    var elCl = document.getElementById('cf-stat-count-label');
    var elCi = document.getElementById('cf-stat-count-item');

    if (elA)  elA.textContent  = STATE.isMetric ? area.toFixed(2) : (area * 10.7639).toFixed(2);
    if (elP)  elP.textContent  = fmtLen(perim);
    if (elAu) elAu.textContent = STATE.isMetric ? 'm²' : 'ft²';
    if (elPu) elPu.textContent = unitLabel();

    if (elCi) {
      if (count == null) {
        elCi.style.display = 'none';      /* collapse — no leftover gap */
        _setSepVisible(elCi, false);
      } else {
        elCi.style.display = '';
        _setSepVisible(elCi, true);
        if (elC)  elC.textContent  = String(count);
        if (elCl) elCl.textContent = getCountLabel();
      }
    }
  }

  /* Show/hide a separator sitting directly next to an info-bar cell, so a
     collapsed (empty) cell does not leave its divider dangling. */
  function _setSepVisible(cell, vis) {
    if (!cell) return;
    var sibs = [cell.previousElementSibling, cell.nextElementSibling];
    for (var i = 0; i < sibs.length; i++) {
      var s = sibs[i];
      if (!s) continue;
      var cls = s.className || '';
      var sid = s.id || '';
      if (/sep/i.test(cls) || /sep/i.test(sid)) s.style.display = vis ? '' : 'none';
    }
  }

  function refreshUI(skipPublish) {
    refreshInfoBar();
    if (global.BaseRenderer && typeof global.BaseRenderer.build === 'function') {
      global.BaseRenderer.build();
    }
    if (typeof _applyAssemblyStep === 'function') _applyAssemblyStep();
    positionDragHandles();
    if (_VisualizationManager && _VisualizationManager.refreshDimensions) _VisualizationManager.refreshDimensions();
    if (!skipPublish) _debouncedPublishBoQ();
    if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
  }

  var _UndoHistory = {
    _stack: [],
    _MAX:   50,

    push: function () {
      var snap = {
        polygon: JSON.parse(JSON.stringify(STATE.polygon)),
        variant: STATE.variant
      };
      this._stack.push(snap);
      if (this._stack.length > this._MAX) this._stack.shift();
      this._updateButton();
    },

    pop: function () {
      if (!this._stack.length) return null;
      var snap = this._stack.pop();
      this._updateButton();
      return snap;
    },

    canUndo: function () {
      return this._stack.length > 0;
    },

    pushIfChanged: function (prevPolygon, prevVariant) {
      var sameVariant = (prevVariant === STATE.variant);
      var samePoly = JSON.stringify(prevPolygon) === JSON.stringify(STATE.polygon);
      if (sameVariant && samePoly) return;
      var snap = {
        polygon: JSON.parse(JSON.stringify(prevPolygon)),
        variant: prevVariant
      };
      this._stack.push(snap);
      if (this._stack.length > this._MAX) this._stack.shift();
      this._updateButton();
    },

    clear: function () {
      this._stack = [];
      this._updateButton();
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-undo');
      if (!btn) return;
      var enabled = this.canUndo();
      btn.disabled = !enabled;
      btn.style.opacity = enabled ? '' : '0.4';
      btn.style.cursor  = enabled ? 'pointer' : 'not-allowed';
    }
  };

  function undo() {
    var snap = _UndoHistory.pop();
    if (!snap) return;
    STATE.polygon = snap.polygon;
    if (typeof snap.variant === 'number') STATE.variant = snap.variant;
    if (typeof snap.lvl === 'number') STATE.lvl = snap.lvl;
    rebuildDragHandles();
    _updateLvlButton();
    selectVariant(STATE.variant, true);
    refreshUI();
  }

  function reset() {
    var prevPoly = JSON.parse(JSON.stringify(STATE.polygon));
    var prevVariant = STATE.variant;
    var prevLvl = STATE.lvl;
    var fresh = JSON.parse(JSON.stringify(DEFAULTS));
    for (var k in fresh) {
      if (fresh.hasOwnProperty(k)) STATE[k] = fresh[k];
    }
    _UndoHistory._stack.push({
      polygon: prevPoly, variant: prevVariant, lvl: prevLvl
    });
    _UndoHistory._updateButton();
    _updateLvlButton();
    rebuildDragHandles();
    selectVariant(STATE.variant);
    refreshUI();
  }

  function resetShapeToRect() {
    var samePoly = JSON.stringify(STATE.polygon) === JSON.stringify(DEFAULT_POLYGON);
    if (samePoly) return;
    _UndoHistory._stack.push({
      polygon: JSON.parse(JSON.stringify(STATE.polygon)),
      variant: STATE.variant,
      lvl: STATE.lvl
    });
    if (_UndoHistory._stack.length > _UndoHistory._MAX) _UndoHistory._stack.shift();
    _UndoHistory._updateButton();
    STATE.polygon = JSON.parse(JSON.stringify(DEFAULT_POLYGON));
    rebuildDragHandles();
    selectVariant(STATE.variant, true);
    refreshUI();
  }

  function cycleLvl() {
    _UndoHistory._stack.push({
      polygon: JSON.parse(JSON.stringify(STATE.polygon)),
      variant: STATE.variant,
      lvl: STATE.lvl
    });
    _UndoHistory._updateButton();
    STATE.lvl = (STATE.lvl >= 3) ? 1 : (STATE.lvl + 1);
    _updateLvlButton();
    _showLvlAvatar();
    refreshUI();
  }

  function _showLvlAvatar() {
    var img = document.getElementById('cf-lvl-avatar');
    if (!img) return;
    var boot = global.BASE_BOOT || {};
    var url = boot.lvlAvatars && boot.lvlAvatars[STATE.lvl];
    if (!url) return;
    img.classList.remove('cf-lvl-avatar-show');
    img.style.display = 'none';
    if (img.src !== url) {
      img.src = url;
    }
    void img.offsetWidth;
    img.style.display = '';
    img.classList.add('cf-lvl-avatar-show');
  }

  function _preloadLvlAvatars() {
    var boot = global.BASE_BOOT || {};
    var avatars = boot.lvlAvatars || {};
    for (var k in avatars) {
      if (avatars.hasOwnProperty(k)) {
        var preImg = new Image();
        preImg.src = avatars[k];
      }
    }
  }

  function _updateLvlButton() {
    var btn = document.getElementById('cf-btn-lvl');
    if (!btn) return;
    btn.classList.toggle('active', STATE.lvl !== 1);
    btn.setAttribute('data-lvl', String(STATE.lvl));
    btn.setAttribute('aria-pressed', STATE.lvl !== 1 ? 'true' : 'false');
    var needle = document.getElementById('cf-lvl-needle');
    if (needle) {
      var deg = (STATE.lvl === 1) ? -60 : (STATE.lvl === 2) ? 0 : 60;
      needle.style.transform = 'rotate(' + deg + 'deg)';
    }
  }

  var ASSEMBLY_STEPS = {
    slab:    { 0: ['gravel','slab','mesh'], 1: ['gravel'], 2: ['gravel','slab','mesh'] },
    strip:   { 0: ['strip','slab','rebar','mesh'], 1: ['strip','rebar'], 2: ['strip','slab','rebar','mesh'] },
    piers:   { 0: ['gravel','pier','post-base','timber-beam'], 1: ['gravel'], 2: ['gravel','pier','post-base','timber-beam'] },
    precast: { 0: ['gravel','precast','post-base','timber-beam'], 1: ['gravel'], 2: ['gravel','precast','post-base','timber-beam'] },
    screws:  { 0: ['screw','screw-head','post-base','timber-beam'], 1: ['screw'], 2: ['screw','screw-head','post-base','timber-beam'] }
  };

  var ASSEMBLY_STEP_LABELS = {
    slab:    { 0: '__HINT__', 1: 'FFG00001', 2: 'FFM00001' },
    strip:   { 0: '__HINT__', 1: 'FFM00002', 2: 'FFM00001' },
    piers:   { 0: '__HINT__', 1: 'FFG00001', 2: 'PWC00001' },
    precast: { 0: '__HINT__', 1: 'FFG00001', 2: 'FCO00008' },
    screws:  { 0: '__HINT__', 1: 'FGR00001', 2: 'FGR00001' }
  };

  var ASSEMBLY_FALLBACK_NAMES = {
    FFG00001: 'Gravel base',
    FFM00001: 'Reinforced concrete slab',
    FFM00002: 'Hollow concrete blocks',
    FCO00001: 'Gravel pad',
    PWC00001: 'Cast concrete pier',
    FCO00008: 'Precast pier block',
    FGR00001: 'Ground screw'
  };

  function _currentVariantKey() {
    return ['slab','strip','piers','precast','screws'][STATE.variant - 1] || 'slab';
  }

  function cycleAssembly() {
    STATE.assemblyStep = (STATE.assemblyStep + 1) % 3;
    _updateAssemblyButton();
    _applyAssemblyStep();
  }

  function _applyAssemblyStep() {
    var eng = global.BaseEngine;
    if (!eng || !eng.sceneGroup) return;
    var vk = _currentVariantKey();
    var map = ASSEMBLY_STEPS[vk] || {};
    var allowedArr = map[STATE.assemblyStep] || map[0] || [];
    var allowed = {};
    for (var i = 0; i < allowedArr.length; i++) allowed[allowedArr[i]] = true;

    var SLOPE_TYPES = { 'excavation-box': true, 'slope-terrain': true, 'slope-box': true };

    eng.sceneGroup.traverse(function (node) {
      var ud = node.userData || {};
      var t = ud.assetType;
      if (!t) return;
      if (SLOPE_TYPES[t]) return;
      /* Section-cut helper geometry (outline lines) is owned by
         SectionCutManager — leave it alone here so the viz-stage
         logic can manage its own visibility. */
      if (t === 'section-cut-aux') return;
      var topLevel = node;
      while (topLevel.parent && topLevel.parent !== eng.sceneGroup) topLevel = topLevel.parent;
      var shouldShow = !!allowed[t];
      if (node === topLevel || node.parent === eng.sceneGroup) {
        node.visible = shouldShow;
      }
    });
  }

  function _updateAssemblyButton() {
    var btn = document.getElementById('cf-btn-assembly');
    if (!btn) return;
    var lbl = document.getElementById('cf-stat-assembly');
    if (lbl) lbl.textContent = STATE.assemblyStep + '/2';
    btn.classList.toggle('active', STATE.assemblyStep !== 0);
    btn.setAttribute('aria-pressed', STATE.assemblyStep !== 0 ? 'true' : 'false');

    var vk = _currentVariantKey();
    var labelMap = ASSEMBLY_STEP_LABELS[vk] || {};
    var code = labelMap[STATE.assemblyStep];
    btn.setAttribute('data-tooltip-style', 'hint');
    if (!code) {
      btn.removeAttribute('title');
      return;
    }
    if (code === '__HINT__') {
      var boot = global.BASE_BOOT || {};
      var T2 = (boot.i18n) || {};
      btn.title = T2.assemblyStepsHint || 'Assembly steps';
      return;
    }
    var name = ASSEMBLY_FALLBACK_NAMES[code] || code;
    var bridge = global.ConfiguratorBudgetBridge || null;
    if (bridge && bridge.getBoqItem && code) {
      var item = bridge.getBoqItem(code);
      if (item && item.name && String(item.name).trim()) {
        name = String(item.name).trim();
      }
    }
    if (!name) name = code;
    btn.title = name;
  }

  var _SlopeManager = {
    init: function () {
      var btn = document.getElementById('cf-btn-slope');
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function () { self.toggle(); });
      this._wireSlider();
      this._injectArrow();
      this._updateAll();
    },

    _wireSlider: function () {
      var slider = document.getElementById('cf-slope-slider');
      if (!slider) return;
      var maxV = parseInt(slider.max, 10) || 15;
      var self = this;
      var updateFill = function (val) {
        var fillPct = 100 - (val / maxV) * 100;
        slider.style.setProperty('--cfg-fill', fillPct + '%');
      };
      var onChange = function () {
        var v = parseInt(slider.value, 10) || 0;
        STATE.slopeDeg = v;
        updateFill(v);
        var lbl = document.getElementById('cf-slope-value');
        if (lbl) lbl.textContent = v + '\u00b0';
        self._updateArrow();
        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
        refreshUI();
      };
      slider.addEventListener('input',  onChange);
      slider.addEventListener('change', onChange);
      slider.value = STATE.slopeDeg;
      updateFill(STATE.slopeDeg);
      var lbl = document.getElementById('cf-slope-value');
      if (lbl) lbl.textContent = STATE.slopeDeg + '\u00b0';
    },

    _injectArrow: function () {
      if (document.getElementById('cf-slope-arrow')) return;
      var wrap = document.getElementById('cf-wrap-base');
      if (!wrap) return;
      var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
      var slopeLabel = TT.slopeArrowLabel || 'SLOPE';
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.id = 'cf-slope-arrow';
      svg.setAttribute('viewBox', '0 0 100 36');
      svg.style.cssText = [
        'position:absolute', 'left:15%', 'top:50%',
        'transform:translate(-50%, -50%)',
        'width:100px', 'height:36px',
        'pointer-events:none', 'display:none', 'z-index:9'
      ].join(';');
      svg.innerHTML = [
        '<line x1="6" y1="18" x2="86" y2="18" stroke="#D2A878" stroke-width="2.5" stroke-linecap="round"/>',
        '<polyline points="78,10 90,18 78,26" fill="none" stroke="#D2A878" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>',
        '<text x="48" y="34" text-anchor="middle" font-family="Montserrat, system-ui, sans-serif" font-size="9" font-weight="700" fill="#D2A878" id="cf-slope-arrow-label">' + slopeLabel + '</text>'
      ].join('');
      wrap.appendChild(svg);
    },

    _updateArrow: function () {
      var svg = document.getElementById('cf-slope-arrow');
      if (!svg) return;
      var visible = STATE.slopeActive && STATE.view === '2d';
      svg.style.display = visible ? 'block' : 'none';
      var lbl = document.getElementById('cf-slope-arrow-label');
      if (lbl) {
        var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
        lbl.textContent = TT.slopeArrowLabel || 'SLOPE';
      }
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-slope');
      if (!btn) return;
      btn.classList.toggle('active', STATE.slopeActive);
      btn.setAttribute('aria-pressed', STATE.slopeActive ? 'true' : 'false');
    },

    _updateSlider: function () {
      var wrap = document.getElementById('cf-slope-slider-wrap');
      if (!wrap) return;
      var visible = STATE.slopeActive && STATE.view === '2d' && STATE.vizStage !== 1;
      wrap.classList.toggle('cf-slope-visible', visible);
    },

    _updateAll: function () {
      this._updateButton();
      this._updateSlider();
      this._updateArrow();
    },

    toggle: function () {
      STATE.slopeActive = !STATE.slopeActive;
      if (STATE.slopeActive && STATE.view !== '2d') {
        if (global.BaseEngine && global.BaseEngine.toggleView) {
          global.BaseEngine.toggleView();
        }
      }
      this._updateAll();
      if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      refreshUI();
    }
  };

  function _updateMapLockButton() {
    _applyMapLockState();
    var btn = document.getElementById('cf-map-lock');
    if (!btn) return;
    btn.classList.toggle('locked', !!STATE.mapLocked);
    btn.setAttribute('aria-pressed', STATE.mapLocked ? 'true' : 'false');
    btn.title = STATE.mapLocked ? 'Unlock map position' : 'Lock map position';
    var shackle = document.getElementById('cf-map-lock-shackle');
    if (shackle) {
      shackle.setAttribute('d', STATE.mapLocked
        ? 'M8 11V7a4 4 0 0 1 8 0v4'
        : 'M8 11V7a4 4 0 0 1 7-2.65');
    }
    _applyMapLockState();
  }

  function _applyMapLockState() {
    if (!_MapManager || !_MapManager.map) return;
    var m = _MapManager.map;
    /* a layout locked to the house must not be moved/rotated in the config */
    var locked = !!STATE.dispoLocked;
    try {
      if (locked) {
        m.dragPan.disable();
        m.scrollZoom.disable();
        m.boxZoom.disable();
        m.dragRotate.disable();
        m.doubleClickZoom.disable();
        m.touchZoomRotate.disable();
      } else {
        m.dragPan.enable();
        m.scrollZoom.enable();
        m.boxZoom.enable();
        m.dragRotate.enable();
        m.doubleClickZoom.enable();
        m.touchZoomRotate.enable();
      }
      /* hard guarantee: kill pointer-events on the map when locked so no
         touch/drag reaches it regardless of which handlers are enabled */
      try {
        var cont = m.getContainer && m.getContainer();
        if (cont) cont.style.pointerEvents = locked ? 'none' : '';
      } catch (e2) {}
    } catch (e) {}
    var rotateInput = document.getElementById('cf-map-rotate');
    if (rotateInput) {
      rotateInput.disabled = locked;
      rotateInput.style.opacity = locked ? '0.4' : '';
      rotateInput.style.pointerEvents = locked ? 'none' : '';
    }
  }

  function _slopeExcavationFactor() {
    if (!STATE.slopeActive || STATE.slopeDeg <= 0) return { extraDepthAvgM: 0, maxDeltaM: 0 };
    var bb = (typeof getBBox === 'function') ? getBBox() : null;
    if (!bb) return { extraDepthAvgM: 0, maxDeltaM: 0 };
    var rad = STATE.slopeDeg * Math.PI / 180;
    var maxDelta = bb.L * Math.tan(rad);
    var avgExtra = maxDelta * 0.5;
    return { extraDepthAvgM: avgExtra, maxDeltaM: maxDelta };
  }

  function _slopeRefBearing() {
    if (_MapManager && typeof _MapManager.bearing === 'number') return _MapManager.bearing;
    return 0;
  }

  function _rotatePoint(x, z, bearingDeg) {
    if (!bearingDeg) return { x: x, z: z };
    var rad = -bearingDeg * Math.PI / 180;
    var cs = Math.cos(rad), sn = Math.sin(rad);
    return { x: x * cs - z * sn, z: x * sn + z * cs };
  }

  function _slopeRefX() {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return 0;
    var bearing = _slopeRefBearing();
    var xMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var r = _rotatePoint(poly[i][0], poly[i][1], bearing);
      if (r.x > xMax) xMax = r.x;
    }
    return xMax;
  }

  function _padSlopeExtra(padX, padZ) {
    if (!STATE.slopeActive || STATE.slopeDeg <= 0) return 0;
    var bearing = _slopeRefBearing();
    var rotated = _rotatePoint(padX, (typeof padZ === 'number' ? padZ : 0), bearing);
    var xMax = _slopeRefX();
    var rad = STATE.slopeDeg * Math.PI / 180;
    var extra = (xMax - rotated.x) * Math.tan(rad);
    return extra > 0 ? extra : 0;
  }

  function _sumPadSlopeExtras(positions) {
    var sum = 0;
    if (!positions || !positions.length) return 0;
    for (var i = 0; i < positions.length; i++) {
      sum += _padSlopeExtra(positions[i].x, positions[i].z);
    }
    return sum;
  }

  function _avgSlopeExtraOverPolygon() {
    if (!STATE.slopeActive || STATE.slopeDeg <= 0) return 0;
    var poly = STATE.polygon;
    if (!poly || poly.length < 3) return 0;
    var area = 0, cxSum = 0, czSum = 0;
    for (var i = 0; i < poly.length; i++) {
      var p0 = poly[i], p1 = poly[(i + 1) % poly.length];
      var cross = p0[0] * p1[1] - p1[0] * p0[1];
      area += cross;
      cxSum += (p0[0] + p1[0]) * cross;
      czSum += (p0[1] + p1[1]) * cross;
    }
    area *= 0.5;
    if (Math.abs(area) < 1e-6) return 0;
    var cx = cxSum / (6 * area);
    var cz = czSum / (6 * area);
    return _padSlopeExtra(cx, cz);
  }

  function toggleUnits() {
    STATE.isMetric = !STATE.isMetric;
    /* Re-snap every polygon vertex to the new unit's grid step.
       Metric → 5 cm grid; imperial → 2″ grid. This is a real re-model
       (not just a label refresh): imperial 3.678 m becomes a clean
       3.70 m when switched to metric, etc. */
    _snapPolygonToGrid();
    if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
    refreshUI(true);
    _broadcastUnitToBudget();
  }

  /* Snap all polygon vertices to the active unit's grid using snap(),
     which honours STATE.isMetric (5 cm vs 2″). Clamps to MAX_COORD so
     snapping never pushes a vertex outside the drawable area. */
  function _snapPolygonToGrid() {
    if (!STATE.polygon || !STATE.polygon.length) return;
    for (var i = 0; i < STATE.polygon.length; i++) {
      var p = STATE.polygon[i];
      var nx = snap(p[0]);
      var nz = snap(p[1]);
      if (nx > MAX_COORD) nx = MAX_COORD;
      if (nx < -MAX_COORD) nx = -MAX_COORD;
      if (nz > MAX_COORD) nz = MAX_COORD;
      if (nz < -MAX_COORD) nz = -MAX_COORD;
      p[0] = nx;
      p[1] = nz;
    }
  }

  function _broadcastUnitToBudget() {
    var sel = document.getElementById('unitSelector');
    if (sel) {
      sel.setAttribute('data-current-unit', STATE.isMetric ? 'metric' : 'imperial');
      sel.dispatchEvent(new CustomEvent('unitChange', {
        detail: { unit: STATE.isMetric ? 'metric' : 'imperial' }, bubbles: true
      }));
    }
  }

  function _syncFromBudgetUnit() {
    var sel = document.getElementById('unitSelector');
    if (!sel) return;
    var u = sel.getAttribute('data-current-unit');
    var nextMetric = (u !== 'imperial');
    if (STATE.isMetric !== nextMetric) {
      STATE.isMetric = nextMetric;
      _snapPolygonToGrid();
      if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
      refreshUI(true);
    }
  }

  function selectVariant(n, silent) {
    if (n < 1 || n > 5) return;
    if (!silent && STATE.masterLinked) {
      _updateVariantLockUI();
      return;
    }
    if (!silent && STATE.variant !== n) {
      _UndoHistory.pushIfChanged(STATE.polygon, STATE.variant);
    }
    STATE.variant = n;
    STATE.assemblyStep = 0;
    _updateAssemblyButton();
    if (_VisualizationManager && _VisualizationManager.reset) _VisualizationManager.reset();
    _syncVariantNameDisplay();
    /* Foundation type is an internal switcher only — decoupled from Shopify
       variants. No product-form / URL sync is fired on change. */
    _updateVariantLockUI();
    refreshUI();
  }

  function _updateVariantLockUI() {
    var locked = !!STATE.masterLinked;
    var ids = ['cf-base-variant-prev', 'cf-base-variant-next'];
    for (var i = 0; i < ids.length; i++) {
      var btn = document.getElementById(ids[i]);
      if (!btn) continue;
      btn.disabled = locked;
      btn.style.opacity = locked ? '0.35' : '';
      btn.style.pointerEvents = locked ? 'none' : '';
      btn.setAttribute('aria-disabled', locked ? 'true' : 'false');
    }
  }

  function nextVariant() {
    var n = STATE.variant + 1;
    if (n > 5) n = 1;
    selectVariant(n);
  }

  function prevVariant() {
    var n = STATE.variant - 1;
    if (n < 1) n = 5;
    selectVariant(n);
  }

  function _syncVariantNameDisplay() {
    var boot = global.BASE_BOOT || {};
    var i18n = boot.i18n || {};
    var key = 'roof_v' + STATE.variant;
    var fallback = ['Gable', 'Hip', 'Flat', 'Mono-pitch', 'Mansard'][STATE.variant - 1];
    var label = i18n[key];
    if (!label || /translation missing/i.test(label)) label = fallback;
    /* legacy top switcher name + bottom info-bar cell (foundation-specific id
       and the shelters-style "material" slot are both updated) */
    var ids = ['cf-base-variant-name', 'cf-stat-foundation-name', 'cf-stat-material-name'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el) el.textContent = label;
    }
  }

  /* Bottom info-bar foundation-type switcher — mirrors the shelters banner.
     The lib INJECTS the switcher cell into the existing info-bar if it is not
     already present (so no liquid markup is required), then binds the click
     and keeps the label in sync. Binding is retried up to 20× / 400 ms because
     the info-bar may be mounted after the lib boots. Both the injected ids
     (cf-info-foundation / cf-btn-foundation / cf-stat-foundation-name) and the
     shelters "material" slot are supported. Decoupled from Shopify variants. */
  var _FoundationBanner = {
    _bound: false,
    SWAP_ICON: 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/swap.png?v=1772625955',
    init: function () {
      var self = this, tries = 0;
      function attempt() {
        tries++;
        self._ensureCell();
        self._bind();
        if (!self._bound && tries < 20) { setTimeout(attempt, 400); return; }
        self.sync();
      }
      attempt();
    },
    _findRow: function () {
      var r = document.querySelector('#cf-info-bar .cf-info-row') ||
              document.querySelector('.cf-info-bar .cf-info-row') ||
              document.querySelector('#cf-info-bar') ||
              document.querySelector('.cf-info-bar');
      if (r) return r;
      var a = document.getElementById('cf-stat-area') ||
              document.getElementById('cf-stat-perim') ||
              document.getElementById('cf-stat-count');
      return (a && a.closest) ? (a.closest('.cf-info-row') || a.closest('.cf-info-bar')) : null;
    },
    _ensureCell: function () {
      /* a cell already exists (injected earlier or provided by the liquid) */
      if (document.getElementById('cf-info-foundation') ||
          document.getElementById('cf-stat-foundation-name') ||
          document.getElementById('cf-stat-material-name')) return;
      var row = this._findRow();
      if (!row) return;

      var cell = document.createElement('div');
      cell.className = 'cf-info-item';
      cell.id = 'cf-info-foundation';
      cell.style.cssText = 'cursor:pointer;display:flex;align-items:center;gap:6px;' +
        'padding-left:16px;margin-left:8px;border-left:1px solid rgba(0,0,0,0.12);';

      var label = document.createElement('span');
      label.className = 'cf-info-value cf-info-edge-name';
      label.id = 'cf-stat-foundation-name';
      label.style.cssText = 'font-size:16px;font-weight:800;letter-spacing:0.4px;' +
        'text-transform:uppercase;white-space:nowrap;line-height:1.1;';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'cf-btn-foundation';
      btn.className = 'cf-edge-cycle-btn';
      btn.setAttribute('aria-label', 'Foundation type');
      btn.title = 'Foundation type';
      btn.style.cssText = '-webkit-appearance:none;appearance:none;background:transparent;' +
        'border:none;padding:2px 0 0 0;margin:0;cursor:pointer;display:flex;' +
        'align-items:center;justify-content:center;';

      var img = document.createElement('img');
      img.src = this.SWAP_ICON;
      img.width = 22; img.height = 22; img.alt = '';
      img.style.cssText = 'display:block;opacity:0.85;';
      btn.appendChild(img);

      cell.appendChild(label);
      cell.appendChild(btn);
      row.appendChild(cell);
    },
    _bind: function () {
      if (this._bound) return;
      var lbl = document.getElementById('cf-stat-foundation-name') ||
                document.getElementById('cf-stat-material-name');
      if (!lbl) return;   /* info-bar not in the DOM yet — retry */
      var hookIds = ['cf-info-foundation', 'cf-btn-foundation',
                     'cf-info-material',   'cf-btn-material'];
      for (var i = 0; i < hookIds.length; i++) {
        var el = document.getElementById(hookIds[i]);
        if (!el || el.getAttribute('data-cf-found-bound')) continue;
        el.setAttribute('data-cf-found-bound', '1');
        el.style.cursor = 'pointer';
        el.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();   /* button click won't also fire the cell */
          nextVariant();
        });
      }
      this._bound = true;
    },
    sync: function () {
      _syncVariantNameDisplay();
    }
  };

  /* Shopify variant sync is implemented in the section template
     (configurator-base.liquid → "Shopify variant sync" script block).
     The template's logic handles BOTH directions (configurator ↔
     product form). Lib only fires a window-level callback so the
     template can react to any variant change — switcher buttons,
     dropdown, URL boot, undo, all routed through selectVariant. */
  function _syncShopifyVariant(n) {
    try {
      if (typeof global._onConfiguratorVariantChange === 'function') {
        global._onConfiguratorVariantChange(n);
      }
    } catch (e) {}
  }

  function _readShopifyVariantFromURL() {
    /* Foundation type is decoupled from Shopify variants — it is an internal
       switcher only, so the type is no longer booted from the ?variant URL
       parameter (there is a single Shopify variant for the product). */
    return;
  }

  var _handleEls = [];

  function rebuildDragHandles() {
    var container = document.getElementById('cf-base-handles');
    if (!container) return;
    container.innerHTML = '';
    _handleEls = [];

    var poly = getFootprintPolygon();
    var defs = _buildHandleDefs(poly);

    for (var i = 0; i < defs.length; i++) {
      var def = defs[i];
      var el = document.createElement('div');
      el.className = 'cf-base-handle cf-base-handle-' + def.type;
      el.setAttribute('data-handle-index', String(i));
      el.style.display = 'none';
      container.appendChild(el);
      _attachHandleDrag(el, def);
      _handleEls.push({ el: el, def: def });
    }
    positionDragHandles();
  }

  function _buildHandleDefs(poly) {
    var defs = [];
    var n = poly ? poly.length : 0;
    for (var i = 0; i < n; i++) {
      defs.push({ type: 'corner', vertexIndex: i });
    }
    for (var i = 0; i < n; i++) {
      defs.push({ type: 'edge', edgeIndex: i });
    }
    return defs;
  }

  function _clampCoord(v) {
    if (v >  MAX_COORD) return  MAX_COORD;
    if (v < -MAX_COORD) return -MAX_COORD;
    return v;
  }

  function _worldToScreen(x, z) {
    var eng = global.BaseEngine;
    if (!eng || !eng.camera || !eng.renderer) return null;
    var T = global.THREE;
    if (!T) return null;
    var v = new T.Vector3(x, 0, z);
    v.project(eng.camera);
    var canvasRect = eng.renderer.domElement.getBoundingClientRect();
    var parent = document.getElementById('cf-wrap-base');
    var parentRect = parent ? parent.getBoundingClientRect() : { left: 0, top: 0 };
    return {
      left: (canvasRect.left - parentRect.left) + ((v.x + 1) / 2) * canvasRect.width,
      top:  (canvasRect.top  - parentRect.top)  + ((1 - (v.y + 1) / 2)) * canvasRect.height,
      depth: v.z
    };
  }

  function _screenToWorld(clientX, clientY) {
    var eng = global.BaseEngine;
    if (!eng || !eng.camera || !eng.renderer) return null;
    var T = global.THREE;
    if (!T) return null;
    var rect = eng.renderer.domElement.getBoundingClientRect();
    var ndc = new T.Vector2(
      ((clientX - rect.left) / rect.width)  * 2 - 1,
      -((clientY - rect.top)  / rect.height) * 2 + 1
    );
    var ray = new T.Raycaster();
    ray.setFromCamera(ndc, eng.camera);
    var plane = new T.Plane(new T.Vector3(0, 1, 0), 0);
    var p = new T.Vector3();
    ray.ray.intersectPlane(plane, p);
    return p ? { x: p.x, z: p.z } : null;
  }

  function positionDragHandles() {
    if (STATE.view !== '2d' || STATE.dispoLocked) {
      for (var i = 0; i < _handleEls.length; i++) {
        _handleEls[i].el.style.display = 'none';
      }
      return;
    }
    var poly = getFootprintPolygon();
    var n = poly.length;
    for (var i = 0; i < _handleEls.length; i++) {
      var h = _handleEls[i];
      var def = h.def;
      var wx = 0, wz = 0;
      if (def.type === 'corner') {
        wx = poly[def.vertexIndex][0];
        wz = poly[def.vertexIndex][1];
      } else if (def.type === 'edge') {
        var a = poly[def.edgeIndex];
        var b = poly[(def.edgeIndex + 1) % n];
        wx = (a[0] + b[0]) / 2;
        wz = (a[1] + b[1]) / 2;
      }
      var s = _worldToScreen(wx, wz);
      if (!s) continue;
      h.el.style.left = (s.left - 6) + 'px';
      h.el.style.top  = (s.top  - 6) + 'px';
      h.el.style.display = 'block';
    }
  }

  function _attachHandleDrag(el, def) {
    var dragging = false;
    var startWorld = null;
    var startState = null;
    var startPoly = null;

    el.addEventListener('pointerdown', function (e) {
      if (STATE.view !== '2d' || STATE.dispoLocked) return;
      e.preventDefault();
      dragging = true;
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = false;
      startWorld = _screenToWorld(e.clientX, e.clientY);
      startState = JSON.parse(JSON.stringify(STATE.polygon));
      startPoly = getFootprintPolygon();
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging || !startWorld) return;
      if (STATE.view !== '2d') { dragging = false; return; }
      var p = _screenToWorld(e.clientX, e.clientY);
      if (!p) return;
      var dx = p.x - startWorld.x;
      var dz = p.z - startWorld.z;
      _applyHandleDelta(def, dx, dz, startState);
      refreshUI();
      var nowPoly = getFootprintPolygon();
      _showEdgeDimensionLabels(_changingEdges(nowPoly, startPoly));
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { if (e) el.releasePointerCapture(e.pointerId); } catch (_) {}
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = true;
      _hideAllEdgeLabels();
      if (startState) _UndoHistory.pushIfChanged(startState, STATE.variant);
      startState = null;
    }
    el.addEventListener('pointerup',     endDrag);
    el.addEventListener('pointercancel', endDrag);
    el._forceEndDrag = function () {
      if (!dragging) return;
      dragging = false;
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = true;
      _hideAllEdgeLabels();
      if (startState) _UndoHistory.pushIfChanged(startState, STATE.variant);
      startState = null;
    };
  }

  function _resetAllHandleDrags() {
    for (var i = 0; i < _handleEls.length; i++) {
      var hel = _handleEls[i] && _handleEls[i].el;
      if (hel && hel._forceEndDrag) hel._forceEndDrag();
    }
    var widget = document.getElementById('cf-budget-widget');
    if (widget && widget._forceEndDrag) widget._forceEndDrag();
  }

  function _changingEdges(currentPoly, startPoly) {
    if (!currentPoly || !startPoly) return [];
    if (currentPoly.length !== startPoly.length) return [];
    var changed = [];
    var n = currentPoly.length;
    for (var i = 0; i < n; i++) {
      var ca = currentPoly[i], cb = currentPoly[(i + 1) % n];
      var sa = startPoly[i],   sb = startPoly[(i + 1) % n];
      var clen = Math.hypot(cb[0] - ca[0], cb[1] - ca[1]);
      var slen = Math.hypot(sb[0] - sa[0], sb[1] - sa[1]);
      if (Math.abs(clen - slen) > 0.0001) changed.push(i);
    }
    return changed;
  }

  function _applyHandleDelta(def, dx, dz, s0) {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return;
    var n = s0.length;
    if (def.type === 'corner') {
      var i = def.vertexIndex;
      if (i < 0 || i >= n) return;
      var nx = snap(s0[i][0] + dx);
      var nz = snap(s0[i][1] + dz);
      poly[i][0] = _clampCoord(nx);
      poly[i][1] = _clampCoord(nz);
    } else if (def.type === 'edge') {
      var ei = def.edgeIndex;
      if (ei < 0 || ei >= n) return;
      var a = s0[ei];
      var b = s0[(ei + 1) % n];
      var edx = b[0] - a[0], edz = b[1] - a[1];
      var len = Math.hypot(edx, edz);
      if (len < 1e-6) return;
      var nrmX = -edz / len, nrmZ = edx / len;
      var proj = dx * nrmX + dz * nrmZ;
      var ax = snap(a[0] + proj * nrmX);
      var az = snap(a[1] + proj * nrmZ);
      var bx = snap(b[0] + proj * nrmX);
      var bz = snap(b[1] + proj * nrmZ);
      poly[ei][0] = _clampCoord(ax);
      poly[ei][1] = _clampCoord(az);
      poly[(ei + 1) % n][0] = _clampCoord(bx);
      poly[(ei + 1) % n][1] = _clampCoord(bz);
    }
  }

  var _edgeLabels = [];
  var _edgeLabelCssInjected = false;

  function _injectEdgeLabelCSS() {
    if (_edgeLabelCssInjected) return;
    _edgeLabelCssInjected = true;
    var css = '#cf-wrap-base .cf-base-dim-label {' +
              '  position: absolute; z-index: 12;' +
              '  background: rgba(20,20,20,0.92); color: #fff;' +
              '  font: 700 11px/1.2 Montserrat, -apple-system, sans-serif;' +
              '  padding: 4px 8px; border-radius: 6px;' +
              '  letter-spacing: 0.02em; white-space: nowrap;' +
              '  pointer-events: none;' +
              '  transform: translate(-50%, -50%);' +
              '  box-shadow: 0 2px 6px rgba(0,0,0,0.25);' +
              '}';
    var style = document.createElement('style');
    style.id = 'cf-base-dim-label-css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _ensureEdgeLabelPool(n) {
    _injectEdgeLabelCSS();
    var parent = document.getElementById('cf-wrap-base');
    if (!parent) return;
    while (_edgeLabels.length < n) {
      var el = document.createElement('div');
      el.className = 'cf-base-dim-label';
      el.style.display = 'none';
      parent.appendChild(el);
      _edgeLabels.push(el);
    }
  }

  function _hideAllEdgeLabels() {
    for (var i = 0; i < _edgeLabels.length; i++) {
      _edgeLabels[i].style.display = 'none';
    }
  }

  function _showEdgeDimensionLabels(activeEdgeIndices) {
    var poly = getFootprintPolygon();
    if (!poly || !poly.length) { _hideAllEdgeLabels(); return; }
    var n = poly.length;
    _ensureEdgeLabelPool(n);

    for (var i = 0; i < n; i++) {
      var label = _edgeLabels[i];
      if (activeEdgeIndices.indexOf(i) === -1) {
        label.style.display = 'none';
        continue;
      }
      var a = poly[i];
      var b = poly[(i + 1) % n];
      var mx = (a[0] + b[0]) / 2;
      var mz = (a[1] + b[1]) / 2;
      var dx = b[0] - a[0];
      var dz = b[1] - a[1];
      var lenWorld = Math.sqrt(dx * dx + dz * dz);
      label.textContent = fmtDim(lenWorld);

      var ms = _worldToScreen(mx, mz);
      if (!ms) { label.style.display = 'none'; continue; }

      var nlen = Math.sqrt(dx * dx + dz * dz);
      var nxW, nzW;
      if (nlen < 1e-6) {
        nxW = 0; nzW = -1;
      } else {
        nxW = -dz / nlen;
        nzW =  dx / nlen;
      }
      var probe = 0.02;
      if (_pointInPolygonOrBoundary(mx + nxW * probe, mz + nzW * probe, poly)) {
        nxW = -nxW; nzW = -nzW;
      }
      var probeS = _worldToScreen(mx + nxW * probe, mz + nzW * probe);
      var sx, sy, slen;
      if (probeS) {
        sx = probeS.left - ms.left;
        sy = probeS.top  - ms.top;
        slen = Math.sqrt(sx * sx + sy * sy);
        if (slen < 0.001) { sx = 0; sy = -1; slen = 1; }
      } else {
        sx = 0; sy = -1; slen = 1;
      }
      var off = 26;
      var lx = ms.left + (sx / slen) * off;
      var ly = ms.top  + (sy / slen) * off;

      label.style.display = 'block';
      label.style.left = lx + 'px';
      label.style.top  = ly + 'px';
    }
  }

  function _startBudgetWidgetSync() {
    var dstTotal    = document.getElementById('cf-bw-total');
    var dstMaterial = document.getElementById('cf-bw-material');
    var dstExec     = document.getElementById('cf-bw-execution');
    var dstTime     = document.getElementById('cf-bw-time');
    var dstCapacity = document.getElementById('cf-bw-capacity');

    function refresh() {
      var srcTotal    = document.querySelector('[data-budget-total-cost]');
      var srcMaterial = document.querySelector('[data-budget-total-material]');
      var srcExec     = document.querySelector('[data-budget-total-execution]');
      var srcTime     = document.querySelector('[data-budget-total-time]');

      var totalText    = (srcTotal    && srcTotal.textContent)    ? srcTotal.textContent.trim()    : '';
      var materialText = (srcMaterial && srcMaterial.textContent) ? srcMaterial.textContent.trim() : '';
      var execText     = (srcExec     && srcExec.textContent)     ? srcExec.textContent.trim()     : '';
      var timeText     = (srcTime     && srcTime.textContent)     ? srcTime.textContent.trim()     : '';

      var needFallback = (!totalText || totalText === '—' || !materialText || materialText === '—');
      if (needFallback) {
        var matVal  = (typeof global.lastMaterialsTotal === 'number') ? global.lastMaterialsTotal : null;
        var execVal = (typeof global.lastDeliveryTotal  === 'number') ? global.lastDeliveryTotal  : null;
        if (matVal !== null || execVal !== null) {
          var fmt = (typeof global.formatPrice === 'function')
            ? global.formatPrice
            : function (n) { return '$' + Math.round(n || 0); };
          var m = matVal  || 0;
          var e = execVal || 0;
          if (!totalText    || totalText    === '—') totalText    = fmt(m + e);
          if (!materialText || materialText === '—') materialText = fmt(m);
          if (!execText     || execText     === '—') execText     = fmt(e);
        }
      }

      if (dstTotal    && totalText)    dstTotal.textContent    = totalText;
      if (dstMaterial && materialText) dstMaterial.textContent = materialText;
      if (dstExec     && execText)     dstExec.textContent     = execText;
      if (dstTime     && timeText)     dstTime.textContent     = timeText;

      if (dstCapacity) {
        var rows = computeBoQ();
        var excavM3 = 0;
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] && rows[i][0] === 'FEE00001') {
            excavM3 = rows[i][1] || 0;
            break;
          }
        }
        dstCapacity.textContent = STATE.isMetric
          ? excavM3.toFixed(1) + ' m³'
          : (excavM3 * 1.30795).toFixed(1) + ' yd³';
      }
    }
    refresh();
    setInterval(refresh, 500);

    setTimeout(function () {
      if (typeof global.updateTotal !== 'function') return;
      var srcTotal = document.querySelector('[data-budget-total-cost]');
      var t = (srcTotal && srcTotal.textContent) ? srcTotal.textContent.trim() : '';
      var stillEmpty = (t === '' || t === '—' || typeof global.lastMaterialsTotal !== 'number');
      if (!stillEmpty) return;
      try { global.updateTotal(); } catch (err) {}
    }, 2500);
  }

  function _initBudgetWidgetDrag() {
    var widget = document.getElementById('cf-budget-widget');
    var toggle = document.getElementById('cf-budget-widget-toggle');
    if (!widget) return;
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var collapsed = widget.getAttribute('data-collapsed') === 'true';
        widget.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      });
      toggle.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    }

    var dragging = false, startX = 0, startY = 0, startLeft = 0, startTop = 0;
    widget.addEventListener('pointerdown', function (e) {
      if (e.target.closest('#cf-budget-widget-toggle')) return;
      dragging = true;
      startX = e.clientX; startY = e.clientY;
      var r = widget.getBoundingClientRect();
      var pr = (widget.offsetParent || document.body).getBoundingClientRect();
      startLeft = r.left - pr.left;
      startTop  = r.top  - pr.top;
      try { widget.setPointerCapture(e.pointerId); } catch (_) {}
    });
    widget.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      var parent = widget.offsetParent || document.body;
      var pr = parent.getBoundingClientRect();
      var nx = Math.max(0, Math.min(pr.width  - widget.offsetWidth,  startLeft + dx));
      var ny = Math.max(0, Math.min(pr.height - widget.offsetHeight, startTop  + dy));
      widget.style.left = nx + 'px';
      widget.style.top  = ny + 'px';
      widget.style.right = 'auto';
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { if (e) widget.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    widget.addEventListener('pointerup',     endDrag);
    widget.addEventListener('pointercancel', endDrag);
    widget._forceEndDrag = function () { dragging = false; };
  }

  function share() {
    if (global.ConfiguratorShare && typeof global.ConfiguratorShare.open === 'function') {
      try { global.ConfiguratorShare.open(); return; }
      catch (err) { _dbg('ConfiguratorShare.open threw: ' + (err && err.message ? err.message : err)); }
    }
    var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
    var txt = TT.shareFallbackText || 'Foundation configuration from LEVA';
    var title = TT.shareFallbackTitle || 'Configuration';
    if (navigator.share) {
      navigator.share({ title: title, text: txt }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(txt);
      alert(TT.shareCopied || 'Copied to clipboard');
    }
  }

  function openBudgetDrawer() {
    /* Any user-initiated open of the drawer counts as "engaged"
       and disables the onboarding nudge for this product. The
       30-day throttle is also written so we don't pop it again
       if they refresh. */
    try {
      var BOOT = global.BASE_BOOT || {};
      global.__cfBudgetUserTouched = true;
      if (BOOT.productId) {
        localStorage.setItem('cf-budget-touched-' + BOOT.productId, String(Date.now()));
      }
      _onboardMarkSeen();
    } catch (_) {}
    if (typeof global.openShareBudgetDrawer === 'function') {
      global.openShareBudgetDrawer('data');
    } else if (typeof global.openRefreshDrawer === 'function') {
      global.openRefreshDrawer();
    } else {
      _dbg('no budget drawer opener on window');
    }
  }

  function toggleView() {
    if (global.BaseEngine && typeof global.BaseEngine.toggleView === 'function') {
      global.BaseEngine.toggleView();
    }
  }

  /* PDF is the primary deliverable. Until the central BoQ data has loaded
     (names + prices), an export would be incomplete — so the button stays
     visually disabled (greyed, non-clickable). Once data is ready it is
     promoted to the single RED primary action (white icon) so it stands out. */
  var PDF_BTN_RED = '#D8232A';   /* LEVA red */

  function _initPdfButtonState() {
    var btn = document.getElementById('cf-btn-pdf');
    if (!btn) return;

    if (!document.getElementById('cf-pdf-btn-style')) {
      var st = document.createElement('style');
      st.id = 'cf-pdf-btn-style';
      st.textContent =
        '#cf-btn-pdf.cf-pdf-loading{opacity:.4;pointer-events:none;cursor:default;filter:grayscale(1);}' +
        '#cf-btn-pdf.cf-pdf-ready{background:' + PDF_BTN_RED + ' !important;border-color:' + PDF_BTN_RED + ' !important;color:#fff !important;}' +
        /* White icon regardless of how it is rendered (inline SVG,
           <img>, or a CSS mask / background-image child). */
        '#cf-btn-pdf.cf-pdf-ready > *{filter:brightness(0) invert(1) !important;}';
      document.head.appendChild(st);
    }

    var bridge = global.ConfiguratorBudgetBridge || null;
    function isReady() {
      return !(bridge && typeof bridge.isReady === 'function') || bridge.isReady();
    }
    function promote() {
      btn.classList.remove('cf-pdf-loading');
      btn.classList.add('cf-pdf-ready');
    }

    if (isReady()) { promote(); return; }

    btn.classList.add('cf-pdf-loading');
    if (bridge && typeof bridge.onReady === 'function') {
      try { bridge.onReady(promote); } catch (e) {}
    }
    var waited = 0;
    var iv = setInterval(function () {
      if (isReady()) { clearInterval(iv); promote(); }
      else if ((waited += 300) >= 30000) { clearInterval(iv); promote(); }  /* fail-open after 30 s */
    }, 300);
  }

  /* =================================================================
     DISPOSITION LOCK — when foundations is opened from the master house
     it arrives linked + locked: the footprint follows the house and the
     shape handles are hidden. The user can UNLOCK to edit freely; doing so
     detaches from the master (its house is left untouched).
     ================================================================= */
  /* Read the CURRENT master-house footprint (+ placement) from its
     levaProject payload (productHandle 'main-house', shape.polygon in m) so
     that re-locking always snaps to the latest house shape. */
  function _findMasterHousePayload() {
    var best = null, bestT = -1;
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (!k || k.indexOf('levaProject:') !== 0) continue;
        var raw = localStorage.getItem(k); if (!raw) continue;
        var pj; try { pj = JSON.parse(raw); } catch (e) { continue; }
        if (!pj || pj.productHandle !== 'main-house') continue;
        var t = Date.parse(pj.updatedAt || '') || 0;
        if (t > bestT) { bestT = t; best = pj; }
      }
    } catch (e2) {}
    return best;
  }

  var _MASTER_ROOF_TO_VARIANT = { sedlo: 1, valba: 2, atika: 3, pult: 4 };

  function _adoptMasterRoofType(rt) {
    var v = _MASTER_ROOF_TO_VARIANT[rt];
    if (!v || STATE.variant === v) return;
    STATE.variant = v;
    STATE.assemblyStep = 0;
    try { _syncVariantNameDisplay(); } catch (e) {}
    try { _updateVariantLockUI(); } catch (e) {}
  }

  function _adoptHouseFootprint() {
    var src = null, mapData = null, masterRoofType = null;
    /* prefer the live broadcast key (works across projectIds) */
    try {
      var raw = localStorage.getItem('mc:house:footprint');
      if (raw) {
        var b = JSON.parse(raw);
        if (b && Array.isArray(b.polygon) && b.polygon.length >= 3) {
          src = b.polygon; mapData = b.map || null;
          if (typeof b.roofType === 'string') masterRoofType = b.roofType;
        }
      }
    } catch (e) {}
    if (!src) {
      var h = _findMasterHousePayload();
      if (!h || !h.shape || !Array.isArray(h.shape.polygon)) return false;
      src = h.shape.polygon; mapData = h.map || null;
      if (typeof h.shelterRoofType === 'string') masterRoofType = h.shelterRoofType;
      else if (typeof h.roofType === 'string') masterRoofType = h.roofType;
    }
    var newPoly = [];
    for (var i = 0; i < src.length; i++) {
      var pt = src[i];
      if (Array.isArray(pt) && pt.length === 2 && typeof pt[0] === 'number' && typeof pt[1] === 'number') {
        newPoly.push([_clampCoord(pt[0]), _clampCoord(pt[1])]);
      }
    }
    if (newPoly.length < 3) return false;
    STATE.polygon = newPoly;
    if (masterRoofType) _adoptMasterRoofType(masterRoofType);
    /* adopt the house map placement too, so the foundation aligns with it */
    if (mapData && Array.isArray(mapData.center) && mapData.center.length === 2 && _MapManager) {
      _MapManager.bearing = typeof mapData.bearing === 'number' ? mapData.bearing : 0;
      if (_MapManager.map && _MapManager.center) {
        _MapManager.center = mapData.center.slice();
        try { _MapManager.map.jumpTo({ center: mapData.center, bearing: _MapManager.bearing }); } catch (e) {}
      } else {
        _pendingMapRestore = { center: mapData.center.slice(), address: mapData.address || '', bearing: _MapManager.bearing };
      }
    }
    return true;
  }

  /* Live master->config follow: when locked, mirror the master house footprint
     + placement the instant it broadcasts a change (cross-tab storage event). */
  var _houseFollowBound = false;
  function _bindHouseFollow() {
    if (_houseFollowBound) return;
    _houseFollowBound = true;
    try {
      global.addEventListener('storage', function (e) {
        if (!e || e.key !== 'mc:house:footprint') return;
        if (!STATE.masterLinked) return;
        if (_adoptHouseFootprint()) {
          try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (er) {}
          try { refreshUI(); } catch (er) {}
          try { positionDragHandles(); } catch (er) {}
          try { if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish(); } catch (er) {}
        }
      });
    } catch (e) {}
  }

  function _setDispoLocked(locked, detach) {
    STATE.dispoLocked = !!locked;
    if (locked) {
      /* re-locking snaps the layout to the CURRENT house footprint */
      var adopted = _adoptHouseFootprint();
      if (adopted) STATE.masterLinked = true;
      if (adopted) {
        try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (e) {}
        try { refreshUI(); } catch (e) {}
      }
    } else if (detach) {
      STATE.masterLinked = false;
    }
    _updateDispoLockButton();
    positionDragHandles();
    try { _applyMapLockState(); } catch (e) {}
    /* publish immediately (not debounced) so the master hides/shows the
       footprint in real time, like rotation/position do */
    try { if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publishNow(); } catch (e) {}
  }

  function _updateDispoLockButton() {
    var btn = document.getElementById('cf-btn-dispo-lock');
    if (!btn) return;
    btn.style.display = '';   /* lock icon present on the config */
    var locked = !!STATE.dispoLocked;
    btn.classList.toggle('locked', locked);
    btn.setAttribute('aria-pressed', locked ? 'true' : 'false');
    btn.title = locked ? 'Layout locked to the house — tap to unlock & edit'
                       : 'Layout free — tap to lock';
    var shackle = document.getElementById('cf-dispo-lock-shackle');
    if (shackle) {
      shackle.setAttribute('d', locked
        ? 'M8 11V7a4 4 0 0 1 8 0v4'
        : 'M8 11V7a4 4 0 0 1 7-2.65');
    }
  }

  function wireSidebar() {
    var on = function (id, fn) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', fn);
    };
    on('cf-btn-dispo-lock', function () { _setDispoLocked(!STATE.dispoLocked, true); });
    _updateDispoLockButton();
    _bindHouseFollow();
    on('cf-btn-view',     toggleView);
    on('cf-btn-undo',     undo);
    on('cf-btn-lvl',      cycleLvl);
    on('cf-btn-assembly', cycleAssembly);
    _SlopeManager.init();
    on('cf-btn-unit',     toggleUnits);
    on('cf-btn-budget',   openBudgetDrawer);
    on('cf-btn-share',    share);
    on('cf-btn-pdf',      function () { _openPdfSocialModal(); });
    on('cf-btn-ar',       function () { _openArModal(); });

    (function () {
      if (document.getElementById('cf-btn-reset')) return;
      var undoBtn = document.getElementById('cf-btn-undo');
      var sidebar = (undoBtn && undoBtn.parentNode) || document.querySelector('.cf-sidebar');
      if (!sidebar) return;
      var i18n = (boot && boot.i18n) || {};
      var rb = document.createElement('button');
      rb.id = 'cf-btn-reset';
      rb.className = (undoBtn && undoBtn.className) || 'cf-icon-btn';
      rb.type = 'button';
      rb.title = i18n.reset_shape || 'Reset shape to rectangle';
      rb.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>';
      if (undoBtn && undoBtn.parentNode === sidebar) sidebar.insertBefore(rb, undoBtn.nextSibling);
      else sidebar.appendChild(rb);
      rb.addEventListener('click', function () {
        var msg = i18n.reset_confirm || 'Reset the shape back to a rectangle? The current footprint will be cleared (you can undo afterwards).';
        if (global.confirm && !global.confirm(msg)) return;
        resetShapeToRect();
      });
    })();

    var prevBtn = document.getElementById('cf-base-variant-prev');
    var nextBtn = document.getElementById('cf-base-variant-next');
    if (prevBtn) prevBtn.addEventListener('click', prevVariant);
    if (nextBtn) nextBtn.addEventListener('click', nextVariant);

    /* Bottom info-bar foundation-type switcher (retry-bound, shelters-style). */
    _FoundationBanner.init();

    /* Hide the legacy top variant switcher (name + arrows) — the foundation
       type is now driven from the bottom info-bar cell. */
    var _topSwitcherIds = ['cf-base-variant-name', 'cf-base-variant-prev', 'cf-base-variant-next'];
    for (var _ti = 0; _ti < _topSwitcherIds.length; _ti++) {
      var _tel = document.getElementById(_topSwitcherIds[_ti]);
      if (_tel) _tel.style.display = 'none';
    }

    _syncVariantNameDisplay();

    /* PDF button: disabled until data loads, then promoted to red primary. */
    _initPdfButtonState();

    var opacitySlider = document.getElementById('cf-2d-opacity-slider');
    if (opacitySlider) {
      opacitySlider.addEventListener('input', function (e) {
        var sv = parseInt(e.target.value, 10);
        STATE.opacity2D = (100 - sv) / 100;
        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      });
    }

    _startBudgetWidgetSync();
    _initBudgetWidgetDrag();
    _init2DZoom();
    _init2DMapPan();
    _bindIconTooltips();
    _VisualizationManager.init();
    _CornerInserter.init();
    _UndoHistory._updateButton();
    _updateLvlButton();
    _updateAssemblyButton();
    _preloadLvlAvatars();

    var _bridgeRetry = 0;
    var _bridgeTimer = setInterval(function () {
      _bridgeRetry++;
      var bridge = global.ConfiguratorBudgetBridge;
      if (bridge && bridge.isReady && bridge.isReady()) {
        _updateAssemblyButton();
        clearInterval(_bridgeTimer);
      } else if (_bridgeRetry > 150) {
        clearInterval(_bridgeTimer);
      }
    }, 200);

    global.addEventListener('prices-updated', function () {
      _updateAssemblyButton();
    });

    global.addEventListener('unitChange', _syncFromBudgetUnit);
    setTimeout(_syncFromBudgetUnit, 50);
  }

  var _CORE_CSS_INJECTED = false;
  function _injectCoreCSS() {
    if (_CORE_CSS_INJECTED) return;
    if (document.getElementById('cf-core-css-inline')) { _CORE_CSS_INJECTED = true; return; }
    var css = [
      ':root { --cfg-color-primary: #D2A878; }',
      '.cfg-slider-vert-wrap {',
      '  display: inline-flex; flex-direction: column; align-items: center;',
      '  background: transparent; padding: 0; user-select: none;',
      '}',
      '.cfg-slider-vert {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 4px; height: 130px;',
      '  background: linear-gradient(to top,',
      '    var(--cfg-color-primary, #D2A878) 0%,',
      '    var(--cfg-color-primary, #D2A878) var(--cfg-fill, 50%),',
      '    #e0e0e0 var(--cfg-fill, 50%),',
      '    #e0e0e0 100%);',
      '  border-radius: 10px; outline: none; cursor: pointer; touch-action: none;',
      '  writing-mode: tb-lr; -webkit-writing-mode: vertical-lr;',
      '}',
      '.cfg-slider-vert::-webkit-slider-thumb {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 12px; height: 12px;',
      '  background: var(--cfg-color-primary, #D2A878);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cfg-slider-vert::-moz-range-thumb {',
      '  width: 12px; height: 12px;',
      '  background: var(--cfg-color-primary, #D2A878);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-dim-chip {',
      '  position: absolute; transform: translate(-50%, -50%);',
      '  background: #ffffff; border-radius: 8px; padding: 6px 10px;',
      '  font-family: Montserrat, system-ui, sans-serif;',
      '  font-size: 12px; font-weight: 700; color: #1a1a1a;',
      '  box-shadow: 0 2px 8px rgba(0,0,0,0.12);',
      '  display: inline-flex; align-items: center; gap: 6px;',
      '  white-space: nowrap; pointer-events: auto; touch-action: none;',
      '  user-select: none; z-index: 8; cursor: pointer;',
      '  transition: background-color 0.12s, box-shadow 0.12s;',
      '}',
      '.cf-dim-chip:hover {',
      '  background: #f7f1e6;',
      '  box-shadow: 0 3px 10px rgba(0,0,0,0.18);',
      '}',
      '.cf-dim-chip.cf-dim-chip--editing {',
      '  background: #fff8ec; cursor: text;',
      '}',
      '.cf-dim-chip input.cf-dim-chip-input {',
      '  width: 56px; border: none; outline: none;',
      '  font: inherit; color: inherit; background: transparent;',
      '  text-align: center; padding: 0; margin: 0;',
      '}'
    ].join('\n');
    var s = document.createElement('style');
    s.id = 'cf-core-css-inline';
    s.textContent = css;
    document.head.appendChild(s);
    _CORE_CSS_INJECTED = true;
  }

  /* ───────────────────────────────────────────────────────────────
     SectionCutManager
     Provides assembly step 2 = vertical section cut through the
     3D scene. The cutting plane is computed deterministically per
     variant + polygon so the result is identical for every user.

     Pipeline:
       1. compute()  — find a cut plane (THREE.Plane) per variant
       2. apply()    — set material.clippingPlanes on every mesh
                       in the scene group (called from BaseRenderer)
       3. addCaps()  — overlay opaque cap meshes so the cut surface
                       reads as solid instead of hollow
       4. clear()    — remove clipping + caps for all other steps

     Plane orientation: perpendicular to the LONGER polygon edge —
     that maximises the amount of material visible in the slice.
     Position: passes through the polygon centroid for slab / strip
     variants; for piers / precast / screws it snaps onto the
     element nearest the centroid so the cut actually intersects
     something instead of slicing between objects.
     ─────────────────────────────────────────────────────────────── */
  var _SectionCutManager = {
    _capsGroup: null,
    _outlineGroup: null,
    _activePlane: null,
    _activeOffset: 0,
    _userOffset: null,
    _minCoord: 0,
    _maxCoord: 0,

    /* Compute a THREE.Plane that slices the scene vertically through
       a sensible spot. Returns null if THREE isn't ready yet (caller
       must noop). */
    compute: function (poly, variantKey, eng) {
      var T = global.THREE;
      if (!T || !poly || poly.length < 3) return null;

      /* 1. find polygon bbox + centroid */
      var xs = poly.map(function (p) { return p[0]; });
      var zs = poly.map(function (p) { return p[1]; });
      var xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs);
      var zMin = Math.min.apply(null, zs), zMax = Math.max.apply(null, zs);
      var cx = (xMin + xMax) / 2;
      var cz = (zMin + zMax) / 2;
      var bbL = xMax - xMin;
      var bbW = zMax - zMin;

      /* 2. pick orientation — cut perpendicular to the longer edge.
         If the polygon is wider than it is deep we cut along the X
         axis (plane normal = +Z), otherwise along Z (normal = +X). */
      var cutAlongX = (bbL >= bbW);
      var normal = cutAlongX
        ? new T.Vector3(0, 0, 1)
        : new T.Vector3(1, 0, 0);
      this._minCoord = cutAlongX ? zMin : xMin;
      this._maxCoord = cutAlongX ? zMax : xMax;

      /* 3. position the plane. For uniform variants (slab / strip)
         the centroid is fine. For discrete elements (piers, precast,
         screws) the plane must pass THROUGH one of them or the cut
         will land in empty space and show nothing useful. */
      var planeCoord = cutAlongX ? cz : cx;

      var elementPositions = this._findElementPositions(variantKey, eng);
      if (elementPositions && elementPositions.length) {
        var best = null, bestDist = Infinity;
        for (var i = 0; i < elementPositions.length; i++) {
          var p = elementPositions[i];
          var d = cutAlongX
            ? Math.abs(p.z - cz)
            : Math.abs(p.x - cx);
          if (d < bestDist) { bestDist = d; best = p; }
        }
        if (best) planeCoord = cutAlongX ? best.z : best.x;
      }

      if (this._userOffset != null) {
        planeCoord = Math.max(this._minCoord, Math.min(this._maxCoord, this._userOffset));
      }
      /* THREE.Plane equation: n·x + constant = 0
         Fragments are clipped where n·x + constant < 0. We want to
         hide the NEAR half of the model (the half closest to the
         default camera angle), so the cut surface ends up facing
         the user without them having to orbit. Practically that
         means picking a normal that points TOWARDS the visible
         half, then making the plane sit at planeCoord. */
      var plane = new T.Plane(normal.clone().negate(), planeCoord);
      this._activePlane = plane;
      this._activeOffset = planeCoord;
      this._activeCutAlongX = cutAlongX;
      return plane;
    },

    /* Pull world positions of discrete elements out of the scene
       graph. Relies on asset markers BaseRenderer sets on each
       mesh's userData when it builds piers / screws / precast. */
    _findElementPositions: function (variantKey, eng) {
      if (!eng || !eng.sceneGroup) return [];
      var targets = {
        piers:   ['pier'],
        precast: ['precast'],
        screws:  ['screw']
      }[variantKey];
      if (!targets) return [];
      var hits = [];
      eng.sceneGroup.traverse(function (node) {
        if (!node || !node.userData) return;
        if (targets.indexOf(node.userData.assetType) !== -1) {
          var pos = new global.THREE.Vector3();
          node.getWorldPosition(pos);
          hits.push(pos);
        }
      });
      return hits;
    },

    /* Walk the scene group and attach our plane to every material
       so the GPU clips fragments on the far side of it. We also
       enable per-material `clipShadows: false` because the scene's
       shadows look weird when the casting mesh is half-clipped.
       Returns the number of materials touched (handy for logging). */
    apply: function (plane) {
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup || !plane) return 0;
      var n = 0;
      eng.sceneGroup.traverse(function (node) {
        if (!node.material) return;
        var mats = Array.isArray(node.material) ? node.material : [node.material];
        for (var i = 0; i < mats.length; i++) {
          var m = mats[i];
          if (!m) continue;
          m.clippingPlanes = [plane];
          m.clipShadows = false;
          m.needsUpdate = true;
          n++;
        }
      });
      return n;
    },

    /* Remove any active clipping + cap geometry. Called when the
       user leaves step 2 of the assembly cycle. */
    clear: function () {
      var eng = global.BaseEngine;
      if (eng && eng.sceneGroup) {
        eng.sceneGroup.traverse(function (node) {
          if (!node.material) return;
          var mats = Array.isArray(node.material) ? node.material : [node.material];
          for (var i = 0; i < mats.length; i++) {
            if (mats[i]) {
              mats[i].clippingPlanes = null;
              mats[i].needsUpdate = true;
            }
          }
        });
      }
      this._removeCapsGroup();
      this._activePlane = null;
    },

    _removeCapsGroup: function () {
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup) return;
      if (this._capsGroup) {
        eng.sceneGroup.remove(this._capsGroup);
        this._disposeGroup(this._capsGroup);
        this._capsGroup = null;
      }
      if (this._outlineGroup) {
        eng.sceneGroup.remove(this._outlineGroup);
        this._disposeGroup(this._outlineGroup);
        this._outlineGroup = null;
      }
    },

    _disposeGroup: function (group) {
      group.traverse(function (n) {
        if (n.geometry) n.geometry.dispose();
        if (n.material) {
          var ms = Array.isArray(n.material) ? n.material : [n.material];
          ms.forEach(function (m) { m && m.dispose && m.dispose(); });
        }
      });
    },

    /* Add a thin highlighted line along the cut so the user can see
       exactly where the slice plane sits in 3D — without this it
       reads as just "half the model deleted". */
    addOutline: function (plane, poly, eng) {
      var T = global.THREE;
      if (!T || !plane || !poly || !eng) return;
      var grp = new T.Group();
      grp.userData.assetType = 'section-cut-aux';

      var cutAlongX = this._activeCutAlongX;
      var coord = this._activeOffset;
      var heightTop = 0.6;
      var heightBot = -2.0;

      var xs = poly.map(function (p) { return p[0]; });
      var zs = poly.map(function (p) { return p[1]; });
      var xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs);
      var zMin = Math.min.apply(null, zs), zMax = Math.max.apply(null, zs);

      var a, b;
      if (cutAlongX) {
        a = new T.Vector3(xMin - 0.5, heightBot, coord);
        b = new T.Vector3(xMax + 0.5, heightBot, coord);
      } else {
        a = new T.Vector3(coord, heightBot, zMin - 0.5);
        b = new T.Vector3(coord, heightBot, zMax + 0.5);
      }
      var top = a.clone(); top.y = heightTop;
      var top2 = b.clone(); top2.y = heightTop;

      var lineGeo = new T.BufferGeometry().setFromPoints([a, b, top2, top, a]);
      var lineMat = new T.LineBasicMaterial({ color: 0xd2a878, linewidth: 2 });
      grp.add(new T.Line(lineGeo, lineMat));

      eng.sceneGroup.add(grp);
      this._outlineGroup = grp;
    },

    /* Stencil-buffer cap fill — turns the "thin-shell hole" effect
       into a proper solid cross-section.

       Per-material variant: we don't paint every cut surface the
       same neutral grey. Instead we group the solid meshes by their
       source material and run an independent stencil pass per
       group, then draw a coloured cap using that material's own
       diffuse colour. The result: gravel reads brown, concrete
       reads grey, precast block reads its own tone — same as the
       3D bodies they belong to.

       Rebar / wire mesh is rendered as line geometry, so the cap
       trick doesn't apply directly; we still want their cross-
       section to show up as small filled circles inside the slab
       cap. We do that as a second pass that ignores the stencil
       and uses additive blending so the rebar lines pop on top of
       the concrete cap.

       Algorithm per material group:
         1. clear stencil to 0
         2. render BACK faces of every mesh in the group with the
            cut clipping plane, INCREMENTing the stencil counter
         3. render FRONT faces DECREMENTing
            → counter != 0 exactly where the cut is inside any mesh
              from this material group
         4. draw a big quad on the cut plane in the material's own
            colour, gated by `stencilFunc: NotEqual, ref: 0`
            and CLEARING the stencil back to 0 with `Zero` ops so
            the next material group starts from a clean slate

       Each pass is given its own renderOrder block (group N uses
       10*N+0 / +1 / +2) so Three.js processes them in the right
       sequence. */
    addCaps: function (plane, poly, eng) {
      var T = global.THREE;
      if (!T || !plane || !poly || !eng) return;

      var grp = new T.Group();
      grp.userData.assetType = 'section-cut-aux';

      /* Asset types that read as solid bodies → get the per-material
         coloured cap. Wireframe assets (mesh / rebar) get a
         separate overlay pass below. */
      var SOLID_TYPES = {
        'gravel':         true,
        'slab':           true,
        'strip':          true,
        'pier':           true,
        'precast':        true,
        'screw':          true,
        'excavation-box': true
      };
      /* Wireframe / line assets — drawn over the cap as accent lines
         so the user can still see the rebar grid intersecting the
         slab cross-section. */
      var WIRE_TYPES = {
        'mesh':  true,
        'rebar': true
      };

      /* Bucket meshes by their material UUID. Meshes that share the
         same material end up in the same group, so a single
         coloured cap covers everything that visually belongs
         together (e.g. all concrete pours).

         We darken the cap colour to 70% because the cap is drawn
         with MeshBasicMaterial (unlit), while the source meshes use
         MeshLambertMaterial which is attenuated by scene lighting.
         Cloning the raw colour straight across makes the caps look
         noticeably brighter than the surrounding 3D — multiplying
         by 0.7 brings them roughly in line with how the rest of the
         lit geometry reads on screen. */
      var CAP_BRIGHTNESS = 0.7;
      var groups = {};
      eng.sceneGroup.traverse(function (node) {
        if (!node.isMesh || !node.geometry || !node.material) return;
        if (node.userData && node.userData.assetType === 'section-cut-aux') return;
        var t = (node.userData && node.userData.assetType)
              || (node.parent && node.parent.userData && node.parent.userData.assetType);
        if (!t || !SOLID_TYPES[t]) return;
        var mats = Array.isArray(node.material) ? node.material : [node.material];
        for (var mi = 0; mi < mats.length; mi++) {
          var m = mats[mi];
          if (!m || !m.color) continue;
          var key = m.uuid;
          if (!groups[key]) {
            var capColor = m.color.clone().multiplyScalar(CAP_BRIGHTNESS);
            groups[key] = { color: capColor, meshes: [], typeHint: t };
          }
          groups[key].meshes.push({ node: node, materialIndex: mi });
        }
      });

      var groupKeys = Object.keys(groups);
      _dbg('[section-cut] addCaps: ' + groupKeys.length + ' material groups');

      var xs = poly.map(function (p) { return p[0]; });
      var zs = poly.map(function (p) { return p[1]; });
      var xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs);
      var zMin = Math.min.apply(null, zs), zMax = Math.max.apply(null, zs);
      var capH = 4.0;
      var capW = (this._activeCutAlongX ? (xMax - xMin) : (zMax - zMin)) + 4;
      var capCenterX = this._activeCutAlongX ? (xMin + xMax) / 2 : this._activeOffset;
      var capCenterZ = this._activeCutAlongX ? this._activeOffset : (zMin + zMax) / 2;
      var capY = capH / 2 - 2.5;
      var self = this;

      function makeStencilMat(faceSide, op, refClear) {
        return new T.MeshBasicMaterial({
          side: faceSide,
          clippingPlanes: [plane],
          colorWrite: false,
          depthWrite: false,
          depthTest: true,
          stencilWrite: true,
          stencilFunc: T.AlwaysStencilFunc,
          stencilRef: 0,
          stencilMask: 0xff,
          stencilFail: T.KeepStencilOp,
          stencilZFail: op,
          stencilZPass: op
        });
      }

      function buildCapMesh(color, renderOrder) {
        /* The cap material uses NotEqual / Zero so the same pass
           both draws the colour AND resets the stencil to 0 — that
           way the next material group's stencil pass starts clean
           without needing an explicit clear. */
        var capMat = new T.MeshBasicMaterial({
          color: color,
          side: T.DoubleSide,
          clippingPlanes: null,
          stencilWrite: true,
          stencilRef: 0,
          stencilMask: 0xff,
          stencilFunc: T.NotEqualStencilFunc,
          stencilFail: T.ZeroStencilOp,
          stencilZFail: T.ZeroStencilOp,
          stencilZPass: T.ZeroStencilOp
        });
        var capGeo = new T.PlaneGeometry(capW, capH);
        var cap = new T.Mesh(capGeo, capMat);
        cap.renderOrder = renderOrder;
        if (self._activeCutAlongX) {
          cap.position.set(capCenterX, capY, self._activeOffset);
        } else {
          cap.rotation.y = Math.PI / 2;
          cap.position.set(self._activeOffset, capY, capCenterZ);
        }
        return cap;
      }

      /* Each group gets its own renderOrder window so the stencil
         passes for group N+1 don't fight with the cap from group N.
         We leave plenty of room (10 slots per group) for the line
         overlay below. */
      for (var gi = 0; gi < groupKeys.length; gi++) {
        var g = groups[groupKeys[gi]];
        var base = 10 + gi * 10;
        var matBack  = makeStencilMat(T.BackSide,  T.IncrementWrapStencilOp);
        var matFront = makeStencilMat(T.FrontSide, T.DecrementWrapStencilOp);
        for (var i = 0; i < g.meshes.length; i++) {
          var entry = g.meshes[i];
          var src = entry.node;
          src.updateMatrixWorld(true);
          var geom = src.geometry.clone();
          geom.applyMatrix4(src.matrixWorld);
          var mB = new T.Mesh(geom, matBack);
          var mF = new T.Mesh(geom, matFront);
          mB.renderOrder = base;
          mF.renderOrder = base + 1;
          grp.add(mB);
          grp.add(mF);
        }
        var cap = buildCapMesh(g.color, base + 2);
        grp.add(cap);
      }

      /* Wire-frame overlay pass — rebar / kari mesh lines that
         actually cross the cut plane render on top of whatever cap
         sits behind them. We just clone the line geometry, give it
         a clipping plane (so we only see the half-cut side), and
         draw it with a high render order. No stencil needed; lines
         have no interior to fill. */
      var wireOverlayCount = 0;
      eng.sceneGroup.traverse(function (node) {
        if (node.userData && node.userData.assetType === 'section-cut-aux') return;
        if (!(node.isLine || node.isLineSegments)) return;
        var t = (node.userData && node.userData.assetType)
              || (node.parent && node.parent.userData && node.parent.userData.assetType);
        if (!t || !WIRE_TYPES[t]) return;
        if (!node.material || !node.geometry) return;
        wireOverlayCount++;
      });
      _dbg('[section-cut] addCaps: ' + wireOverlayCount + ' wire overlays already clipped via main pass');
      /* Note: line meshes inherit the main clipping pipeline (we
         call apply() on every material in the scene), so the rebar
         already auto-clips. We don't duplicate them here — that
         would draw them twice and make the lines look bold. */

      eng.sceneGroup.add(grp);
      if (this._capsGroup) {
        eng.sceneGroup.remove(this._capsGroup);
        this._disposeGroup(this._capsGroup);
      }
      this._capsGroup = grp;
    },

    /* Re-run the whole pipeline for the current state. Called from
       BaseRenderer after every build so the cut survives variant /
       level / polygon edits. Heavily logged so a console session
       can trace exactly why the cut didn't appear. */
    refresh: function () {
      var eng = global.BaseEngine;
      _dbg('[section-cut] refresh: vizStage=' + STATE.vizStage + ' view=' + STATE.view + ' eng=' + !!eng);
      if (!eng) return;
      var inSection = (STATE.vizStage === 2 && STATE.view === '3d');
      if (!inSection) {
        _dbg('[section-cut] refresh: not in section-cut mode, clearing');
        this.clear();
        return;
      }
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 3) {
        _dbg('[section-cut] refresh: invalid polygon, clearing');
        this.clear();
        return;
      }
      var vk = _currentVariantKey();
      _dbg('[section-cut] refresh: computing plane for variant=' + vk + ' polyN=' + poly.length);
      var plane = this.compute(poly, vk, eng);
      if (!plane) {
        _dbg('[section-cut] refresh: compute returned null, clearing');
        this.clear();
        return;
      }
      _dbg('[section-cut] refresh: plane normal=' + JSON.stringify(plane.normal) + ' constant=' + plane.constant + ' offset=' + this._activeOffset + ' cutAlongX=' + this._activeCutAlongX);
      var matCount = this.apply(plane);
      _dbg('[section-cut] refresh: applied clipping to ' + matCount + ' materials');
      this.addCaps(plane, poly, eng);
      this.addOutline(plane, poly, eng);
      _dbg('[section-cut] refresh: caps + outline added');
    },

    setOffset01: function (frac) {
      if (this._maxCoord <= this._minCoord) return;
      if (frac < 0) frac = 0;
      if (frac > 1) frac = 1;
      this._userOffset = this._minCoord + frac * (this._maxCoord - this._minCoord);
      this.refresh();
    },

    offset01: function () {
      if (this._maxCoord <= this._minCoord) return 0.5;
      var f = (this._activeOffset - this._minCoord) / (this._maxCoord - this._minCoord);
      return Math.max(0, Math.min(1, f));
    }
  };

  var _BaseDimensions = {
    svgEl: null,
    chipLayer: null,
    chipEls: [],
    SVG_NS: 'http://www.w3.org/2000/svg',

    init: function () {
      var root = document.getElementById('cf-wrap-base');
      if (!root) return;
      if (!this.svgEl) {
        var svg = document.createElementNS(this.SVG_NS, 'svg');
        svg.id = 'cf-base-dims-svg';
        svg.style.cssText = [
          'position:absolute', 'top:0', 'left:0',
          'width:100%', 'height:100%',
          'pointer-events:none', 'display:none', 'z-index:6'
        ].join(';');
        root.appendChild(svg);
        this.svgEl = svg;
        var self = this;
        global.addEventListener('resize', function () { self.refresh(); });
      }
      if (!this.chipLayer) {
        var existing = document.getElementById('cf-base-dim-chips');
        if (existing) {
          this.chipLayer = existing;
        } else {
          var layer = document.createElement('div');
          layer.id = 'cf-base-dim-chips';
          layer.style.cssText = [
            'position:absolute', 'top:0', 'left:0',
            'width:100%', 'height:100%',
            'pointer-events:none', 'z-index:7'
          ].join(';');
          root.appendChild(layer);
          this.chipLayer = layer;
        }
      }
    },

    _clearChips: function () {
      for (var i = 0; i < this.chipEls.length; i++) {
        if (this.chipEls[i] && this.chipEls[i].parentNode) {
          this.chipEls[i].parentNode.removeChild(this.chipEls[i]);
        }
      }
      this.chipEls = [];
    },

    hide: function () {
      this.init();
      if (this.svgEl) { this.svgEl.style.display = 'none'; this.svgEl.innerHTML = ''; }
      if (this.chipLayer) this.chipLayer.style.display = 'none';
      this._clearChips();
    },

    refresh: function () {
      this.init();
      if (!this.svgEl) return;
      var show = (STATE.view === '2d' && STATE.vizStage === 1);
      if (!show) { this.hide(); return; }

      this.svgEl.style.display = '';
      this.svgEl.innerHTML = '';
      this.chipLayer.style.display = '';
      this._clearChips();

      var eng = global.BaseEngine;
      if (!eng || !eng.cameraOrtho || !eng.renderer) return;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      var w = rect.width, h = rect.height;
      if (w < 10 || h < 10) return;
      this.svgEl.setAttribute('viewBox', '0 0 ' + w + ' ' + h);

      var T = global.THREE;
      var cam = eng.cameraOrtho;
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 2) return;

      function proj(x, z) {
        var v = new T.Vector3(x, 0, z).project(cam);
        return {
          x: (v.x * 0.5 + 0.5) * w,
          y: (1 - (v.y * 0.5 + 0.5)) * h
        };
      }

      var cx = 0, cz = 0;
      for (var i = 0; i < poly.length; i++) { cx += poly[i][0]; cz += poly[i][1]; }
      cx /= poly.length; cz /= poly.length;

      var GRAY = '#888', DARK = '#1a1a1a';
      var DIM_OFFSET = 32;
      var EXT_GAP = 4, EXT_OVER = 6, ARROW = 6;
      var unit = STATE.isMetric ? 'm' : 'ft';

      for (var i = 0; i < poly.length; i++) {
        var a = poly[i];
        var b = poly[(i + 1) % poly.length];
        var lenM = Math.hypot(b[0] - a[0], b[1] - a[1]);
        if (lenM < 0.05) continue;

        var label = fmtDim(lenM);

        var pA = proj(a[0], a[1]);
        var pB = proj(b[0], b[1]);
        var mid = proj((a[0] + b[0]) / 2, (a[1] + b[1]) / 2);
        var cs  = proj(cx, cz);

        var ex = pB.x - pA.x, ey = pB.y - pA.y;
        var elen = Math.hypot(ex, ey);
        if (elen < 1) continue;

        var nxs = -ey / elen, nys = ex / elen;
        var dot = (mid.x - cs.x) * nxs + (mid.y - cs.y) * nys;
        if (dot < 0) { nxs = -nxs; nys = -nys; }

        var oxA = pA.x + nxs * DIM_OFFSET;
        var oyA = pA.y + nys * DIM_OFFSET;
        var oxB = pB.x + nxs * DIM_OFFSET;
        var oyB = pB.y + nys * DIM_OFFSET;

        var exAx = pA.x + nxs * EXT_GAP;
        var exAy = pA.y + nys * EXT_GAP;
        var exAend_x = pA.x + nxs * (DIM_OFFSET + EXT_OVER);
        var exAend_y = pA.y + nys * (DIM_OFFSET + EXT_OVER);

        var exBx = pB.x + nxs * EXT_GAP;
        var exBy = pB.y + nys * EXT_GAP;
        var exBend_x = pB.x + nxs * (DIM_OFFSET + EXT_OVER);
        var exBend_y = pB.y + nys * (DIM_OFFSET + EXT_OVER);

        this._addLine(exAx, exAy, exAend_x, exAend_y, GRAY, 0.4);
        this._addLine(exBx, exBy, exBend_x, exBend_y, GRAY, 0.4);
        this._addLine(oxA, oyA, oxB, oyB, DARK, 0.5);

        var tx = -ex / elen, ty = -ey / elen;
        this._addLine(oxA, oyA, oxA + tx * ARROW + nxs * (ARROW * 0.5), oyA + ty * ARROW + nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxA, oyA, oxA + tx * ARROW - nxs * (ARROW * 0.5), oyA + ty * ARROW - nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxB, oyB, oxB - tx * ARROW + nxs * (ARROW * 0.5), oyB - ty * ARROW + nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxB, oyB, oxB - tx * ARROW - nxs * (ARROW * 0.5), oyB - ty * ARROW - nys * (ARROW * 0.5), DARK, 0.5);

        var chipX = (oxA + oxB) / 2 + nxs * 14;
        var chipY = (oyA + oyB) / 2 + nys * 14;
        this._addChip(chipX, chipY, label, i);
      }
    },

    _addLine: function (x1, y1, x2, y2, color, width) {
      var line = document.createElementNS(this.SVG_NS, 'line');
      line.setAttribute('x1', x1); line.setAttribute('y1', y1);
      line.setAttribute('x2', x2); line.setAttribute('y2', y2);
      line.setAttribute('stroke', color);
      line.setAttribute('stroke-width', width);
      line.setAttribute('stroke-linecap', 'round');
      this.svgEl.appendChild(line);
    },

    _addChip: function (x, y, text, edgeIndex) {
      var self = this;
      var chip = document.createElement('div');
      chip.className = 'cf-dim-chip cf-dim-chip--label-only';
      chip.style.left = x + 'px';
      chip.style.top  = y + 'px';
      chip.textContent = text;
      chip.title = 'Click to edit length';
      chip.setAttribute('data-edge-index', String(edgeIndex));
      chip.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      chip.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        self._editChipInline(chip, edgeIndex);
      });
      this.chipLayer.appendChild(chip);
      this.chipEls.push(chip);
    },

    _editChipInline: function (chip, edgeIndex) {
      if (chip._editing) return;
      var poly = STATE.polygon;
      if (!poly || edgeIndex < 0 || edgeIndex >= poly.length) return;
      var a = poly[edgeIndex];
      var b = poly[(edgeIndex + 1) % poly.length];
      var lenM = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (lenM < 1e-3) return;
      var lenDisp = STATE.isMetric ? lenM : (lenM * 3.28084);
      var unit = STATE.isMetric ? 'm' : 'ft';
      var orig = chip.textContent;

      chip._editing = true;
      chip.classList.add('cf-dim-chip--editing');
      chip.textContent = '';

      var input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'decimal';
      input.className = 'cf-dim-chip-input';
      input.value = lenDisp.toFixed(2);
      chip.appendChild(input);
      var unitSpan = document.createElement('span');
      unitSpan.textContent = unit;
      chip.appendChild(unitSpan);

      var done = false;
      function finish(commit) {
        if (done) return;
        done = true;
        chip._editing = false;
        chip.classList.remove('cf-dim-chip--editing');
        if (commit) {
          var raw = String(input.value).replace(',', '.').trim();
          var newLen = parseFloat(raw);
          if (isFinite(newLen) && newLen > 0.05) {
            var newLenM = STATE.isMetric ? newLen : (newLen / 3.28084);
            _applyEdgeLengthEdit(edgeIndex, newLenM);
            return;
          }
        }
        chip.textContent = orig;
      }
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); finish(true); }
        else if (e.key === 'Escape') { e.preventDefault(); finish(false); }
      });
      input.addEventListener('blur', function () { finish(true); });
      input.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      input.addEventListener('click', function (e) { e.stopPropagation(); });

      setTimeout(function () { input.focus(); input.select(); }, 0);
    }
  };

  function _applyEdgeLengthEdit(edgeIndex, newLenM) {
    var poly = STATE.polygon;
    if (!poly || edgeIndex < 0 || edgeIndex >= poly.length) return;
    var n = poly.length;
    var iA = edgeIndex;
    var iB = (edgeIndex + 1) % n;
    var a = poly[iA];
    var b = poly[iB];
    var dx = b[0] - a[0], dz = b[1] - a[1];
    var lenM = Math.hypot(dx, dz);
    if (lenM < 1e-3) return;
    var delta = newLenM - lenM;
    if (Math.abs(delta) < 1e-4) return;

    var startState = JSON.parse(JSON.stringify(STATE.polygon));
    var ux = dx / lenM, uz = dz / lenM;
    var AXIS_TOL = 0.05;
    var axisHorz = Math.abs(dz) < AXIS_TOL;
    var axisVert = Math.abs(dx) < AXIS_TOL;

    if (axisHorz) {
      /* Horizontal edge — the wall on the V_{i+1} side is identified by
         X coordinate. Translate every vertex sharing that X by the edge
         delta along X. Other axis-aligned edges keep their length and
         direction; only the parallel edge on the opposite side absorbs
         the change in polygon closure. */
      var wallX = b[0];
      var moveX = ux * delta;
      for (var k = 0; k < n; k++) {
        if (Math.abs(poly[k][0] - wallX) < AXIS_TOL) {
          poly[k][0] = _clampCoord(snap(poly[k][0] + moveX));
        }
      }
    } else if (axisVert) {
      var wallZ = b[1];
      var moveZ = uz * delta;
      for (var k = 0; k < n; k++) {
        if (Math.abs(poly[k][1] - wallZ) < AXIS_TOL) {
          poly[k][1] = _clampCoord(snap(poly[k][1] + moveZ));
        }
      }
    } else {
      /* Diagonal edge — fall back to moving V_{i+1} along the edge
         axis. Adjacent edges may skew slightly; for a foundation
         that's almost always axis-aligned this branch is rare. */
      poly[iB][0] = _clampCoord(snap(poly[iB][0] + ux * delta));
      poly[iB][1] = _clampCoord(snap(poly[iB][1] + uz * delta));
    }

    if (typeof _UndoHistory !== 'undefined' && _UndoHistory && _UndoHistory.pushIfChanged) {
      _UndoHistory.pushIfChanged(startState, STATE.variant);
    }
    if (typeof refreshUI === 'function') refreshUI();
  }

  var _VisualizationManager = {
    DISABLED: false,

    init: function () {
      _injectCoreCSS();
      var btn = document.getElementById('cf-btn-viz');
      if (this.DISABLED) {
        if (btn) btn.style.display = 'none';
        STATE.vizStage = 0;
        var wrap = document.getElementById('cf-2d-opacity-slider-wrap');
        if (wrap) wrap.classList.remove('cf-2d-visible');
        return;
      }
      STATE.vizStage = 0;
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function () { self.cycle(); });
      this._wireSlider();
      this._injectSectionSlider();
      this.apply();
    },

    _wireSlider: function () {
      var slider = document.getElementById('cf-2d-opacity-slider');
      if (!slider) return;
      var maxV = parseInt(slider.max, 10) || 100;
      var self = this;
      var updateFill = function (pct) {
        var fillPct = 100 - (pct / maxV) * 100;
        slider.style.setProperty('--cfg-fill', fillPct + '%');
      };
      var onChange = function () {
        var sv = parseInt(slider.value, 10) || 0;
        STATE.opacity2D = (100 - sv) / 100;
        updateFill(sv);
        self._applyOpacityToMaterials();
      };
      slider.addEventListener('input',  onChange);
      slider.addEventListener('change', onChange);
      var initSliderVal = Math.round((1 - STATE.opacity2D) * 100);
      slider.value = initSliderVal;
      updateFill(initSliderVal);
    },

    _injectSectionSlider: function () {
      if (document.getElementById('cf-section-slider-wrap')) return;
      if (!document.getElementById('cf-section-slider-css')) {
        var st = document.createElement('style');
        st.id = 'cf-section-slider-css';
        st.textContent =
          '#cf-section-slider-wrap{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
          'display:none;align-items:center;gap:8px;padding:10px 14px;border-radius:999px;' +
          'background:rgba(255,255,255,0.96);box-shadow:0 4px 16px rgba(0,0,0,0.22);z-index:99999;' +
          'font:15px/1 system-ui,-apple-system,sans-serif;color:#3b4250;user-select:none;-webkit-user-select:none;}' +
          '#cf-section-slider-wrap.cf-section-visible{display:flex;}' +
          '#cf-section-slider-wrap .cf-sec-btn{width:34px;height:34px;border:none;border-radius:50%;' +
          'background:#eceae3;color:#3b4250;font-size:18px;line-height:1;cursor:pointer;flex:0 0 auto;}' +
          '#cf-section-slider-wrap .cf-sec-btn:active{background:#d9d7cf;}' +
          '#cf-section-slider{width:200px;height:28px;accent-color:#3b4250;cursor:pointer;touch-action:none;}' +
          '#cf-section-slider-wrap .cf-sec-lbl{font-size:18px;padding:0 2px;}';
        document.head.appendChild(st);
      }
      var wrap = document.createElement('div');
      wrap.id = 'cf-section-slider-wrap';
      wrap.title = 'Posunúť rovinu rezu';

      var lbl = document.createElement('span');
      lbl.className = 'cf-sec-lbl';
      lbl.textContent = '\u21C6';

      var bMinus = document.createElement('button');
      bMinus.type = 'button';
      bMinus.className = 'cf-sec-btn';
      bMinus.textContent = '\u25C0';

      var slider = document.createElement('input');
      slider.type = 'range';
      slider.id = 'cf-section-slider';
      slider.min = '0';
      slider.max = '100';
      slider.value = '50';

      var bPlus = document.createElement('button');
      bPlus.type = 'button';
      bPlus.className = 'cf-sec-btn';
      bPlus.textContent = '\u25B6';

      wrap.appendChild(lbl);
      wrap.appendChild(bMinus);
      wrap.appendChild(slider);
      wrap.appendChild(bPlus);
      document.body.appendChild(wrap);

      var commit = function (v) {
        if (v < 0) v = 0;
        if (v > 100) v = 100;
        slider.value = v;
        if (_SectionCutManager && _SectionCutManager.setOffset01) _SectionCutManager.setOffset01(v / 100);
      };
      var onChange = function () { commit(parseInt(slider.value, 10) || 0); };
      slider.addEventListener('input', onChange);
      slider.addEventListener('change', onChange);
      bMinus.addEventListener('click', function () { commit((parseInt(slider.value, 10) || 0) - 5); });
      bPlus.addEventListener('click', function () { commit((parseInt(slider.value, 10) || 0) + 5); });
    },

    cycle: function () {
      if (this.DISABLED) return;
      /* 3-stage cycle:
           0 = off (= default material visibility, no overlays)
           1 = stage view (= opacity-faded materials, dimensions on top)
           2 = section cut (= vertical clipping plane, 3D only)
         Section cut is meaningless in 2D plan view (= the cut is
         perpendicular to the ground), so we wrap around from 1 if
         the user is in 2D. */
      /* stages: 0 off | 1 stage view | 2 section cut (3D) | 3 x-ray covering (3D) */
      var next = (STATE.vizStage + 1) % 4;
      if (STATE.view !== '3d' && next >= 2) next = 0;   /* 2 & 3 are 3D-only */
      STATE.vizStage = next;
      _dbg('[viz-cycle] vizStage=' + STATE.vizStage + ' view=' + STATE.view);
      this.apply();
    },

    reset: function () {
      STATE.vizStage = 0;
      if (this.DISABLED) return;
      this.apply();
    },

    apply: function () {
      if (this.DISABLED) return;
      this._applyOpacityToMaterials();
      if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      this._updateButton();
      this._updateSliderVisibility();
      this._updateStageOverlays();
      if (_SlopeManager && _SlopeManager._updateSlider) _SlopeManager._updateSlider();
      _BaseDimensions.refresh();
      /* Trigger the section-cut pipeline whenever the stage state
         changes. The refresh function itself handles the early
         return when the stage isn't 2. */
      if (_SectionCutManager) _SectionCutManager.refresh();
    },

    refreshDimensions: function () {
      if (this.DISABLED) return;
      _BaseDimensions.refresh();
    },

    _applyOpacityToMaterials: function () {
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup) return;
      /* Stage 1 = faded materials so dimensions + overlays read on
         top. Stage 2 (section cut) wants FULL opacity so the cut
         surface looks solid — fading would defeat the point. */
      var in2DStage = (STATE.view === '2d' && STATE.vizStage === 1);
      var in3DStage = (STATE.view === '3d' && STATE.vizStage === 1);
      var in3DXray  = (STATE.view === '3d' && STATE.vizStage === 3);
      var emat = eng._materials || {};
      eng.sceneGroup.traverse(function (node) {
        if (!node.isMesh || !node.material) return;
        var pt = (node.userData && node.userData.partType) ||
                 (node.parent && node.parent.userData && node.parent.userData.partType);
        if (pt === 'houseGhost') return;
        /* Prefer the mesh's OWN userData (set by single-mesh rebars in
           the strip variant) over the parent group's userData (set on
           the stirrup/sheet group wrapping multiple wires). Falling back
           to the parent ensures grouped mesh-wires still get detected. */
        var ud = node.userData;
        if (!ud || !ud.assetType) {
          ud = (node.parent && node.parent.userData) || {};
        }
        var isMeshWire = (ud.assetType === 'mesh');
        var isRebar    = (ud.assetType === 'rebar');
        var isTimber   = (ud.assetType === 'timber-beam');
        var isPostBase = (ud.assetType === 'post-base');
        /* roof covering = skin + standing seams (shared materials) */
        var isCover = (node.material === emat.shelterRoof || node.material === emat.seam);
        var op;
        if (in3DXray) {
          op = isCover ? 0.18 : 1.0;
        } else if (isMeshWire || isRebar || isTimber || isPostBase) {
          op = 1.0;
        } else if (in3DStage) {
          op = 1.0;
        } else if (in2DStage) {
          op = STATE.opacity2D;
        } else {
          op = 1.0;
        }
        var m = node.material;
        if (Array.isArray(m)) {
          for (var i = 0; i < m.length; i++) {
            m[i].transparent = op < 1;
            m[i].opacity = op;
            m[i].depthWrite = (op > 0.99);
            m[i].needsUpdate = true;
          }
        } else {
          m.transparent = op < 1;
          m.opacity = op;
          m.depthWrite = (op > 0.99);
          m.needsUpdate = true;
        }
      });
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-viz');
      if (!btn) return;
      var stage = STATE.vizStage;
      btn.classList.toggle('active', stage !== 0);
      btn.setAttribute('data-stage', String(stage));
      btn.setAttribute('aria-pressed', stage !== 0 ? 'true' : 'false');
      var lbl = document.getElementById('cf-stat-viz') || btn.querySelector('.cf-viz-label');
      if (lbl) {
        /* Labels:
             stage 0 → "off"        (no overlay)
             stage 1 → "1/2"        (stage view)
             stage 2 → "2/2"        (section cut)
           In 2D we don't expose stage 2, but if the cycle wrapped
           in 3D before the user switched to 2D, the cached value
           can still be 2 — render the literal stage so the user
           sees what state they're in. */
        lbl.textContent = (stage === 0) ? 'off' : (stage + '/3');
      }
    },

    _updateSliderVisibility: function () {
      var wrap = document.getElementById('cf-2d-opacity-slider-wrap');
      if (wrap) {
        var visible = (STATE.vizStage === 1);
        wrap.classList.toggle('cf-2d-visible', visible);
      }
      var sw = document.getElementById('cf-section-slider-wrap');
      if (sw) {
        var secVis = (STATE.vizStage === 2 && STATE.view === '3d');
        sw.classList.toggle('cf-section-visible', secVis);
        if (secVis) {
          var sl = document.getElementById('cf-section-slider');
          if (sl && _SectionCutManager && _SectionCutManager.offset01) {
            sl.value = Math.round(_SectionCutManager.offset01() * 100);
          }
        }
      }
    },

    _updateStageOverlays: function () {
      var wrap = document.getElementById('cf-wrap-base');
      if (!wrap) return;
      var inStageView = (STATE.vizStage === 1);
      wrap.classList.toggle('cf-stage-view', inStageView);
      if (inStageView) {
        if (_MapManager && _MapManager.map && _MapManager.map.dragPan) _MapManager.map.dragPan.disable();
      } else {
        if (_MapManager && _MapManager.map && _MapManager.map.dragPan && STATE.view === '2d' && !STATE.dispoLocked) _MapManager.map.dragPan.enable();
      }
    }
  };

  function _snapToNearestPolygonEdge(x, z) {
    var poly = STATE.polygon;
    if (!poly || poly.length < 2) return null;
    var n = poly.length;
    var best = null;
    for (var i = 0; i < n; i++) {
      var a = poly[i];
      var b = poly[(i + 1) % n];
      var ax = a[0], az = a[1];
      var bx = b[0], bz = b[1];
      var ex = bx - ax, ez = bz - az;
      var lenSq = ex * ex + ez * ez;
      if (lenSq < 1e-6) continue;
      var t = ((x - ax) * ex + (z - az) * ez) / lenSq;
      if (t < 0) t = 0;
      if (t > 1) t = 1;
      var px = ax + t * ex;
      var pz = az + t * ez;
      var d = Math.hypot(x - px, z - pz);
      if (!best || d < best.dist) {
        best = { edgeIdx: i, tFrac: t, x: px, z: pz, dist: d };
      }
    }
    return best;
  }

  function _insertCornerOnEdge(edgeIdx, tFrac) {
    var poly = STATE.polygon;
    if (!poly || poly.length < 3) return false;
    var n = poly.length;
    if (edgeIdx < 0 || edgeIdx >= n) return false;

    var a = poly[edgeIdx];
    var b = poly[(edgeIdx + 1) % n];
    var ax = a[0], az = a[1];
    var bx = b[0], bz = b[1];

    var px = ax + tFrac * (bx - ax);
    var pz = az + tFrac * (bz - az);

    var distA = Math.hypot(px - ax, pz - az);
    var distB = Math.hypot(px - bx, pz - bz);

    var sharedIdx, sharedV, otherEndOnE, adjOtherIdx;
    if (distA <= distB) {
      sharedIdx     = edgeIdx;
      sharedV       = a;
      otherEndOnE   = b;
      adjOtherIdx   = (edgeIdx - 1 + n) % n;
    } else {
      sharedIdx     = (edgeIdx + 1) % n;
      sharedV       = b;
      otherEndOnE   = a;
      adjOtherIdx   = (edgeIdx + 2) % n;
    }
    var adjOther = poly[adjOtherIdx];

    var lenE   = Math.hypot(otherEndOnE[0] - sharedV[0], otherEndOnE[1] - sharedV[1]);
    var lenAdj = Math.hypot(adjOther[0]    - sharedV[0], adjOther[1]    - sharedV[1]);
    if (lenE < 0.2 || lenAdj < 0.2) return false;

    var d = Math.min(distA, distB);
    d = Math.min(d, lenE * 0.49, lenAdj * 0.49);
    if (d < 0.15) return false;

    var v1x = snap(sharedV[0] + (d / lenE)   * (otherEndOnE[0] - sharedV[0]));
    var v1z = snap(sharedV[1] + (d / lenE)   * (otherEndOnE[1] - sharedV[1]));
    var v2x = snap(sharedV[0] + (d / lenAdj) * (adjOther[0]    - sharedV[0]));
    var v2z = snap(sharedV[1] + (d / lenAdj) * (adjOther[1]    - sharedV[1]));
    var v3x = snap(v1x + v2x - sharedV[0]);
    var v3z = snap(v1z + v2z - sharedV[1]);

    var v1 = [_clampCoord(v1x), _clampCoord(v1z)];
    var v2 = [_clampCoord(v2x), _clampCoord(v2z)];
    var v3 = [_clampCoord(v3x), _clampCoord(v3z)];

    if (distA <= distB) {
      poly.splice(sharedIdx, 1, v2, v3, v1);
    } else {
      poly.splice(sharedIdx, 1, v1, v3, v2);
    }
    return true;
  }

  var _CornerInserter = {
    pendingPlacement: false,
    _setPending: function (on) {
      this.pendingPlacement = !!on;
      var canvas = document.getElementById('cf-canvas-base');
      if (canvas) canvas.style.cursor = on ? 'crosshair' : '';
      var btn = document.getElementById('cf-btn-insert-corner');
      if (btn) {
        btn.classList.toggle('active', !!on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    },
    init: function () {
      var self = this;
      var btn = document.getElementById('cf-btn-insert-corner');
      if (btn) {
        btn.addEventListener('click', function () {
          if (STATE.view !== '2d') return;
          self._setPending(!self.pendingPlacement);
        });
      }
      var canvas = document.getElementById('cf-canvas-base');
      if (canvas) {
        canvas.addEventListener('click', function (e) {
          if (!self.pendingPlacement) return;
          if (STATE.view !== '2d') { self._setPending(false); return; }
          var p = _screenToWorld(e.clientX, e.clientY);
          if (!p) return;
          var snapped = _snapToNearestPolygonEdge(p.x, p.z);
          if (!snapped) return;
          var prevPoly = JSON.parse(JSON.stringify(STATE.polygon));
          var ok = _insertCornerOnEdge(snapped.edgeIdx, snapped.tFrac);
          self._setPending(false);
          if (!ok) return;
          _UndoHistory.pushIfChanged(prevPoly, STATE.variant);
          rebuildDragHandles();
          if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
          refreshUI();
        });
      }
    }
  };

  var _AssetDrawer = {
    _ready: false,
    _raycaster: null,
    _mouse: null,
    _selectedMesh: null,
    _origMaterial: null,

    _HIGHLIGHT_HEX: 0xff8c42,

    _findBoQRow: function (boqCode) {
      var rows = computeBoQ();
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (Array.isArray(r) && r[0] === boqCode) {
          return { code: r[0], qty: r[1] || 0, qtyAlt: r[2] || 0 };
        }
        if (r && r.code === boqCode) return r;
      }
      return null;
    },

    _buildInstance: function (mesh) {
      if (!mesh || !mesh.userData || !mesh.userData.boqCode) return null;
      var ud = mesh.userData;
      var bridge = global.ConfiguratorBudgetBridge || null;

      var boqItem = (bridge && bridge.getBoqItem) ? bridge.getBoqItem(ud.boqCode) : null;
      var name     = (boqItem && boqItem.name)     || ud.boqCode;
      var category = (boqItem && boqItem.category) || ud.category || ud.assetType;
      var unit     = boqItem
        ? (STATE.isMetric ? boqItem.unitMetric : boqItem.unitImperial)
        : null;
      if (!unit) unit = STATE.isMetric ? 'pcs' : 'pcs';

      var userPrice = (bridge && bridge.getUserPrice) ? bridge.getUserPrice(ud.boqCode) : null;
      var product = userPrice ? {
        title:    userPrice.title,
        url:      userPrice.url,
        image:    userPrice.image,
        source:   userPrice.source,
        price:    userPrice.price,
        currency: userPrice.currency,
        unit:     unit
      } : null;

      var row = this._findBoQRow(ud.boqCode);
      var qty = (row && typeof row.qty === 'number') ? row.qty : 0;
      var unitPrice = userPrice ? userPrice.price : 0;
      var totalPrice = qty * unitPrice;

      var pos = mesh.getWorldPosition ? mesh.getWorldPosition(new global.THREE.Vector3()) : { x: 0, y: 0, z: 0 };
      var inst = {
        id:                 ud.assetType + ':' + (ud.index != null ? ud.index : 0),
        name:               name,
        type:               name,
        boqCode:            ud.boqCode,
        category:           category,
        unit:               unit,
        projectQuantity:    qty,
        projectUnitPrice:   unitPrice,
        projectTotalPrice:  totalPrice,
        position:           { x: pos.x, y: pos.y, z: pos.z }
      };
      if (typeof ud.length === 'number') inst.length = ud.length;
      if (product) inst.product = product;
      return inst;
    },

    _i18nLabels: function () {
      var boot = global.BASE_BOOT || {};
      var i18n = boot.i18n || {};
      var ad = i18n.assetDrawer || {};
      var labels = {};
      for (var k in ad) { if (ad.hasOwnProperty(k)) labels[k] = ad[k]; }
      return labels;
    },

    _highlight: function (mesh) {
      this._clearHighlight();
      if (!mesh || !mesh.material) return;
      this._selectedMesh = mesh;
      this._origMaterial = mesh.material;
      try {
        var T = global.THREE;
        mesh.material = new T.MeshLambertMaterial({ color: this._HIGHLIGHT_HEX });
      } catch (_) {}
    },

    _clearHighlight: function () {
      if (this._selectedMesh && this._origMaterial) {
        try { this._selectedMesh.material = this._origMaterial; } catch (_) {}
      }
      this._selectedMesh = null;
      this._origMaterial = null;
    },

    init: function () {
      if (this._ready) return;
      if (!global.ConfiguratorAssetDrawer) {
        _dbg('AssetDrawer: ConfiguratorAssetDrawer global not loaded yet');
        var self = this;
        setTimeout(function () { self.init(); }, 200);
        return;
      }
      var T = global.THREE;
      if (!T) return;
      this._raycaster = new T.Raycaster();
      this._mouse = new T.Vector2();

      var self = this;
      global.ConfiguratorAssetDrawer.init({
        registry: function (id) {
          if (!self._selectedMesh) return null;
          return self._buildInstance(self._selectedMesh);
        },
        onClose: function () { self._clearHighlight(); },
        labels: this._i18nLabels(),
        drawerScopeClass: 'base-asset-drawer'
      });

      this._bindCanvas();
      this._ready = true;
      _dbg('AssetDrawer initialised');
    },

    _bindCanvas: function () {
      var self = this;
      var eng = global.BaseEngine;
      if (!eng || !eng.renderer || !eng.renderer.domElement) {
        setTimeout(function () { self._bindCanvas(); }, 100);
        return;
      }
      var canvas = eng.renderer.domElement;
      var pressStart = { x: 0, y: 0, t: 0 };

      canvas.addEventListener('pointerdown', function (e) {
        pressStart.x = e.clientX;
        pressStart.y = e.clientY;
        pressStart.t = Date.now();
      });

      canvas.addEventListener('pointerup', function (e) {
        if (STATE.view !== '3d') return;
        if (_CornerInserter && _CornerInserter.pendingPlacement) return;
        var dx = e.clientX - pressStart.x;
        var dy = e.clientY - pressStart.y;
        var dt = Date.now() - pressStart.t;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) return;
        if (dt > 500) return;
        self._handleCanvasClick(e);
      });
    },

    _handleCanvasClick: function (e) {
      var eng = global.BaseEngine;
      if (!eng || !eng.scene || !eng.cameraPersp || !eng.sceneGroup) return;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      this._mouse.x =  ((e.clientX - rect.left) / rect.width)  * 2 - 1;
      this._mouse.y = -((e.clientY - rect.top)  / rect.height) * 2 + 1;
      this._raycaster.setFromCamera(this._mouse, eng.cameraPersp);
      var hits = this._raycaster.intersectObjects(eng.sceneGroup.children, true);
      if (!hits || !hits.length) {
        if (global.ConfiguratorAssetDrawer && global.ConfiguratorAssetDrawer.isOpen && global.ConfiguratorAssetDrawer.isOpen()) {
          global.ConfiguratorAssetDrawer.close();
        }
        return;
      }
      var mesh = null;
      for (var i = 0; i < hits.length; i++) {
        var h = hits[i].object;
        if (h && h.userData && h.userData.boqCode) { mesh = h; break; }
      }
      if (!mesh) return;
      this._highlight(mesh);
      var instance = this._buildInstance(mesh);
      if (!instance) return;
      global.ConfiguratorAssetDrawer.open(instance.id);
    }
  };

  var _ProjectStore = {
    SCHEMA_VERSION:  1,
    MASTER_PAGE_URL: 'https://www.theleva.com/pages/my',
    CONFIG_KEY:      'roof',

    _projectId:   null,
    _saveTimer:   null,
    _subscribers: {},
    _initialized: false,

    init: function () {
      if (this._initialized) return;
      var boot = global.BASE_BOOT || {};
      var pid = boot.linkedMainProjectId || null;
      var activeKey = this._activeKey();
      if (!pid) {
        try { pid = localStorage.getItem(activeKey); } catch (_) {}
      }
      if (!pid) {
        pid = this._generateUuid();
        try { localStorage.setItem(activeKey, pid); } catch (_) {}
      }
      this._projectId = pid;

      var self = this;
      global.addEventListener('storage', function (e) { self._onStorageEvent(e); });
      global.addEventListener('pagehide', function () { self.publishNow(); });

      this._initialized = true;
      _dbg('ProjectStore: project=' + pid + ' customer=' + this.getCustomerId());
    },

    getProjectId:  function () { return this._projectId; },
    getCustomerId: function () {
      var boot = global.BASE_BOOT || {};
      return (boot.customerId != null) ? String(boot.customerId) : 'anon';
    },

    _activeKey: function () {
      return 'levaActiveProject:c' + this.getCustomerId();
    },
    _payloadKey: function (configKey) {
      return 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':' + configKey;
    },

    _generateUuid: function () {
      if (global.crypto && global.crypto.randomUUID) {
        try { return global.crypto.randomUUID(); } catch (_) {}
      }
      return 'p-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    },

    _readTotalsFromWidget: function () {
      function parseNum(id) {
        var el = document.getElementById(id);
        if (!el) return 0;
        var t = (el.textContent || '').replace(/[^0-9.,-]/g, '').replace(',', '.');
        return parseFloat(t) || 0;
      }
      /* The budget widget DOM (cf-bw-*) is the primary source, but on
         pages where it is absent or not yet rendered it reads 0 — which
         then ships a zero budget to the master canvas. Fall back to the
         live globals the page exposes (lastMaterialsTotal / lastDelivery
         Total) so foundations always reports a real budget. */
      var matDom  = parseNum('cf-bw-material');
      var execDom = parseNum('cf-bw-execution');
      var totDom  = parseNum('cf-bw-total');
      var matGlobal  = (typeof global.lastMaterialsTotal === 'number') ? global.lastMaterialsTotal : null;
      var execGlobal = (typeof global.lastDeliveryTotal  === 'number') ? global.lastDeliveryTotal  : null;
      var materialKc  = matDom  > 0 ? matDom  : (matGlobal  != null ? matGlobal  : 0);
      var executionKc = execDom > 0 ? execDom : (execGlobal != null ? execGlobal : 0);
      var totalKc     = totDom  > 0 ? totDom  : (materialKc + executionKc);
      return {
        materialKc:  materialKc,
        executionKc: executionKc,
        totalKc:     totalKc,
        hours:       parseNum('cf-bw-time')
      };
    },

    serialize: function () {
      var boot = global.BASE_BOOT || {};
      var poly = getFootprintPolygon();
      var bb   = getBBox();
      var area = computeArea();
      var per  = computePerimeter();
      var mapData = null;
      if (_MapManager && _MapManager.center) {
        mapData = {
          address: _MapManager.address || null,
          center:  _MapManager.center  || null,
          bearing: _MapManager.bearing || 0
        };
      }
      return {
        v:             this.SCHEMA_VERSION,
        configKey:     this.CONFIG_KEY,
        productHandle: boot.productHandle || null,
        productId:     boot.productId     || null,
        productTitle:  boot.productTitle  || null,
        variant:       STATE.variant,
        variantKey:    ['slab','strip','piers','precast','screws'][STATE.variant - 1] || null,
        lvl:           STATE.lvl,
        slope:         { active: STATE.slopeActive, deg: STATE.slopeDeg },
        mapLocked:     STATE.mapLocked,
        units:         STATE.isMetric ? 'm' : 'ft',
        masterLinked:  STATE.masterLinked,
        shape: {
          polygon:     poly,
          bboxL:       bb.L,
          bboxW:       bb.W,
          area:        area,
          perimeter:   per,
          cornerCount: poly.length
        },
        totals:        this._readTotalsFromWidget(),
        map:           mapData,
        updatedAt:     new Date().toISOString()
      };
    },

    publish: function () {
      var self = this;
      if (this._saveTimer) clearTimeout(this._saveTimer);
      this._saveTimer = setTimeout(function () { self.publishNow(); }, 500);
    },

    publishNow: function () {
      if (!this._initialized || !this._projectId) return;
      try {
        var payload = this.serialize();
        localStorage.setItem(this._payloadKey(this.CONFIG_KEY), JSON.stringify(payload));
      } catch (e) {
        _dbg('ProjectStore publish error: ' + (e && e.message ? e.message : e));
      }
    },

    read: function (configKey) {
      if (!this._projectId || !configKey) return null;
      try {
        var raw = localStorage.getItem(this._payloadKey(configKey));
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || data.v !== this.SCHEMA_VERSION) return null;
        return data;
      } catch (e) { return null; }
    },

    list: function () {
      if (!this._projectId) return [];
      var prefix = 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':';
      var keys = [];
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k && k.indexOf(prefix) === 0) {
            keys.push(k.substring(prefix.length));
          }
        }
      } catch (e) {}
      return keys;
    },

    clear: function () {
      if (!this._projectId) return;
      try { localStorage.removeItem(this._payloadKey(this.CONFIG_KEY)); } catch (e) {}
    },

    subscribe: function (configKey, callback) {
      if (typeof callback !== 'function') return;
      if (!this._subscribers[configKey]) this._subscribers[configKey] = [];
      this._subscribers[configKey].push(callback);
    },

    unsubscribe: function (configKey, callback) {
      var arr = this._subscribers[configKey];
      if (!arr) return;
      for (var i = arr.length - 1; i >= 0; i--) {
        if (arr[i] === callback) arr.splice(i, 1);
      }
    },

    _onStorageEvent: function (e) {
      if (!this._projectId || !e || !e.key) return;
      var prefix = 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':';
      if (e.key.indexOf(prefix) !== 0) return;
      var configKey = e.key.substring(prefix.length);
      if (configKey === this.CONFIG_KEY) return;
      var arr = this._subscribers[configKey];
      if (!arr || !arr.length) return;
      var data = null;
      try { if (e.newValue) data = JSON.parse(e.newValue); } catch (_) {}
      for (var i = 0; i < arr.length; i++) {
        try { arr[i](data); } catch (_) {}
      }
    }
  };

  function _restoreFromProjectStore() {
    var data = _ProjectStore.read(_ProjectStore.CONFIG_KEY);
    if (!data) return false;
    var sh = data.shape || {};
    if (Array.isArray(sh.polygon) && sh.polygon.length >= 3) {
      var newPoly = [];
      for (var i = 0; i < sh.polygon.length; i++) {
        var p = sh.polygon[i];
        if (Array.isArray(p) && p.length === 2 && typeof p[0] === 'number' && typeof p[1] === 'number') {
          newPoly.push([_clampCoord(p[0]), _clampCoord(p[1])]);
        }
      }
      if (newPoly.length >= 3) STATE.polygon = newPoly;
    }
    if (typeof data.variant === 'number' && data.variant >= 1 && data.variant <= 5) {
      STATE.variant = data.variant;
    }
    if (typeof data.lvl === 'number' && data.lvl >= 1 && data.lvl <= 3) {
      STATE.lvl = data.lvl;
    }
    if (data.slope && typeof data.slope.deg === 'number') {
      STATE.slopeDeg = Math.max(0, Math.min(15, data.slope.deg | 0));
      STATE.slopeActive = !!data.slope.active;
    }
    if (data.units === 'ft') STATE.isMetric = false;
    if (data.units === 'm')  STATE.isMetric = true;
    STATE.mapLocked = !!data.mapLocked;
    STATE.masterLinked = !!data.masterLinked;
    if (STATE.masterLinked) STATE.dispoLocked = true;
    if (data.map && Array.isArray(data.map.center) && data.map.center.length === 2) {
      _pendingMapRestore = {
        center:  data.map.center,
        address: data.map.address || '',
        bearing: typeof data.map.bearing === 'number' ? data.map.bearing : 0
      };
    }
    _dbg('ProjectStore: state restored from storage');
    try { _updateDispoLockButton(); } catch (e) {}
    try { positionDragHandles(); } catch (e) {}
    try { _applyMapLockState(); } catch (e) {}
    return true;
  }

  var _pendingMapRestore = null;

  function _applyPendingMapRestore() {
    if (!_pendingMapRestore) return;
    if (!global.mapboxgl || !_MapManager || !_MapManager._loadMap) {
      setTimeout(_applyPendingMapRestore, 200);
      return;
    }
    var data = _pendingMapRestore;
    _pendingMapRestore = null;
    if (typeof data.bearing === 'number') _MapManager.bearing = data.bearing;
    try {
      _MapManager._loadMap(data.center, data.address);
      try { _MapManager.persist(); } catch (ep) {}
      _dbg('Map restored from storage: ' + JSON.stringify(data.center));
    } catch (e) {
      _dbg('Map restore failed: ' + e.message);
    }
  }

  function _init2DZoom() {
    function getCanvas() {
      return global.BaseEngine && global.BaseEngine.renderer && global.BaseEngine.renderer.domElement;
    }
    function getOrtho() {
      return global.BaseEngine && global.BaseEngine.cameraOrtho;
    }
    function render() {
      var eng = global.BaseEngine;
      if (eng && eng.renderer && eng.camera) eng.renderer.render(eng.scene, eng.camera);
    }
    function applyZoom(factor) {
      var cam = getOrtho();
      if (!cam) return;
      cam.zoom = Math.max(0.2, Math.min(8, cam.zoom * factor));
      cam.updateProjectionMatrix();
      render();
      if (typeof positionDragHandles === 'function') positionDragHandles();
      if (_VisualizationManager && _VisualizationManager.refreshDimensions) _VisualizationManager.refreshDimensions();
      _orthoEventEmitter.fire();
    }

    var canvas = getCanvas();
    if (!canvas) { setTimeout(_init2DZoom, 100); return; }

    canvas.addEventListener('wheel', function (e) {
      if (STATE.view !== '2d') return;
      e.preventDefault();
      var factor = e.deltaY > 0 ? (1 / 1.1) : 1.1;
      applyZoom(factor);
    }, { passive: false });

    var pinch = { active: false, lastDist: 0 };
    canvas.addEventListener('touchstart', function (e) {
      if (STATE.view !== '2d') return;
      if (e.touches.length === 2) {
        pinch.active = true;
        pinch.lastDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
      }
    }, { passive: true });
    canvas.addEventListener('touchmove', function (e) {
      if (STATE.view !== '2d' || !pinch.active || e.touches.length !== 2) return;
      e.preventDefault();
      var dist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      if (pinch.lastDist > 0) applyZoom(dist / pinch.lastDist);
      pinch.lastDist = dist;
    }, { passive: false });
    function endPinch(e) {
      if (!e.touches || e.touches.length < 2) pinch.active = false;
    }
    canvas.addEventListener('touchend',    endPinch);
    canvas.addEventListener('touchcancel', endPinch);
  }

  function _init2DMapPan() {
    var canvas = global.BaseEngine && global.BaseEngine.renderer && global.BaseEngine.renderer.domElement;
    if (!canvas) { setTimeout(_init2DMapPan, 100); return; }
    var drag = { active: false, lastX: 0, lastY: 0, pointerId: null };

    function canPan() {
      /* THE actual map-pan path: the user drags the Three.js canvas and we
         call map.panBy() programmatically. When the layout is locked to the
         master house, the map must not move — gate it HERE at the source. */
      if (STATE.dispoLocked) return false;
      if (STATE.view !== '2d') return false;
      if (!_MapManager || !_MapManager.map) return false;
      if (_CornerInserter && _CornerInserter.pendingPlacement) return false;
      var mapDiv = document.getElementById('cf-mapbox');
      if (!mapDiv || !mapDiv.classList.contains('cf-map-visible')) return false;
      return true;
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (!canPan()) return;
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      drag.active = true;
      drag.lastX = e.clientX;
      drag.lastY = e.clientY;
      drag.pointerId = e.pointerId;
      try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
    });

    canvas.addEventListener('pointermove', function (e) {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      if (!canPan()) { drag.active = false; return; }
      var dx = e.clientX - drag.lastX;
      var dy = e.clientY - drag.lastY;
      drag.lastX = e.clientX;
      drag.lastY = e.clientY;
      if (_MapManager.map && (dx !== 0 || dy !== 0)) {
        _MapManager.map.panBy([-dx, -dy], { animate: false });
      }
    });

    function endDrag(e) {
      if (!drag.active) return;
      drag.active = false;
      try { if (e) canvas.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    canvas.addEventListener('pointerup',     endDrag);
    canvas.addEventListener('pointercancel', endDrag);
    canvas.addEventListener('pointerleave',  endDrag);
  }

  function _injectTooltipCSS() {
    if (document.getElementById('cf-tooltip-runtime-css-base')) return;
    var css = [
      '#cf-wrap-base .cf-icon-btn { position: relative !important; overflow: visible !important; }',
      '#cf-wrap-base .cf-sidebar { overflow: visible !important; }',
      '#cf-wrap-base .cf-icon-btn::after {',
      '  content: attr(title) !important;',
      '  position: absolute !important;',
      '  right: calc(100% + 8px) !important;',
      '  top: 50% !important;',
      '  transform: translateY(-50%) !important;',
      '  background: rgba(20, 20, 20, 0.92) !important;',
      '  color: #fff !important;',
      '  padding: 6px 10px !important;',
      '  border-radius: 6px !important;',
      '  font: 600 11px/1.2 Montserrat, -apple-system, sans-serif !important;',
      '  letter-spacing: 0.02em !important;',
      '  white-space: nowrap !important;',
      '  pointer-events: none !important;',
      '  opacity: 0 !important;',
      '  transition: opacity 0.15s ease !important;',
      '  z-index: 9999 !important;',
      '  display: block !important;',
      '  visibility: visible !important;',
      '}',
      '#cf-wrap-base .cf-icon-btn:hover::after,',
      '#cf-wrap-base .cf-icon-btn:active::after,',
      '#cf-wrap-base .cf-icon-btn.show-tip::after { opacity: 1 !important; }'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'cf-tooltip-runtime-css-base';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _bindIconTooltips() {
    _injectTooltipCSS();
    var btns = document.querySelectorAll('#cf-wrap-base .cf-icon-btn');
    var tipTimer = null;
    btns.forEach(function (btn) {
      btn.addEventListener('touchstart', function () {
        if (tipTimer) clearTimeout(tipTimer);
        document.querySelectorAll('#cf-wrap-base .cf-icon-btn.show-tip').forEach(function (b) {
          b.classList.remove('show-tip');
        });
        btn.classList.add('show-tip');
        tipTimer = setTimeout(function () { btn.classList.remove('show-tip'); }, 1500);
      }, { passive: true });
    });
  }

  function _rebuildGrid(eng) {
    var T = global.THREE;
    if (!T || !eng || !eng.scene) return;
    if (eng._gridHelper) {
      eng.scene.remove(eng._gridHelper);
      if (eng._gridHelper.geometry) eng._gridHelper.geometry.dispose();
      if (eng._gridHelper.material) eng._gridHelper.material.dispose();
      eng._gridHelper = null;
    }
    var size = 40;
    var step = STATE.isMetric ? 1.0 : 0.3048;
    var divisions = Math.round(size / step);
    eng._gridHelper = new T.GridHelper(size, divisions, 0xcccccc, 0xe5e5e5);
    eng._gridHelper.visible = true;
    eng.scene.add(eng._gridHelper);
  }

  var _orthoEventEmitter = {
    _listeners: [],
    addEventListener: function (name, cb) {
      if (name === 'change' && typeof cb === 'function') this._listeners.push(cb);
    },
    fire: function () {
      for (var i = 0; i < this._listeners.length; i++) {
        try { this._listeners[i](); } catch (e) {}
      }
    }
  };

  function _loadMapboxSDK() {
    if (global.mapboxgl) return Promise.resolve();
    if (global.__cfBaseMapSDKPromise) return global.__cfBaseMapSDKPromise;
    global.__cfBaseMapSDKPromise = new Promise(function (resolve, reject) {
      if (!document.getElementById('cf-mapbox-gl-css')) {
        var css = document.createElement('link');
        css.id = 'cf-mapbox-gl-css';
        css.rel = 'stylesheet';
        css.href = 'https://api.mapbox.com/mapbox-gl-js/v3.0.1/mapbox-gl.css';
        document.head.appendChild(css);
      }
      var existing = document.getElementById('cf-mapbox-gl-js');
      if (existing) {
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', function () { reject(new Error('Mapbox SDK load failed')); });
        return;
      }
      var script = document.createElement('script');
      script.id = 'cf-mapbox-gl-js';
      script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.0.1/mapbox-gl.js';
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('Mapbox SDK load failed')); };
      document.head.appendChild(script);
    });
    return global.__cfBaseMapSDKPromise;
  }

  function _injectMapCSS() {
    if (document.getElementById('cf-base-map-css')) return;
    var css = [
      '#cf-mapbox {',
      '  position: absolute !important; inset: 0;',
      '  width: 100% !important; height: 100% !important;',
      '  z-index: 0; background-color: #f5f5f5;',
      '  transition: opacity 0.35s ease; display: none;',
      '}',
      '#cf-mapbox.cf-map-visible { display: block; }',
      '#cf-wrap-base .cf-map-fade {',
      '  position: absolute; inset: 0; z-index: 1;',
      '  pointer-events: none; display: none;',
      '  background:',
      '    linear-gradient(to right,  rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) left   / 100% 100% no-repeat,',
      '    linear-gradient(to left,   rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) right  / 100% 100% no-repeat,',
      '    linear-gradient(to bottom, rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) top    / 100% 100% no-repeat,',
      '    linear-gradient(to top,    rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) bottom / 100% 100% no-repeat;',
      '}',
      '#cf-wrap-base .cf-map-fade.cf-map-visible { display: block; }',
      '#cf-mapbox .mapboxgl-ctrl-attrib, #cf-mapbox .mapboxgl-ctrl-logo { display: none !important; }',
      '#cf-wrap-base .cf-map-credit {',
      '  position: absolute; left: 10px; bottom: 10px; z-index: 150;',
      '  font: 9px/1 system-ui, sans-serif; color: rgba(0,0,0,0.5);',
      '  background: rgba(255,255,255,0.7); padding: 3px 6px; border-radius: 4px;',
      '  pointer-events: none; display: none;',
      '}',
      '#cf-wrap-base .cf-map-credit.cf-map-visible { display: block; }',
      '#cf-wrap-base.cf-has-map .cf-canvas { background-color: transparent !important; }',
      '#cf-wrap-base.cf-has-map { background: #f5f5f5; }',
      '.cf-map-modal-backdrop {',
      '  position: fixed; inset: 0; z-index: 9999;',
      '  background: rgba(0,0,0,0.45); display: none;',
      '  align-items: center; justify-content: center;',
      '}',
      '.cf-map-modal-backdrop.open { display: flex; }',
      '.cf-map-modal {',
      '  background: #fff; border-radius: 14px; box-shadow: 0 20px 60px rgba(0,0,0,0.30);',
      '  padding: 18px 18px 14px; width: min(380px, calc(100vw - 32px));',
      '  font-family: Montserrat, -apple-system, sans-serif;',
      '}',
      '.cf-map-modal h3 {',
      '  margin: 0 0 12px; font-size: 14px; font-weight: 700; color: #111;',
      '  letter-spacing: 0.02em;',
      '}',
      '.cf-map-modal-input-wrap { position: relative; }',
      '.cf-map-modal input {',
      '  width: 100%; padding: 10px 12px; border: 1px solid #e0e0e0; border-radius: 8px;',
      '  font: 13px/1.3 Montserrat, sans-serif; outline: none; box-sizing: border-box;',
      '}',
      '.cf-map-modal input:focus { border-color: #5A6B47; }',
      '.cf-map-modal-suggestions {',
      '  position: absolute; top: 100%; left: 0; right: 0; margin-top: 4px;',
      '  background: #fff; border: 1px solid #e0e0e0; border-radius: 8px;',
      '  box-shadow: 0 6px 20px rgba(0,0,0,0.10);',
      '  max-height: 220px; overflow-y: auto; display: none; z-index: 10;',
      '}',
      '.cf-map-modal-suggestions.open { display: block; }',
      '.cf-map-modal-sugg-item {',
      '  padding: 9px 12px; font: 12px/1.35 Montserrat, sans-serif; color: #333;',
      '  cursor: pointer; border-bottom: 1px solid #f0f0f0;',
      '}',
      '.cf-map-modal-sugg-item:last-child { border-bottom: none; }',
      '.cf-map-modal-sugg-item:hover { background: #f5f5f0; }',
      '.cf-map-modal-buttons { display: flex; gap: 8px; margin-top: 12px; }',
      '.cf-map-modal-btn {',
      '  flex: 1; padding: 9px 14px; border: none; border-radius: 8px;',
      '  font: 700 12px Montserrat, sans-serif; cursor: pointer;',
      '  letter-spacing: 0.02em;',
      '}',
      '.cf-map-modal-btn-cancel { background: #f0f0f0; color: #555; }',
      '.cf-map-modal-btn-cancel:hover { background: #e6e6e6; }',
      '.cf-map-modal-btn-ok { background: #5A6B47; color: #fff; }',
      '.cf-map-modal-btn-ok:hover { background: #4a5a3b; }',
      '.cf-map-modal-btn-ok:disabled { opacity: 0.4; cursor: not-allowed; }',
      '#cf-wrap-base .cf-map-controls {',
      '  position: absolute; left: 14px; top: 14px; z-index: 220;',
      '  display: none; flex-direction: row; gap: 12px; align-items: flex-start;',
      '  pointer-events: none;',
      '}',
      '#cf-wrap-base .cf-map-controls.open { display: flex; }',
      '#cf-wrap-base .cf-map-controls > * { pointer-events: auto; }',
      '.cf-map-rotate-vert {',
      '  display: flex; flex-direction: column; align-items: center; gap: 8px;',
      '}',
      '.cf-map-rotate-slider {',
      '  -webkit-appearance: none; appearance: none;',
      '  accent-color: var(--cf-accent, #5A6B47);',
      '  writing-mode: vertical-lr; direction: rtl;',
      '  width: 4px; height: 320px;',
      '  background: linear-gradient(to top, var(--cf-accent, #5A6B47) 0%, var(--cf-accent, #5A6B47) var(--cf-fill, 0%), #e0e0e0 var(--cf-fill, 0%), #e0e0e0 100%);',
      '  border-radius: 10px; outline: none; cursor: pointer;',
      '}',
      '.cf-map-rotate-slider::-webkit-slider-thumb {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 12px; height: 12px; background: var(--cf-accent, #5A6B47);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-map-rotate-slider::-moz-range-thumb {',
      '  width: 12px; height: 12px; background: var(--cf-accent, #5A6B47);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-map-right-col { display: flex; flex-direction: column; gap: 10px; }',
      '.cf-map-style-row { display: flex; gap: 6px; align-items: center; }',
      '.cf-map-style-btn {',
      '  width: 42px; height: 32px; border: none; border-radius: 8px; cursor: pointer;',
      '  background: rgba(255,255,255,0.92); color: #333; font: 700 10px sans-serif;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.08);',
      '  display: flex; align-items: center; justify-content: center;',
      '  transition: all 0.15s;',
      '}',
      '.cf-map-style-btn.active { background: #111; color: #fff; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active { background: #5A6B47 !important; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active img,',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active svg { filter: brightness(0) invert(1) !important; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active:hover { background: #5A6B47 !important; }'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'cf-base-map-css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _injectMapDOM() {
    var wrap = document.getElementById('cf-wrap-base');
    if (!wrap) return;
    var canvas = document.getElementById('cf-canvas-base');

    if (!document.getElementById('cf-mapbox')) {
      var mapDiv = document.createElement('div');
      mapDiv.id = 'cf-mapbox';
      if (canvas) wrap.insertBefore(mapDiv, canvas); else wrap.appendChild(mapDiv);
    }
    if (!wrap.querySelector('.cf-map-fade')) {
      var fade = document.createElement('div');
      fade.className = 'cf-map-fade';
      if (canvas) wrap.insertBefore(fade, canvas); else wrap.appendChild(fade);
    }
    if (!document.getElementById('cf-map-credit')) {
      var credit = document.createElement('div');
      credit.id = 'cf-map-credit';
      credit.className = 'cf-map-credit';
      credit.textContent = '© Mapbox © OpenStreetMap';
      wrap.appendChild(credit);
    }
    if (!document.getElementById('cf-map-controls')) {
      var ctrls = document.createElement('div');
      ctrls.id = 'cf-map-controls';
      ctrls.className = 'cf-map-controls';
      ctrls.innerHTML =
        '<div class="cf-map-rotate-vert">' +
        '  <input type="range" id="cf-map-rotate" class="cf-map-rotate-slider" min="0" max="360" step="1" value="0" aria-label="Rotation">' +
        '</div>' +
        '<div class="cf-map-right-col">' +
        '  <div class="cf-map-style-row">' +
        '    <button id="cf-map-style-streets" class="cf-map-style-btn active" type="button">MAP</button>' +
        '    <button id="cf-map-style-satellite" class="cf-map-style-btn" type="button">SAT</button>' +
        '  </div>' +
        '</div>';
      wrap.appendChild(ctrls);
    }
    if (!document.getElementById('cf-map-modal-backdrop')) {
      var modal = document.createElement('div');
      modal.id = 'cf-map-modal-backdrop';
      modal.className = 'cf-map-modal-backdrop';
      modal.innerHTML =
        '<div class="cf-map-modal" role="dialog" aria-modal="true">' +
        '  <h3>Map location</h3>' +
        '  <div class="cf-map-modal-input-wrap">' +
        '    <input id="cf-map-address-input" type="text" placeholder="Address, city or place..." autocomplete="off">' +
        '    <div id="cf-map-suggestions" class="cf-map-modal-suggestions"></div>' +
        '  </div>' +
        '  <div class="cf-map-modal-buttons">' +
        '    <button id="cf-map-modal-cancel" type="button" class="cf-map-modal-btn cf-map-modal-btn-cancel">Cancel</button>' +
        '    <button id="cf-map-modal-ok" type="button" class="cf-map-modal-btn cf-map-modal-btn-ok" disabled>Load</button>' +
        '  </div>' +
        '</div>';
      document.body.appendChild(modal);
    }
    var sidebar = wrap.querySelector('.cf-sidebar');
    if (sidebar && !document.getElementById('cf-btn-map')) {
      var btn = document.createElement('button');
      btn.id = 'cf-btn-map';
      btn.className = 'cf-icon-btn';
      btn.type = 'button';
      btn.title = 'Add map background';
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z"/><path d="M9 4v16"/><path d="M15 6v16"/></svg>';
      var shareBtn = document.getElementById('cf-btn-share');
      if (shareBtn && shareBtn.parentNode === sidebar) {
        sidebar.insertBefore(btn, shareBtn.nextSibling);
      } else {
        sidebar.appendChild(btn);
      }
    }
  }

  var _MapManager = (function () {
    var I18N_DEFAULTS = {
      rotation:           'Rotation',
      streets:            'Roadmap',
      satellite:          'Satellite',
      addressPlaceholder: 'Address, city or place…',
      load:               'Load',
      cancel:             'Cancel',
      modalTitle:         'Map location',
      addBackground:      'Add map background',
      changeLocation:     'Change map location'
    };

    var MM = {
      _deps: null,
      _i18n: I18N_DEFAULTS,
      _storageKey: null,
      MAPBOX_TOKEN: null,
      STYLE_STREETS:   'mapbox://styles/mapbox/light-v11',
      STYLE_SATELLITE: 'mapbox://styles/mapbox/satellite-streets-v12',

      map: null,
      currentStyle: 'streets',
      center: null,
      zoomLevel: null,
      bearing: 0,
      address: '',
      _geocodeAbort: null,
      _suggestionItems: [],
      _suppressStorageEvent: false,

      _bindUI: function () {
        var self = this;
        if (!global.mapboxgl) return;
        global.mapboxgl.accessToken = this.MAPBOX_TOKEN;

        var btn = document.getElementById('cf-btn-map');
        if (btn) btn.addEventListener('click', function () {
          var mapDiv = document.getElementById('cf-mapbox');
          var visible = mapDiv && mapDiv.classList.contains('cf-map-visible');
          if (self.map && visible) self._hideMap();
          else self._openModal();
        });

        var backdrop = document.getElementById('cf-map-modal-backdrop');
        var input    = document.getElementById('cf-map-address-input');
        var okBtn    = document.getElementById('cf-map-modal-ok');
        var cancelBtn= document.getElementById('cf-map-modal-cancel');
        var sugg     = document.getElementById('cf-map-suggestions');
        if (!backdrop || !input || !okBtn || !cancelBtn || !sugg) return;

        backdrop.addEventListener('click', function (e) {
          if (e.target === backdrop) self._closeModal();
        });
        cancelBtn.addEventListener('click', function () { self._closeModal(); });

        var debounceT = null;
        input.addEventListener('input', function () {
          clearTimeout(debounceT);
          var q = input.value.trim();
          if (q.length < 3) {
            sugg.classList.remove('open');
            okBtn.disabled = true;
            return;
          }
          debounceT = setTimeout(function () { self._geocode(q); }, 300);
        });

        okBtn.addEventListener('click', function () {
          var selected = null;
          for (var i = 0; i < self._suggestionItems.length; i++) {
            if (self._suggestionItems[i].selected) { selected = self._suggestionItems[i]; break; }
          }
          if (!selected) selected = self._suggestionItems[0];
          if (!selected) return;
          self._loadMap(selected.center, selected.label);
          self._closeModal();
        });

        var btnS  = document.getElementById('cf-map-style-streets');
        var btnSa = document.getElementById('cf-map-style-satellite');
        if (btnS)  btnS.addEventListener('click',  function () { self._setStyle('streets'); });
        if (btnSa) btnSa.addEventListener('click', function () { self._setStyle('satellite'); });

        var rotateInput = document.getElementById('cf-map-rotate');
        if (rotateInput) {
          var updateRotateFill = function () {
            var pct = (parseFloat(rotateInput.value) / 360) * 100;
            rotateInput.style.setProperty('--cf-fill', pct + '%');
          };
          rotateInput.addEventListener('input', function () {
            var deg = parseInt(rotateInput.value, 10);
            self.bearing = deg;
            if (self.map) {
              if (self._deps.getView() === '3d') {
                self._syncMapTo3D(false);
              } else {
                self.map.setBearing(deg);
              }
            }
            updateRotateFill();
            if (STATE.slopeActive && STATE.slopeDeg > 0) {
              if (self._slopeRefreshTimer) clearTimeout(self._slopeRefreshTimer);
              self._slopeRefreshTimer = setTimeout(function () {
                self._slopeRefreshTimer = null;
                if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
                refreshUI();
              }, 1000);
            }
          });
          updateRotateFill();
        }

        this._updateSidebarButton();
      },

      _openModal: function () {
        var bd = document.getElementById('cf-map-modal-backdrop');
        var input = document.getElementById('cf-map-address-input');
        if (bd) bd.classList.add('open');
        if (input) { input.value = this.address || ''; setTimeout(function () { input.focus(); }, 50); }
      },
      _closeModal: function () {
        var bd = document.getElementById('cf-map-modal-backdrop');
        var sugg = document.getElementById('cf-map-suggestions');
        if (bd) bd.classList.remove('open');
        if (sugg) sugg.classList.remove('open');
      },

      _geocode: function (query) {
        var self = this;
        if (this._geocodeAbort) this._geocodeAbort.abort();
        this._geocodeAbort = new AbortController();
        var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
                  encodeURIComponent(query) + '.json?access_token=' + this.MAPBOX_TOKEN +
                  '&autocomplete=true&limit=5&types=address,place,locality,neighborhood,region';
        fetch(url, { signal: this._geocodeAbort.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var sugg = document.getElementById('cf-map-suggestions');
            var okBtn = document.getElementById('cf-map-modal-ok');
            if (!sugg || !okBtn) return;
            sugg.innerHTML = '';
            var feats = (data && data.features) || [];
            self._suggestionItems = feats.map(function (f, i) {
              return { label: f.place_name, center: f.center, selected: i === 0 };
            });
            if (!self._suggestionItems.length) {
              sugg.classList.remove('open');
              okBtn.disabled = true;
              return;
            }
            self._suggestionItems.forEach(function (s) {
              var div = document.createElement('div');
              div.className = 'cf-map-modal-sugg-item';
              div.textContent = s.label;
              div.addEventListener('click', function () {
                self._suggestionItems.forEach(function (it) { it.selected = false; });
                s.selected = true;
                var input = document.getElementById('cf-map-address-input');
                if (input) input.value = s.label;
                sugg.classList.remove('open');
                okBtn.disabled = false;
              });
              sugg.appendChild(div);
            });
            sugg.classList.add('open');
            okBtn.disabled = false;
          })
          .catch(function (e) {
            if (e && e.name !== 'AbortError') _dbg('geocode failed: ' + e.message);
          });
      },

      _computeZoomForLat: function (lat) {
        var wrap = document.getElementById('cf-wrap-base');
        if (!wrap) return 18;
        var canvasW = wrap.clientWidth;
        var cam = this._deps.orthoCamera;
        if (!cam) return 18;
        var frustumW = (cam.right - cam.left) / (cam.zoom || 1);
        var ourMpp = frustumW / canvasW;
        return Math.log2(78271.51696 * Math.cos(lat * Math.PI / 180) / ourMpp);
      },

      _loadMap: function (center, label) {
        var self = this;
        this.center = center;
        this.address = label;
        this.zoomLevel = this._computeZoomForLat(center[1]);

        var mapDiv = document.getElementById('cf-mapbox');
        var creditEl = document.getElementById('cf-map-credit');
        var wrap = document.getElementById('cf-wrap-base');
        var fade = document.querySelector('#cf-wrap-base .cf-map-fade');
        if (mapDiv) mapDiv.classList.add('cf-map-visible');
        if (creditEl) creditEl.classList.add('cf-map-visible');
        if (wrap) wrap.classList.add('cf-has-map');
        if (fade) fade.classList.add('cf-map-visible');

        if (global.BaseEngine && global.BaseEngine.scene) {
          global.BaseEngine.scene.background = null;
          if (global.BaseEngine.renderer && global.BaseEngine.renderer.setClearAlpha) {
            global.BaseEngine.renderer.setClearAlpha(0);
          }
        }

        if (this.map) {
          this.map.jumpTo({ center: center, zoom: this.zoomLevel, bearing: this.bearing });
        } else {
          this.map = new global.mapboxgl.Map({
            container: 'cf-mapbox',
            style: this.STYLE_STREETS,
            center: center,
            zoom: this.zoomLevel,
            bearing: this.bearing,
            pitch: 0,
            attributionControl: false,
            interactive: false,
            preserveDrawingBuffer: true
          });
          this.map.dragPan.disable();
          this.map.scrollZoom.disable();
          this.map.boxZoom.disable();
          this.map.dragRotate.disable();
          this.map.keyboard.disable();
          this.map.doubleClickZoom.disable();
          this.map.touchZoomRotate.disable();

          this._updateSidebarButton();

          var canvas = document.getElementById('cf-canvas-base');
          if (canvas) canvas.style.pointerEvents = 'auto';

          var syncZoom = function () {
            if (!self.map || !self.center) return;
            if (self._deps.getView() !== '2d-top') return;
            var z = self._computeZoomForLat(self.center[1]);
            if (Math.abs(z - self.zoomLevel) > 0.005) {
              self.zoomLevel = z;
              self.map.setZoom(z);
            }
          };
          if (this._deps.orthoControls && this._deps.orthoControls.addEventListener) {
            this._deps.orthoControls.addEventListener('change', syncZoom);
          }
          window.addEventListener('resize', function () { setTimeout(syncZoom, 50); });
          setTimeout(syncZoom, 100);

          if (this._deps.controls && this._deps.controls.addEventListener) {
            var _syncPending = false;
            this._deps.controls.addEventListener('change', function () {
              if (self._deps.getView() !== '3d' || !self.map || !self.center) return;
              if (_syncPending) return;
              _syncPending = true;
              requestAnimationFrame(function () {
                _syncPending = false;
                if (self._deps.getView() === '3d' && self.map && self.center) self._syncMapTo3D(false);
              });
            });
          }

          this.map.on('style.load', function () {
            self._install3DLayers();
            if (self._deps.getView() === '3d') self._syncMapTo3D(false);
          });

          this.map.on('moveend', function () {
            if (!self.map) return;
            var c = self.map.getCenter();
            self.center = [c.lng, c.lat];
            if (self._deps.getView() !== '3d') {
              self.bearing = self.map.getBearing();
            }
            if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
          });

          _applyMapLockState();

          if (typeof ResizeObserver !== 'undefined' && mapDiv) {
            new ResizeObserver(function () {
              if (self.map) { self.map.resize(); syncZoom(); }
            }).observe(mapDiv);
          }
        }

        var ctrls = document.getElementById('cf-map-controls');
        if (ctrls) ctrls.classList.add('open');
        this._deps.onChange();
      },

      _hideMap: function () {
        var mapDiv = document.getElementById('cf-mapbox');
        var credit = document.getElementById('cf-map-credit');
        var wrap = document.getElementById('cf-wrap-base');
        var fade = document.querySelector('#cf-wrap-base .cf-map-fade');
        var ctrls = document.getElementById('cf-map-controls');
        if (mapDiv) mapDiv.classList.remove('cf-map-visible');
        if (credit) credit.classList.remove('cf-map-visible');
        if (fade)   fade.classList.remove('cf-map-visible');
        if (wrap)   wrap.classList.remove('cf-has-map');
        if (ctrls)  ctrls.classList.remove('open');
        if (global.BaseEngine && global.BaseEngine.scene && global.THREE) {
          global.BaseEngine.scene.background = new global.THREE.Color(0xf5f5f5);
          if (global.BaseEngine.renderer && global.BaseEngine.renderer.setClearAlpha) {
            global.BaseEngine.renderer.setClearAlpha(1);
          }
        }
      },

      _setStyle: function (s) {
        if (!this.map) return;
        this.currentStyle = s;
        var url = s === 'satellite' ? this.STYLE_SATELLITE : this.STYLE_STREETS;
        this.map.setStyle(url);
        var b1 = document.getElementById('cf-map-style-streets');
        var b2 = document.getElementById('cf-map-style-satellite');
        if (b1) b1.classList.toggle('active', s === 'streets');
        if (b2) b2.classList.toggle('active', s === 'satellite');
        var self2 = this;
        this.map.once('style.load', function () { try { _applyMapLockState(); } catch (e) {} });
        try { _applyMapLockState(); } catch (e) {}
        this._deps.onChange();
      },

      _install3DLayers: function () {
        if (!this.map) return;
        var m = this.map;
        try {
          if (!m.getLayer('cf-sky')) {
            m.addLayer({
              id: 'cf-sky', type: 'sky',
              paint: { 'sky-type': 'atmosphere', 'sky-atmosphere-sun-intensity': 5 }
            });
          }
        } catch (e) {}
        try {
          if (!m.getLayer('cf-3d-buildings') && m.getSource('composite')) {
            m.addLayer({
              id: 'cf-3d-buildings',
              source: 'composite',
              'source-layer': 'building',
              filter: ['==', 'extrude', 'true'],
              type: 'fill-extrusion',
              minzoom: 14,
              paint: {
                'fill-extrusion-color': '#d6cfc2',
                'fill-extrusion-height': ['get', 'height'],
                'fill-extrusion-base': ['get', 'min_height'],
                'fill-extrusion-opacity': 0.85
              }
            });
          }
        } catch (e) {}
        this._set3DLayerVisibility(this._deps.getView() === '3d');
      },

      _computeMapStateFor3D: function () {
        if (!this._deps.camera || !this._deps.controls || !this.center) return null;
        var target = this._deps.controls.target;
        var pos = this._deps.camera.position;
        var offX = pos.x - target.x;
        var offY = pos.y - target.y;
        var offZ = pos.z - target.z;
        var horiz = Math.sqrt(offX*offX + offZ*offZ);
        var dist = Math.sqrt(horiz*horiz + offY*offY);
        if (dist < 0.01) return null;
        var elev = Math.atan2(offY, horiz);
        var pitch = Math.max(0, Math.min(85, 90 - elev * 180 / Math.PI));
        var sceneBearingDeg = Math.atan2(-offX, offZ) * 180 / Math.PI;
        var bearing = (this.bearing || 0) + sceneBearingDeg;
        var wrap = document.getElementById('cf-wrap-base');
        var canvasH = wrap ? wrap.clientHeight : 600;
        var fovRad = this._deps.camera.fov * Math.PI / 180;
        var heightAtTarget = 2 * dist * Math.tan(fovRad / 2);
        var mpp = heightAtTarget / canvasH;
        var lat = this.center[1];
        var zoom = Math.log2(78271.51696 * Math.cos(lat * Math.PI / 180) / mpp);
        return { pitch: pitch, bearing: bearing, zoom: zoom };
      },

      _syncMapTo3D: function (animate) {
        if (!this.map || !this.center) return;
        var s = this._computeMapStateFor3D();
        if (!s) return;
        if (animate) this.map.easeTo({ pitch: s.pitch, bearing: s.bearing, zoom: s.zoom, duration: 400 });
        else         this.map.jumpTo({ pitch: s.pitch, bearing: s.bearing, zoom: s.zoom });
      },

      _syncMapTo2D: function (animate) {
        if (!this.map || !this.center) return;
        var z = this._computeZoomForLat(this.center[1]);
        this.zoomLevel = z;
        if (animate) this.map.easeTo({ pitch: 0, bearing: this.bearing || 0, zoom: z, duration: 400 });
        else         this.map.jumpTo({ pitch: 0, bearing: this.bearing || 0, zoom: z });
      },

      _set3DLayerVisibility: function (visible) {
        if (!this.map) return;
        var v = visible ? 'visible' : 'none';
        var ids = ['cf-3d-buildings', 'cf-sky'];
        for (var i = 0; i < ids.length; i++) {
          try {
            if (this.map.getLayer(ids[i])) this.map.setLayoutProperty(ids[i], 'visibility', v);
          } catch (e) {}
        }
      },

      _updateSidebarButton: function () {
        var btn = document.getElementById('cf-btn-map');
        if (!btn) return;
        if (this.map) {
          btn.classList.add('cf-map-btn-active');
          btn.title = this._i18n.changeLocation;
        } else {
          btn.classList.remove('cf-map-btn-active');
          btn.title = this._i18n.addBackground;
        }
      },

      _panMeters: function (dirX, dirZ) {
        if (!this.map) return;
        var lat = this.center[1];
        var zoom = this.map.getZoom();
        var mpp = 78271.51696 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom);
        var dx = dirX / mpp;
        var dy = dirZ / mpp;
        this.map.panBy([dx, dy], { animate: false });
        var c = this.map.getCenter();
        this.center = [c.lng, c.lat];
        this._deps.onChange();
      },

      serialize: function () {
        if (!this.map || !this.center) return null;
        return {
          center: this.center,
          bearing: this.bearing || 0,
          style: this.currentStyle,
          address: this.address
        };
      },
      restore: function (data) {
        if (!data || !data.center) return;
        this.bearing = data.bearing || 0;
        var rotateInput = document.getElementById('cf-map-rotate');
        if (rotateInput) {
          rotateInput.value = Math.round(this.bearing);
          rotateInput.style.setProperty('--cf-fill', (this.bearing / 360 * 100) + '%');
        }
        this._loadMap(data.center, data.address || '');
        if (data.style === 'satellite') this._setStyle('satellite');
      },

      persist: function () {
        if (!this._storageKey) return;
        var data = this.serialize();
        if (!data) return;
        try {
          this._suppressStorageEvent = true;
          localStorage.setItem(this._storageKey, JSON.stringify(data));
          var self = this;
          setTimeout(function () { self._suppressStorageEvent = false; }, 0);
        } catch (e) {}
      },
      loadFromStorage: function () {
        if (!this._storageKey) return false;
        try {
          var raw = localStorage.getItem(this._storageKey);
          if (!raw) return false;
          var data = JSON.parse(raw);
          this.restore(data);
          return true;
        } catch (e) { return false; }
      },

      _onStorageEvent: function (e) {
        if (this._suppressStorageEvent) return;
        if (!this._storageKey || e.key !== this._storageKey) return;
        if (!e.newValue) return;
        try {
          var data = JSON.parse(e.newValue);
          var oldCenter = this.center;
          if (!oldCenter || data.center[0] !== oldCenter[0] || data.center[1] !== oldCenter[1]) {
            this.restore(data);
          } else {
            if (typeof data.bearing === 'number') {
              this.bearing = data.bearing;
              if (this.map) this.map.setBearing(data.bearing);
              var ri = document.getElementById('cf-map-rotate');
              if (ri) {
                ri.value = Math.round(data.bearing);
                ri.style.setProperty('--cf-fill', (data.bearing / 360 * 100) + '%');
              }
            }
            if (data.style && data.style !== this.currentStyle) this._setStyle(data.style);
          }
        } catch (err) {}
      }
    };

    var _initialized = false;
    MM.init = function (opts) {
      opts = opts || {};
      var hostOnChange = opts.onChange || function () {};
      MM._deps = opts.engine ? Object.assign({}, opts.engine, {
        getView:       opts.getView       || function () { return '2d-top'; },
        getRootSize:   opts.getRootSize   || function () { return { w: window.innerWidth, h: window.innerHeight }; },
        getPadStep:    opts.getPadStep    || function () { return 2; },
        onChange:      function () { MM.persist(); hostOnChange(); },
        requestRender: opts.requestRender || function () {}
      }) : null;
      MM._i18n = Object.assign({}, I18N_DEFAULTS, opts.i18n || {});
      MM._storageKey = opts.storageKey || 'levaMap:default';
      MM.MAPBOX_TOKEN = opts.token || MM.MAPBOX_TOKEN;
      if (_initialized) return;
      _initialized = true;
      window.addEventListener('storage', function (e) { MM._onStorageEvent(e); });
      MM._bindUI();
    };

    return MM;
  })();

  function _initMap() {
    var token = (global.BASE_BOOT && global.BASE_BOOT.mapboxToken) || global.MAPBOX_TOKEN;
    if (!token) {
      _dbg('map: no MAPBOX_TOKEN — map feature disabled');
      return;
    }
    _injectMapCSS();
    _injectMapDOM();
    _loadMapboxSDK().then(function () {
      var boot = global.BASE_BOOT || {};
      var storageKey = 'levaMap:p' + (boot.productId || '0') + ':c' + (boot.customerId || 'anon');
      _MapManager.init({
        token: token,
        storageKey: storageKey,
        i18n: boot.i18n || {},
        engine: {
          camera:        global.BaseEngine.cameraPersp,
          controls:      global.BaseEngine.controls,
          orthoCamera:   global.BaseEngine.cameraOrtho,
          orthoControls: _orthoEventEmitter
        },
        getView: function () { return STATE.view === '2d' ? '2d-top' : '3d'; },
        getRootSize: function () {
          var w = document.getElementById('cf-wrap-base');
          return { w: w ? w.clientWidth : 0, h: w ? w.clientHeight : 0 };
        },
        getPadStep: function () {
          var bb = (typeof getBBox === 'function') ? getBBox() : null;
          if (!bb) return 2;
          return Math.max(1, Math.min(20, (bb.L + bb.W) * 0.025));
        },
        onChange: function () {},
        requestRender: function () {
          var eng = global.BaseEngine;
          if (eng && eng.renderer && eng.camera) eng.renderer.render(eng.scene, eng.camera);
        }
      });
      if (_pendingMapRestore) {
        _applyPendingMapRestore();
      } else {
        _MapManager.loadFromStorage();
      }
    }).catch(function (err) {
      _dbg('map: ' + (err && err.message ? err.message : err));
    });
  }

  global.BaseEngine = {
    scene: null,
    camera: null,
    cameraPersp: null,
    cameraOrtho: null,
    renderer: null,
    controls: null,
    sceneGroup: null,
    _gridHelper: null,
    _animating: false,

    /* Public access to the live STATE — exposed read-only via
       these helpers so external modules (FloorplanLib, future
       Structure configurator, dashboard view) can read & write
       the footprint without reaching into module-private vars. */
    getState: function () { return STATE; },
    getPolygon: function () {
      return STATE.polygon ? JSON.parse(JSON.stringify(STATE.polygon)) : null;
    },
    setPolygon: function (newPoly) {
      if (!Array.isArray(newPoly) || newPoly.length < 3) return false;
      STATE.polygon = JSON.parse(JSON.stringify(newPoly));
      try { rebuildDragHandles(); } catch (e) { _dbg('rebuildDragHandles after setPolygon failed', e); }
      if (global.BaseRenderer && global.BaseRenderer.build) {
        try { global.BaseRenderer.build(); } catch (e) { _dbg('build after setPolygon failed', e); }
      }
      if (_MapManager && _MapManager.map && _MapManager.center) {
        try {
          if (STATE.view === '2d') _MapManager._syncMapTo2D(true);
          else _MapManager._syncMapTo3D(true);
        } catch (e) {}
      }
      if (_SlopeManager && _SlopeManager._updateAll) {
        try { _SlopeManager._updateAll(); } catch (e) {}
      }
      return true;
    },

    /* Project a world-space point (XZ-plane, Y=0) to screen
       coordinates relative to #cf-wrap-base. Used by FloorplanLib
       to position HTML drag handles on top of the Three.js scene. */
    worldToScreen: function (x, z) { return _worldToScreen(x, z); },

    /* Inverse — screen-space client coordinates to world XZ. Used
       by FloorplanLib while a wall handle is being dragged. */
    screenToWorld: function (clientX, clientY) { return _screenToWorld(clientX, clientY); },

    /* Show/hide the foundations drag handles. FloorplanLib calls
       this when entering floorplan-edit mode so the polygon and
       its corner/edge handles get out of the way of the wall
       handles. The render group itself stays — we just toggle the
       HTML pin layer. */
    setFoundationsHandlesVisible: function (visible) {
      var container = document.getElementById('cf-base-handles');
      if (!container) return;
      container.style.display = visible ? '' : 'none';
    },

    init: function () {
      var T = global.THREE;
      if (!T) { _dbg('init: THREE missing'); return; }
      var canvas = document.getElementById('cf-canvas-base');
      if (!canvas) { _dbg('init: canvas missing'); return; }

      this.scene = new T.Scene();
      this.scene.background = new T.Color(0xf5f5f5);

      var w = canvas.clientWidth || 800;
      var h = canvas.clientHeight || 600;

      this.cameraPersp = new T.PerspectiveCamera(40, w / h, 0.1, 200);
      this.cameraPersp.position.set(14, 12, 14);
      this.cameraPersp.lookAt(0, 0, 0);

      var d = 12;
      this.cameraOrtho = new T.OrthographicCamera(-d * w / h, d * w / h, d, -d, 0.1, 200);
      this.cameraOrtho.position.set(0, 30, 0);
      this.cameraOrtho.up.set(0, 0, -1);
      this.cameraOrtho.lookAt(0, 0, 0);

      this.camera = (STATE.view === '2d') ? this.cameraOrtho : this.cameraPersp;

      this.renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, preserveDrawingBuffer: true, stencil: true });
      this.renderer.localClippingEnabled = true;
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      this.renderer.setSize(w, h, false);
      /* Enable per-material clipping planes — used by SectionCutManager
         (assembly step 2). Stencil buffer is enabled so we can render
         opaque caps over the cut surface instead of leaving holes in
         the geometry. */
      this.renderer.localClippingEnabled = true;

      var amb = new T.AmbientLight(0xffffff, 0.7);
      var dir = new T.DirectionalLight(0xffffff, 0.6);
      dir.position.set(10, 20, 8);
      this.scene.add(amb);
      this.scene.add(dir);

      _rebuildGrid(this);

      this.sceneGroup = new T.Group();
      this.scene.add(this.sceneGroup);

      var OC = T.OrbitControls || global.OrbitControls;
      if (OC) {
        this.controls = new OC(this.cameraPersp, this.renderer.domElement);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.08;
        this.controls.target.set(0, 0, 0);
        this.controls.maxPolarAngle = Math.PI * 0.49;
        this.controls.update();
      }

      var self = this;
      window.addEventListener('resize', function () { self._onResize(); });
      this._onResize();

      this._animating = true;
      this._animate();
    },

    _onResize: function () {
      var canvas = this.renderer && this.renderer.domElement;
      if (!canvas) return;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;
      this.renderer.setSize(w, h, false);
      this.cameraPersp.aspect = w / h;
      this.cameraPersp.updateProjectionMatrix();
      var d = this._currentOrthoD || 12;
      this.cameraOrtho.left   = -d * w / h;
      this.cameraOrtho.right  =  d * w / h;
      this.cameraOrtho.top    =  d;
      this.cameraOrtho.bottom = -d;
      this.cameraOrtho.updateProjectionMatrix();
      positionDragHandles();
    },

    fitCameraToFootprint: function () {
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 2) return;
      var canvas = this.renderer && this.renderer.domElement;
      if (!canvas) return;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;

      var xMin =  Infinity, xMax = -Infinity;
      var zMin =  Infinity, zMax = -Infinity;
      for (var i = 0; i < poly.length; i++) {
        if (poly[i][0] < xMin) xMin = poly[i][0];
        if (poly[i][0] > xMax) xMax = poly[i][0];
        if (poly[i][1] < zMin) zMin = poly[i][1];
        if (poly[i][1] > zMax) zMax = poly[i][1];
      }
      var bbL = xMax - xMin;
      var bbW = zMax - zMin;
      if (bbL < 0.5 && bbW < 0.5) return;

      var PADDING = 4.0;
      var aspect = w / h;
      var halfW = bbL * 0.5 + PADDING;
      var halfH = bbW * 0.5 + PADDING;
      var d = Math.max(halfH, halfW / aspect);
      d = Math.max(d, 6);
      this._currentOrthoD = d;

      this.cameraOrtho.left   = -d * aspect;
      this.cameraOrtho.right  =  d * aspect;
      this.cameraOrtho.top    =  d;
      this.cameraOrtho.bottom = -d;
      this.cameraOrtho.updateProjectionMatrix();

      var cx = (xMin + xMax) / 2;
      var cz = (zMin + zMax) / 2;
      var dist = Math.max(bbL, bbW) * 1.6 + 6;
      this.cameraPersp.position.set(cx + dist * 0.6, dist * 0.6, cz + dist * 0.6);
      this.cameraPersp.lookAt(cx, 0, cz);
      if (this.controls) {
        this.controls.target.set(cx, 0, cz);
        this.controls.update();
      }
      this.cameraOrtho.position.set(cx, 30, cz);
      this.cameraOrtho.lookAt(cx, 0, cz);
      positionDragHandles();
    },

    _animate: function () {
      if (!this._animating) return;
      var self = this;
      requestAnimationFrame(function () { self._animate(); });
      if (this.controls && this.camera === this.cameraPersp) this.controls.update();
      if (this.renderer && this.camera) this.renderer.render(this.scene, this.camera);
      /* Drive any external per-frame work that needs world-to-screen
         tracking (FloorplanLib's wall-drag handles ride on this). */
      if (global.FloorplanLib && typeof global.FloorplanLib._onFrame === 'function') {
        global.FloorplanLib._onFrame();
      }
    },

    toggleView: function () {
      _resetAllHandleDrags();
      if (_CornerInserter && _CornerInserter.pendingPlacement) {
        _CornerInserter._setPending(false);
      }
      STATE.view = (STATE.view === '2d') ? '3d' : '2d';
      STATE.vizStage = 0;
      this.camera = (STATE.view === '2d') ? this.cameraOrtho : this.cameraPersp;
      var wrap = document.getElementById('cf-wrap-base');
      if (wrap) {
        wrap.classList.toggle('cf-view-2d', STATE.view === '2d');
        wrap.classList.toggle('cf-view-3d', STATE.view === '3d');
      }
      if (this._gridHelper) this._gridHelper.visible = true;
      var viewIcon = document.getElementById('cf-view-icon');
      if (viewIcon) {
        viewIcon.src = (STATE.view === '2d')
          ? 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/3d.png?v=1772625064'
          : 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/2d.png?v=1772625064';
      }
      positionDragHandles();
      if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();
      if (_MapManager && _MapManager.map && _MapManager.center) {
        if (STATE.view === '2d') {
          _MapManager._set3DLayerVisibility(false);
          _MapManager._syncMapTo2D(true);
        } else {
          _MapManager._set3DLayerVisibility(true);
          _MapManager._syncMapTo3D(true);
        }
      }
      if (_SlopeManager && _SlopeManager._updateAll) _SlopeManager._updateAll();
      /* Section cut only renders in 3D — toggle into 2D wipes any
         active clipping planes so the orthographic plan doesn't end
         up with chunks missing from materials that were clipped a
         moment ago. */
      if (_SectionCutManager) _SectionCutManager.refresh();
    }
  };

  global.BaseRenderer = {
    _materials: null,

    _ensureMaterials: function () {
      var T = global.THREE;
      if (this._materials) {
        /* Self-heal: if an older cached instance is missing newer
           materials (timber, steel added later), top them up so existing
           pages don't need a hard reload to get the new keys. */
        if (!this._materials.timber) {
          this._materials.timber = new T.MeshLambertMaterial({ color: 0xa67c52 });
        }
        if (!this._materials.steel) {
          this._materials.steel = new T.MeshLambertMaterial({ color: 0x3b4250 });
        }
        if (!this._materials.shelterRoof) {
          this._materials.shelterTimber   = new T.MeshLambertMaterial({ color: 0xb5895a });
          this._materials.shelterRoof     = new T.MeshLambertMaterial({ color: 0x6f7e87, side: T.DoubleSide });
          this._materials.shelterFooting  = new T.MeshLambertMaterial({ color: 0x9a9a9a });
          this._materials.houseWall       = new T.MeshLambertMaterial({ color: 0xe8e2d6 });
          this._materials.houseFoundation = new T.MeshLambertMaterial({ color: 0x9a948a });
        }
        if (!this._materials.houseGhost) {
          this._materials.houseGhost = new T.MeshLambertMaterial({ color: 0xe8e2d6, transparent: true, opacity: 0.18, depthWrite: false });
        }
        if (!this._materials.flashing) {
          this._materials.flashing = new T.MeshLambertMaterial({ color: 0x9aa0a4 });
        }
        if (!this._materials.gutter) {
          this._materials.gutter = new T.MeshLambertMaterial({ color: 0xc8ccce });
        }
        if (!this._materials.seam) {
          this._materials.seam = new T.MeshLambertMaterial({ color: 0x5b656b });
        }
        return this._materials;
      }
      this._materials = {
        slab:        new T.MeshLambertMaterial({ color: 0xb8b8b8 }),
        slabEdge:    new T.LineBasicMaterial({ color: 0x333333 }),
        strip:       new T.MeshLambertMaterial({ color: 0x9a9a9a }),
        pier:        new T.MeshLambertMaterial({ color: 0x7d7d7d }),
        precast:     new T.MeshLambertMaterial({ color: 0xa5a5a5 }),
      anchorSteel: new T.MeshLambertMaterial({ color: 0x9a9a9a }),
        screw:       new T.MeshLambertMaterial({ color: 0x444444 }),
        screwHead:   new T.MeshLambertMaterial({ color: 0x2a2a2a }),
        gravel:      new T.MeshLambertMaterial({ color: 0xc7b9a3 }),
        timber:      new T.MeshLambertMaterial({ color: 0xa67c52 }),
        /* Galvanized steel post base (Simpson ABU/PBS-style standoff
           bracket). Dark blue-grey for visible contrast against the
           lighter concrete pier. */
        steel:       new T.MeshLambertMaterial({ color: 0x3b4250 }),
        ghost:       new T.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.0 }),
        fill2D:      new T.MeshBasicMaterial({ color: 0xb8b8b8, transparent: true, opacity: 0.45, side: T.DoubleSide }),
        edge2D:      new T.LineBasicMaterial({ color: 0x222222 }),
        shelterTimber:   new T.MeshLambertMaterial({ color: 0xb5895a }),
        shelterRoof:     new T.MeshLambertMaterial({ color: 0x6f7e87, side: T.DoubleSide }),
        shelterFooting:  new T.MeshLambertMaterial({ color: 0x9a9a9a }),
        houseWall:       new T.MeshLambertMaterial({ color: 0xe8e2d6 }),
        houseFoundation: new T.MeshLambertMaterial({ color: 0x9a948a }),
        houseGhost:      new T.MeshLambertMaterial({ color: 0xe8e2d6, transparent: true, opacity: 0.18, depthWrite: false }),
        flashing:        new T.MeshLambertMaterial({ color: 0x9aa0a4 }),
        seam:            new T.MeshLambertMaterial({ color: 0x5b656b }),
        gutter:          new T.MeshLambertMaterial({ color: 0xc8ccce })
      };
      return this._materials;
    },

    build: function () {
      var T = global.THREE;
      var eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var G = eng.sceneGroup;
      while (G.children.length) {
        var c = G.children[0];
        G.remove(c);
        if (c.geometry && c.geometry.dispose) c.geometry.dispose();
        /* Per-mesh cloned materials (e.g. timber beams) must be disposed
           or each rebuild leaks a clone. Shared materials in `mats` are
           kept and reused — we only dispose if userData marks the mesh
           as owning its material. */
        if (c.userData && (c.userData.assetType === 'timber-beam' ||
                           c.userData.assetType === 'post-base') && c.material) {
          if (Array.isArray(c.material)) {
            for (var mi = 0; mi < c.material.length; mi++) {
              if (c.material[mi] && c.material[mi].dispose) c.material[mi].dispose();
            }
          } else if (c.material.dispose) {
            c.material.dispose();
          }
        }
      }
      var poly = getFootprintPolygon();
      if (!poly.length) return;

      if (STATE.view === '2d') {
        this._build2D(poly);
      } else {
        this._build3D(poly);
        this._build3D_SlopeViz(poly);
      }

      /* After every rebuild the freshly-created materials need the
         clipping planes re-attached if we're currently in section
         cut mode (viz stage 2 + 3D view). */
      if (_SectionCutManager && STATE.vizStage === 2 && STATE.view === '3d') {
        _SectionCutManager.refresh();
      }
    },

    _build3D_SlopeViz: function (poly) {
      if (!STATE.slopeActive || STATE.slopeDeg <= 0) return;
      var T = global.THREE;
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup) return;
      if (!poly || !poly.length) return;

      var xMin =  Infinity, xMax = -Infinity;
      var zMin =  Infinity, zMax = -Infinity;
      for (var i = 0; i < poly.length; i++) {
        var p = poly[i];
        if (p[0] < xMin) xMin = p[0];
        if (p[0] > xMax) xMax = p[0];
        if (p[1] < zMin) zMin = p[1];
        if (p[1] > zMax) zMax = p[1];
      }
      var bbL = xMax - xMin;
      var bbW = zMax - zMin;
      if (bbL < 0.1 || bbW < 0.1) return;

      var rad = STATE.slopeDeg * Math.PI / 180;
      var L = bbL * 2.5;
      var W = bbW * 2.0;
      var cx = (xMin + xMax) / 2;
      var cz = (zMin + zMax) / 2;

      var planeGeom = new T.PlaneGeometry(L, W, 1, 1);
      var posAttr = planeGeom.attributes.position;
      for (var i = 0; i < posAttr.count; i++) {
        var lx = posAttr.getX(i);
        posAttr.setY(i, -lx * Math.tan(rad));
      }
      planeGeom.computeVertexNormals();
      var planeMat = new T.MeshLambertMaterial({
        color: 0xD2A878, transparent: true, opacity: 0.22, side: T.DoubleSide
      });
      var plane = new T.Mesh(planeGeom, planeMat);
      plane.rotation.x = -Math.PI / 2;
      var bearing = _slopeRefBearing();
      if (bearing) plane.rotation.z = bearing * Math.PI / 180;
      plane.position.set(cx, 0, cz);
      plane.userData = { assetType: 'slope-terrain' };
      eng.sceneGroup.add(plane);
    },

    _addExcavationPit: function (cx, cz, sizeX, sizeZ, topY, depth) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var verts = [
        cx - sizeX/2, topY,         cz - sizeZ/2,
        cx + sizeX/2, topY,         cz - sizeZ/2,
        cx + sizeX/2, topY,         cz + sizeZ/2,
        cx - sizeX/2, topY,         cz + sizeZ/2,
        cx - sizeX/2, topY - depth, cz - sizeZ/2,
        cx + sizeX/2, topY - depth, cz - sizeZ/2,
        cx + sizeX/2, topY - depth, cz + sizeZ/2,
        cx - sizeX/2, topY - depth, cz + sizeZ/2
      ];
      var edges = [
        0,1, 1,2, 2,3, 3,0,
        4,5, 5,6, 6,7, 7,4,
        0,4, 1,5, 2,6, 3,7
      ];
      var lineGeom = new T.BufferGeometry();
      var positions = [];
      for (var e = 0; e < edges.length; e++) {
        var idx = edges[e] * 3;
        positions.push(verts[idx], verts[idx+1], verts[idx+2]);
      }
      lineGeom.setAttribute('position', new T.Float32BufferAttribute(positions, 3));
      var lineMat = new T.LineBasicMaterial({ color: 0xD2A878, transparent: true, opacity: 0.7 });
      var box = new T.LineSegments(lineGeom, lineMat);
      box.userData = { assetType: 'excavation-box' };
      eng.sceneGroup.add(box);
    },

    _polyToShape: function (poly) {
      var T = global.THREE;
      var shape = new T.Shape();
      shape.moveTo(poly[0][0], poly[0][1]);
      for (var i = 1; i < poly.length; i++) shape.lineTo(poly[i][0], poly[i][1]);
      shape.closePath();
      return shape;
    },

    _build2D: function (poly) {
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;

      mats.fill2D.opacity = STATE.opacity2D;
      var shape = this._polyToShape(poly);
      var geom = new T.ShapeGeometry(shape);
      var mesh = new T.Mesh(geom, mats.fill2D);
      mesh.rotation.x = Math.PI / 2;
      mesh.position.y = 0.001;
      eng.sceneGroup.add(mesh);

      var pts = [];
      for (var i = 0; i < poly.length; i++) {
        pts.push(new T.Vector3(poly[i][0], 0.002, poly[i][1]));
      }
      pts.push(new T.Vector3(poly[0][0], 0.002, poly[0][1]));
      var lineGeom = new T.BufferGeometry().setFromPoints(pts);
      var line = new T.Line(lineGeom, mats.edge2D);
      eng.sceneGroup.add(line);

      this._addRidge2D(poly);
    },

    _addRidge2D: function (poly) {
      if ((STATE.variant | 0) === 3) return;
      var T = global.THREE;
      var eng = global.BaseEngine;
      var mats = this._ensureMaterials();
      var yPlan = 0.004;

      var addSolid = function (ax, az, bx, bz) {
        var p = [new T.Vector3(ax, yPlan, az), new T.Vector3(bx, yPlan, bz)];
        eng.sceneGroup.add(new T.Line(new T.BufferGeometry().setFromPoints(p), mats.edge2D));
      };
      var _valleyMat = null;
      var addValley = function (ax, az, bx, bz) {
        if (!_valleyMat) _valleyMat = new T.LineDashedMaterial({ color: 0x3b4250, dashSize: 0.25, gapSize: 0.18 });
        var p = [new T.Vector3(ax, yPlan + 0.0005, az), new T.Vector3(bx, yPlan + 0.0005, bz)];
        var ln = new T.Line(new T.BufferGeometry().setFromPoints(p), _valleyMat);
        ln.computeLineDistances();
        eng.sceneGroup.add(ln);
      };

      try {
        var s = SHELTER_SPECS.carport;
        var hipRoof = (_roofTypeForVariant() === 'valba');
        var tanPitch = Math.tan(s.pitchDeg * Math.PI / 180);

        var Lp = _carportLParams(poly);
        if (Lp) {
          var A = Lp.a, B = Lp.b, ov = Lp.ov, Uarm = Lp.U, Vext = Lp.V;
          var hipL = hipRoof ? (Lp.yR - Lp.eaveY) / tanPitch : 0;
          var cuE = Uarm + ov - hipL, cvE = Vext + ov - hipL;
          var LW = function (cu, cv) { var w = Lp.toW(cu, cv, 0); return [w[0], w[2]]; };

          var jp = LW(A / 2, B / 2);
          var r1 = LW(cuE, B / 2);
          var r2 = LW(A / 2, cvE);
          addSolid(jp[0], jp[1], r1[0], r1[1]);
          addSolid(jp[0], jp[1], r2[0], r2[1]);

          var oc = LW(-ov, -ov);
          addSolid(jp[0], jp[1], oc[0], oc[1]);

          var ic = LW(A + ov, B + ov);
          addValley(jp[0], jp[1], ic[0], ic[1]);

          if (hipRoof) {
            var e1a = LW(Uarm + ov, -ov), e1b = LW(Uarm + ov, B + ov);
            addSolid(r1[0], r1[1], e1a[0], e1a[1]);
            addSolid(r1[0], r1[1], e1b[0], e1b[1]);
            var e2a = LW(-ov, Vext + ov), e2b = LW(A + ov, Vext + ov);
            addSolid(r2[0], r2[1], e2a[0], e2a[1]);
            addSolid(r2[0], r2[1], e2b[0], e2b[1]);
          }
          return;
        }

        var g = _carportGeom();
        for (var wi = 0; wi < g.wings.length; wi++) {
          var wg = g.wings[wi];
          var pts = [
            new T.Vector3(wg.ax.x, yPlan, wg.ax.z),
            new T.Vector3(wg.bx.x, yPlan, wg.bx.z)
          ];
          eng.sceneGroup.add(new T.Line(new T.BufferGeometry().setFromPoints(pts), mats.edge2D));
        }
      } catch (e) {
        _dbg('[roof] ridge2D error: ' + (e && e.message ? e.message : e));
      }
    },

    _addStripOutline2D: function (poly) {
      /* This is a 2D-only overlay (dashed inner line showing strip's
         inner face). Guard against accidental rendering in 3D view if
         the rebuild path ever changes. */
      if (STATE.view !== '2d') return;
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;
      var inset = getVariantDefaults('strip', STATE.lvl).stripWidthM;

      /* _insetVertex offsets along the OUTWARD bisector for CCW
         polygons (positive signed area) and INWARD for CW (negative).
         We always want the dashed line INSIDE, so flip the sign of
         the inset when the polygon is CCW. */
      var signedArea = 0;
      for (var k = 0; k < poly.length; k++) {
        var aSA = poly[k], bSA = poly[(k + 1) % poly.length];
        signedArea += aSA[0] * bSA[1] - bSA[0] * aSA[1];
      }
      var effectiveInset = (signedArea > 0) ? -inset : inset;

      var pts = [];
      for (var i = 0; i < poly.length; i++) {
        var prev = poly[(i - 1 + poly.length) % poly.length];
        var curr = poly[i];
        var next = poly[(i + 1) % poly.length];
        var p = _insetVertex(prev, curr, next, effectiveInset);
        pts.push(new T.Vector3(p[0], 0.003, p[1]));
      }
      pts.push(pts[0].clone());
      var g = new T.BufferGeometry().setFromPoints(pts);
      var dashed = new T.LineDashedMaterial({ color: 0x444444, dashSize: 0.2, gapSize: 0.15 });
      var line = new T.Line(g, dashed);
      line.computeLineDistances();
      eng.sceneGroup.add(line);
    },

    _addPierMarkers2D: function (poly) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var d = getVariantDefaults('piers', STATE.lvl);
      var raster = _computeTimberRaster(poly, 1.5);
      var side = d.pierSideM;
      var pierMat = new T.MeshBasicMaterial({ color: 0x444444 });
      for (var i = 0; i < raster.piers.length; i++) {
        var pg = new T.PlaneGeometry(side, side);
        var pm = new T.Mesh(pg, pierMat);
        pm.rotation.x = -Math.PI / 2;
        pm.position.set(raster.piers[i].x, 0.005, raster.piers[i].z);
        eng.sceneGroup.add(pm);
      }
    },

    _addPrecastMarkers2D: function (poly) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var dP = getVariantDefaults('precast', STATE.lvl);
      var raster = _computeTimberRaster(poly, dP.blockSpacingM);
      var positions = raster.piers;
      var side = dP.blockBaseM;
      var mat = new T.MeshBasicMaterial({ color: 0x666666 });
      for (var i = 0; i < positions.length; i++) {
        var g = new T.PlaneGeometry(side, side);
        var m = new T.Mesh(g, mat);
        m.rotation.x = -Math.PI / 2;
        m.position.set(positions[i].x, 0.005, positions[i].z);
        eng.sceneGroup.add(m);
      }
    },

    _addScrewMarkers2D: function (poly) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var positions = _computeTimberRaster(poly, getVariantDefaults('screws', STATE.lvl).screwSpacingM).piers;
      var mat = new T.MeshBasicMaterial({ color: 0x222222 });
      for (var i = 0; i < positions.length; i++) {
        var g = new T.CircleGeometry(0.10, 16);
        var m = new T.Mesh(g, mat);
        m.rotation.x = -Math.PI / 2;
        m.position.set(positions[i].x, 0.005, positions[i].z);
        eng.sceneGroup.add(m);
      }
    },

    _build3D: function (poly) {
      return this._build3D_Roof(poly);
    },

    _build3D_Roof: function (poly) {
      var T = global.THREE, eng = global.BaseEngine;
      var mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup || !poly || poly.length < 3) return;
      try {
        var spec = SHELTER_SPECS.carport;
        spec.pitchDeg     = (typeof STATE.roofPitchDeg === 'number' && STATE.roofPitchDeg > 0) ? STATE.roofPitchDeg : 22;
        spec.pultPitchDeg = (typeof STATE.roofMonoPitchDeg === 'number' && STATE.roofMonoPitchDeg > 0) ? STATE.roofMonoPitchDeg : 10;
        spec.overhangM    = (typeof STATE.roofOverhangM === 'number') ? STATE.roofOverhangM : 0.30;
        spec.clearHeight  = (typeof STATE.roofWallH === 'number' && STATE.roofWallH > 0) ? STATE.roofWallH : 2.40;
        if (spec.truss) spec.truss.spacing = (typeof STATE.trussSpacingM === 'number' && STATE.trussSpacingM > 0) ? STATE.trussSpacingM : 0.61;
        if (spec.truss) spec.truss.panels = (typeof STATE.trussPanels === 'number' && STATE.trussPanels >= 2) ? (STATE.trussPanels | 0) : 3;
        var g = _carportGeom(), s = g.s, SG = eng.sceneGroup;

        function V(x, y, z) { return new T.Vector3(x, y, z); }

        function memberAlong(p1, p2, sectH, sectW, mat) {
          var dir = new T.Vector3().subVectors(p2, p1);
          var len = dir.length();
          if (len < 1e-4) return null;
          var m = new T.Mesh(new T.BoxGeometry(len, sectH, sectW), mat);
          m.position.copy(new T.Vector3().addVectors(p1, p2).multiplyScalar(0.5));
          var q = new T.Quaternion();
          q.setFromUnitVectors(new T.Vector3(1, 0, 0), dir.clone().normalize());
          m.quaternion.copy(q);
          SG.add(m);
          return m;
        }

        function memberTruss(p1, p2, sectH, sectW, mat, depth) {
          var dir = new T.Vector3().subVectors(p2, p1);
          var len = dir.length();
          if (len < 1e-4) return null;
          var xA = dir.clone().normalize();
          var zA = depth.clone();
          zA.addScaledVector(xA, -zA.dot(xA));
          if (zA.lengthSq() < 1e-6) zA.set(0, 0, 1).addScaledVector(xA, -xA.z * 1);
          zA.normalize();
          var yA = new T.Vector3().crossVectors(zA, xA).normalize();
          var m = new T.Mesh(new T.BoxGeometry(len, sectH, sectW), mat);
          m.quaternion.setFromRotationMatrix(new T.Matrix4().makeBasis(xA, yA, zA));
          m.position.copy(new T.Vector3().addVectors(p1, p2).multiplyScalar(0.5));
          SG.add(m);
          return m;
        }
        function quad(a, b, c, d, mat) {
          var geo = new T.BufferGeometry();
          geo.setAttribute('position', new T.BufferAttribute(new Float32Array([
            a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z,
            a.x, a.y, a.z, c.x, c.y, c.z, d.x, d.y, d.z
          ]), 3));
          geo.computeVertexNormals();
          var mesh = new T.Mesh(geo, mat);
          mesh.userData.partType = 'roofSkin';
          mesh.visible = (STATE.vizStage !== 2);
          SG.add(mesh);
        }
        function tri(a, b, c, mat) {
          var geo = new T.BufferGeometry();
          geo.setAttribute('position', new T.BufferAttribute(new Float32Array([
            a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z
          ]), 3));
          geo.computeVertexNormals();
          var mesh = new T.Mesh(geo, mat);
          mesh.userData.partType = 'roofSkin';
          mesh.visible = (STATE.vizStage !== 2);
          SG.add(mesh);
        }

        /* Volumetric ghost of the house under the roof. Shown only in
           viz stage 1 so the default view is the roof alone. */
        var wallH = s.clearHeight + s.beam.h;
        var ghostGeo = new T.ExtrudeGeometry(this._polyToShape(poly), { depth: wallH, bevelEnabled: false });
        var ghost = new T.Mesh(ghostGeo, mats.houseGhost);
        ghost.rotation.x = Math.PI / 2;
        ghost.position.y = wallH;
        ghost.userData.partType = 'houseGhost';
        ghost.visible = (STATE.vizStage === 1);
        SG.add(ghost);

        var lift = 0.14;
        function WP(wg, t, p, y) {
          return new T.Vector3(
            wg.ax.x + wg.dirU.x * t + wg.dirV.x * p,
            y,
            wg.ax.z + wg.dirU.z * t + wg.dirV.z * p
          );
        }
        function Va(p) { return new T.Vector3(p[0], p[1], p[2]); }
        function quadA(p, q, r, u, mat) { quad(Va(p), Va(q), Va(r), Va(u), mat); }
        var roofType = _roofTypeForVariant();
        var flatRoof = roofType === 'atika';
        var pultRoof = roofType === 'pult';
        var customRoof = flatRoof || pultRoof;
        var hipRoof = roofType === 'valba';
        var tanPitch = Math.tan(s.pitchDeg * Math.PI / 180);
        var _trussSel = (STATE.roofStructure === 'truss') && (roofType === 'sedlo');
        /* COVERING-FIRST for complex footprints: even in truss mode, route L/U/T/H
           to the carport roof renderer (proper ridges + valleys at inner corners).
           Trusses stay on plain rectangles for now; complex-shape trusses come next. */
        var Lp = (!customRoof && true) ? _carportLParams(poly) : null;
        var Up = (!customRoof && !Lp && true) ? _carportUParams(poly) : null;
        var Tp = (!customRoof && !Lp && !Up && true) ? _carportTeeParams(poly) : null;
        var Hp = (!customRoof && !Lp && !Up && !Tp && true) ? _carportHParams(poly) : null;
        var RV = (!customRoof && !_trussSel && hipRoof && !Lp && !Up && !Tp && !Hp && true) ? _carportRectParams(poly) : null;
        var useTruss = _trussSel && !Lp && !Up && !Tp && !Hp && !RV;
        var RC = (!customRoof && !useTruss && !Lp && !Up && !Tp && !Hp && !RV && true) ? _carportRoofComb(poly) : null;
        if (flatRoof || pultRoof) {
          var eYc = s.clearHeight + s.beam.h;
          var thR = _carportPrincipalAngle(poly);
          var vMinR = Infinity, vMaxR = -Infinity;
          for (var pv = 0; pv < poly.length; pv++) {
            var lq = _carportRotPt(poly[pv][0], poly[pv][1], -thR);
            if (lq[1] < vMinR) vMinR = lq[1];
            if (lq[1] > vMaxR) vMaxR = lq[1];
          }
          var pultRate = Math.tan((s.pultPitchDeg || 10) * Math.PI / 180);
          var hAt = function (x, z) {
            if (flatRoof) return eYc;
            var lv = _carportRotPt(x, z, -thR)[1];
            return eYc + (vMaxR - lv) * pultRate;
          };
          var trisR = _carportPolyTris(poly);
          for (var tr2 = 0; tr2 < trisR.length; tr2++) {
            var t3 = trisR[tr2];
            tri(
              new T.Vector3(t3[0][0], hAt(t3[0][0], t3[0][1]) + lift, t3[0][1]),
              new T.Vector3(t3[1][0], hAt(t3[1][0], t3[1][1]) + lift, t3[1][1]),
              new T.Vector3(t3[2][0], hAt(t3[2][0], t3[2][1]) + lift, t3[2][1]),
              mats.shelterRoof
            );
          }
          /* obvodové trámy s ČISTÝMI rohmi (butt joint, bez clippingu):
             párne hrany prejdú cez roh (predĺžené o pol šírky, vyplnia
             vonkajší roh), nepárne sa o pol šírky skrátia a zarazia sa
             o ich vnútornú plochu -> žiadne prekrytie ani presah. */
          var perimeterMitred = function (yFn, sectH, sectW, code, ptype) {
            var NN = poly.length, hw = sectW * 0.5, alt = (NN % 2 === 0);
            for (var ei = 0; ei < NN; ei++) {
              var A = poly[ei], B = poly[(ei + 1) % NN];
              var pA = Va([A[0], yFn(A[0], A[1]), A[1]]), pB = Va([B[0], yFn(B[0], B[1]), B[1]]);
              var dir = new T.Vector3().subVectors(pB, pA), len = dir.length(); if (len < 1e-4) continue; dir.normalize();
              var d = (!alt || ei % 2 === 0) ? hw : -hw;   /* párne predĺž, nepárne skráť */
              var qA = pA.clone().addScaledVector(dir, -d), qB = pB.clone().addScaledVector(dir, d);
              var m = memberAlong(qA, qB, sectH, sectW, mats.shelterTimber);
              if (m) {
                m.userData.partType = ptype; m.userData.assetType = ptype; m.userData.category = 'STRUCTURAL';
                if (code) m.userData.boqCode = code;
                m.userData.index = eng._roofElIdx++;
              }
            }
          };
          if (flatRoof) {
            perimeterMitred(function () { return eYc + lift + 0.225; }, 0.45, 0.12, null, 'roofParapet');
          } else {
            perimeterMitred(function (x, z) { return hAt(x, z); }, s.beam.h, s.beam.w, null, 'roofBeam');
          }

          /* --- štruktúrny rám plochej strechy: obvodový RÁM (rim/band joist)
             na úrovni trámkov + vnútorné trámky (joists) ‖ kratšej strane,
             US rozteč 16" o.c. (0.4064 m), napojené do rámu, + 2 rovné rady
             blokovania. Parapet (vyššie) sedí navrchu. (viď 3D schéma flat roof) */
          (function () {
            var jW = 0.06, jD = 0.20, rimW = 0.10, rimHalf = rimW * 0.5, SPACING = 16 * 0.0254;
            var jCy = eYc + lift - jD * 0.5;   /* trámky tesne pod doskou */
            /* obvodový rám na úrovni trámkov (band joist) — s 45° miterom */
            perimeterMitred(function () { return jCy; }, jD, rimW, 'KVH10200', 'roofRim');
            var uMinR = Infinity, uMaxR = -Infinity;
            for (var pu = 0; pu < poly.length; pu++) {
              var lqu = _carportRotPt(poly[pu][0], poly[pu][1], -thR);
              if (lqu[0] < uMinR) uMinR = lqu[0];
              if (lqu[0] > uMaxR) uMaxR = lqu[0];
            }
            var uLen = uMaxR - uMinR, vLen = vMaxR - vMinR;
            var joistsAlongV = (uLen >= vLen);   /* trámky ‖ kratšej strane */
            var longMin = joistsAlongV ? uMinR : vMinR, longMax = joistsAlongV ? uMaxR : vMaxR;
            var shortMin = joistsAlongV ? vMinR : uMinR, shortMax = joistsAlongV ? vMaxR : uMaxR;
            var mkBeam = function (longA, shortA, longB, shortB, sw, kind) {
              var uA = joistsAlongV ? longA : shortA, vA = joistsAlongV ? shortA : longA;
              var uB = joistsAlongV ? longB : shortB, vB = joistsAlongV ? shortB : longB;
              var wA = _carportRotPt(uA, vA, thR), wB = _carportRotPt(uB, vB, thR);
              var yA = hAt(wA[0], wA[1]) + lift - jD * 0.5, yB = hAt(wB[0], wB[1]) + lift - jD * 0.5;
              var jm = memberAlong(Va([wA[0], yA, wA[1]]), Va([wB[0], yB, wB[1]]), jD, sw, mats.shelterTimber);
              if (jm) { jm.userData.partType = 'roofJoist'; jm.userData.assetType = (kind || 'roofJoist'); jm.userData.category = 'STRUCTURAL'; jm.userData.boqCode = 'KVH60200'; jm.userData.index = eng._roofElIdx++; }
            };
            var blo = shortMin + rimHalf, bhi = shortMax - rimHalf;   /* rozpätie trámka: butt do rámu */
            var alo = longMin + rimHalf + jW, ahi = longMax - rimHalf - jW;
            var n = Math.max(1, Math.round((ahi - alo) / SPACING)), step = (ahi - alo) / n;
            var pos = [];
            for (var i = 0; i <= n; i++) { var a = alo + i * step; pos.push(a); mkBeam(a, blo, a, bhi, jW); }
            /* blokovanie: 2 rady (1/3 a 2/3 rozpätia), každý plne obsadený
               (blok v každom poli), v rámci radu prekladaný (staggered ±) —
               plné pokrytie celého rozpätia + zigzag na koncové klincovanie */
            var rowsB = [blo + (bhi - blo) / 3, blo + (bhi - blo) * 2 / 3];
            for (var rw = 0; rw < rowsB.length; rw++) {
              for (var bk = 0; bk < pos.length - 1; bk++) {
                var soff = (bk % 2 ? 1 : -1) * (jD * 0.55);
                mkBeam(pos[bk], rowsB[rw] + soff, pos[bk + 1], rowsB[rw] + soff, jW, 'roofBlocking');
              }
            }
          })();
        } else if (Lp) {
          var Uarm = Lp.U, Vext = Lp.V, A = Lp.a, B = Lp.b, ovL = Lp.ov;
          var yRr = Lp.yR + lift, yEe = Lp.yE + lift;
          var P = function (cu, cv, y) { return Lp.toW(cu, cv, y); };
          var ocu = -ovL, ocv = -ovL, rcu = A + ovL, rcv = B + ovL;
          var hipL = hipRoof ? (Lp.yR - Lp.eaveY) / tanPitch : 0;
          var cuE = Uarm + ovL - hipL, cvE = Vext + ovL - hipL;

          quadA(P(A / 2, B / 2, yRr), P(cuE, B / 2, yRr), P(Uarm + ovL, ocv, yEe), P(ocu, ocv, yEe), mats.shelterRoof);
          quadA(P(A / 2, B / 2, yRr), P(cuE, B / 2, yRr), P(Uarm + ovL, rcv, yEe), P(rcu, rcv, yEe), mats.shelterRoof);
          quadA(P(A / 2, B / 2, yRr), P(A / 2, cvE, yRr), P(ocu, Vext + ovL, yEe), P(ocu, ocv, yEe), mats.shelterRoof);
          quadA(P(A / 2, B / 2, yRr), P(A / 2, cvE, yRr), P(rcu, Vext + ovL, yEe), P(rcu, rcv, yEe), mats.shelterRoof);
          if (hipRoof) {
            tri(Va(P(cuE, B / 2, yRr)), Va(P(Uarm + ovL, ocv, yEe)), Va(P(Uarm + ovL, rcv, yEe)), mats.shelterRoof);
            tri(Va(P(A / 2, cvE, yRr)), Va(P(ocu, Vext + ovL, yEe)), Va(P(rcu, Vext + ovL, yEe)), mats.shelterRoof);
          }

          /* --- štítové oplechovanie (rake / gable flashing, ROD06030):
             ROVNAKÝ systém a veľkosti ako obdĺžnikový tvar (wings) — 2 rake
             plechy na štít (odkvap -> hrebeň, každý spád), mitrované do roviny
             acrossDir·point = acrossDir·apex, takže sa oba spády stretnú.
             depthDir = smer hrebeňa ramena, acrossDir = naprieč (vodorovne). */
          if (!hipRoof) (function () {
            var FLg = (mats.flashing || mats.gutter || mats.steel).clone(); FLg.side = T.DoubleSide;
            var GP = GABLE_PROFILE, gpN = GP.length;
            var axF = 0.09, ayF = 0.059, EAVE_EXTEND = 0.07;
            var _o0 = Lp.toW(0, 0, 0), _du = Lp.toW(1, 0, 0), _dv = Lp.toW(0, 1, 0);
            var duL = new T.Vector3(_du[0] - _o0[0], 0, _du[2] - _o0[2]); if (duL.lengthSq() > 1e-9) duL.normalize();
            var dvL = new T.Vector3(_dv[0] - _o0[0], 0, _dv[2] - _o0[2]); if (dvL.lengthSq() > 1e-9) dvL.normalize();
            var rake = function (Pe, Pa, depthDir, acrossDir) {
              var rakeDir = new T.Vector3().subVectors(Pa, Pe).normalize();
              var rakeLen = Pe.distanceTo(Pa);
              var N2 = new T.Vector3().crossVectors(depthDir, rakeDir).normalize();
              if (N2.y < 0) N2.multiplyScalar(-1);
              var uDir = depthDir.clone();   /* von za štít (+depthDir smerom k okraju) */
              uDir.addScaledVector(rakeDir, -uDir.dot(rakeDir));
              uDir.addScaledVector(N2, -uDir.dot(N2)).normalize();
              var O = Pe.clone().addScaledVector(uDir, -axF).addScaledVector(N2, -ayF).add(new T.Vector3(0, lift, 0));
              var apexAcross = acrossDir.dot(Pa);
              var adRake = acrossDir.dot(rakeDir), adU = acrossDir.dot(uDir), adN = acrossDir.dot(N2), adO = acrossDir.dot(O);
              var Ept = function (i) { return new T.Vector3().copy(O).addScaledVector(rakeDir, -EAVE_EXTEND).addScaledVector(uDir, GP[i][0]).addScaledVector(N2, GP[i][1]); };
              var Apt = function (i) {
                var z = (Math.abs(adRake) > 1e-6) ? (apexAcross - adO - GP[i][0] * adU - GP[i][1] * adN) / adRake : rakeLen;
                return new T.Vector3().copy(O).addScaledVector(rakeDir, z).addScaledVector(uDir, GP[i][0]).addScaledVector(N2, GP[i][1]);
              };
              var pos = [];
              for (var gi = 0; gi < gpN - 1; gi++) {
                var e0 = Ept(gi), e1 = Ept(gi + 1), a1 = Apt(gi + 1), a0 = Apt(gi);
                pos.push(e0.x, e0.y, e0.z, e1.x, e1.y, e1.z, a1.x, a1.y, a1.z);
                pos.push(e0.x, e0.y, e0.z, a1.x, a1.y, a1.z, a0.x, a0.y, a0.z);
              }
              var geo = new T.BufferGeometry();
              geo.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
              geo.computeVertexNormals();
              var mesh = new T.Mesh(geo, FLg);
              mesh.userData.partType  = 'roofFlashing';
              mesh.userData.boqCode   = 'ROD06030';
              mesh.userData.assetType = 'roofFlashing';
              mesh.userData.category  = 'ROOF';
              mesh.userData.index     = eng._roofElIdx++;
              mesh.userData.length    = rakeLen;
              SG.add(mesh);
            };
            /* bottom-arm štít (cu = Uarm+ov): hrebeň pozdĺž cu (duL), naprieč cv (dvL) */
            var apxU = Va(P(Uarm + ovL, B / 2, Lp.yR));
            rake(Va(P(Uarm + ovL, ocv, Lp.yE)), apxU, duL, dvL);
            rake(Va(P(Uarm + ovL, rcv, Lp.yE)), apxU, duL, dvL);
            /* left-arm štít (cv = Vext+ov): hrebeň pozdĺž cv (dvL), naprieč cu (duL) */
            var apxV = Va(P(A / 2, Vext + ovL, Lp.yR));
            rake(Va(P(ocu, Vext + ovL, Lp.yE)), apxV, dvL, duL);
            rake(Va(P(rcu, Vext + ovL, Lp.yE)), apxV, dvL, duL);
          })();

          if (!_trussSel) {
            var jR = P(A / 2, B / 2, Lp.yR);
            memberAlong(Va(jR), Va(P(cuE, B / 2, Lp.yR)), s.ridge.h, s.ridge.w, mats.shelterTimber);
            memberAlong(Va(jR), Va(P(A / 2, cvE, Lp.yR)), s.ridge.h, s.ridge.w, mats.shelterTimber);
            memberAlong(Va(jR), Va(P(ocu, ocv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(jR), Va(P(rcu, rcv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (hipRoof) {
              memberAlong(Va(P(cuE, B / 2, Lp.yR)), Va(P(Uarm + ovL, ocv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(Va(P(cuE, B / 2, Lp.yR)), Va(P(Uarm + ovL, rcv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(Va(P(A / 2, cvE, Lp.yR)), Va(P(ocu, Vext + ovL, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(Va(P(A / 2, cvE, Lp.yR)), Va(P(rcu, Vext + ovL, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
            var hspL = s.rafter.spacing;
            var UarmT = hipRoof ? Math.max(A, Math.min(Uarm, cuE)) : Uarm;
            var hn = Math.max(1, Math.ceil((UarmT - A) / hspL));
            for (var ri = 1; ri <= hn; ri++) {
              var cuH = A + (UarmT - A) * ri / hn;
              memberAlong(Va(P(cuH, B / 2, Lp.yR)), Va(P(cuH, ocv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(Va(P(cuH, B / 2, Lp.yR)), Va(P(cuH, rcv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
            var VextT = hipRoof ? Math.max(B, Math.min(Vext, cvE)) : Vext;
            var vn = Math.max(1, Math.ceil((VextT - B) / hspL));
            for (var rj = 1; rj <= vn; rj++) {
              var cvV = B + (VextT - B) * rj / vn;
              memberAlong(Va(P(A / 2, cvV, Lp.yR)), Va(P(ocu, cvV, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(Va(P(A / 2, cvV, Lp.yR)), Va(P(rcu, cvV, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          } else {
            /* L truss layout (step 1): primary Fink trusses in the two
               rectangular arms only; corner square left empty for the
               valley sets + jack trusses coming in a later step.
               u-arm: cu in [A, Uarm], ridge along u at cv=B/2, half=B/2.
               v-arm: cv in [B, Vext], ridge along v at cu=A/2, half=A/2. */
            var tsL  = s.truss || {};
            var CHl  = tsL.chord || { w: 0.06, h: 0.16, code: 'KVH60160' };
            var WBl  = tsL.web   || { w: 0.06, h: 0.12, code: 'KVH60120' };
            var nPanL = tsL.panels || 3;
            var tspL  = tsL.spacing || 0.61;
            if (typeof eng._roofElIdx !== 'number') eng._roofElIdx = 0;

            var _o0 = Lp.toW(0, 0, 0);
            var _du = Lp.toW(1, 0, 0), _dv = Lp.toW(0, 1, 0);
            var duW = new T.Vector3(_du[0] - _o0[0], 0, _du[2] - _o0[2]);
            var dvW = new T.Vector3(_dv[0] - _o0[0], 0, _dv[2] - _o0[2]);
            if (duW.lengthSq() > 1e-9) duW.normalize();
            if (dvW.lengthSq() > 1e-9) dvW.normalize();

            var _diagChordMat = new T.MeshStandardMaterial({ color: 0xff2200, roughness: 0.6, metalness: 0.0 });
            var placeTrussMember = function (p1w, p2w, sectH, sectW, depthDir, code, kind) {
              var dir = new T.Vector3().subVectors(p2w, p1w);
              var len = dir.length();
              if (len < 1e-4) return;
              var xA = dir.clone().normalize();
              var zA = depthDir.clone();
              zA.addScaledVector(xA, -zA.dot(xA));
              if (zA.lengthSq() < 1e-6) zA.set(0, 0, 1);
              zA.normalize();
              var yA = new T.Vector3().crossVectors(zA, xA).normalize();
              var m = new T.Mesh(new T.BoxGeometry(len, sectH, sectW), mats.shelterTimber);
              m.quaternion.setFromRotationMatrix(new T.Matrix4().makeBasis(xA, yA, zA));
              m.position.copy(new T.Vector3().addVectors(p1w, p2w).multiplyScalar(0.5));
              m.userData.partType  = 'roofTimber';
              m.userData.boqCode   = code;
              m.userData.assetType = kind;
              m.userData.category  = 'STRUCTURAL';
              m.userData.index     = eng._roofElIdx++;
              m.userData.length    = len;
              SG.add(m);
            };

            var PLl  = tsL.plate    || { len: 0.30, wid: 0.15, t: 0.012, code: 'FSP00001' };
            var PLWl = tsL.plateWeb || { len: 0.18, wid: 0.10, t: 0.012, code: 'FSP00001' };
            var BTl  = s.batten || { w: 0.05, h: 0.03, code: 'KVR50031', spacing: 0.35 };
            var UP = new T.Vector3(0, 1, 0);

            var _diagGussetMat = new T.MeshStandardMaterial({ color: 0x00cc44, roughness: 0.6, metalness: 0.0 });
            var placeGussetGen = function (stationW, depthDir, acrossDir, tt, cp, cy, dirP, dirY, pl) {
              pl = pl || PLl;
              var memDir = new T.Vector3().copy(acrossDir).multiplyScalar(dirP).addScaledVector(UP, dirY).normalize();
              var perp = new T.Vector3().crossVectors(depthDir, memDir).normalize();
              var basis = new T.Matrix4().makeBasis(memDir, perp, depthDir);
              var faceOff = (CHl.w * 0.5) + (pl.t * 0.5);
              for (var sgn = -1; sgn <= 1; sgn += 2) {
                var m = new T.Mesh(new T.BoxGeometry(pl.len, pl.wid, pl.t), mats.steel);
                m.quaternion.setFromRotationMatrix(basis);
                m.position.copy(stationW(tt, cp, cy)).addScaledVector(depthDir, sgn * faceOff);
                m.userData.partType  = 'gussetPlate';
                m.userData.boqCode   = pl.code || 'FSP00001';
                m.userData.assetType = 'gussetPlate';
                m.userData.category  = 'STRUCTURAL';
                m.userData.index     = eng._roofElIdx++;
                SG.add(m);
              }
            };
            var placePlateOnMemberGen = function (stationW, depthDir, acrossDir, tt, p1, y1, p2, y2) {
              var dp = p2 - p1, dy = y2 - y1, Lm = Math.hypot(dp, dy);
              if (Lm < 1e-4) return;
              var ux = dp / Lm, uy = dy / Lm;
              var off = Math.min(PLWl.len * 0.45, Lm * 0.45);
              placeGussetGen(stationW, depthDir, acrossDir, tt, p1 + ux * off, y1 + uy * off, ux, uy, PLWl);
            };
            var gussetNodesGen = function (stationW, depthDir, acrossDir, tt, truss, half) {
              var raiseBottom = (PLl.wid - CHl.h) / 2 + 0.02;
              for (var ni = 0; ni < truss.nodes.length; ni++) {
                var nd2 = truss.nodes[ni];
                var onTie = Math.abs(nd2.y - Lp.yE) < 1e-6;
                if (nd2.multi) {
                  placeGussetGen(stationW, depthDir, acrossDir, tt, nd2.p, nd2.y + (onTie ? raiseBottom : 0), nd2.dp, nd2.dy, PLl);
                } else if (nd2.heel) {
                  var sgnH = (nd2.p >= 0) ? 1 : -1;
                  var inOff = Math.min(PLl.len * 0.5 + 0.15, half * 0.45);
                  placeGussetGen(stationW, depthDir, acrossDir, tt, nd2.p - sgnH * inOff, nd2.y + raiseBottom, 1, 0, PLl);
                }
              }
              for (var mj = 0; mj < truss.members.length; mj++) {
                var mw = truss.members[mj];
                if (mw.kind !== 'web' && mw.kind !== 'post') continue;
                if ((truss.conn[truss.key(mw.p1, mw.y1)] || 0) < 2) placePlateOnMemberGen(stationW, depthDir, acrossDir, tt, mw.p1, mw.y1, mw.p2, mw.y2);
                if ((truss.conn[truss.key(mw.p2, mw.y2)] || 0) < 2) placePlateOnMemberGen(stationW, depthDir, acrossDir, tt, mw.p2, mw.y2, mw.p1, mw.y1);
              }
            };
            var placeBattenGen = function (stationW, depthDir, acrossDir, half, t0b, t1b, pB) {
              var rise = Lp.yR - Lp.yE;
              var run = half;   /* spád ako horný pás väzníka (_finkTruss TCy: run=hWall=half),
                                   aby laty sadli PRESNE na krokvy, nie na (plytšiu) rovinu krytiny */
              var yPlane = Lp.yR - (Math.abs(pB) / run) * rise;
              var slopeDir, N;
              if (Math.abs(pB) < 1e-6) { slopeDir = acrossDir.clone(); N = UP.clone(); }
              else {
                var sd = (pB >= 0) ? 1 : -1;
                slopeDir = new T.Vector3().copy(acrossDir).multiplyScalar(-sd * run).addScaledVector(UP, rise).normalize();
                N = new T.Vector3().crossVectors(depthDir, slopeDir).normalize();
                if (N.y < 0) N.multiplyScalar(-1);
              }
              var basisW = new T.Vector3().crossVectors(depthDir, N);
              var basis = new T.Matrix4().makeBasis(depthDir, N, basisW);
              var c0 = stationW(t0b, pB, yPlane), c1 = stationW(t1b, pB, yPlane);
              var lift2 = (CHl.h * 0.5) + (BTl.h * 0.5) + 0.005;
              var ctr = new T.Vector3().addVectors(c0, c1).multiplyScalar(0.5).addScaledVector(N, lift2);
              var bl = t1b - t0b;
              var m = new T.Mesh(new T.BoxGeometry(bl, BTl.h, BTl.w), mats.shelterTimber);
              m.quaternion.setFromRotationMatrix(basis);
              m.position.copy(ctr);
              m.userData.partType  = 'roofBatten';
              m.userData.boqCode   = BTl.code;
              m.userData.assetType = 'roofBatten';
              m.userData.category  = 'STRUCTURAL';
              m.userData.index     = eng._roofElIdx++;
              m.userData.length    = bl;
              SG.add(m);
            };
            var battenArm = function (stationW, depthDir, acrossDir, half, clipOuter, clipInner, t1b, nLevels) {
              var eaveInset = 0.06;
              for (var bside = -1; bside <= 1; bside += 2) {
                for (var kb = 0; kb <= nLevels; kb++) {
                  if (bside === 1 && kb === 0) continue;
                  var pBat = (kb === nLevels) ? (half - eaveInset) : (kb / nLevels) * half;
                  var t0 = (bside === -1) ? clipOuter(pBat) : clipInner(pBat);
                  if (t0 >= t1b - 0.05) continue;
                  placeBattenGen(stationW, depthDir, acrossDir, half, t0, t1b, bside * pBat);
                }
              }
            };

            var drawArmTrusses = function (t0, t1, half, depthDir, acrossDir, stationW) {
              var span = t1 - t0;
              if (span <= 0.05 || half <= 0.05) return;
              var nT = Math.max(2, Math.ceil(span / tspL) + 1);
              var truss = _finkTruss(half, Lp.yE, Lp.yR, nPanL);
              for (var iT = 0; iT < nT; iT++) {
                var tt = t0 + span * iT / (nT - 1);
                for (var mIdx = 0; mIdx < truss.members.length; mIdx++) {
                  var mm = truss.members[mIdx];
                  var isChord = (mm.kind === 'chord' || mm.kind === 'tie');
                  var SECl = isChord ? CHl : WBl;
                  placeTrussMember(
                    stationW(tt, mm.p1, mm.y1),
                    stationW(tt, mm.p2, mm.y2),
                    SECl.h, SECl.w, depthDir, SECl.code,
                    isChord ? 'roofChord' : 'roofWeb'
                  );
                }
                gussetNodesGen(stationW, depthDir, acrossDir, tt, truss, half);
              }
            };

            /* Mirror corner: every truss is cut along the hip diagonal
               (outer corner -> ridge junction). Vertical field (bottom-arm
               direction) fills below the diagonal + the whole bottom arm;
               horizontal field (left-arm direction) fills above the diagonal
               + the whole left arm. Both shorten toward the outer corner and
               meet on the diagonal -> mirror symmetric. buildCutTruss with
               top=full span reduces to a normal symmetric Fink. */
            var buildCutTruss = function (half, top, yE, yR) {
              var mem = [], nodes = [];
              if (top < 0.20 || half < 0.05) return { members: mem, nodes: nodes };
              var panel = 1.1;
              mem.push({ s1: 0, y1: yE, s2: top, y2: yE, kind: 'tie' });

              var apexS, apexY, chordFn;
              if (top <= half + 1e-3) {
                apexS = top; apexY = yE + (yR - yE) * (top / half);
                chordFn = function (s) { return yE + (apexY - yE) * (s / top); };
                mem.push({ s1: 0, y1: yE, s2: top, y2: apexY, kind: 'chord' });
                if (apexY - yE > 0.05) mem.push({ s1: top, y1: yE, s2: top, y2: apexY, kind: 'post' });
                nodes.push({ s: 0, y: yE, dp: 1, dy: 0 });
                nodes.push({ s: top, y: apexY, dp: 0, dy: 1 });
              } else {
                apexS = half; apexY = yR;
                var hc2 = Math.max(yE, yR - (yR - yE) * (top - half) / half);
                chordFn = function (s) { return (s <= half) ? (yE + (yR - yE) * (s / half)) : Math.max(yE, yR - (yR - yE) * (s - half) / half); };
                mem.push({ s1: 0, y1: yE, s2: half, y2: yR, kind: 'chord' });
                mem.push({ s1: half, y1: yR, s2: top, y2: hc2, kind: 'chord' });
                mem.push({ s1: half, y1: yE, s2: half, y2: yR, kind: 'post' });
                if (top - half > 0.05 && hc2 - yE > 0.05) mem.push({ s1: top, y1: yE, s2: top, y2: hc2, kind: 'post' });
                nodes.push({ s: 0, y: yE, dp: 1, dy: 0 });
                nodes.push({ s: half, y: yR, dp: 0, dy: 1 });
                nodes.push({ s: top, y: hc2, dp: 0, dy: 1 });
              }

              /* Fink fan on each side: vertical post at every interior node +
                 a diagonal pointing toward the apex (to the next inner chord
                 node, or the apex itself for the first one). */
              var fanSide = function (sFar) {
                var span = Math.abs(sFar - apexS);
                if (span < 0.30) return;
                var nP = Math.max(2, Math.round(span / panel));
                var dir = (sFar > apexS) ? 1 : -1;
                for (var j = 1; j < nP; j++) {
                  var sj = apexS + dir * span * j / nP;
                  mem.push({ s1: sj, y1: yE, s2: sj, y2: chordFn(sj), kind: 'web' });
                  var inS = (j === 1) ? apexS : (apexS + dir * span * (j - 1) / nP);
                  var inY = (j === 1) ? apexY : chordFn(inS);
                  mem.push({ s1: sj, y1: yE, s2: inS, y2: inY, kind: 'web' });
                }
              };
              fanSide(0);
              if (top > half + 1e-3) fanSide(top);

              return { members: mem, nodes: nodes };
            };

            var emitField = function (tr, toW3, depthDir, acrossDir) {
              for (var em = 0; em < tr.members.length; em++) {
                var md = tr.members[em];
                var isC = (md.kind === 'chord' || md.kind === 'tie');
                var SX = isC ? CHl : WBl;
                placeTrussMember(toW3(md.s1, md.y1), toW3(md.s2, md.y2), SX.h, SX.w, depthDir, SX.code, isC ? 'roofChord' : 'roofWeb');
              }
              var raiseBottom = (PLl.wid - CHl.h) / 2 + 0.02;
              for (var ni = 0; ni < tr.nodes.length; ni++) {
                var nd = tr.nodes[ni];
                var onTie = Math.abs(nd.y - Lp.yE) < 1e-6;
                placeGussetGen(function (_t, s, y) { return toW3(s, y); }, depthDir, acrossDir, 0, nd.s, nd.y + (onTie ? raiseBottom : 0), nd.dp, nd.dy, PLl);
              }
              /* plates on web/post member joints (same as the arm trusses) */
              var _stW = function (_t, s, y) { return toW3(s, y); };
              for (var emj = 0; emj < tr.members.length; emj++) {
                var mwj = tr.members[emj];
                if (mwj.kind !== 'web' && mwj.kind !== 'post') continue;
                placePlateOnMemberGen(_stW, depthDir, acrossDir, 0, mwj.s1, mwj.y1, mwj.s2, mwj.y2);
                placePlateOnMemberGen(_stW, depthDir, acrossDir, 0, mwj.s2, mwj.y2, mwj.s1, mwj.y1);
              }
            };

            var stepU = Math.max(2, Math.ceil(Uarm / tspL) + 1);
            for (var iu = 0; iu < stepU; iu++) {
              var cuU = Uarm * iu / (stepU - 1);
              if (cuU < 0.12) continue;
              var topV = Math.min(B, (B / A) * cuU, B / 2 + (cuU - A / 2) * ((B / 2 + ovL) / (A / 2 + ovL)));
              var trV = buildCutTruss(B / 2, topV, Lp.yE, Lp.yR);
              (function (cc) {
                emitField(trV, function (s, y) { return Va(Lp.toW(cc, s, y)); }, duW, dvW);
              })(cuU);
            }

            var stepV = Math.max(2, Math.ceil(Vext / tspL) + 1);
            for (var iv = 0; iv < stepV; iv++) {
              var cvV2 = Vext * iv / (stepV - 1);
              if (cvV2 < 0.12) continue;
              var topH = Math.min(A, (A / B) * cvV2, A / 2 + (cvV2 - B / 2) * ((A / 2 + ovL) / (B / 2 + ovL)));
              var trH = buildCutTruss(A / 2, topH, Lp.yE, Lp.yR);
              (function (cc) {
                emitField(trH, function (s, y) { return Va(Lp.toW(s, cc, y)); }, dvW, duW);
              })(cvV2);
            }

            var battenTarget = (typeof STATE.battenSpacingM === 'number' && STATE.battenSpacingM > 0.1) ? STATE.battenSpacingM : 0.41;
            var riseBt = Lp.yR - Lp.yE;
            var slopeMaxBt = Math.hypot(Math.max(A / 2, B / 2), riseBt) || 1;
            var nLevels = Math.max(2, Math.ceil(slopeMaxBt / battenTarget));
            var khB = (A / 2 + ovL) / (B / 2 + ovL);
            var khA = (B / 2 + ovL) / (A / 2 + ovL);
            var khBv = (B > 0.01) ? (A / B) : 1;
            var khAv = (A > 0.01) ? (B / A) : 1;
            /* left arm: along cv, half=A/2; outer slope (cu<A/2) clips on hip
               (with overhang), inner slope (cu>A/2) clips on valley (no
               overhang -> stops at the reflex, never into the notch). */
            battenArm(
              function (t, p, y) { return Va(Lp.toW(A / 2 + p, t, y)); }, dvW, duW, A / 2,
              function (pB) { var cu = A / 2 - pB; return -ovL + (cu + ovL) * khA; },
              function (pB) { return B / 2 + pB * khA; },
              Vext + ovL, nLevels
            );
            /* bottom arm: along cu, half=B/2; outer slope (cv<B/2) clips on hip,
               inner slope (cv>B/2) clips on valley (no overhang). */
            battenArm(
              function (t, p, y) { return Va(Lp.toW(t, B / 2 + p, y)); }, duW, dvW, B / 2,
              function (pB) { var cv = B / 2 - pB; return -ovL + (cv + ovL) * khB; },
              function (pB) { return A / 2 + pB * khB; },
              Uarm + ovL, nLevels
            );
          }

          /* --- okapy / žľaby: ROVNAKÝ systém ako v obdĺžnikovom tvare —
             GUTTER_PROFILE (extrude), mats.gutter, hákový bracket s tailom
             podľa spádu, čelá z profilu; kategória GUTTERS. 4 odkvapy L:
             front, left, back, right. Štíty (cu=Uarm, cv=Vext) sú šikmé. --- */
          (function () {
            var _o0g = Lp.toW(0, 0, 0);
            var _dug = Lp.toW(1, 0, 0), _dvg = Lp.toW(0, 1, 0);
            var duG = new T.Vector3(_dug[0] - _o0g[0], 0, _dug[2] - _o0g[2]);
            var dvG = new T.Vector3(_dvg[0] - _o0g[0], 0, _dvg[2] - _o0g[2]);
            if (duG.lengthSq() > 1e-9) duG.normalize();
            if (dvG.lengthSq() > 1e-9) dvG.normalize();
            var upW = new T.Vector3(0, 1, 0);
            var GT = mats.gutter || mats.flashing || mats.steel;
            var GTd = GT.clone(); GTd.side = T.DoubleSide;
            var GUP = GUTTER_PROFILE, gupN = GUP.length;
            var gutterShape = new T.Shape();
            for (var gsi = 0; gsi < gupN; gsi++) {
              if (gsi === 0) gutterShape.moveTo(GUP[gsi][0], GUP[gsi][1]);
              else gutterShape.lineTo(GUP[gsi][0], GUP[gsi][1]);
            }
            gutterShape.closePath();

            var gutterEave = function (u0, v0, u1, v1, outDir, halfPitch, cornerA, cornerB) {
              var pA = Va(Lp.toW(u0, v0, Lp.eaveY));
              var pB2 = Va(Lp.toW(u1, v1, Lp.eaveY));
              var sweepDir = new T.Vector3().subVectors(pB2, pA);
              var gLen = sweepDir.length();
              if (gLen < 0.10) return;
              sweepDir.normalize();
              var startP = pA.clone(); var flipped = false;
              if (new T.Vector3().crossVectors(outDir, upW).dot(sweepDir) < 0) {
                sweepDir.multiplyScalar(-1); startP = pB2.clone(); flipped = true;
              }
              var gutterRaise = 0.08, gutterOut = 0.04;
              var gOrigin = startP
                .addScaledVector(upW, -(0.098 + 0.02) + gutterRaise)
                .addScaledVector(outDir, gutterOut);

              /* skrátenie behu pri rohu, aby doň dosadla rohová tvarovka (elbow) */
              var gLenBase = gLen, capAtOrigin = true, capAtFar = true;
              var insOrigin = flipped ? cornerB : cornerA, insFar = flipped ? cornerA : cornerB;
              if (insOrigin != null) { gOrigin.addScaledVector(sweepDir, insOrigin); gLen -= insOrigin; capAtOrigin = false; }
              if (insFar != null)    { gLen -= insFar; capAtFar = false; }
              if (gLen < 0.05) return;
              var gBasis = new T.Matrix4().makeBasis(outDir, upW, sweepDir);

              var ggeo = new T.ExtrudeGeometry(gutterShape, { depth: gLen, bevelEnabled: false, steps: 1 });
              var gmesh = new T.Mesh(ggeo, GTd);
              gmesh.quaternion.setFromRotationMatrix(gBasis);
              gmesh.position.copy(gOrigin);
              gmesh.userData.partType = 'roofGutter'; gmesh.userData.boqCode = 'ROG01251';
              gmesh.userData.assetType = 'roofGutter'; gmesh.userData.category = 'GUTTERS';
              gmesh.userData.index = eng._roofElIdx++; gmesh.userData.length = gLen;
              SG.add(gmesh);

              /* gutter brackets (ROA01251) — tail follows roof pitch */
              var pitchSlope = (Lp.yR - Lp.yE) / (halfPitch || 1);
              var brC = [0.0864, 0.0889], brR = 0.091, brTh = 0.004;
              var backX = -0.006, backTopY = 0.118, tailRun = 0.17;
              var cl = [];
              cl.push([backX - tailRun, backTopY + tailRun * pitchSlope]);
              cl.push([backX, backTopY]);
              for (var ba = 0; ba <= 28; ba++) {
                var ang = (179 + (361 - 179) * ba / 28) * Math.PI / 180;
                cl.push([brC[0] + brR * Math.cos(ang), brC[1] + brR * Math.sin(ang)]);
              }
              var brOffset = function (poly, t) {
                var out = [];
                for (var oi = 0; oi < poly.length; oi++) {
                  var a = poly[Math.max(0, oi - 1)], b = poly[Math.min(poly.length - 1, oi + 1)];
                  var dx = b[0] - a[0], dy = b[1] - a[1], L = Math.hypot(dx, dy) || 1;
                  out.push([poly[oi][0] - dy / L * t, poly[oi][1] + dx / L * t]);
                }
                return out;
              };
              var brOutline = brOffset(cl, brTh / 2).concat(brOffset(cl, -brTh / 2).reverse());
              var brShape = new T.Shape();
              for (var bsi = 0; bsi < brOutline.length; bsi++) {
                if (bsi === 0) brShape.moveTo(brOutline[bsi][0], brOutline[bsi][1]);
                else brShape.lineTo(brOutline[bsi][0], brOutline[bsi][1]);
              }
              brShape.closePath();
              var brW = 0.025;
              var nTb = Math.max(2, Math.ceil(gLen / tspL) + 1);
              for (var rb = 0; rb < nTb; rb++) {
                var zB = gLen * (rb / (nTb - 1));
                var brGeo = new T.ExtrudeGeometry(brShape, { depth: brW, bevelEnabled: false, steps: 1 });
                var brMesh = new T.Mesh(brGeo, mats.steel);
                brMesh.quaternion.setFromRotationMatrix(gBasis);
                brMesh.position.copy(gOrigin).addScaledVector(sweepDir, zB - brW * 0.5);
                brMesh.userData.partType = 'gutterBracket'; brMesh.userData.boqCode = 'ROA01251';
                brMesh.userData.assetType = 'gutterBracket'; brMesh.userData.category = 'GUTTERS';
                brMesh.userData.index = eng._roofElIdx++;
                SG.add(brMesh);
              }

              /* end caps (ROG00001) — len na štítovom konci, nie na mitrovanom rohu */
              var capDepth = 0.005;
              var capPositions = [];
              if (capAtOrigin) capPositions.push(gOrigin.clone().addScaledVector(sweepDir, -capDepth));
              if (capAtFar)    capPositions.push(gOrigin.clone().addScaledVector(sweepDir, gLen));
              for (var ci = 0; ci < capPositions.length; ci++) {
                var capGeo = new T.ExtrudeGeometry(gutterShape, { depth: capDepth, bevelEnabled: false, steps: 1 });
                var capMesh = new T.Mesh(capGeo, GTd);
                capMesh.quaternion.setFromRotationMatrix(gBasis);
                capMesh.position.copy(capPositions[ci]);
                capMesh.userData.partType = 'gutterEndCap'; capMesh.userData.boqCode = 'ROG00001';
                capMesh.userData.assetType = 'gutterEndCap'; capMesh.userData.category = 'GUTTERS';
                capMesh.userData.index = eng._roofElIdx++;
                SG.add(capMesh);
              }
            };

            var nDuG = duG.clone().multiplyScalar(-1), nDvG = dvG.clone().multiplyScalar(-1);

            /* rohová tvarovka (elbow, ROG01251): profil vytvarovaný pozdĺž
               dvoch krátkych úsekov cez roh so ZDIEĽANÝM bisektorovým
               prierezom v strede -> bezšvový 90° roh (ako liata tvarovka).
               Rovné behy sa doň skrátia o presný inset. */
            var elbowSeg = 0.18, gOutC = 0.04, hC = -(0.098 + 0.02) + 0.08;
            var buildElbow = function (eaveCu, eaveCv, outDir1, outDir2, dd1, dd2) {
              var eaveW = Va(Lp.toW(eaveCu, eaveCv, Lp.eaveY));
              var B1 = eaveW.clone().addScaledVector(upW, hC).addScaledVector(outDir1, gOutC);
              var B2 = eaveW.clone().addScaledVector(upW, hC).addScaledVector(outDir2, gOutC);
              var diff = new T.Vector3().subVectors(B1, B2);
              var tt1 = -diff.dot(dd1), ss = diff.dot(dd2);
              var Pint = B1.clone().addScaledVector(dd1, tt1);
              var bisOut = outDir1.clone().add(outDir2).normalize();
              var ins1 = tt1 + elbowSeg, ins2 = ss + elbowSeg;
              var M = 7, GUP = GUTTER_PROFILE, nP = GUP.length;
              var lerpV = function (a, b, f) { return new T.Vector3().copy(a).lerp(b, f); };
              var ringAt = function (pos, outw) {
                var r = [];
                for (var i = 0; i < nP; i++) r.push(new T.Vector3().copy(pos).addScaledVector(outw, GUP[i][0]).addScaledVector(upW, GUP[i][1]));
                return r;
              };
              var rings = [];
              var Q1 = Pint.clone().addScaledVector(dd1, elbowSeg);
              var Q2 = Pint.clone().addScaledVector(dd2, elbowSeg);
              for (var k = 0; k <= M; k++) { var f = k / M; rings.push(ringAt(lerpV(Q1, Pint, f), lerpV(outDir1, bisOut, f).normalize())); }
              for (var k2 = 1; k2 <= M; k2++) { var f2 = k2 / M; rings.push(ringAt(lerpV(Pint, Q2, f2), lerpV(bisOut, outDir2, f2).normalize())); }
              var pos = [];
              for (var rr = 0; rr < rings.length - 1; rr++) {
                var A0 = rings[rr], A1 = rings[rr + 1];
                for (var pi = 0; pi < nP - 1; pi++) {
                  var p0 = A0[pi], p1 = A0[pi + 1], q1 = A1[pi + 1], q0 = A1[pi];
                  pos.push(p0.x, p0.y, p0.z, p1.x, p1.y, p1.z, q1.x, q1.y, q1.z);
                  pos.push(p0.x, p0.y, p0.z, q1.x, q1.y, q1.z, q0.x, q0.y, q0.z);
                }
              }
              var egeo = new T.BufferGeometry();
              egeo.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
              egeo.computeVertexNormals();
              var emesh = new T.Mesh(egeo, GTd);
              emesh.userData.partType = 'roofGutter'; emesh.userData.boqCode = 'ROG01251';
              emesh.userData.assetType = 'gutterCorner'; emesh.userData.category = 'GUTTERS';
              emesh.userData.index = eng._roofElIdx++; emesh.userData.length = 2 * elbowSeg;
              SG.add(emesh);
              return { ins1: ins1, ins2: ins2 };
            };

            /* vonkajší roh (-ov,-ov): front(+cu) + left(+cv), outward -cv / -cu */
            var eO = buildElbow(-ovL, -ovL, nDvG, nDuG, duG, dvG);
            /* reflexný roh (A+ov,B+ov): back(+cu) + right(+cv), outward +cv / +cu */
            var eR = buildElbow(A + ovL, B + ovL, dvG, duG, duG, dvG);

            gutterEave(-ovL, -ovL, Uarm + ovL, -ovL, nDvG, B / 2, eO.ins1, null);          /* front */
            gutterEave(-ovL, -ovL, -ovL, Vext + ovL, nDuG, A / 2, eO.ins2, null);          /* left */
            gutterEave(A + ovL, B + ovL, Uarm + ovL, B + ovL, dvG, B / 2, eR.ins1, null);   /* back */
            gutterEave(A + ovL, B + ovL, A + ovL, Vext + ovL, duG, A / 2, eR.ins2, null);   /* right */
          })();
        } else if (Up) {
          var eYu = Up.eaveY, yRu = Up.yR, ovU = Up.ov;
          var Wu = Up.W, Bu = Up.B, ALu = Up.AL, ARu2 = Up.AR, VLu = Up.VL, VRu = Up.VR;
          var PU = Up.P;
          var Bhu = Bu / 2, uJL = ALu / 2, uJR = Wu - ARu2 / 2;
          var yRl = yRu + lift, yEl = eYu + lift;
          var hipU = hipRoof ? (yRu - eYu) / tanPitch : 0;
          var dLE = VLu + ovU - hipU, dRE = VRu + ovU - hipU;

          quadA(PU(uJL, Bhu, yRl), PU(uJR, Bhu, yRl), PU(Wu + ovU, -ovU, yEl), PU(-ovU, -ovU, yEl), mats.shelterRoof);
          quadA(PU(uJL, Bhu, yRl), PU(uJR, Bhu, yRl), PU(Wu - ARu2 - ovU, Bu + ovU, yEl), PU(ALu + ovU, Bu + ovU, yEl), mats.shelterRoof);
          quadA(PU(uJL, Bhu, yRl), PU(uJL, dLE, yRl), PU(-ovU, VLu + ovU, yEl), PU(-ovU, -ovU, yEl), mats.shelterRoof);
          quadA(PU(uJL, Bhu, yRl), PU(uJL, dLE, yRl), PU(ALu + ovU, VLu + ovU, yEl), PU(ALu + ovU, Bu + ovU, yEl), mats.shelterRoof);
          quadA(PU(uJR, Bhu, yRl), PU(uJR, dRE, yRl), PU(Wu + ovU, VRu + ovU, yEl), PU(Wu + ovU, -ovU, yEl), mats.shelterRoof);
          quadA(PU(uJR, Bhu, yRl), PU(uJR, dRE, yRl), PU(Wu - ARu2 - ovU, VRu + ovU, yEl), PU(Wu - ARu2 - ovU, Bu + ovU, yEl), mats.shelterRoof);

          memberAlong(Va(PU(uJL, Bhu, yRu)), Va(PU(uJR, Bhu, yRu)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PU(uJL, Bhu, yRu)), Va(PU(uJL, dLE, yRu)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PU(uJR, Bhu, yRu)), Va(PU(uJR, dRE, yRu)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PU(uJL, Bhu, yRu)), Va(PU(-ovU, -ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PU(uJR, Bhu, yRu)), Va(PU(Wu + ovU, -ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PU(uJL, Bhu, yRu)), Va(PU(ALu + ovU, Bu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PU(uJR, Bhu, yRu)), Va(PU(Wu - ARu2 - ovU, Bu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          if (hipRoof) {
            tri(Va(PU(uJL, dLE, yRl)), Va(PU(-ovU, VLu + ovU, yEl)), Va(PU(ALu + ovU, VLu + ovU, yEl)), mats.shelterRoof);
            tri(Va(PU(uJR, dRE, yRl)), Va(PU(Wu + ovU, VRu + ovU, yEl)), Va(PU(Wu - ARu2 - ovU, VRu + ovU, yEl)), mats.shelterRoof);
            memberAlong(Va(PU(uJL, dLE, yRu)), Va(PU(-ovU, VLu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PU(uJL, dLE, yRu)), Va(PU(ALu + ovU, VLu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PU(uJR, dRE, yRu)), Va(PU(Wu + ovU, VRu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PU(uJR, dRE, yRu)), Va(PU(Wu - ARu2 - ovU, VRu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }

          var rspU = s.rafter.spacing;
          var nbar = Math.max(1, Math.ceil((uJR - uJL) / rspU));
          for (var rb = 0; rb <= nbar; rb++) {
            var ub = uJL + (uJR - uJL) * rb / nbar;
            memberAlong(Va(PU(ub, Bhu, yRu)), Va(PU(ub, -ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (ub > ALu && ub < Wu - ARu2) {
              memberAlong(Va(PU(ub, Bhu, yRu)), Va(PU(ub, Bu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
          var dLT = hipRoof ? Math.max(Bhu, dLE) : (VLu + ovU);
          var nL2 = Math.max(1, Math.ceil((dLT - Bhu) / rspU));
          for (var rl2 = 1; rl2 <= nL2; rl2++) {
            var dl2 = Bhu + (dLT - Bhu) * rl2 / nL2;
            memberAlong(Va(PU(uJL, dl2, yRu)), Va(PU(-ovU, dl2, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (dl2 > Bu) {
              memberAlong(Va(PU(uJL, dl2, yRu)), Va(PU(ALu + ovU, dl2, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
          var dRT = hipRoof ? Math.max(Bhu, dRE) : (VRu + ovU);
          var nR2 = Math.max(1, Math.ceil((dRT - Bhu) / rspU));
          for (var rr2 = 1; rr2 <= nR2; rr2++) {
            var dr2 = Bhu + (dRT - Bhu) * rr2 / nR2;
            memberAlong(Va(PU(uJR, dr2, yRu)), Va(PU(Wu + ovU, dr2, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (dr2 > Bu) {
              memberAlong(Va(PU(uJR, dr2, yRu)), Va(PU(Wu - ARu2 - ovU, dr2, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
        } else if (Tp) {
          var eY = Tp.eaveY, Hh = Tp.H, Rr = Tp.R, ovT = Tp.ov;
          var loT = Tp.luMin - ovT, hiT = Tp.luMax + ovT;
          var s0 = Tp.su0, s1 = Tp.su1, cxT = Tp.cx;
          var dLb = Tp.DL + ovT, dRb = Tp.DR + ovT, dSb = Tp.DS + ovT;
          var PT = Tp.P;
          var yRt = Hh + lift, yEt = eY + lift;
          var hipT = hipRoof ? (Hh - eY) / tanPitch : 0;
          var uLE = loT + hipT, uRE = hiT - hipT, dSE = dSb - hipT;

          quadA(PT(loT, -ovT, yEt), PT(hiT, -ovT, yEt), PT(uRE, Rr, yRt), PT(uLE, Rr, yRt), mats.shelterRoof);
          quadA(PT(uLE, Rr, yRt), PT(cxT, Rr, yRt), PT(s0 - ovT, dLb, yEt), PT(loT, dLb, yEt), mats.shelterRoof);
          quadA(PT(uRE, Rr, yRt), PT(cxT, Rr, yRt), PT(s1 + ovT, dRb, yEt), PT(hiT, dRb, yEt), mats.shelterRoof);
          quadA(PT(cxT, Rr, yRt), PT(s0 - ovT, dLb, yEt), PT(s0 - ovT, dSb, yEt), PT(cxT, dSE, yRt), mats.shelterRoof);
          quadA(PT(cxT, Rr, yRt), PT(s1 + ovT, dRb, yEt), PT(s1 + ovT, dSb, yEt), PT(cxT, dSE, yRt), mats.shelterRoof);

          memberAlong(Va(PT(uLE, Rr, Hh)), Va(PT(uRE, Rr, Hh)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PT(cxT, Rr, Hh)), Va(PT(cxT, hipRoof ? dSE : Tp.DS, Hh)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PT(Tp.luMin, -ovT, eY)), Va(PT(Tp.luMax, -ovT, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(Tp.luMin, 0, eY)), Va(PT(s0, Tp.DL, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(Tp.luMax, Tp.DR, eY)), Va(PT(s1, Tp.DR, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(s0, Tp.DL, eY)), Va(PT(s0, Tp.DS, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(s1, Tp.DR, eY)), Va(PT(s1, Tp.DS, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(s0, Tp.DS, eY)), Va(PT(s1, Tp.DS, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          if (hipRoof) {
            tri(Va(PT(uLE, Rr, yRt)), Va(PT(loT, -ovT, yEt)), Va(PT(loT, dLb, yEt)), mats.shelterRoof);
            tri(Va(PT(uRE, Rr, yRt)), Va(PT(hiT, -ovT, yEt)), Va(PT(hiT, dRb, yEt)), mats.shelterRoof);
            tri(Va(PT(cxT, dSE, yRt)), Va(PT(s0 - ovT, dSb, yEt)), Va(PT(s1 + ovT, dSb, yEt)), mats.shelterRoof);
            memberAlong(Va(PT(uLE, Rr, Hh)), Va(PT(loT, -ovT, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(uLE, Rr, Hh)), Va(PT(loT, dLb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(uRE, Rr, Hh)), Va(PT(hiT, -ovT, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(uRE, Rr, Hh)), Va(PT(hiT, dRb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(cxT, dSE, Hh)), Va(PT(s0 - ovT, dSb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(cxT, dSE, Hh)), Va(PT(s1 + ovT, dSb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }

          var rsp = s.rafter.spacing;
          var uF0 = hipRoof ? uLE : Tp.luMin, uF1 = hipRoof ? uRE : Tp.luMax;
          var nf = Math.max(1, Math.ceil((uF1 - uF0) / rsp));
          for (var rf = 0; rf <= nf; rf++) {
            var ufx = uF0 + (uF1 - uF0) * rf / nf;
            memberAlong(Va(PT(ufx, -ovT, eY)), Va(PT(ufx, Rr, Hh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var nbl = Math.max(1, Math.ceil((s0 - uF0) / rsp));
          for (var rl = 0; rl <= nbl; rl++) {
            var ulx = uF0 + (s0 - uF0) * rl / nbl;
            memberAlong(Va(PT(ulx, Rr, Hh)), Va(PT(ulx, dLb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var nbr = Math.max(1, Math.ceil((uF1 - s1) / rsp));
          for (var rr = 0; rr <= nbr; rr++) {
            var urx = s1 + (uF1 - s1) * rr / nbr;
            memberAlong(Va(PT(urx, Rr, Hh)), Va(PT(urx, dRb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var dSW = hipRoof ? Math.max(dLb, dSE) : dSb;
          var nstW = Math.max(1, Math.ceil((dSW - dLb) / rsp));
          for (var rw = 0; rw <= nstW; rw++) {
            var dwx = dLb + (dSW - dLb) * rw / nstW;
            memberAlong(Va(PT(cxT, dwx, Hh)), Va(PT(s0 - ovT, dwx, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var dSEa = hipRoof ? Math.max(dRb, dSE) : dSb;
          var nstE = Math.max(1, Math.ceil((dSEa - dRb) / rsp));
          for (var re = 0; re <= nstE; re++) {
            var dex = dRb + (dSEa - dRb) * re / nstE;
            memberAlong(Va(PT(cxT, dex, Hh)), Va(PT(s1 + ovT, dex, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
        } else if (Hp) {
          var eYh = Hp.eaveY, ovH = Hp.ov, Wh = Hp.W;
          var L0h = Hp.L0, L1h = Hp.L1, R0h = Hp.R0, R1h = Hp.R1, c0h = Hp.c0, c1h = Hp.c1;
          var ALn = Hp.ALn, ALs = Hp.ALs, ARn = Hp.ARn, ARs = Hp.ARs;
          var cxLh = Hp.cxL, cxRh = Hp.cxR, yRL = Hp.yRL, yRR = Hp.yRR;
          var PH = Hp.P;
          var zch = (c0h + c1h) / 2, zNh = c0h - ovH, zSh = c1h + ovH;
          var lf = lift;
          var runHL = hipRoof ? (yRL - eYh) / tanPitch : 0;
          var runHR = hipRoof ? (yRR - eYh) / tanPitch : 0;
          var l0E = Math.min(L0h - ovH + runHL, zch), l1E = Math.max(L1h + ovH - runHL, zch);
          var r0E = Math.min(R0h - ovH + runHR, zch), r1E = Math.max(R1h + ovH - runHR, zch);
          var uMid = (Math.max(ALn, ALs) + (Wh - Math.max(ARn, ARs))) / 2;

          quadA(PH(cxLh, l0E, yRL + lf), PH(cxLh, l1E, yRL + lf), PH(-ovH, L1h + ovH, eYh + lf), PH(-ovH, L0h - ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxLh, l0E, yRL + lf), PH(cxLh, zch, yRL + lf), PH(ALn + ovH, zNh, eYh + lf), PH(ALn + ovH, L0h - ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxLh, l1E, yRL + lf), PH(cxLh, zch, yRL + lf), PH(ALs + ovH, zSh, eYh + lf), PH(ALs + ovH, L1h + ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxRh, r0E, yRR + lf), PH(cxRh, r1E, yRR + lf), PH(Wh + ovH, R1h + ovH, eYh + lf), PH(Wh + ovH, R0h - ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxRh, r0E, yRR + lf), PH(cxRh, zch, yRR + lf), PH(Wh - ARn - ovH, zNh, eYh + lf), PH(Wh - ARn - ovH, R0h - ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxRh, r1E, yRR + lf), PH(cxRh, zch, yRR + lf), PH(Wh - ARs - ovH, zSh, eYh + lf), PH(Wh - ARs - ovH, R1h + ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxLh, zch, yRL + lf), PH(uMid, zch, yRL + lf), PH(uMid, zNh, eYh + lf), PH(ALn + ovH, zNh, eYh + lf), mats.shelterRoof);
          quadA(PH(cxLh, zch, yRL + lf), PH(uMid, zch, yRL + lf), PH(uMid, zSh, eYh + lf), PH(ALs + ovH, zSh, eYh + lf), mats.shelterRoof);
          quadA(PH(uMid, zch, yRR + lf), PH(cxRh, zch, yRR + lf), PH(Wh - ARn - ovH, zNh, eYh + lf), PH(uMid, zNh, eYh + lf), mats.shelterRoof);
          quadA(PH(uMid, zch, yRR + lf), PH(cxRh, zch, yRR + lf), PH(Wh - ARs - ovH, zSh, eYh + lf), PH(uMid, zSh, eYh + lf), mats.shelterRoof);
          if (Math.abs(yRR - yRL) > 1e-4) {
            quadA(PH(uMid, zNh, eYh + lf), PH(uMid, zch, Math.max(yRL, yRR) + lf), PH(uMid, zSh, eYh + lf), PH(uMid, zch, Math.min(yRL, yRR) + lf), mats.shelterRoof);
          }

          memberAlong(Va(PH(cxLh, l0E, yRL)), Va(PH(cxLh, l1E, yRL)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PH(cxRh, r0E, yRR)), Va(PH(cxRh, r1E, yRR)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PH(cxLh, zch, yRL)), Va(PH(uMid, zch, yRL)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PH(uMid, zch, yRR)), Va(PH(cxRh, zch, yRR)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PH(cxLh, zch, yRL)), Va(PH(ALn + ovH, zNh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PH(cxLh, zch, yRL)), Va(PH(ALs + ovH, zSh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PH(cxRh, zch, yRR)), Va(PH(Wh - ARn - ovH, zNh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PH(cxRh, zch, yRR)), Va(PH(Wh - ARs - ovH, zSh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          if (hipRoof) {
            tri(Va(PH(cxLh, l0E, yRL + lf)), Va(PH(-ovH, L0h - ovH, eYh + lf)), Va(PH(ALn + ovH, L0h - ovH, eYh + lf)), mats.shelterRoof);
            tri(Va(PH(cxLh, l1E, yRL + lf)), Va(PH(-ovH, L1h + ovH, eYh + lf)), Va(PH(ALs + ovH, L1h + ovH, eYh + lf)), mats.shelterRoof);
            tri(Va(PH(cxRh, r0E, yRR + lf)), Va(PH(Wh + ovH, R0h - ovH, eYh + lf)), Va(PH(Wh - ARn - ovH, R0h - ovH, eYh + lf)), mats.shelterRoof);
            tri(Va(PH(cxRh, r1E, yRR + lf)), Va(PH(Wh + ovH, R1h + ovH, eYh + lf)), Va(PH(Wh - ARs - ovH, R1h + ovH, eYh + lf)), mats.shelterRoof);
            memberAlong(Va(PH(cxLh, l0E, yRL)), Va(PH(-ovH, L0h - ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxLh, l0E, yRL)), Va(PH(ALn + ovH, L0h - ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxLh, l1E, yRL)), Va(PH(-ovH, L1h + ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxLh, l1E, yRL)), Va(PH(ALs + ovH, L1h + ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxRh, r0E, yRR)), Va(PH(Wh + ovH, R0h - ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxRh, r0E, yRR)), Va(PH(Wh - ARn - ovH, R0h - ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxRh, r1E, yRR)), Va(PH(Wh + ovH, R1h + ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxRh, r1E, yRR)), Va(PH(Wh - ARs - ovH, R1h + ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }

          var rspH = s.rafter.spacing;
          var lA = hipRoof ? l0E : (L0h - ovH), lB = hipRoof ? l1E : (L1h + ovH);
          var spanL = Math.max(0.01, lB - lA);
          var nbarL = Math.max(1, Math.ceil(spanL / rspH));
          for (var rh = 0; rh <= nbarL; rh++) {
            var dl3 = lA + spanL * rh / nbarL;
            memberAlong(Va(PH(cxLh, dl3, yRL)), Va(PH(-ovH, dl3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (dl3 < zNh) {
              memberAlong(Va(PH(cxLh, dl3, yRL)), Va(PH(ALn + ovH, dl3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            } else if (dl3 > zSh) {
              memberAlong(Va(PH(cxLh, dl3, yRL)), Va(PH(ALs + ovH, dl3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
          var rA = hipRoof ? r0E : (R0h - ovH), rB = hipRoof ? r1E : (R1h + ovH);
          var spanR = Math.max(0.01, rB - rA);
          var nbarR = Math.max(1, Math.ceil(spanR / rspH));
          for (var rh2 = 0; rh2 <= nbarR; rh2++) {
            var dr3 = rA + spanR * rh2 / nbarR;
            memberAlong(Va(PH(cxRh, dr3, yRR)), Va(PH(Wh + ovH, dr3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (dr3 < zNh) {
              memberAlong(Va(PH(cxRh, dr3, yRR)), Va(PH(Wh - ARn - ovH, dr3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            } else if (dr3 > zSh) {
              memberAlong(Va(PH(cxRh, dr3, yRR)), Va(PH(Wh - ARs - ovH, dr3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
          var ncrs = Math.max(1, Math.ceil((cxRh - cxLh) / rspH));
          for (var rc2 = 1; rc2 < ncrs; rc2++) {
            var fr2 = rc2 / ncrs;
            var uc = cxLh + (cxRh - cxLh) * fr2;
            var yc = uc < uMid ? yRL : yRR;
            if (uc > Math.max(ALn, ALs) && uc < Wh - Math.max(ARn, ARs)) {
              memberAlong(Va(PH(uc, zch, yc)), Va(PH(uc, zNh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(Va(PH(uc, zch, yc)), Va(PH(uc, zSh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
        } else if (RV) {
          var eYv = RV.eaveY, ovV = RV.ov, Lv = RV.L, Sv = RV.S, PV = RV.P;
          var yRv = eYv + (Sv / 2 + ovV) * tanPitch;
          var runV = Sv / 2 + ovV;
          var u0v = -ovV + runV, u1v = Lv + ovV - runV;
          if (u1v < u0v) { u0v = (u0v + u1v) / 2; u1v = u0v; }
          var vmv = Sv / 2;
          quadA(PV(u0v, vmv, yRv + lift), PV(u1v, vmv, yRv + lift), PV(Lv + ovV, -ovV, eYv + lift), PV(-ovV, -ovV, eYv + lift), mats.shelterRoof);
          quadA(PV(u0v, vmv, yRv + lift), PV(u1v, vmv, yRv + lift), PV(Lv + ovV, Sv + ovV, eYv + lift), PV(-ovV, Sv + ovV, eYv + lift), mats.shelterRoof);
          tri(Va(PV(u0v, vmv, yRv + lift)), Va(PV(-ovV, -ovV, eYv + lift)), Va(PV(-ovV, Sv + ovV, eYv + lift)), mats.shelterRoof);
          tri(Va(PV(u1v, vmv, yRv + lift)), Va(PV(Lv + ovV, -ovV, eYv + lift)), Va(PV(Lv + ovV, Sv + ovV, eYv + lift)), mats.shelterRoof);
          memberAlong(Va(PV(u0v, vmv, yRv)), Va(PV(u1v, vmv, yRv)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PV(u0v, vmv, yRv)), Va(PV(-ovV, -ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PV(u0v, vmv, yRv)), Va(PV(-ovV, Sv + ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PV(u1v, vmv, yRv)), Va(PV(Lv + ovV, -ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PV(u1v, vmv, yRv)), Va(PV(Lv + ovV, Sv + ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          var rspV = s.rafter.spacing;
          var nrv = Math.max(1, Math.ceil(Math.max(0.01, u1v - u0v) / rspV));
          for (var rv2 = 0; rv2 <= nrv; rv2++) {
            var uv2 = u0v + (u1v - u0v) * rv2 / nrv;
            memberAlong(Va(PV(uv2, vmv, yRv)), Va(PV(uv2, -ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PV(uv2, vmv, yRv)), Va(PV(uv2, Sv + ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
        } else if (useTruss) {
          var ts = s.truss || {};
          var CH = ts.chord || { w: 0.06, h: 0.16 };   /* 2x6 tie + top chords */
          var WB = ts.web   || { w: 0.06, h: 0.12 };  /* 2x5 posts + diagonals */
          var PL  = ts.plate    || { len: 0.30, wid: 0.15, t: 0.012 };
          var PLW = ts.plateWeb || { len: 0.18, wid: 0.10, t: 0.012 };
          var nPanel = ts.panels || 3;
          var timberW = CH.w;                          /* both sections share 60 mm width */
          /* Framing pipeline. Stage 1: dominant plane = primary field (full
             overhang). Stage 2: secondary planes are framed in their own footprint
             with NO overhang into the primary, so they meet the primary roof at the
             valley line instead of poking through. (Valley sets + jack trusses on
             top of the primary come in a later stage.) */
          var _useWings = g.wings;
          if (g.wings.length > 1) {
            var _dom = 0, _domA = -1;
            for (var _dw = 0; _dw < g.wings.length; _dw++) {
              var _a = g.wings[_dw].coreLen * (g.wings[_dw].half * 2);
              if (_a > _domA) { _domA = _a; _dom = _dw; }
            }
            _useWings = [g.wings[_dom]];          /* dominant ALWAYS first (index 0 = primary) */
            for (var _uw = 0; _uw < g.wings.length; _uw++) {
              if (_uw === _dom) continue;
              var _w = g.wings[_uw];
              /* secondary wing: drop the overhang so it stays inside its footprint */
              var _w2 = {}; for (var _k in _w) _w2[_k] = _w[_k];
              _w2.half = Math.max(0.5, _w.half - _w.overhang);
              _w2.overhang = 0;
              _w2.rafterSlope = Math.hypot(_w2.half, _w.rise);
              _useWings.push(_w2);
            }
          }
          for (var wi2 = 0; wi2 < _useWings.length; wi2++) {
            var wg2 = _useWings[wi2];
            var _isPrimary = (wi2 === 0);   /* details (battens/gutter/flashing) only on primary */
            var ov2 = wg2.overhang, L2 = wg2.coreLen;
            var hWall = wg2.half;                       /* full half-span: tie spans eave to eave (matches skin) */
            var eY2 = wg2.eaveY, rY2 = wg2.ridgeY;
            var t0b = -ov2, t1b = L2 + ov2;
            var depthDir = new T.Vector3(wg2.dirU.x, 0, wg2.dirU.z);
            if (depthDir.lengthSq() < 1e-6) depthDir.set(1, 0, 0);
            depthDir.normalize();
            var acrossDir = new T.Vector3(wg2.dirV.x, 0, wg2.dirV.z);
            if (acrossDir.lengthSq() < 1e-6) acrossDir.set(0, 0, 1);
            acrossDir.normalize();
            var upDir = new T.Vector3(0, 1, 0);

            var truss = _finkTruss(hWall, eY2, rY2, nPanel);
            if (typeof eng._roofElIdx !== 'number') eng._roofElIdx = 0;

            var faceOff = (timberW * 0.5) + (PL.t * 0.5);

            /* gusset clamped front + back, oriented along (dirP,dirY) in the
               truss plane, centred at (cp,cy) */
            function placeGusset(tt, cp, cy, dirP, dirY, pl) {
              pl = pl || PL;
              var memDir = new T.Vector3().copy(acrossDir).multiplyScalar(dirP).addScaledVector(upDir, dirY).normalize();
              var perp = new T.Vector3().crossVectors(depthDir, memDir).normalize();
              var basis = new T.Matrix4().makeBasis(memDir, perp, depthDir);
              for (var sgn = -1; sgn <= 1; sgn += 2) {
                var m = new T.Mesh(new T.BoxGeometry(pl.len, pl.wid, pl.t), mats.steel);
                m.quaternion.setFromRotationMatrix(basis);
                m.position.copy(WP(wg2, tt, cp, cy)).addScaledVector(depthDir, sgn * faceOff);
                m.userData.partType  = 'gussetPlate';
                m.userData.boqCode   = pl.code || 'FSP00001';
                m.userData.assetType = 'gussetPlate';
                m.userData.category  = 'STRUCTURAL';
                m.userData.index     = eng._roofElIdx++;
                SG.add(m);
              }
            }
            /* single-member joint: plate along the member, set onto the joint */
            function placePlateOnMember(tt, p1, y1, p2, y2) {
              var dp = p2 - p1, dy = y2 - y1, Lm = Math.hypot(dp, dy);
              if (Lm < 1e-4) return;
              var ux = dp / Lm, uy = dy / Lm;
              var off = Math.min(PLW.len * 0.45, Lm * 0.45);
              placeGusset(tt, p1 + ux * off, y1 + uy * off, ux, uy, PLW);
            }
            /* two-member (V) joint: one plate along the chord at the node */
            function placePlateAtNode(tt, nd) { placeGusset(tt, nd.p, nd.y, nd.dp, nd.dy); }

            /* roof battens running the length over the rafters, lying in the
               slope plane and lifted along the roof normal */
            var BT = s.batten || { w: 0.05, h: 0.03, code: 'KVR50031', spacing: 0.35 };
            var rise2 = rY2 - eY2;
            var slopeLen = Math.hypot(hWall, rise2) || 1;
            var nB = Math.max(2, Math.ceil(slopeLen / BT.spacing));
            var battenLen3 = (t1b - t0b);
            var battenNormLift = (CH.h * 0.5) + (BT.h * 0.5) + 0.005;

            function placeBatten(pB) {
              var yPlane = eY2 + (1 - Math.abs(pB) / hWall) * rise2;
              var slopeDir, N;
              if (Math.abs(pB) < 1e-6) {
                slopeDir = acrossDir.clone();
                N = upDir.clone();
              } else {
                var sd = (pB >= 0) ? 1 : -1;
                slopeDir = new T.Vector3().copy(acrossDir).multiplyScalar(-sd * hWall).addScaledVector(upDir, rise2).normalize();
                N = new T.Vector3().crossVectors(depthDir, slopeDir).normalize();
                if (N.y < 0) N.multiplyScalar(-1);
              }
              var basisW = new T.Vector3().crossVectors(depthDir, N);
              var basis = new T.Matrix4().makeBasis(depthDir, N, basisW);
              var c0 = WP(wg2, t0b, pB, yPlane), c1 = WP(wg2, t1b, pB, yPlane);
              var ctr = new T.Vector3().addVectors(c0, c1).multiplyScalar(0.5).addScaledVector(N, battenNormLift);
              var m = new T.Mesh(new T.BoxGeometry(battenLen3, BT.h, BT.w), mats.shelterTimber);
              m.quaternion.setFromRotationMatrix(basis);
              m.position.copy(ctr);
              m.userData.partType  = 'roofBatten';
              m.userData.boqCode   = BT.code;
              m.userData.assetType = 'roofBatten';
              m.userData.category  = 'STRUCTURAL';
              m.userData.index     = eng._roofElIdx++;
              m.userData.length    = battenLen3;
              SG.add(m);
            }
            var eaveBattenInset = 0.08;   /* pull the edge batten inward to flush the eave */
            if (_isPrimary) for (var bside = -1; bside <= 1; bside += 2) {
              for (var kb = 0; kb <= nB; kb++) {
                if (bside === 1 && kb === 0) continue;   /* ridge batten placed once */
                var pBat = (kb === nB) ? (hWall - eaveBattenInset) : (kb / nB) * hWall;
                placeBatten(bside * pBat);
              }
            }

            /* parametric truss density: stations along the core by spacing */
            var nT = Math.max(2, Math.ceil(L2 / ts.spacing) + 1);
            for (var rT = 0; rT < nT; rT++) {
              var tt = L2 * (nT === 1 ? 0.5 : rT / (nT - 1));
              /* timber members: chords KVH60160, webs KVH60120 */
              for (var mi = 0; mi < truss.members.length; mi++) {
                var mm = truss.members[mi];
                var SEC = (mm.kind === 'chord' || mm.kind === 'tie') ? CH : WB;
                var tMesh = memberTruss(WP(wg2, tt, mm.p1, mm.y1), WP(wg2, tt, mm.p2, mm.y2), SEC.h, SEC.w, mats.shelterTimber, depthDir);
                if (tMesh) {
                  tMesh.userData.partType  = 'roofTimber';
                  tMesh.userData.boqCode   = SEC.code;
                  tMesh.userData.assetType = (mm.kind === 'chord' || mm.kind === 'tie') ? 'roofChord' : 'roofWeb';
                  tMesh.userData.category  = 'STRUCTURAL';
                  tMesh.userData.index     = eng._roofElIdx++;
                  tMesh.userData.length    = Math.hypot(mm.p2 - mm.p1, mm.y2 - mm.y1);
                }
              }
              /* V-joints (two web members meet): one chord-aligned plate.
                 Heel joints (rafter meets tie at the eave): one plate set in
                 from the corner along the tie. */
              /* lift bottom-chord (tie-level) plates so their lower edge clears
                 the underside of the tie beam */
              var raiseBottom = (PL.wid - CH.h) / 2 + 0.02;
              for (var ni = 0; ni < truss.nodes.length; ni++) {
                var nd2 = truss.nodes[ni];
                var onTie = Math.abs(nd2.y - eY2) < 1e-6;
                if (nd2.multi) {
                  placeGusset(tt, nd2.p, nd2.y + (onTie ? raiseBottom : 0), nd2.dp, nd2.dy);
                } else if (nd2.heel) {
                  /* set the corner plate well in from the eave edge */
                  var sgnH = (nd2.p >= 0) ? 1 : -1;
                  var inOff = Math.min(PL.len * 0.5 + 0.15, hWall * 0.45);
                  placeGusset(tt, nd2.p - sgnH * inOff, nd2.y + raiseBottom, 1, 0);
                }
              }
              /* single-member web/post ends: keep the member-aligned plate */
              for (var mj = 0; mj < truss.members.length; mj++) {
                var mw = truss.members[mj];
                if (mw.kind !== 'web' && mw.kind !== 'post') continue;
                if ((truss.conn[truss.key(mw.p1, mw.y1)] || 0) < 2) placePlateOnMember(tt, mw.p1, mw.y1, mw.p2, mw.y2);
                if ((truss.conn[truss.key(mw.p2, mw.y2)] || 0) < 2) placePlateOnMember(tt, mw.p2, mw.y2, mw.p1, mw.y1);
              }
            }

            /* edge flashing: eave drip edge (long edges) + gable/rake (gable ends) */
            var FL = mats.flashing || mats.steel;
            var flW = 0.025;
            function tagFlash(mesh, len, code) {
              if (!mesh) return;
              mesh.userData.partType  = 'roofFlashing';
              mesh.userData.boqCode   = code;
              mesh.userData.assetType = 'roofFlashing';
              mesh.userData.category  = 'ROOF';
              mesh.userData.index     = eng._roofElIdx++;
              mesh.userData.length    = len;
            }
            /* eave gutter (+ caps, brackets) — primary plane only for now */
            if (_isPrimary) {
            var GT = mats.gutter || mats.flashing || mats.steel;
            var GTd = GT.clone(); GTd.side = T.DoubleSide;
            var GUP = GUTTER_PROFILE, gupN = GUP.length;
            var gutterShape = new T.Shape();
            for (var gsi = 0; gsi < gupN; gsi++) {
              if (gsi === 0) gutterShape.moveTo(GUP[gsi][0], GUP[gsi][1]);
              else gutterShape.lineTo(GUP[gsi][0], GUP[gsi][1]);
            }
            gutterShape.closePath();
            var upW = new T.Vector3(0, 1, 0);

            for (var gf = -1; gf <= 1; gf += 2) {
              var gLen = (t1b - t0b);
              var outDir = acrossDir.clone().multiplyScalar(gf);   /* horizontal, away from ridge */
              var sweepDir = depthDir.clone();
              var startT = t0b;
              if (new T.Vector3().crossVectors(outDir, upW).dot(sweepDir) < 0) {
                sweepDir.multiplyScalar(-1); startT = t1b;
              }
              var Pe = WP(wg2, startT, gf * wg2.half, eY2);
              /* placement of the gutter (brackets follow gOrigin) */
              var gutterRaise = 0.08;   /* vertical */
              var gutterOut   = 0.04;   /* outward from the fascia */
              var gOrigin = Pe.clone()
                .addScaledVector(upW, -(0.098 + 0.02) + gutterRaise)
                .addScaledVector(outDir, gutterOut);

              var ggeo = new T.ExtrudeGeometry(gutterShape, { depth: gLen, bevelEnabled: false, steps: 1 });
              var gBasis = new T.Matrix4().makeBasis(outDir, upW, sweepDir);
              var gmesh = new T.Mesh(ggeo, GTd);
              gmesh.quaternion.setFromRotationMatrix(gBasis);
              gmesh.position.copy(gOrigin);
              gmesh.userData.partType  = 'roofGutter';
              gmesh.userData.boqCode   = 'ROG01251';
              gmesh.userData.assetType = 'roofGutter';
              gmesh.userData.category  = 'GUTTERS';
              gmesh.userData.index     = eng._roofElIdx++;
              gmesh.userData.length    = gLen;
              SG.add(gmesh);

              /* gutter brackets (ROA01251) — one per truss, cradling the gutter */
              /* bracket built dynamically so the tail follows the roof slope:
                 sloped tail (inboard, up the pitch) -> short drop at the gutter
                 back -> half-round cradle around the gutter underside */
              var pitchSlope = (rY2 - eY2) / (wg2.half || 1);   /* tan(pitch) */
              var brC = [0.0864, 0.0889], brR = 0.091, brTh = 0.004;
              var backX = -0.006, backTopY = 0.118, tailRun = 0.17;
              var cl = [];
              cl.push([backX - tailRun, backTopY + tailRun * pitchSlope]);  /* tail far end, up the slope */
              cl.push([backX, backTopY]);                                   /* gutter back top */
              for (var ba = 0; ba <= 28; ba++) {                            /* cradle 179..361 deg */
                var ang = (179 + (361 - 179) * ba / 28) * Math.PI / 180;
                cl.push([brC[0] + brR * Math.cos(ang), brC[1] + brR * Math.sin(ang)]);
              }
              function brOffset(poly, t) {
                var out = [];
                for (var oi = 0; oi < poly.length; oi++) {
                  var a = poly[Math.max(0, oi - 1)], b = poly[Math.min(poly.length - 1, oi + 1)];
                  var dx = b[0] - a[0], dy = b[1] - a[1], L = Math.hypot(dx, dy) || 1;
                  out.push([poly[oi][0] - dy / L * t, poly[oi][1] + dx / L * t]);
                }
                return out;
              }
              var brOutline = brOffset(cl, brTh / 2).concat(brOffset(cl, -brTh / 2).reverse());
              var brShape = new T.Shape();
              for (var bsi = 0; bsi < brOutline.length; bsi++) {
                if (bsi === 0) brShape.moveTo(brOutline[bsi][0], brOutline[bsi][1]);
                else brShape.lineTo(brOutline[bsi][0], brOutline[bsi][1]);
              }
              brShape.closePath();
              var brW = 0.025;
              var nTb = Math.max(2, Math.ceil(L2 / ts.spacing) + 1);
              for (var rb = 0; rb < nTb; rb++) {
                var ttB = L2 * (nTb === 1 ? 0.5 : rb / (nTb - 1));
                var zB = (startT === t0b) ? (ttB - t0b) : (t1b - ttB);
                var brGeo = new T.ExtrudeGeometry(brShape, { depth: brW, bevelEnabled: false, steps: 1 });
                var brMesh = new T.Mesh(brGeo, mats.steel);
                brMesh.quaternion.setFromRotationMatrix(gBasis);
                var bracketRaise = 0.00;   /* bracket stays; gutter raised to meet it */
                brMesh.position.copy(gOrigin).addScaledVector(sweepDir, zB - brW * 0.5).addScaledVector(upW, bracketRaise);
                brMesh.userData.partType  = 'gutterBracket';
                brMesh.userData.boqCode   = 'ROA01251';
                brMesh.userData.assetType = 'gutterBracket';
                brMesh.userData.category  = 'GUTTERS';
                brMesh.userData.index     = eng._roofElIdx++;
                SG.add(brMesh);
              }

              /* gutter end caps (ROG00001) — thin profile-shaped plate at each end */
              var capDepth = 0.005;
              var capPositions = [
                gOrigin.clone().addScaledVector(sweepDir, -capDepth),
                gOrigin.clone().addScaledVector(sweepDir, gLen)
              ];
              for (var ci = 0; ci < capPositions.length; ci++) {
                var capGeo = new T.ExtrudeGeometry(gutterShape, { depth: capDepth, bevelEnabled: false, steps: 1 });
                var capMesh = new T.Mesh(capGeo, GTd);
                capMesh.quaternion.setFromRotationMatrix(gBasis);
                capMesh.position.copy(capPositions[ci]);
                capMesh.userData.partType  = 'gutterEndCap';
                capMesh.userData.boqCode   = 'ROG00001';
                capMesh.userData.assetType = 'gutterEndCap';
                capMesh.userData.category  = 'GUTTERS';
                capMesh.userData.index     = eng._roofElIdx++;
                SG.add(capMesh);
              }

            }
            }   /* end gutter (primary only) */
            /* shared eave extension: gable flashing + roof skin end flush */
            var EAVE_EXTEND = 0.07;

            /* gable / rake flashing: sweep the sheet-metal profile along each
               rake edge (eave -> ridge), both gable ends, both slopes — primary only */
            if (_isPrimary) (function () {
              if (eng.renderer) eng.renderer.localClippingEnabled = true;
              var shape = new T.Shape();
              for (var pi = 0; pi < GABLE_PROFILE.length; pi++) {
                var pp = GABLE_PROFILE[pi];
                if (pi === 0) shape.moveTo(pp[0], pp[1]); else shape.lineTo(pp[0], pp[1]);
              }
              shape.closePath();
              var ax = 0.09, ay = 0.059;   /* anchor: edge at face, flange height */
              var FLgable = FL.clone(); FLgable.side = T.DoubleSide;
              var GP = GABLE_PROFILE, gpN = GP.length;
              var tEnds = [t0b, t1b];
              for (var te = 0; te < tEnds.length; te++) {
                var inboardSign = (te === 0) ? 1 : -1;
                for (var rs = -1; rs <= 1; rs += 2) {
                  var P0 = WP(wg2, tEnds[te], rs * wg2.half, eY2);   /* eave */
                  var P1 = WP(wg2, tEnds[te], 0, rY2);               /* ridge apex */
                  var rakeLen = P0.distanceTo(P1);
                  var rakeDir = new T.Vector3().subVectors(P1, P0).normalize();
                  var N2 = new T.Vector3().crossVectors(depthDir, rakeDir).normalize();
                  if (N2.y < 0) N2.multiplyScalar(-1);
                  var uDir = depthDir.clone().multiplyScalar(-inboardSign);
                  uDir.addScaledVector(rakeDir, -uDir.dot(rakeDir));
                  uDir.addScaledVector(N2, -uDir.dot(N2)).normalize();

                  /* sweep origin: eave end, anchored + raised onto the roof sheet */
                  var O = P0.clone().addScaledVector(uDir, -ax).addScaledVector(N2, -ay).add(new T.Vector3(0, lift, 0));

                  /* miter: the ridge-end cross-section lies in the vertical plane
                     through the ridge (across = apex across), so neighbouring
                     profiles meet exactly. Solve per-point z onto that plane. */
                  var apexAcross = acrossDir.dot(P1);
                  var adRake = acrossDir.dot(rakeDir);
                  var adU = acrossDir.dot(uDir);
                  var adN = acrossDir.dot(N2);
                  var adO = acrossDir.dot(O);

                  /* extend the eave end down past the eave so water sheds into the
                     gutter (same value as the skin so both end flush) */
                  var eaveExtend = EAVE_EXTEND;
                  var pos = [];
                  function Ept(i) {
                    return new T.Vector3().copy(O).addScaledVector(rakeDir, -eaveExtend).addScaledVector(uDir, GP[i][0]).addScaledVector(N2, GP[i][1]);
                  }
                  function Apt(i) {
                    var z = (Math.abs(adRake) > 1e-6)
                      ? (apexAcross - adO - GP[i][0] * adU - GP[i][1] * adN) / adRake
                      : rakeLen;
                    return new T.Vector3().copy(O).addScaledVector(rakeDir, z).addScaledVector(uDir, GP[i][0]).addScaledVector(N2, GP[i][1]);
                  }
                  for (var gi = 0; gi < gpN - 1; gi++) {
                    var e0 = Ept(gi), e1 = Ept(gi + 1), a1 = Apt(gi + 1), a0 = Apt(gi);
                    pos.push(e0.x, e0.y, e0.z, e1.x, e1.y, e1.z, a1.x, a1.y, a1.z);
                    pos.push(e0.x, e0.y, e0.z, a1.x, a1.y, a1.z, a0.x, a0.y, a0.z);
                  }
                  var geo = new T.BufferGeometry();
                  geo.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
                  geo.computeVertexNormals();

                  var mesh = new T.Mesh(geo, FLgable);
                  mesh.userData.partType  = 'roofFlashing';
                  mesh.userData.boqCode   = 'ROD06030';
                  mesh.userData.assetType = 'roofFlashing';
                  mesh.userData.category  = 'ROOF';
                  mesh.userData.index     = eng._roofElIdx++;
                  mesh.userData.length    = rakeLen;
                  SG.add(mesh);
                }
              }
            })();
            /* eave extension shared with the gable flashing (defined above) */
            var slpLen2 = Math.hypot(wg2.half, rY2 - eY2) || 1;
            var pE = wg2.half + EAVE_EXTEND * wg2.half / slpLen2;     /* eave edge, extended down-slope */
            var yE = eY2 - EAVE_EXTEND * (rY2 - eY2) / slpLen2;

            /* roof skin (both planes, eave extended to the flashing line) */
            quad(WP(wg2, t0b,  pE, yE + lift), WP(wg2, t1b,  pE, yE + lift),
                 WP(wg2, t1b, 0, rY2 + lift),  WP(wg2, t0b, 0, rY2 + lift), mats.shelterRoof);
            quad(WP(wg2, t0b, -pE, yE + lift), WP(wg2, t1b, -pE, yE + lift),
                 WP(wg2, t1b, 0, rY2 + lift),  WP(wg2, t0b, 0, rY2 + lift), mats.shelterRoof);

          }
        } else if (RC) {
          for (var ti = 0; ti < RC.skin.length; ti++) {
            var tf = RC.skin[ti];
            tri(
              new T.Vector3(tf[0][0], tf[0][1] + lift, tf[0][2]),
              new T.Vector3(tf[1][0], tf[1][1] + lift, tf[1][2]),
              new T.Vector3(tf[2][0], tf[2][1] + lift, tf[2][2]),
              mats.shelterRoof
            );
          }
          for (var sbi = 0; sbi < RC.beams.length; sbi++) {
            var bm = RC.beams[sbi];
            memberAlong(Va(bm.a), Va(bm.b), bm.ridge ? s.ridge.h : s.rafter.h, bm.ridge ? s.ridge.w : s.rafter.w, mats.shelterTimber);
          }
        } else {
          for (var wi = 0; wi < g.wings.length; wi++) {
            var wg = g.wings[wi];
            var ov = wg.overhang, L = wg.coreLen, h = wg.half;
            var t0 = -ov, t1 = L + ov;

            memberAlong(WP(wg, t0, 0, wg.ridgeY), WP(wg, t1, 0, wg.ridgeY), s.ridge.h, s.ridge.w, mats.shelterTimber);

            var pairs = wg.rafterPairs;
            for (var r = 0; r < pairs; r++) {
              var t = L * (pairs === 1 ? 0.5 : r / (pairs - 1));
              memberAlong(WP(wg, t,  h, wg.eaveY), WP(wg, t, 0, wg.ridgeY), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(WP(wg, t, -h, wg.eaveY), WP(wg, t, 0, wg.ridgeY), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }

            quad(WP(wg, t0,  h, wg.eaveY + lift), WP(wg, t1,  h, wg.eaveY + lift),
                 WP(wg, t1, 0, wg.ridgeY + lift), WP(wg, t0, 0, wg.ridgeY + lift), mats.shelterRoof);
            quad(WP(wg, t0, -h, wg.eaveY + lift), WP(wg, t1, -h, wg.eaveY + lift),
                 WP(wg, t1, 0, wg.ridgeY + lift), WP(wg, t0, 0, wg.ridgeY + lift), mats.shelterRoof);
          }
        }

        _dbg('[roof] 3D built, meshes=' + SG.children.length);
      } catch (err) {
        if (window.Configurator && window.Configurator.log) {
          window.Configurator.log.log('[roof] build error: ' + (err && err.message ? err.message : err));
        }
      }
    },


    _build3D_Slab: function (poly) {
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;
      var d = getVariantDefaults('slab', STATE.lvl);
      var stageOn = (STATE.view === '3d' && STATE.vizStage === 1);

      var shape = this._polyToShape(poly);
      var geom = new T.ExtrudeGeometry(shape, { depth: d.slabThicknessM, bevelEnabled: false });
      var mesh = new T.Mesh(geom, mats.slab);
      mesh.rotation.x = Math.PI / 2;
      mesh.position.y = d.slabThicknessM;
      mesh.userData = { assetType: 'slab', boqCode: 'PBW00001', category: 'concrete' };
      eng.sceneGroup.add(mesh);

      var gravelGeom = new T.ExtrudeGeometry(shape, { depth: d.gravelDepthM, bevelEnabled: false });
      var gravel = new T.Mesh(gravelGeom, mats.gravel);
      gravel.rotation.x = Math.PI / 2;
      gravel.position.y = 0;
      gravel.userData = { assetType: 'gravel', boqCode: 'FFG00001', category: 'gravel' };
      eng.sceneGroup.add(gravel);

      this._build3D_Mesh(poly, d, stageOn);

      if (STATE.slopeActive && STATE.slopeDeg > 0) {
        var xMin =  Infinity, xMax = -Infinity;
        var zMin =  Infinity, zMax = -Infinity;
        for (var p = 0; p < poly.length; p++) {
          if (poly[p][0] < xMin) xMin = poly[p][0];
          if (poly[p][0] > xMax) xMax = poly[p][0];
          if (poly[p][1] < zMin) zMin = poly[p][1];
          if (poly[p][1] > zMax) zMax = poly[p][1];
        }
        this._addTiltedPit(
          xMin - 0.2, xMax + 0.2,
          zMin - 0.2, zMax + 0.2,
          0,
          d.excavationDepthM + 0.10
        );
      }
    },

    _addTiltedPit: function (xMin, xMax, zMin, zMax, topY, baseDepth) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var rad = STATE.slopeDeg * Math.PI / 180;
      var tanS = Math.tan(rad);
      var depthAtLeft  = baseDepth + (xMax - xMin) * tanS;
      var depthAtRight = baseDepth;
      var verts = [
        xMin, topY,                cz0(zMin),
        xMax, topY,                cz0(zMin),
        xMax, topY,                cz0(zMax),
        xMin, topY,                cz0(zMax),
        xMin, topY - depthAtLeft,  cz0(zMin),
        xMax, topY - depthAtRight, cz0(zMin),
        xMax, topY - depthAtRight, cz0(zMax),
        xMin, topY - depthAtLeft,  cz0(zMax)
      ];
      function cz0(z) { return z; }
      var edges = [0,1, 1,2, 2,3, 3,0, 4,5, 5,6, 6,7, 7,4, 0,4, 1,5, 2,6, 3,7];
      var lineGeom = new T.BufferGeometry();
      var positions = [];
      for (var e = 0; e < edges.length; e++) {
        var idx = edges[e] * 3;
        positions.push(verts[idx], verts[idx+1], verts[idx+2]);
      }
      lineGeom.setAttribute('position', new T.Float32BufferAttribute(positions, 3));
      var lineMat = new T.LineBasicMaterial({ color: 0xD2A878, transparent: true, opacity: 0.7 });
      var box = new T.LineSegments(lineGeom, lineMat);
      box.userData = { assetType: 'excavation-box' };
      eng.sceneGroup.add(box);
    },

    _build3D_Mesh: function (poly, d, visible) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var mats = this._ensureMaterials();
      if (!mats.meshWire) {
        mats.meshWire = new T.MeshLambertMaterial({ color: 0x2266cc });
      }
      var sheets = distributeMeshSheets(d.meshSheetLM, d.meshSheetWM, d.meshOverlapM);
      if (!sheets.length) return;
      var layers = (typeof d.meshLayers === 'number' && d.meshLayers > 0) ? d.meshLayers : 1;
      var WIRE_R = 0.006;
      var WIRE_LONG_SPACING  = 0.254;
      var WIRE_TRANS_SPACING = 0.152;
      var REBAR_COVER_M = 0.050;
      var clipPoly = _insetPolygon(poly, REBAR_COVER_M);
      if (!clipPoly || clipPoly.length < 3) clipPoly = poly;
      /* Defence in depth: after polygon clipping, also drop any
         sub-segment whose midpoint, quarter-points or end-points fall
         outside the ORIGINAL polygon. Catches edge cases where the
         inset polygon self-intersects on degenerate step shapes. */
      function _segmentFullyInsideOriginal(seg) {
        var samples = 5;
        for (var i = 0; i <= samples; i++) {
          var t = i / samples;
          var sx = seg.x1 + (seg.x2 - seg.x1) * t;
          var sz = seg.z1 + (seg.z2 - seg.z1) * t;
          if (!_pointInPolygonOrBoundary(sx, sz, poly)) return false;
        }
        return true;
      }
      var meshYList;
      /* Reinforcement positioning follows standard slab-on-grade
         practice: bottom mat carries tensile load from soil settlement
         and sits close to the bottom surface. A second mat (only at
         lvl=Robust, meshLayers=2) goes near the top. Bottom cover is
         clamped to at least 8 mm so the wire (radius 6 mm) never
         visually pokes through the slab's bottom face. */
      var COVER_BOTTOM = 0.015;
      var COVER_TOP    = 0.025;
      var bottomY = Math.max(0.008, Math.min(COVER_BOTTOM, d.slabThicknessM * 0.15));
      var topY    = Math.min(d.slabThicknessM - 0.008, Math.max(d.slabThicknessM - COVER_TOP, d.slabThicknessM * 0.85));
      if (layers === 1) {
        meshYList = [bottomY];
      } else {
        meshYList = [bottomY, topY];
      }

      for (var layer = 0; layer < meshYList.length; layer++) {
        var meshY = meshYList[layer];
        for (var s = 0; s < sheets.length; s++) {
          var sh = sheets[s];
          var sheetGroup = new T.Group();
          sheetGroup.visible = visible;
          sheetGroup.userData = {
            assetType: 'mesh',
            boqCode:   'FFR30001',
          category:  'rebar',
          index:     sh.index,
          length:    sh.L
        };

        var x0 = sh.x - sh.L / 2, x1 = sh.x + sh.L / 2;
        var z0 = sh.z - sh.W / 2, z1 = sh.z + sh.W / 2;

        var nLong = Math.floor(sh.W / WIRE_LONG_SPACING) + 1;
        for (var i = 0; i < nLong; i++) {
          var wz = z0 + i * WIRE_LONG_SPACING;
          if (wz > z1 + 1e-6) break;
          var segments = _clipSegmentToPolygon(x0, wz, x1, wz, clipPoly);
          for (var k = 0; k < segments.length; k++) {
            var seg = segments[k];
            var segLen = Math.hypot(seg.x2 - seg.x1, seg.z2 - seg.z1);
            if (segLen < 0.02) continue;
            if (!_segmentFullyInsideOriginal(seg)) continue;
            var geom = new T.CylinderGeometry(WIRE_R, WIRE_R, segLen, 6);
            geom.rotateZ(Math.PI / 2);
            var wire = new T.Mesh(geom, mats.meshWire);
            wire.position.set((seg.x1 + seg.x2) / 2, meshY, wz);
            sheetGroup.add(wire);
          }
        }

        var nTrans = Math.floor(sh.L / WIRE_TRANS_SPACING) + 1;
        for (var i = 0; i < nTrans; i++) {
          var wx = x0 + i * WIRE_TRANS_SPACING;
          if (wx > x1 + 1e-6) break;
          var segments = _clipSegmentToPolygon(wx, z0, wx, z1, clipPoly);
          for (var k = 0; k < segments.length; k++) {
            var seg = segments[k];
            var segLen = Math.hypot(seg.x2 - seg.x1, seg.z2 - seg.z1);
            if (segLen < 0.02) continue;
            if (!_segmentFullyInsideOriginal(seg)) continue;
            var geom = new T.CylinderGeometry(WIRE_R, WIRE_R, segLen, 6);
            geom.rotateX(Math.PI / 2);
            var wire = new T.Mesh(geom, mats.meshWire);
            wire.position.set(wx, meshY, (seg.z1 + seg.z2) / 2);
            sheetGroup.add(wire);
          }
        }

        if (sheetGroup.children.length) eng.sceneGroup.add(sheetGroup);
        }
      }
    },

    _build3D_Strip: function (poly) {
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;
      var d = getVariantDefaults('strip', STATE.lvl);
      var stageOn = (STATE.view === '3d' && STATE.vizStage === 1);

      var shape = this._polyToShape(poly);
      var slabGeom = new T.ExtrudeGeometry(shape, { depth: d.slabThicknessM, bevelEnabled: false });
      var slab = new T.Mesh(slabGeom, mats.slab);
      slab.rotation.x = Math.PI / 2;
      slab.position.y = d.slabThicknessM;
      slab.userData = { assetType: 'slab', boqCode: 'PBW00001', category: 'concrete' };
      eng.sceneGroup.add(slab);

      /* Gravel pad — TWO parts:
         1) INNER pad inside the strip ring: y ∈ [-0.10, 0] (cushion
            under the interior slab, flush with strip's inner face).
         2) UNDER-STRIP pad: y ∈ [-stripDepthM-0.10, -stripDepthM]
            (drainage layer beneath the strip itself, full polygon
            footprint, sits just below the strip's bottom face).
         Two separate meshes so they read clearly in section view and
         don't z-fight with the strip ring between them. */
      var STRIP_GRAVEL_DEPTH_M = 0.100;

      var gravelInner = _insetPolygon(poly, d.stripWidthM);
      if (gravelInner && gravelInner.length >= 3) {
        var gravelShape = new T.Shape();
        gravelShape.moveTo(gravelInner[0][0], gravelInner[0][1]);
        for (var gi = 1; gi < gravelInner.length; gi++) {
          gravelShape.lineTo(gravelInner[gi][0], gravelInner[gi][1]);
        }
        gravelShape.closePath();
        var gravelGeom = new T.ExtrudeGeometry(gravelShape, { depth: STRIP_GRAVEL_DEPTH_M, bevelEnabled: false });
        var gravel = new T.Mesh(gravelGeom, mats.gravel);
        gravel.rotation.x = Math.PI / 2;
        gravel.position.y = 0;
        gravel.userData = { assetType: 'gravel', boqCode: 'FFG00001', category: 'gravel' };
        eng.sceneGroup.add(gravel);
      }

      /* Under-strip pad: gravel ONLY beneath the strip ring itself,
         not under the inner area (the inner pad above already covers
         that). Use Shape+hole so the gravel footprint exactly mirrors
         the strip's. gravelInner already equals stripInner — same
         _insetPolygon(poly, stripWidthM) call. */
      if (gravelInner && gravelInner.length >= 3) {
        var underStripShape = new T.Shape();
        underStripShape.moveTo(poly[0][0], poly[0][1]);
        for (var usi = 1; usi < poly.length; usi++) {
          underStripShape.lineTo(poly[usi][0], poly[usi][1]);
        }
        underStripShape.closePath();
        var usSignedArea = 0;
        for (var ua = 0; ua < poly.length; ua++) {
          var uA = poly[ua], uB = poly[(ua + 1) % poly.length];
          usSignedArea += uA[0] * uB[1] - uB[0] * uA[1];
        }
        var usCCW = usSignedArea > 0;
        var usInnerSignedArea = 0;
        for (var uia = 0; uia < gravelInner.length; uia++) {
          var uiA = gravelInner[uia], uiB = gravelInner[(uia + 1) % gravelInner.length];
          usInnerSignedArea += uiA[0] * uiB[1] - uiB[0] * uiA[1];
        }
        var usInnerCCW = usInnerSignedArea > 0;
        var usInnerLoop = (usInnerCCW === usCCW) ? gravelInner.slice().reverse() : gravelInner;
        var usHole = new T.Path();
        usHole.moveTo(usInnerLoop[0][0], usInnerLoop[0][1]);
        for (var uh = 1; uh < usInnerLoop.length; uh++) {
          usHole.lineTo(usInnerLoop[uh][0], usInnerLoop[uh][1]);
        }
        usHole.closePath();
        underStripShape.holes.push(usHole);

        var underStripGeom = new T.ExtrudeGeometry(underStripShape, { depth: STRIP_GRAVEL_DEPTH_M, bevelEnabled: false });
        var underStrip = new T.Mesh(underStripGeom, mats.gravel);
        underStrip.rotation.x = Math.PI / 2;
        underStrip.position.y = -d.stripDepthM;
        underStrip.userData = { assetType: 'gravel', boqCode: 'FFG00001', category: 'gravel' };
        eng.sceneGroup.add(underStrip);
      }

      /* Strip placement: build the strip as a single extruded "ring"
         — the polygon (outer face) with the inset polygon (inner face)
         carved out as a hole. This produces a monolithic strip whose
         outer edge is flush with the slab edge and whose inner edge is
         the inset polygon, with corners that mitre correctly at ANY
         angle (convex, concave, oblique). No per-edge boxes, no gaps,
         no overshoot — the geometry is exact by construction. */
      var stripSignedArea = 0;
      for (var sa = 0; sa < poly.length; sa++) {
        var pA = poly[sa], pB = poly[(sa + 1) % poly.length];
        stripSignedArea += pA[0] * pB[1] - pB[0] * pA[1];
      }
      var stripCCW = stripSignedArea > 0;
      var stripInner = _insetPolygon(poly, d.stripWidthM);
      if (stripInner && stripInner.length >= 3) {
        var stripShape = new T.Shape();
        stripShape.moveTo(poly[0][0], poly[0][1]);
        for (var si = 1; si < poly.length; si++) {
          stripShape.lineTo(poly[si][0], poly[si][1]);
        }
        stripShape.closePath();

        /* THREE.Path used as a hole must have OPPOSITE winding to the
           outer Shape. Reverse the inner polygon if it shares winding
           with the outer one. */
        var innerSignedArea = 0;
        for (var ia = 0; ia < stripInner.length; ia++) {
          var iA = stripInner[ia], iB = stripInner[(ia + 1) % stripInner.length];
          innerSignedArea += iA[0] * iB[1] - iB[0] * iA[1];
        }
        var innerCCW = innerSignedArea > 0;
        var innerLoop = (innerCCW === stripCCW) ? stripInner.slice().reverse() : stripInner;

        var holePath = new T.Path();
        holePath.moveTo(innerLoop[0][0], innerLoop[0][1]);
        for (var hi = 1; hi < innerLoop.length; hi++) {
          holePath.lineTo(innerLoop[hi][0], innerLoop[hi][1]);
        }
        holePath.closePath();
        stripShape.holes.push(holePath);

        var stripGeom = new T.ExtrudeGeometry(stripShape, { depth: d.stripDepthM, bevelEnabled: false });
        var stripMesh = new T.Mesh(stripGeom, mats.strip);
        stripMesh.rotation.x = Math.PI / 2;
        stripMesh.position.y = 0;
        stripMesh.userData = { assetType: 'strip', boqCode: 'PWC00001', category: 'concrete' };
        eng.sceneGroup.add(stripMesh);
      }

      this._build3D_StripRebar(poly, d, stageOn);
      this._build3D_Mesh(poly, d, stageOn);

      if (STATE.slopeActive && STATE.slopeDeg > 0) {
        for (var ee = 0; ee < poly.length; ee++) {
          var aa = poly[ee], bb = poly[(ee + 1) % poly.length];
          var ddx = bb[0] - aa[0], ddz = bb[1] - aa[1];
          var llen = Math.sqrt(ddx * ddx + ddz * ddz);
          if (llen < 0.1) continue;
          var uux = ddx / llen, uuz = ddz / llen;
          var iinx, iinz;
          if (stripCCW) { iinx = -uuz; iinz =  uux; }
          else          { iinx =  uuz; iinz = -uux; }
          var halfStripW = d.stripWidthM / 2;
          var ccx = (aa[0] + bb[0]) / 2 + iinx * halfStripW;
          var ccz = (aa[1] + bb[1]) / 2 + iinz * halfStripW;
          var aang = Math.atan2(ddz, ddx);
          var pitW = d.stripExcavWidthM + 0.30;
          var pitL = llen + 0.30;
          var edgeSlopeExtra = _padSlopeExtra(ccx, ccz);
          var totalDepth = d.stripDepthM + edgeSlopeExtra + 0.10;

          var verts = [
            -pitL/2, 0,            -pitW/2,
             pitL/2, 0,            -pitW/2,
             pitL/2, 0,             pitW/2,
            -pitL/2, 0,             pitW/2,
            -pitL/2, -totalDepth,  -pitW/2,
             pitL/2, -totalDepth,  -pitW/2,
             pitL/2, -totalDepth,   pitW/2,
            -pitL/2, -totalDepth,   pitW/2
          ];
          var edges = [0,1, 1,2, 2,3, 3,0, 4,5, 5,6, 6,7, 7,4, 0,4, 1,5, 2,6, 3,7];
          var lineGeom = new T.BufferGeometry();
          var positions = [];
          for (var xi = 0; xi < edges.length; xi++) {
            var idx = edges[xi] * 3;
            positions.push(verts[idx], verts[idx+1], verts[idx+2]);
          }
          lineGeom.setAttribute('position', new T.Float32BufferAttribute(positions, 3));
          var lineMat = new T.LineBasicMaterial({ color: 0xD2A878, transparent: true, opacity: 0.7 });
          var box = new T.LineSegments(lineGeom, lineMat);
          box.position.set(ccx, 0, ccz);
          box.rotation.y = -aang;
          box.userData = { assetType: 'excavation-box' };
          eng.sceneGroup.add(box);
        }
      }
    },

    _build3D_StripRebar: function (poly, d, visible) {
      var T = global.THREE;
      var eng = global.BaseEngine;
      var mats = this._ensureMaterials();
      if (!mats.rebar) {
        mats.rebar = new T.MeshLambertMaterial({ color: 0xff4d2e });
      }
      var radius     = d.rebarDiameterM / 2;
      var coverM     = 0.050;
      var stripDepth = d.stripDepthM;
      var stripWidth = d.stripWidthM;
      var idx = 0;

      var halfW = stripWidth / 2;
      var topY    = -coverM;
      var bottomY = -stripDepth + coverM;
      var innerHalfW = halfW - coverM;

      /* Determine inward direction so rebar sits inside the strip,
         which is offset inward from the polygon edge by halfW. */
      var rebarSignedArea = 0;
      for (var ra = 0; ra < poly.length; ra++) {
        var rpA = poly[ra], rpB = poly[(ra + 1) % poly.length];
        rebarSignedArea += rpA[0] * rpB[1] - rpB[0] * rpA[1];
      }
      var rebarCCW = rebarSignedArea > 0;

      for (var i = 0; i < poly.length; i++) {
        var a = poly[i], b = poly[(i + 1) % poly.length];
        var dx = b[0] - a[0], dz = b[1] - a[1];
        var len = Math.sqrt(dx * dx + dz * dz);
        if (len < 0.05) continue;
        var ux = dx / len, uz = dz / len;
        /* inward normal (into polygon) */
        var inx, inz;
        if (rebarCCW) { inx = -uz; inz =  ux; }
        else          { inx =  uz; inz = -ux; }
        /* shift edge midpoint to strip centre */
        var cx = (a[0] + b[0]) / 2 + inx * halfW;
        var cz = (a[1] + b[1]) / 2 + inz * halfW;
        var angle = Math.atan2(dz, dx);
        /* nx/nz: perpendicular to edge axis, used to offset bars to
           the inner / outer face of the strip. Sign convention kept
           as before so 'top-outer' is still on the strip's outer face. */
        var nx = -uz, nz = ux;

        /* Per-end exact extension: each rebar lies on a line parallel
           to the polygon edge, offset from the edge by (halfW + offsetN)
           in the inward direction. To make the rebar reach all the way
           into the corner correctly — regardless of corner angle —
           extend each end up to the intersection with the SAME-offset
           line in the adjacent edge. This produces the right amount of
           extension at convex corners (small), concave corners (large),
           and any oblique angle in between, without any visible gap or
           overshoot at the strip's inner face. */
        function _extendsForOffset(offsetN) {
          /* Offset (along inward normal) from polygon edge to this rebar
             line: halfW (strip centre) + offsetN (where +innerHalfW is
             outer, -innerHalfW is inner). */
          var prev = poly[(i - 1 + poly.length) % poly.length];
          var next = poly[(i + 2) % poly.length];
          /* Line of THIS rebar */
          var lineOffsetA = halfW + offsetN;
          var L_x = (a[0] + b[0]) / 2 + inx * lineOffsetA;
          var L_z = (a[1] + b[1]) / 2 + inz * lineOffsetA;
          /* L line direction is (ux, uz) */

          function intersectAtNeighbour(neiA, neiB, isStartEnd) {
            var ndx = neiB[0] - neiA[0], ndz = neiB[1] - neiA[1];
            var nlen = Math.sqrt(ndx * ndx + ndz * ndz);
            if (nlen < 1e-6) return null;
            var nux = ndx / nlen, nuz = ndz / nlen;
            var ninx, ninz;
            if (rebarCCW) { ninx = -nuz; ninz =  nux; }
            else          { ninx =  nuz; ninz = -nux; }
            /* Detect corner type at the SHARED vertex. The corner turn
               angle at a vertex is the cross of the INCOMING and OUTGOING
               edge directions. For END vertex (b): incoming=this(ux,uz),
               outgoing=neighbour(nux,nuz). For START vertex (a):
               incoming=neighbour, outgoing=this — swap roles. CCW
               polygon: positive cross = left turn = convex corner. */
            var cross;
            if (isStartEnd === 'end') {
              cross = ux * nuz - uz * nux;
            } else {
              cross = nux * uz - nuz * ux;
            }
            var crossSign = (cross > 0) ? 1 : (cross < 0 ? -1 : 0);
            var convex = (rebarCCW && crossSign > 0) || (!rebarCCW && crossSign < 0);
            var neighbourOffset = stripWidth - coverM;
            var N_x = (neiA[0] + neiB[0]) / 2 + ninx * neighbourOffset;
            var N_z = (neiA[1] + neiB[1]) / 2 + ninz * neighbourOffset;
            var det = ux * (-nuz) - uz * (-nux);
            if (Math.abs(det) < 1e-6) return null;
            var rhsX = N_x - L_x, rhsZ = N_z - L_z;
            var t = (rhsX * (-nuz) - rhsZ * (-nux)) / det;
            return t;
          }

          var tStart = intersectAtNeighbour(prev, a, 'start');
          var tEnd = intersectAtNeighbour(b, next, 'end');
          /* Fallbacks: if neighbour parallel (degenerate), keep default
             ±len/2. Otherwise use tStart/tEnd directly so the bar end
             sits exactly at the intersection. Guard against runaway
             extensions on extremely acute angles by capping at ±stripWidth
             beyond the polygon vertex. */
          var defStart = -len / 2;
          var defEnd   =  len / 2;
          var maxExt   =  stripWidth * 2.5;
          var start = (tStart == null) ? defStart : Math.max(defStart - maxExt, Math.min(defStart + maxExt, tStart));
          var end   = (tEnd   == null) ? defEnd   : Math.max(defEnd   - maxExt, Math.min(defEnd   + maxExt, tEnd));
          return { start: start, end: end };
        }

        function placeLongitudinal(offsetNormal, y, label) {
          var ext = _extendsForOffset(offsetNormal);
          var barLen = ext.end - ext.start;
          if (barLen < 0.05) return;
          var midT = (ext.start + ext.end) / 2;
          /* bar centre along edge axis = edge midpoint + midT*ux,uz */
          var bx = (a[0] + b[0]) / 2 + ux * midT + nx * offsetNormal + (inx * halfW);
          var bz = (a[1] + b[1]) / 2 + uz * midT + nz * offsetNormal + (inz * halfW);
          var geom = new T.CylinderGeometry(radius, radius, barLen, 8);
          geom.rotateZ(Math.PI / 2);
          var bar = new T.Mesh(geom, mats.rebar);
          bar.position.set(bx, y, bz);
          bar.rotation.y = -angle;
          bar.visible = visible;
          bar.userData = {
            assetType: 'rebar',
            boqCode:   'FCO00003',
            category:  'rebar',
            index:     idx++,
            length:    barLen,
            note:      label
          };
          eng.sceneGroup.add(bar);
        }

        placeLongitudinal( innerHalfW, topY,    'top-outer');
        placeLongitudinal(-innerHalfW, topY,    'top-inner');
        placeLongitudinal( innerHalfW, bottomY, 'bot-outer');
        placeLongitudinal(-innerHalfW, bottomY, 'bot-inner');

        /* Stirrups: rectangular closed loops distributed along the strip
           axis, perpendicular to it. Standard reinforcement practice —
           ties the 4 longitudinal bars together and handles shear.
           Corner exclusion is asymmetric per-end: CONVEX corners need
           the full stripWidth gap to clear the L-anchor lap zone,
           CONCAVE corners only need a small coverM gap (no L-anchor
           there), allowing one extra stirrup near the step. */
        var stirrupSpacingM = (typeof d.stirrupSpacingM === 'number' && d.stirrupSpacingM > 0)
          ? d.stirrupSpacingM : 0.250;
        function _exclusionAt(vertex, edgeIn, edgeOut) {
          var ex1 = edgeIn[1][0] - edgeIn[0][0], ez1 = edgeIn[1][1] - edgeIn[0][1];
          var ex2 = edgeOut[1][0] - edgeOut[0][0], ez2 = edgeOut[1][1] - edgeOut[0][1];
          var l1 = Math.sqrt(ex1*ex1 + ez1*ez1);
          var l2 = Math.sqrt(ex2*ex2 + ez2*ez2);
          if (l1 < 1e-6 || l2 < 1e-6) return stripWidth;
          var u1x = ex1/l1, u1z = ez1/l1;
          var u2x = ex2/l2, u2z = ez2/l2;
          var crossE = u1x * u2z - u1z * u2x;
          var convexE = (rebarCCW && crossE > 0) || (!rebarCCW && crossE < 0);
          return convexE ? stripWidth : coverM;
        }
        var prev = poly[(i - 1 + poly.length) % poly.length];
        var next = poly[(i + 2) % poly.length];
        var exclStart = _exclusionAt(a, [prev, a], [a, b]);
        var exclEnd   = _exclusionAt(b, [a, b], [b, next]);
        var stirrupStart = exclStart;
        var stirrupEnd   = len - exclEnd;
        var stirrupSpan  = stirrupEnd - stirrupStart;
        if (stirrupSpan > 0.05) {
          var nStirrups = Math.max(1, Math.floor(stirrupSpan / stirrupSpacingM) + 1);
          var actualSpacing = nStirrups > 1 ? (stirrupSpan / (nStirrups - 1)) : 0;
          var stirrupW = stripWidth - 2 * coverM;
          var stirrupH = stripDepth - 2 * coverM;
          var stirrupRadius = radius * 0.7;
          var vGeom = new T.CylinderGeometry(stirrupRadius, stirrupRadius, stirrupH, 6);
          var hGeom = new T.CylinderGeometry(stirrupRadius, stirrupRadius, stirrupW, 6);
          hGeom.rotateX(Math.PI / 2);
          var stirrupY = (topY + bottomY) / 2;

          for (var k = 0; k < nStirrups; k++) {
            var t = stirrupStart + k * actualSpacing;
            /* position along strip axis */
            var px = a[0] + ux * t + inx * halfW;
            var pz = a[1] + uz * t + inz * halfW;

            var stirrupGroup = new T.Group();
            stirrupGroup.position.set(px, stirrupY, pz);
            stirrupGroup.rotation.y = -angle;
            stirrupGroup.visible = visible;
            stirrupGroup.userData = {
              assetType: 'rebar',
              boqCode:   'FCO00003',
              category:  'rebar',
              index:     idx++,
              length:    2 * (stirrupW + stirrupH),
              note:      'stirrup'
            };

            /* 4 sides: two vertical, two horizontal */
            var left  = new T.Mesh(vGeom, mats.rebar);
            left.position.set(0, 0, -innerHalfW);
            stirrupGroup.add(left);
            var right = new T.Mesh(vGeom, mats.rebar);
            right.position.set(0, 0, innerHalfW);
            stirrupGroup.add(right);
            var topBar = new T.Mesh(hGeom, mats.rebar);
            topBar.position.set(0, stirrupH / 2, 0);
            stirrupGroup.add(topBar);
            var botBar = new T.Mesh(hGeom, mats.rebar);
            botBar.position.set(0, -stirrupH / 2, 0);
            stirrupGroup.add(botBar);

            eng.sceneGroup.add(stirrupGroup);
          }
        }
      }

      /* L-shaped corner anchor bars at every CONVEX corner. In real
         construction, longitudinal bars don't bend through the corner
         — instead an L-shaped lap bar is tied to them, transferring
         tensile load across the corner. We add one L per longitudinal
         position (4 per convex corner). Each L has two equal legs of
         length ~1.5 × stripWidth, oriented along the two adjacent
         edges and joined at the corner cube centre. */
      var L_LEG_LEN = stripWidth * 0.85;
      var V_OFFSETS = [
        { y: topY,    label: 'top-outer', n:  innerHalfW },
        { y: topY,    label: 'top-inner', n: -innerHalfW },
        { y: bottomY, label: 'bot-outer', n:  innerHalfW },
        { y: bottomY, label: 'bot-inner', n: -innerHalfW }
      ];
      for (var vi = 0; vi < poly.length; vi++) {
        var prevV = poly[(vi - 1 + poly.length) % poly.length];
        var curV  = poly[vi];
        var nextV = poly[(vi + 1) % poly.length];
        /* Edge in:  prevV → curV (direction iux,iuz)
           Edge out: curV → nextV  (direction oux,ouz)
           Convex turn = cross(in, out) sign matches rebarCCW. */
        var iEx = curV[0] - prevV[0], iEz = curV[1] - prevV[1];
        var iLen = Math.sqrt(iEx*iEx + iEz*iEz);
        if (iLen < 1e-6) continue;
        var iux = iEx / iLen, iuz = iEz / iLen;
        var oEx = nextV[0] - curV[0], oEz = nextV[1] - curV[1];
        var oLen = Math.sqrt(oEx*oEx + oEz*oEz);
        if (oLen < 1e-6) continue;
        var oux = oEx / oLen, ouz = oEz / oLen;
        var crossV = iux * ouz - iuz * oux;
        var convexV = (rebarCCW && crossV > 0) || (!rebarCCW && crossV < 0);
        if (!convexV) continue;
        /* Inward normals for both edges (point into polygon) */
        var iinx = rebarCCW ? -iuz : iuz;
        var iinz = rebarCCW ?  iux : -iux;
        var oinx = rebarCCW ? -ouz : ouz;
        var oinz = rebarCCW ?  oux : -oux;

        for (var vo = 0; vo < V_OFFSETS.length; vo++) {
          var off = V_OFFSETS[vo];
          /* Position of incoming leg: starts at distance L_LEG_LEN
             BEFORE the vertex along in-edge, ends at the vertex itself,
             offset inward by (halfW + n). */
          var inLineOff = halfW + off.n;
          /* Leg 1: along in-edge, ending at vertex (so its end is the
             corner). We position the bar so it extends from vertex
             back along -iux by L_LEG_LEN. Bar centre = vertex - iux*L/2. */
          var leg1cx = curV[0] - iux * (L_LEG_LEN / 2) + iinx * inLineOff;
          var leg1cz = curV[1] - iuz * (L_LEG_LEN / 2) + iinz * inLineOff;
          var leg1geom = new T.CylinderGeometry(radius, radius, L_LEG_LEN, 8);
          leg1geom.rotateZ(Math.PI / 2);
          var leg1 = new T.Mesh(leg1geom, mats.rebar);
          leg1.position.set(leg1cx, off.y, leg1cz);
          leg1.rotation.y = -Math.atan2(iuz, iux);
          leg1.visible = visible;
          leg1.userData = {
            assetType: 'rebar',
            boqCode:   'FCO00003',
            category:  'rebar',
            index:     idx++,
            length:    L_LEG_LEN,
            note:      'L-anchor-' + off.label + '-leg-in'
          };
          eng.sceneGroup.add(leg1);

          /* Leg 2: along out-edge, starting at vertex. Bar centre =
             vertex + oux*L/2. */
          var outLineOff = halfW + off.n;
          var leg2cx = curV[0] + oux * (L_LEG_LEN / 2) + oinx * outLineOff;
          var leg2cz = curV[1] + ouz * (L_LEG_LEN / 2) + oinz * outLineOff;
          var leg2geom = new T.CylinderGeometry(radius, radius, L_LEG_LEN, 8);
          leg2geom.rotateZ(Math.PI / 2);
          var leg2 = new T.Mesh(leg2geom, mats.rebar);
          leg2.position.set(leg2cx, off.y, leg2cz);
          leg2.rotation.y = -Math.atan2(ouz, oux);
          leg2.visible = visible;
          leg2.userData = {
            assetType: 'rebar',
            boqCode:   'FCO00003',
            category:  'rebar',
            index:     idx++,
            length:    L_LEG_LEN,
            note:      'L-anchor-' + off.label + '-leg-out'
          };
          eng.sceneGroup.add(leg2);
        }
      }
    },

    _build3D_Piers: function (poly) {
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;
      var d = getVariantDefaults('piers', STATE.lvl);
      var raster = _computeTimberRaster(poly, 1.5);

      var TOP_Y = 0.05;
      var EXCAV_BORDER = 0.15;
      var EXCAV_EXTRA  = 0.10;
      var baseSide = d.pierSideM * 0.60;
      var gravelSide = d.pierSideM;

      var idx = 0;
      for (var i = 0; i < raster.piers.length; i++) {
        var pp = raster.piers[i];
        var extra = _padSlopeExtra(pp.x, pp.z);
        var totalDepth = d.pierDepthM + extra;
        var box = new T.BoxGeometry(d.pierSideM, totalDepth, d.pierSideM);
        var m = new T.Mesh(box, mats.pier);
        m.position.set(pp.x, TOP_Y - totalDepth / 2, pp.z);
        m.userData = {
          assetType: 'pier',
          boqCode:   'PWC00001',
          category:  'concrete',
          index:     idx++,
          length:    totalDepth,
          note:      'pier-' + pp.role
        };
        eng.sceneGroup.add(m);

        /* gravel bed under the footing (FFG00001), like the strip variant */
        var gravelTopY = TOP_Y - totalDepth;
        var gpad = new T.Mesh(
          new T.BoxGeometry(gravelSide, d.gravelLayerM, gravelSide),
          mats.gravel
        );
        gpad.position.set(pp.x, gravelTopY - d.gravelLayerM / 2, pp.z);
        gpad.userData = { assetType: 'gravel', boqCode: 'FFG00001', category: 'gravel', index: i };
        eng.sceneGroup.add(gpad);

        if (STATE.slopeActive && STATE.slopeDeg > 0) {
          this._addExcavationPit(
            pp.x, pp.z,
            d.pierSideM + 2 * EXCAV_BORDER,
            d.pierSideM + 2 * EXCAV_BORDER,
            TOP_Y,
            totalDepth + EXCAV_EXTRA
          );
        }
      }

      var beamW = d.beamWidthM  || 0.060;
      var beamH = d.beamHeightM || 0.100;
      _buildSupportsTopFrame(T, mats, eng, {
        raster:     raster,
        beamW:      beamW,
        beamH:      beamH,
        beamCode:   d.beamProfileCode || 'KVH10060',
        baseTopY:   TOP_Y,
        baseSide:   baseSide,
        basePlateT: 0.010,
        stemH:      0.040,
        stemR:      0.018,
        floorT:     0.004,
        plateT:     0.004,
        saddleH:    Math.max(0.05, Math.min(0.08, beamH * 0.70)),
        saddleL:    Math.max(beamW * 1.6, baseSide * 0.70),
        boltR:      0.006,
        boltH:      0.004,
        anchorCode: PIER_ANCHOR_CODE,
        capCode:    PIER_CAP_CODE,
        boltCode:   PIER_BOLT_CODE
      });
    },

    _build3D_Precast: function (poly) {
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;
      var d = getVariantDefaults('precast', STATE.lvl);
      var raster = _computeTimberRaster(poly, d.blockSpacingM);

      // 4-sided frustum block (square tapered pier block)
      var bottomR = (d.blockBaseM * Math.SQRT2) / 2;
      var topR    = (d.blockTopM  * Math.SQRT2) / 2;
      var block   = new T.CylinderGeometry(topR, bottomR, d.blockHeightM, 4, 1);
      block.rotateY(Math.PI / 4);
      var gravelPad = new T.BoxGeometry(d.blockBaseM * 1.4, d.gravelLayerM, d.blockBaseM * 1.4);

      var EXCAV_BORDER = 0.15;
      var EXCAV_EXTRA  = 0.10;

      for (var i = 0; i < raster.piers.length; i++) {
        var px = raster.piers[i].x;
        var pz = raster.piers[i].z;
        var extra = _padSlopeExtra(px, pz);
        var totalBlockH = d.blockHeightM + extra;
        var slopeRad = (STATE.slopeActive && STATE.slopeDeg > 0) ? (STATE.slopeDeg * Math.PI / 180) : 0;

        var blockGeom = (slopeRad > 0)
          ? new T.CylinderGeometry(topR, bottomR, totalBlockH, 4, 1)
          : block;
        if (slopeRad > 0) blockGeom.rotateY(Math.PI / 4);

        var g = new T.Mesh(gravelPad, mats.gravel);
        g.position.set(px, -d.gravelLayerM / 2 - extra, pz);
        g.userData = { assetType: 'gravel', boqCode: 'FFG00001', category: 'gravel', index: i };
        eng.sceneGroup.add(g);

        var m = new T.Mesh(blockGeom, mats.precast);
        m.position.set(px, d.blockHeightM - totalBlockH / 2, pz);
        m.userData = { assetType: 'precast', boqCode: 'PPB15001', category: 'precast', index: i, length: totalBlockH };
        eng.sceneGroup.add(m);

        if (STATE.slopeActive && STATE.slopeDeg > 0) {
          this._addExcavationPit(
            px, pz,
            d.blockBaseM + 2 * EXCAV_BORDER,
            d.blockBaseM + 2 * EXCAV_BORDER,
            0,
            totalBlockH + d.gravelLayerM + EXCAV_EXTRA
          );
        }
      }

      /* same anchor + beam logic as the cast piers, sitting on the block top */
      var beamW = 0.080, beamH = 0.160;
      var baseSide = d.blockTopM * 0.85;
      _buildSupportsTopFrame(T, mats, eng, {
        raster:     raster,
        beamW:      beamW,
        beamH:      beamH,
        beamCode:   'KVH16080',
        baseTopY:   d.blockHeightM,
        baseSide:   baseSide,
        basePlateT: 0.010,
        stemH:      0.040,
        stemR:      0.018,
        floorT:     0.004,
        plateT:     0.004,
        saddleH:    Math.max(0.05, Math.min(0.10, beamH * 0.60)),
        saddleL:    Math.max(beamW * 1.6, baseSide * 0.70),
        boltR:      0.006,
        boltH:      0.004,
        anchorCode: PIER_ANCHOR_CODE,
        capCode:    PIER_CAP_CODE,
        boltCode:   PIER_BOLT_CODE
      });
    },

    _build3D_Screws: function (poly) {
      var T = global.THREE;
      var mats = this._ensureMaterials();
      var eng = global.BaseEngine;
      var d = getVariantDefaults('screws', STATE.lvl);
      var raster = _computeTimberRaster(poly, d.screwSpacingM);

      var HEAD_TOP_Y = 0.10;            /* top of the screw head (adapter sits here) */
      var HEAD_H     = 0.06;
      var headCenterY = HEAD_TOP_Y - HEAD_H / 2;
      var shaftTopY   = HEAD_TOP_Y - HEAD_H;
      var shaftR      = ((d.screwDiameterMm || 76) / 1000) / 2;
      var shaft = new T.CylinderGeometry(shaftR, shaftR * 0.55, d.screwLenM, 12);
      var head  = new T.CylinderGeometry(0.07, 0.07, HEAD_H, 16);

      for (var i = 0; i < raster.piers.length; i++) {
        var px = raster.piers[i].x;
        var pz = raster.piers[i].z;
        var s = new T.Mesh(shaft, mats.screw);
        s.position.set(px, shaftTopY - d.screwLenM / 2, pz);
        s.userData = { assetType: 'screw', boqCode: 'FGR00001', category: 'screw', index: i };
        eng.sceneGroup.add(s);
        var h = new T.Mesh(head, mats.screwHead);
        h.position.set(px, headCenterY, pz);
        h.userData = { assetType: 'screw', boqCode: 'FGR00001', category: 'screw', index: i };
        eng.sceneGroup.add(h);
      }

      /* same anchor + beam logic as the cast piers, sitting on the screw head */
      var beamW = 0.080, beamH = 0.160;
      var baseSide = 0.090;
      _buildSupportsTopFrame(T, mats, eng, {
        raster:     raster,
        beamW:      beamW,
        beamH:      beamH,
        beamCode:   'KVH16080',
        baseTopY:   HEAD_TOP_Y,
        baseSide:   baseSide,
        basePlateT: 0.008,
        stemH:      0.015,
        stemR:      0.016,
        floorT:     0.004,
        plateT:     0.004,
        saddleH:    Math.max(0.05, Math.min(0.10, beamH * 0.60)),
        saddleL:    Math.max(beamW * 1.6, baseSide * 0.70),
        boltR:      0.006,
        boltH:      0.004,
        anchorCode: PIER_ANCHOR_CODE,
        capCode:    PIER_CAP_CODE,
        boltCode:   PIER_BOLT_CODE
      });
    }
  };

  function _insetVertex(prev, curr, next, inset) {
    var d1x = curr[0] - prev[0], d1z = curr[1] - prev[1];
    var d2x = next[0] - curr[0], d2z = next[1] - curr[1];
    var l1 = Math.sqrt(d1x*d1x + d1z*d1z) || 1;
    var l2 = Math.sqrt(d2x*d2x + d2z*d2z) || 1;
    var n1x = -d1z / l1, n1z = d1x / l1;
    var n2x = -d2z / l2, n2z = d2x / l2;
    var bx = (n1x + n2x), bz = (n1z + n2z);
    var bl = Math.sqrt(bx*bx + bz*bz) || 1;
    return [curr[0] - bx / bl * inset, curr[1] - bz / bl * inset];
  }

  function boot() {
    if (global.__BASE_BOOTED__) return;
    global.__BASE_BOOTED__ = true;
    var attempts = 0;
    function tryBoot() {
      if (!global.THREE || !(global.THREE.OrbitControls || global.OrbitControls)) {
        if (++attempts > 100) {
          _dbg('boot aborted: THREE / OrbitControls never loaded after 5s');
          global.__BASE_BOOTED__ = false;
          return;
        }
        setTimeout(tryBoot, 50);
        return;
      }
      if (global.BaseEngine && global.BaseEngine.init) global.BaseEngine.init();
      _readShopifyVariantFromURL();
      _ProjectStore.init();
      _restoreFromProjectStore();
      wireSidebar();
      rebuildDragHandles();
      selectVariant(STATE.variant, true);
      var wrap = document.getElementById('cf-wrap-base');
      if (wrap) wrap.classList.add(STATE.view === '2d' ? 'cf-view-2d' : 'cf-view-3d');
      if (global.BaseEngine && global.BaseEngine._gridHelper) {
        global.BaseEngine._gridHelper.visible = true;
      }
      refreshUI();
      if (global.BaseEngine && global.BaseEngine.fitCameraToFootprint) {
        global.BaseEngine.fitCameraToFootprint();
      }
      _initMap();
      setTimeout(_updateMapLockButton, 300);
      _AssetDrawer.init();
      _scheduleOnboardModal();
      _dbg('boot complete, version=' + VERSION);
    }
    tryBoot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementById('cf-wrap-base')) boot();
    });
  } else {
    if (document.getElementById('cf-wrap-base')) boot();
  }

  function _openPdfSocialModal() {
    var BOOT = global.BASE_BOOT || {};
    if (!BOOT.hasOwnership) {
      var T = BOOT.i18n || {};
      var productUrl = '/products/' + (BOOT.productHandle || 'roof');
      var msg = T.pdfPaywallMsg || 'To download the PDF documentation, please purchase this product first.';
      var ok = window.confirm(msg + '\n\n' + (T.pdfPaywallCta || 'Go to product page?'));
      if (ok) window.location.href = productUrl;
      return;
    }
    var modal = document.getElementById('cf-pdf-modal');
    if (!modal) {
      exportPdf().catch(function (e) { console.error('[exportPdf]', e); });
      return;
    }
    modal.hidden = false;

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
    }
    function onClick(e) {
      var closeEl = e.target.closest('[data-cf-pdf-close]');
      if (closeEl) {
        e.preventDefault();
        close();
        return;
      }
      var goEl = e.target.closest('[data-cf-pdf-go]');
      if (goEl) {
        e.preventDefault();
        var url = goEl.getAttribute('href');
        close();
        if (url) {
          try {
            var w = window.open(url, '_blank', 'noopener,noreferrer');
            if (w) w.opener = null;
          } catch (_) {
            window.open(url, '_blank');
          }
        }
        setTimeout(function () {
          exportPdf().catch(function (err) { console.error('[exportPdf]', err); });
        }, 60);
      }
    }
    modal.addEventListener('click', onClick);
  }

  /* ───────────────────────────────────────────────────────────────
     Shared budget onboarding modal
     Goal: nudge a brand-new visitor to consider other people's
     real-world budgets without ever overwriting their own work.

     Trigger contract:
       • 15 seconds after page load
       • only on a configurator product page (we already are)
       • at most once every 30 days, per product, stored in
         localStorage keyed by productId
       • skipped if the user already has any budget activity for
         this product (any saved row, any open share drawer click,
         any price edit) — checked via a permissive interaction
         flag the budget module sets when the user touches data

     On "Show me": close, open the existing share-budget drawer
     ($-icon target). On "Maybe later" / backdrop / X: close +
     write the timestamp so we don't bother them again for 30 days.
     ─────────────────────────────────────────────────────────────── */
  var ONBOARD_THROTTLE_DAYS = 30;
  var ONBOARD_DELAY_MS = 15000;

  function _onboardStorageKey() {
    var BOOT = global.BASE_BOOT || {};
    var pid = BOOT.productId || BOOT.productHandle || 'default';
    return 'cf-onboard-shared-budget-' + pid;
  }

  function _onboardShouldShow() {
    try {
      var raw = localStorage.getItem(_onboardStorageKey());
      if (!raw) return true;
      var ts = parseInt(raw, 10);
      if (!ts || isNaN(ts)) return true;
      var ageMs = Date.now() - ts;
      var maxAge = ONBOARD_THROTTLE_DAYS * 24 * 60 * 60 * 1000;
      return ageMs > maxAge;
    } catch (_) { return true; }
  }

  function _onboardMarkSeen() {
    try { localStorage.setItem(_onboardStorageKey(), String(Date.now())); }
    catch (_) {}
  }

  function _onboardUserHasOwnBudget() {
    /* Conservative interaction detection: if the user already
       opened the budget drawer (= touched the $ icon) or any
       price/qty input on this product, treat them as "engaged"
       and don't pop the onboarding modal at them. We sniff a few
       global flags set by the budget module + any existing rows
       under the well-known budget storage. */
    try {
      if (global.__cfBudgetUserTouched) return true;
      if (global.SharedBudgetUserEngaged) return true;
      var BOOT = global.BASE_BOOT || {};
      var pid = BOOT.productId;
      if (pid) {
        if (localStorage.getItem('cf-budget-touched-' + pid)) return true;
      }
    } catch (_) {}
    return false;
  }

  function _openOnboardModal() {
    var modal = document.getElementById('cf-onboard-modal');
    if (!modal) return;
    modal.hidden = false;

    /* Lock page scroll while the modal is open (prevents scrolling the page
       behind it). Remember previous inline values to restore exactly. */
    var de = document.documentElement, bd = document.body;
    var prevHtmlOv = de ? de.style.overflow : '';
    var prevBodyOv = bd ? bd.style.overflow : '';
    var prevBodyTA = bd ? bd.style.touchAction : '';
    if (de) de.style.overflow = 'hidden';
    if (bd) { bd.style.overflow = 'hidden'; bd.style.touchAction = 'none'; }

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
      if (de) de.style.overflow = prevHtmlOv;
      if (bd) { bd.style.overflow = prevBodyOv; bd.style.touchAction = prevBodyTA; }
      _onboardMarkSeen();
    }
    function onClick(e) {
      if (e.target.closest('[data-cf-onboard-close]')) {
        e.preventDefault();
        close();
        return;
      }
      if (e.target.closest('[data-cf-onboard-go]')) {
        e.preventDefault();
        close();
        /* Tiny delay so the close animation can settle before the
           drawer slides in — feels less jarring than an instant
           swap. */
        setTimeout(function () {
          try { openBudgetDrawer(); }
          catch (err) { console.warn('[onboard] open budget drawer failed', err); }
        }, 120);
      }
    }
    modal.addEventListener('click', onClick);
  }

  function _scheduleOnboardModal() {
    /* Only on configurator pages — this script lives in the base
       configurator already, so being here is the gate. We also
       skip if document is hidden so the timer effectively starts
       when the user actually views the page (avoids burning the
       30-day throttle on a background tab). */
    if (!_onboardShouldShow()) return;
    if (_onboardUserHasOwnBudget()) return;

    var elapsed = 0;
    var tick = 1000;
    var timer = setInterval(function () {
      if (document.visibilityState === 'visible') elapsed += tick;
      if (elapsed >= ONBOARD_DELAY_MS) {
        clearInterval(timer);
        /* Re-check guards at fire time — user may have opened the
           drawer in the meantime. */
        if (_onboardShouldShow() && !_onboardUserHasOwnBudget()) {
          _openOnboardModal();
        }
      }
    }, tick);
  }

  /* ───────────────────────────────────────────────────────────────
     AR export pipeline
     Click → export current Three.js scene as GLB → upload to R2
     via the Cloudflare Worker → render QR code pointing at the
     viewer page. Phone scans QR → opens <model-viewer> page →
     "View in AR" places the model in the user's space.

     Flow:
       1. POST {worker}/upload-url     → { uploadUrl, viewerUrl }
       2. GLTFExporter.parse(scene)    → ArrayBuffer (GLB binary)
       3. PUT {uploadUrl} body=glb     → R2 receives the file
       4. render QR(viewerUrl) in modal

     The full export typically runs in 1–3 s — slow enough to
     warrant a "Preparing scene…" status under the QR placeholder
     so the user doesn't think it's frozen.
     ─────────────────────────────────────────────────────────────── */
  function _setArStatus(msg) {
    var el = document.getElementById('cf-ar-modal-status');
    if (el) el.textContent = msg || '';
  }

  function _setArQR(dataUrl) {
    var el = document.getElementById('cf-ar-modal-qr');
    if (!el) return;
    el.innerHTML = '';
    if (!dataUrl) return;
    var img = document.createElement('img');
    img.src = dataUrl;
    img.alt = 'AR QR code';
    img.style.width = '200px';
    img.style.height = '200px';
    img.style.borderRadius = '8px';
    img.style.background = '#fff';
    img.style.padding = '8px';
    el.appendChild(img);
  }

  function _setArLink(viewerUrl) {
    var el = document.getElementById('cf-ar-modal-link');
    if (!el) return;
    if (viewerUrl) {
      el.style.display = 'block';
      el.innerHTML = '<a href="' + viewerUrl + '" target="_blank" rel="noopener noreferrer" style="color:inherit;text-decoration:underline;">' + viewerUrl + '</a>';
    } else {
      el.style.display = 'none';
      el.innerHTML = '';
    }
  }

  function _arExportScene() {
    /* Builds a clean GLB from the current Three.js scene. We
       export ONLY the configurator's sceneGroup — not the grid,
       map, slope visualisation overlays, or section-cut helper
       geometry — because the AR viewer should show the actual
       foundation, nothing else.

       Returns a Promise<ArrayBuffer> that resolves to the GLB
       bytes ready for upload. */
    return new Promise(function (resolve, reject) {
      var T = global.THREE;
      var Exporter = global.GLTFExporter;
      var eng = global.BaseEngine;
      if (!T || !Exporter || !eng || !eng.sceneGroup) {
        reject(new Error('THREE / GLTFExporter / scene not ready'));
        return;
      }
      /* Build an export-only Group containing clones of the meshes
         we actually want in AR. Each mesh gets its OWN geometry
         clone — Mesh.clone() is shallow and keeps the geometry
         reference, so without a deep clone the applyMatrix4 below
         would mutate the shared buffer and all-but-one mesh would
         end up at the same world position. This is the bug that
         made the AR scene show a single pier instead of the full
         grid of N piers (they all shared one geometry instance,
         all overwritten by the last transform). */
      var exportRoot = new T.Group();
      eng.sceneGroup.traverse(function (node) {
        if (!node.isMesh || !node.geometry || !node.material) return;
        var t = node.userData && node.userData.assetType;
        /* Skip anything that is purely a visualisation aid. */
        if (t === 'section-cut-aux') return;
        if (t === 'slope-terrain') return;
        if (t === 'excavation-box') return;  /* hole-in-ground viz, no real material */
        if (!node.visible) return;
        node.updateMatrixWorld(true);
        /* Deep clone: fresh geometry per mesh, then bake the world
           transform into THIS geometry only. Material can stay
           shared because we never mutate it here. */
        var geom = node.geometry.clone();
        geom.applyMatrix4(node.matrixWorld);
        var cloned = new T.Mesh(geom, node.material);
        cloned.name = node.name || (t || 'mesh') + '_' + exportRoot.children.length;
        cloned.userData = Object.assign({}, node.userData || {});
        exportRoot.add(cloned);
      });

      if (exportRoot.children.length === 0) {
        reject(new Error('No exportable meshes in scene'));
        return;
      }

      var exporter = new Exporter();
      exporter.parse(
        exportRoot,
        function (glb) {
          /* GLTFExporter returns either ArrayBuffer (binary=true)
             or a JSON object. We requested binary so we always
             expect ArrayBuffer. */
          if (glb instanceof ArrayBuffer) {
            resolve(glb);
          } else {
            reject(new Error('Expected GLB ArrayBuffer, got JSON'));
          }
        },
        function (err) { reject(err); },
        { binary: true }
      );
    });
  }

  async function _arUpload(glbBuffer) {
    var BOOT = global.BASE_BOOT || {};
    var T = BOOT.i18n || {};
    var workerUrl = BOOT.arWorkerUrl || (T.arWorkerUrl);
    if (!workerUrl) throw new Error('Worker URL missing');
    _dbg('[ar] worker URL = ' + workerUrl);

    /* Step 1: ask the worker for an upload URL + the matching
       viewer URL. Use GET to avoid a CORS preflight roundtrip
       (POST with application/json body triggers an OPTIONS check
       which makes "Failed to fetch" much more likely to surface
       on flaky connections). The worker generates a fresh UUID
       per request so two simultaneous exports don't collide. */
    _dbg('[ar] GET ' + workerUrl + '/upload-url');
    var r1;
    try {
      r1 = await fetch(workerUrl + '/upload-url');
    } catch (netErr) {
      _dbg('[ar] network error on /upload-url: ' + netErr);
      throw new Error('Network error: ' + (netErr && netErr.message ? netErr.message : netErr));
    }
    _dbg('[ar] /upload-url response status=' + r1.status + ' ok=' + r1.ok);
    if (!r1.ok) throw new Error('upload-url failed: HTTP ' + r1.status);
    var info = await r1.json();
    _dbg('[ar] /upload-url payload: ' + JSON.stringify(info));
    if (!info || !info.uploadUrl) throw new Error('upload-url response invalid');

    /* Step 2: PUT the GLB straight to the worker's upload endpoint.
       The worker stores it in R2 under {uuid}.glb.

       PUT with a binary body + non-simple content-type triggers a
       CORS preflight OPTIONS request — the worker handles it, but
       any tunnel / proxy in between can mess it up. Catch the
       network-level TypeError separately from HTTP errors so we
       can log the actual cause. */
    _dbg('[ar] PUT ' + info.uploadUrl + ' (' + (glbBuffer.byteLength / 1024).toFixed(1) + ' KB)');
    var r2;
    try {
      r2 = await fetch(info.uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'model/gltf-binary' },
        body: glbBuffer
      });
    } catch (netErr) {
      _dbg('[ar] network error on PUT: ' + netErr);
      throw new Error('Network error on PUT: ' + (netErr && netErr.message ? netErr.message : netErr));
    }
    _dbg('[ar] PUT response status=' + r2.status + ' ok=' + r2.ok);
    if (!r2.ok) {
      var errBody = '';
      try { errBody = await r2.text(); } catch (_) {}
      _dbg('[ar] PUT error body: ' + errBody);
      throw new Error('PUT failed: HTTP ' + r2.status + ' ' + errBody);
    }

    return info;  /* { uuid, uploadUrl, publicUrl, viewerUrl } */
  }

  function _arGenerateQR(url) {
    /* Use the same QRCode library the PDF exporter already loaded
       via <script defer>. If it isn't ready yet, fall back to a
       remote QR service so the modal still works on first paint
       before the CDN script lands. */
    return new Promise(function (resolve) {
      function tryLib() {
        if (global.QRCode && global.QRCode.toDataURL) {
          global.QRCode.toDataURL(url, { width: 400, margin: 1, errorCorrectionLevel: 'M' }, function (err, dataUrl) {
            if (err || !dataUrl) {
              resolve('https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=' + encodeURIComponent(url));
            } else {
              resolve(dataUrl);
            }
          });
          return true;
        }
        return false;
      }
      if (tryLib()) return;
      /* Poll for ~2s, then fall back. */
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (tryLib()) { clearInterval(iv); return; }
        if (attempts > 20) {
          clearInterval(iv);
          resolve('https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=' + encodeURIComponent(url));
        }
      }, 100);
    });
  }

  async function _openArModal() {
    var modal = document.getElementById('cf-ar-modal');
    if (!modal) return;
    var BOOT = global.BASE_BOOT || {};
    var T = BOOT.i18n || {};

    /* Reset modal to "preparing" state and show it immediately so
       the user sees feedback before the export runs. */
    _setArQR(null);
    _setArLink(null);
    _setArStatus(T.arPreparing || 'Preparing scene…');
    modal.hidden = false;

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
    }
    function onClick(e) {
      if (e.target.closest('[data-cf-ar-close]')) {
        e.preventDefault();
        close();
      }
    }
    modal.addEventListener('click', onClick);

    /* Make sure we're in 3D — the AR scene is a 3D object. If the
       user clicks AR from the 2D plan view we briefly force a
       build of the 3D version into memory without changing the
       UI view (just so the meshes exist to be exported). */
    var needBuild = false;
    if (STATE.view !== '3d') {
      needBuild = true;
      try {
        if (global.BaseRenderer && global.BaseRenderer._build3D) {
          var poly = getFootprintPolygon();
          if (poly && poly.length >= 3) global.BaseRenderer._build3D(poly);
        }
      } catch (e) { _dbg('[ar] 3D pre-build failed', e); }
    }

    try {
      var glb = await _arExportScene();
      _dbg('[ar] GLB size = ' + (glb.byteLength / 1024).toFixed(1) + ' KB');
      _setArStatus(T.arUploading || 'Uploading to cloud…');

      var info = await _arUpload(glb);
      _dbg('[ar] uploaded uuid=' + info.uuid + ' viewer=' + info.viewerUrl);

      var qrDataUrl = await _arGenerateQR(info.viewerUrl);
      _setArQR(qrDataUrl);
      _setArLink(info.viewerUrl);
      _setArStatus(T.arReady || 'Ready — scan with your phone');
    } catch (e) {
      console.error('[ar] export failed', e);
      _setArStatus((T.arError || 'AR export failed: ') + (e && e.message ? e.message : e));
    }

    /* If we needed a 3D pre-build for export but the user is back
       in 2D, restore the 2D build so the canvas doesn't show
       stray geometry after the modal closes. */
    if (needBuild && global.BaseRenderer && global.BaseRenderer.build) {
      try { global.BaseRenderer.build(); } catch (_) {}
    }
  }

  async function exportPdf() {
    var T = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
    if (!global.ConfiguratorPdfExporter || !global.ConfiguratorPdfExporter.export) {
      alert(T.pdfLibLoading || 'PDF library not yet loaded — try again in a moment.');
      return;
    }
    var BOOT = global.BASE_BOOT || {};
    var bridge = global.ConfiguratorBudgetBridge || null;
    var btn = document.getElementById('cf-btn-pdf');

    if (!BOOT.hasOwnership) {
      var productUrl = '/products/' + (BOOT.productHandle || 'roof');
      var msg = T.pdfPaywallMsg || 'To download the PDF documentation, please purchase this product first.';
      var ok = window.confirm(msg + '\n\n' + (T.pdfPaywallCta || 'Go to product page?'));
      if (ok) window.location.href = productUrl;
      return;
    }

    if (btn) btn.classList.add('active');

    if (bridge && typeof bridge.isReady === 'function' && !bridge.isReady()) {
      var waited = 0;
      var pollMs = 100;
      var timeoutMs = 5000;
      while (!bridge.isReady() && waited < timeoutMs) {
        await new Promise(function (res) { setTimeout(res, pollMs); });
        waited += pollMs;
      }
      if (!bridge.isReady()) {
        if (btn) btn.classList.remove('active');
        alert(T.pdfWaitingForData || 'Configuration data is still loading. Please wait a moment and try again.');
        return;
      }
    }

    try {
      try { publishBoQToBudget(); } catch (_) {}
      if (typeof global.updateTotal === 'function') {
        try { global.updateTotal(); } catch (_) {}
      }
      await new Promise(function (res) { setTimeout(res, 600); });

      var snapshots = await _captureForPdf();
      var instances = _buildInstancePayload();
      var boqNames  = _buildBoqNamesMap(bridge);
      var boq       = _buildBoq(bridge);
      var totals    = _buildTotals(boq);
      var baseDims  = _buildBaseDimensions();
      var variantName = _variantDisplayName();

      try { console.log('[exportPdf] totals=', totals); } catch (_) {}

      var planSnap  = (snapshots || []).find(function (s) { return s && s.key === 'plan'; });
      var crossSnap = (snapshots || []).find(function (s) { return s && s.key === 'cross-section'; });
      try {
        console.log('[exportPdf] snapshots=', snapshots ? snapshots.length : 0,
                    'planSnap=', planSnap ? (planSnap.imageDataUrl ? 'OK (' + planSnap.imageDataUrl.length + ' chars)' : 'no URL') : 'missing',
                    'crossSnap=', crossSnap ? (crossSnap.imageDataUrl ? 'OK' : 'no URL') : 'missing');
      } catch (_) {}

      var assemblyPayload = await _buildAssemblyPayload(boq);
      try { console.log('[exportPdf] assemblyPayload=', assemblyPayload ? 'OK (' + assemblyPayload.legend.length + ' legend rows)' : 'none'); } catch (_) {}

      global.ConfiguratorPdfExporter.export({
        productTitle:    (BOOT.productTitle || 'Foundation') + '\n' + (variantName ? variantName.toUpperCase() : ''),
        customerName:    BOOT.customerName || null,
        coverImage:      BOOT.coverImage   || null,
        shareUrl:        _buildShareUrl(),
        totals:          totals,
        baseAssembly:     assemblyPayload,
        basePlan:         planSnap  ? { imageDataUrl: planSnap.imageDataUrl, bottomLeft: planSnap.bottomLeft || null } : null,
        baseCrossSection: crossSnap ? { imageDataUrl: crossSnap.imageDataUrl } : null,
        baseDims:      baseDims,
        instances:     instances,
        boqNames:      boqNames,
        cutList: [{
          profile:     T.pdfNoCutTitle || 'Cut list',
          profileCode: '',
          unit:        '',
          pieces:      []
        }],
        boq:           boq,
        meta: {
          locale:        BOOT.locale         || 'en',
          productHandle: BOOT.productHandle  || 'roof',
          date:          new Date(),
          variantName:   variantName,
          lvl:           STATE.lvl,
          slope: {
            active: STATE.slopeActive,
            deg:    STATE.slopeDeg
          },
          i18n: {
            pagePlanTitle:           T.pdfPagePlanTitle           || 'Plan view',
            pageCrossSectionTitle:   T.pdfPageCrossSection        || 'Cross-section',
            pageCutListTitle:        T.pdfPageCutListTitle        || 'Cut list',
            pageBoqTitle:            T.pdfPageBoqTitle            || 'Bill of Quantities',
            pageIsoTitle:            T.pdfPageIsoTitle            || '3D visualisation',
            pageOrthosTitle:         T.pdfPageOrthosTitle         || 'Engineering views',
            pageCutListVisualTitle:  T.pdfPageCutListVisualTitle  || 'Cut list — visual',
            orthoTop:                T.pdfOrthoTop                || 'Top view',
            orthoFront:              T.pdfOrthoFront              || 'Front view',
            orthoSide:               T.pdfOrthoSide               || 'Side view',
            totalsTitle:             T.pdfTotalsTitle             || 'TOTAL',
            materialsLabel:          T.pdfMaterialsLabel          || 'Materials',
            executionLabel:          T.pdfExecutionLabel          || 'Execution',
            grandTotalLabel:         T.pdfGrandTotalLabel         || 'GRAND TOTAL',
            noCutsMessage:           T.pdfNoCutsMessage           || 'No cuttable items for this foundation type.',
            noModelData:             T.pdfNoModelData             || 'No 3D model data available.',
            continued:               T.pdfContinued               || '(continued)',
            pcs:                     T.pdfPcs                     || 'pcs',
            deckingLabel:            T.pdfDeckingLabel            || 'decking',
            slopeLabel:              T.pdfSlopeLabel              || 'Slope',
            lvlLabel:                T.pdfLvlLabel                || 'Reinforcement level',
            lvlNames: {
              1: T.pdfLvl1 || 'Standard',
              2: T.pdfLvl2 || 'Reinforced',
              3: T.pdfLvl3 || 'Robust'
            },
            boq: {
              headerCode:      T.pdfBoqHeaderCode      || 'Code',
              headerName:      T.pdfBoqHeaderName      || 'Description',
              headerQty:       T.pdfBoqHeaderQty       || 'Qty',
              headerUnitPrice: T.pdfBoqHeaderUnitPrice || 'Unit price',
              headerTotal:     T.pdfBoqHeaderTotal     || 'Total',
              grandTotal:      T.pdfBoqGrandTotal      || 'Grand total'
            },
            cutList: {
              headerPart:   T.pdfCutHeaderPart   || 'Part',
              headerDesc:   T.pdfCutHeaderDesc   || 'Description',
              headerLength: T.pdfCutHeaderLength || 'Length',
              headerQty:    T.pdfCutHeaderQty    || 'Qty'
            }
          }
        }
      });
    } catch (e) {
      console.error('[exportPdf]', e);
      alert((T.pdfFailed || 'PDF export failed: ') + (e && e.message ? e.message : 'unknown error'));
    } finally {
      if (btn) btn.classList.remove('active');
    }
  }

  async function _captureForPdf() {
    var T = global.THREE;
    var eng = global.BaseEngine;
    if (!T || !eng || !eng.scene || !eng.renderer) return [];

    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return [];

    var prevStage = STATE.vizStage;
    var prevView  = STATE.view;
    var prevSlope = STATE.slopeActive;
    var prevOrthoD = eng._currentOrthoD;
    var prevCamLeft = eng.cameraOrtho ? eng.cameraOrtho.left : null;
    var prevCamRight = eng.cameraOrtho ? eng.cameraOrtho.right : null;
    var prevCamTop = eng.cameraOrtho ? eng.cameraOrtho.top : null;
    var prevCamBottom = eng.cameraOrtho ? eng.cameraOrtho.bottom : null;
    var prevMapZoom = (_MapManager && _MapManager.map) ? _MapManager.map.getZoom() : null;
    var wrap = document.getElementById('cf-wrap-base');
    STATE.vizStage = 1;
    STATE.view = '2d';
    STATE.slopeActive = false;
    if (wrap) {
      wrap.classList.add('cf-view-2d');
      wrap.classList.remove('cf-view-3d');
      wrap.classList.add('cf-stage-view');
    }
    /* Deterministic camera framing — reset the ortho camera to fit
       the polygon with a fixed padding so the export is identical
       for every user regardless of their current pan/zoom state on
       the web. Mapbox follows via _syncMapTo2D so the underlying
       map matches the scene scale. */
    if (eng.fitCameraToFootprint) eng.fitCameraToFootprint();
    if (_MapManager && _MapManager.map && _MapManager._syncMapTo2D) {
      _MapManager._syncMapTo2D(false);
    }
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
    if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();
    if (_BaseDimensions && _BaseDimensions.refresh) _BaseDimensions.refresh();

    await new Promise(function (res) { setTimeout(res, 600); });

    if (_BaseDimensions && _BaseDimensions.refresh) _BaseDimensions.refresh();

    var threeCanvas = eng.renderer.domElement;
    var mapCanvas = null;
    try {
      var mapEl = document.getElementById('cf-mapbox');
      if (mapEl) {
        var mapboxCanvas = mapEl.querySelector('canvas');
        if (mapboxCanvas) mapCanvas = mapboxCanvas;
      }
    } catch (_) {}

    var wrapRect = wrap ? wrap.getBoundingClientRect() : null;
    var threeRect = threeCanvas.getBoundingClientRect();
    var refRect = wrapRect || threeRect;

    var W_PX = 1600;
    var srcW = refRect.width || 1;
    var srcH = refRect.height || 1;
    var H_PX = Math.round(W_PX * srcH / srcW);
    var scale = W_PX / srcW;

    var tmpCanvas = document.createElement('canvas');
    tmpCanvas.width = W_PX;
    tmpCanvas.height = H_PX;
    var ctx = tmpCanvas.getContext('2d');

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W_PX, H_PX);

    var mapDrew = false;
    if (mapCanvas) {
      try {
        if (_MapManager && _MapManager.map && _MapManager.map.triggerRepaint) {
          _MapManager.map.triggerRepaint();
        }
        await new Promise(function (res) { setTimeout(res, 250); });
        var mapElRect = mapEl.getBoundingClientRect();
        var mx = (mapElRect.left - refRect.left) * scale;
        var my = (mapElRect.top  - refRect.top)  * scale;
        var mw = mapElRect.width  * scale;
        var mh = mapElRect.height * scale;
        ctx.globalAlpha = 0.7;
        ctx.drawImage(mapCanvas, mx, my, mw, mh);
        ctx.globalAlpha = 1.0;
        mapDrew = true;
      } catch (e) { console.warn('[exportPdf] map composite failed', e); }
    }

    var sceneDrew = false;
    try {
      eng.renderer.render(eng.scene, eng.camera);
      var cx = (threeRect.left - refRect.left) * scale;
      var cy = (threeRect.top  - refRect.top)  * scale;
      var cw = threeRect.width  * scale;
      var ch = threeRect.height * scale;
      ctx.drawImage(threeCanvas, cx, cy, cw, ch);
      sceneDrew = true;
    } catch (e) { console.warn('[exportPdf] scene composite failed', e); }

    var dimLabelData = [];
    try {
      var labels = document.querySelectorAll('.cf-base-dim-label, .cf-dim-chip');
      var labelsVisible = 0;

      var svgEl = document.getElementById('cf-base-dims-svg');
      if (svgEl) {
        try {
          var svgClone = svgEl.cloneNode(true);
          svgClone.style.display = '';
          var svgRect = svgEl.getBoundingClientRect();
          if (svgRect.width && svgRect.height) {
            var svgStr = new XMLSerializer().serializeToString(svgClone);
            var svgBlob = new Blob([svgStr], { type: 'image/svg+xml;charset=utf-8' });
            var svgUrl = URL.createObjectURL(svgBlob);
            var svgImg = new Image();
            await new Promise(function (res) {
              svgImg.onload = function () { res(); };
              svgImg.onerror = function () { res(); };
              svgImg.src = svgUrl;
            });
            var sx2 = (svgRect.left - refRect.left) * scale;
            var sy2 = (svgRect.top  - refRect.top)  * scale;
            var sw2 = svgRect.width  * scale;
            var sh2 = svgRect.height * scale;
            try { ctx.drawImage(svgImg, sx2, sy2, sw2, sh2); } catch (_) {}
            URL.revokeObjectURL(svgUrl);
          }
        } catch (e) { console.warn('[exportPdf] svg dims composite failed', e); }
      }

      /* Collect label positions in source-canvas coords. Drawing
         is deferred until after crop so the font size stays fixed
         in output-canvas pixels (not multiplied by the crop zoom
         ratio). */
      for (var li = 0; li < labels.length; li++) {
        var lel = labels[li];
        var computed = window.getComputedStyle(lel);
        if (computed.display === 'none' || computed.visibility === 'hidden') continue;
        labelsVisible++;
        var lr = lel.getBoundingClientRect();
        if (!lr.width || !lr.height) continue;
        var lcx = ((lr.left + lr.width / 2)  - refRect.left) * scale;
        var lcy = ((lr.top  + lr.height / 2) - refRect.top)  * scale;
        var txt = (lel.textContent || '').trim();
        if (!txt) continue;
        dimLabelData.push({ cx: lcx, cy: lcy, text: txt });
      }
      try { console.log('[exportPdf] labels collected:', { found: labels.length, visible: labelsVisible, queued: dimLabelData.length, svgEl: !!svgEl }); } catch (_) {}
    } catch (e) { console.warn('[exportPdf] labels collect failed', e); }

    try {
      console.log('[exportPdf] composite: mapDrew=' + mapDrew + ' sceneDrew=' + sceneDrew + ' size=' + W_PX + 'x' + H_PX);
    } catch (_) {}

    var xMin = Infinity, xMax = -Infinity, zMin = Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      if (poly[i][0] < xMin) xMin = poly[i][0];
      if (poly[i][0] > xMax) xMax = poly[i][0];
      if (poly[i][1] < zMin) zMin = poly[i][1];
      if (poly[i][1] > zMax) zMax = poly[i][1];
    }
    var bbL = xMax - xMin;
    var bbW = zMax - zMin;

    /* Crop tmpCanvas so the polygon fills ~75% of the cropped area.
       Probe each polygon corner via _worldToScreen to learn the
       polygon's screen bbox, then center the crop on the polygon
       centroid and size it so polygon_w / crop_w == 0.75. Output
       crop matches A4 landscape aspect (1.414) so the PDF page
       maps 1:1 with no further stretching needed. */
    var cropCanvas = tmpCanvas;
    var cropX = 0, cropY = 0, cropW = W_PX, cropH = H_PX;
    try {
      var corners = [
        _worldToScreen(xMin, zMin),
        _worldToScreen(xMax, zMin),
        _worldToScreen(xMax, zMax),
        _worldToScreen(xMin, zMax)
      ];
      var sxMin = Infinity, sxMax = -Infinity, syMin = Infinity, syMax = -Infinity;
      var ok = true;
      for (var ci = 0; ci < corners.length; ci++) {
        if (!corners[ci]) { ok = false; break; }
        var cpx = corners[ci].left * scale;
        var cpy = corners[ci].top  * scale;
        if (cpx < sxMin) sxMin = cpx;
        if (cpx > sxMax) sxMax = cpx;
        if (cpy < syMin) syMin = cpy;
        if (cpy > syMax) syMax = cpy;
      }
      if (ok && isFinite(sxMin) && isFinite(syMin)) {
        var polyW = sxMax - sxMin;
        var polyH = syMax - syMin;
        var polyCx = (sxMin + sxMax) / 2;
        var polyCy = (syMin + syMax) / 2;

        /* Polygon fills 75% of crop along each axis. To preserve
           A4 landscape aspect (1.414), pick crop dimensions that
           satisfy both polyW/cw==0.75 AND polyH/ch==0.75; the
           larger of the two derived crop sizes wins so neither
           axis is over-cropped. */
        /* Camera is now deterministic (forced fitCameraToFootprint
           with PADDING=4m), so this crop pass is mostly a sanity
           clamp. ~15% smaller polygon → more breathing room around
           it; the crop window is correspondingly wider. */
        var TARGET_FILL = 0.48;
        var PAGE_AR = 297 / 210;
        var cwByX = polyW / TARGET_FILL;
        var cwByY = (polyH / TARGET_FILL) * PAGE_AR;
        var cw = Math.max(cwByX, cwByY);
        var ch = cw / PAGE_AR;

        /* Clamp crop window inside the source canvas so we never
           sample outside the composite (would produce black bands). */
        var cx = polyCx - cw / 2;
        var cy = polyCy - ch / 2;
        if (cx < 0) cx = 0;
        if (cy < 0) cy = 0;
        if (cx + cw > W_PX) cx = W_PX - cw;
        if (cy + ch > H_PX) cy = H_PX - ch;
        if (cw > W_PX) { cw = W_PX; cx = 0; }
        if (ch > H_PX) { ch = H_PX; cy = 0; }

        var OUT_W = 1600;
        var OUT_H = Math.round(OUT_W / PAGE_AR);
        var croppedCanvas = document.createElement('canvas');
        croppedCanvas.width  = OUT_W;
        croppedCanvas.height = OUT_H;
        var cctx = croppedCanvas.getContext('2d');
        cctx.fillStyle = '#ffffff';
        cctx.fillRect(0, 0, OUT_W, OUT_H);
        cctx.drawImage(tmpCanvas, cx, cy, cw, ch, 0, 0, OUT_W, OUT_H);

        cropCanvas = croppedCanvas;
        cropX = cx; cropY = cy; cropW = cw; cropH = ch;
        try {
          console.log('[exportPdf] crop:', { polyW: Math.round(polyW), polyH: Math.round(polyH), cropW: Math.round(cw), cropH: Math.round(ch), fillX: (polyW/cw).toFixed(2), fillY: (polyH/ch).toFixed(2) });
        } catch (_) {}
      }
    } catch (e) { console.warn('[exportPdf] crop failed', e); }

    /* Draw dim labels onto the cropped output canvas with a fixed
       font size so they look the same regardless of how aggressive
       the crop was. Also de-collides labels: if any pair would
       overlap, push each one along the axis with more headroom
       (vertical for horizontal-axis dims, horizontal for vertical
       ones). Iterates a few times until stable or capped. */
    try {
      var cctx2 = cropCanvas.getContext('2d');
      var outW = cropCanvas.width;
      var outH = cropCanvas.height;
      var LABEL_FONT_PX = 18;
      var LABEL_PAD_X = 7;
      var LABEL_PAD_Y = 4;

      cctx2.font = '600 ' + LABEL_FONT_PX + 'px Montserrat, sans-serif';
      cctx2.textAlign = 'center';
      cctx2.textBaseline = 'middle';

      /* Project each captured label from source-canvas coords into
         the cropped output coords, measure, and keep the box for
         collision testing. */
      var placed = [];
      for (var di = 0; di < dimLabelData.length; di++) {
        var d = dimLabelData[di];
        var oxLabel = (d.cx - cropX) / cropW * outW;
        var oyLabel = (d.cy - cropY) / cropH * outH;
        if (oxLabel < -50 || oxLabel > outW + 50) continue;
        if (oyLabel < -50 || oyLabel > outH + 50) continue;
        var tw2 = cctx2.measureText(d.text).width;
        var th2 = LABEL_FONT_PX;
        placed.push({
          text: d.text,
          cx: oxLabel, cy: oyLabel,
          w: tw2 + LABEL_PAD_X * 2,
          h: th2 + LABEL_PAD_Y * 2
        });
      }

      /* Simple de-overlap pass: for each colliding pair, nudge the
         later one away from the earlier one along the smaller-cost
         axis. A handful of iterations is enough for typical 4–8
         label scenes. */
      function rectsOverlap(a, b) {
        return Math.abs(a.cx - b.cx) < (a.w + b.w) / 2 - 1 &&
               Math.abs(a.cy - b.cy) < (a.h + b.h) / 2 - 1;
      }
      for (var iter = 0; iter < 8; iter++) {
        var anyMove = false;
        for (var ai = 0; ai < placed.length; ai++) {
          for (var bi = ai + 1; bi < placed.length; bi++) {
            var A = placed[ai], B = placed[bi];
            if (!rectsOverlap(A, B)) continue;
            var dx = B.cx - A.cx;
            var dy = B.cy - A.cy;
            var overlapX = (A.w + B.w) / 2 - Math.abs(dx);
            var overlapY = (A.h + B.h) / 2 - Math.abs(dy);
            if (overlapX < overlapY) {
              var nudge = overlapX / 2 + 1;
              if (dx >= 0) { A.cx -= nudge; B.cx += nudge; }
              else         { A.cx += nudge; B.cx -= nudge; }
            } else {
              var nudgeY = overlapY / 2 + 1;
              if (dy >= 0) { A.cy -= nudgeY; B.cy += nudgeY; }
              else         { A.cy += nudgeY; B.cy -= nudgeY; }
            }
            anyMove = true;
          }
        }
        if (!anyMove) break;
      }

      for (var pi = 0; pi < placed.length; pi++) {
        var P = placed[pi];
        var bx = P.cx - P.w / 2;
        var by = P.cy - P.h / 2;
        cctx2.fillStyle = '#ffffff';
        cctx2.fillRect(bx, by, P.w, P.h);
        cctx2.strokeStyle = '#999';
        cctx2.lineWidth = 0.7;
        cctx2.strokeRect(bx, by, P.w, P.h);
        cctx2.fillStyle = '#1a1a1a';
        cctx2.fillText(P.text, P.cx, P.cy);
      }
      try { console.log('[exportPdf] labels drawn post-crop:', placed.length); } catch (_) {}
    } catch (e) { console.warn('[exportPdf] labels post-crop draw failed', e); }

    var planImg = cropCanvas.toDataURL('image/png');

    var bottomLeft = null;
    try {
      var blScreen = _worldToScreen(xMin, zMax);
      if (blScreen) {
        /* Re-project bottom-left into the cropped image coords.
           The original blScreen is in scaled tmpCanvas space; we
           subtract the crop offset, scale to the output canvas,
           then normalise to 0..1. */
        var blCanvasX = blScreen.left * scale;
        var blCanvasY = blScreen.top  * scale;
        var blCropX = (blCanvasX - cropX) / cropW;
        var blCropY = (blCanvasY - cropY) / cropH;
        var bottomLeftGps = null;
        if (_MapManager && _MapManager.map && mapEl) {
          var mapRect = mapEl.getBoundingClientRect();
          var pixelInMap = [
            (blScreen.left + refRect.left) - mapRect.left,
            (blScreen.top  + refRect.top)  - mapRect.top
          ];
          try {
            var lngLat = _MapManager.map.unproject(pixelInMap);
            if (lngLat) bottomLeftGps = { lng: lngLat.lng, lat: lngLat.lat };
          } catch (e) { console.warn('[exportPdf] unproject failed', e); }
        }
        bottomLeft = {
          worldX: xMin, worldZ: zMax,
          normX: Math.max(0, Math.min(1, blCropX)),
          normY: Math.max(0, Math.min(1, blCropY)),
          gps:   bottomLeftGps
        };
        try { console.log('[exportPdf] bottomLeft=', bottomLeft); } catch (_) {}
      }
    } catch (e) { console.warn('[exportPdf] bottom-left calc failed', e); }

    STATE.vizStage = prevStage;
    STATE.view = prevView;
    STATE.slopeActive = prevSlope;
    if (wrap) {
      wrap.classList.toggle('cf-stage-view', prevStage === 1);
      wrap.classList.toggle('cf-view-2d', prevView === '2d');
      wrap.classList.toggle('cf-view-3d', prevView === '3d');
    }
    /* Restore the user's previous camera framing so the configurator
       looks the same as before the export. Without this, the user
       would end up with the PDF camera fit after every download. */
    if (eng.cameraOrtho && prevCamLeft !== null) {
      eng.cameraOrtho.left   = prevCamLeft;
      eng.cameraOrtho.right  = prevCamRight;
      eng.cameraOrtho.top    = prevCamTop;
      eng.cameraOrtho.bottom = prevCamBottom;
      eng.cameraOrtho.updateProjectionMatrix();
      eng._currentOrthoD = prevOrthoD;
    }
    if (_MapManager && _MapManager.map && prevMapZoom !== null) {
      try { _MapManager.map.setZoom(prevMapZoom); } catch (_) {}
    }
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
    if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();

    var crossImg = _renderCrossSectionSVG(bbL);

    return [
      {
        key: 'plan',
        label: '',
        imageDataUrl: planImg,
        worldW: bbL, worldH: bbW,
        aspect: W_PX / H_PX,
        bottomLeft: bottomLeft
      },
      {
        key: 'cross-section',
        label: '',
        imageDataUrl: crossImg,
        worldW: bbL, worldH: 2,
        aspect: bbL / 2
      }
    ];
  }

  function _renderCrossSectionSVG(bbL) {
    var d = getVariantDefaults(_currentVariantKey(), STATE.lvl);
    var vk = _currentVariantKey();
    var slopeRad = STATE.slopeActive && STATE.slopeDeg > 0 ? STATE.slopeDeg * Math.PI / 180 : 0;
    var maxDelta = bbL * Math.tan(slopeRad);
    var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};

    var L = {
      concreteSlab:    TT.csLabelConcreteSlab    || 'Concrete slab',
      gravel:          TT.csLabelGravel          || 'Gravel',
      mesh:            TT.csLabelMesh            || 'Mesh',
      topSlab:         TT.csLabelTopSlab         || 'Top slab',
      strip:           TT.csLabelStrip           || 'Strip',
      concretePiers:   TT.csLabelConcretePiers   || 'Concrete piers',
      precastBlocks:   TT.csLabelPrecastBlocks   || 'Precast pier blocks',
      groundScrews:    TT.csLabelGroundScrews    || 'Ground screws',
      groundLevel:     TT.csLabelGroundLevel     || 'Ground level',
      slope:           TT.csLabelSlope           || 'Slope',
      slopeOver:       TT.csLabelSlopeOver       || 'over'
    };

    var W = 1400, H = 700;
    var marginX = 80, marginY = 80;
    var drawW = W - 2 * marginX;
    var drawH = H - 2 * marginY;

    var groundY = marginY + drawH * 0.30;
    var foundTopY = groundY + 10;

    var s = drawW / bbL;
    var leftX = marginX, rightX = marginX + drawW;

    var svg = ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '">'];
    svg.push('<rect width="' + W + '" height="' + H + '" fill="#ffffff"/>');

    var terrainRight = groundY;
    var terrainLeft = groundY - maxDelta * s;
    svg.push('<polygon points="' +
      leftX + ',' + terrainLeft + ' ' +
      rightX + ',' + terrainRight + ' ' +
      rightX + ',' + H + ' ' +
      leftX + ',' + H +
      '" fill="#e8d4b8" stroke="#b39570" stroke-width="1.5"/>');

    svg.push('<line x1="' + leftX + '" y1="' + terrainLeft + '" x2="' + rightX + '" y2="' + terrainRight + '" stroke="#8a6e4a" stroke-width="2" stroke-dasharray="6,4"/>');

    if (vk === 'slab') {
      var slabH = d.slabThicknessM * 50;
      var gravelH = d.gravelDepthM * 50;
      var excavH = d.excavationDepthM * 50;
      svg.push('<rect x="' + (leftX + 20) + '" y="' + foundTopY + '" width="' + (drawW - 40) + '" height="' + slabH + '" fill="#a8a8a8" stroke="#222" stroke-width="1.5"/>');
      svg.push('<text x="' + (leftX + 30) + '" y="' + (foundTopY + slabH / 2 + 4) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.concreteSlab + ' ' + _dimNum(d.slabThicknessM) + ' ' + _dimUnit() + '</text>');
      svg.push('<rect x="' + (leftX + 20) + '" y="' + (foundTopY + slabH) + '" width="' + (drawW - 40) + '" height="' + gravelH + '" fill="#c7b9a3" stroke="#7a6b50" stroke-width="1"/>');
      svg.push('<text x="' + (leftX + 30) + '" y="' + (foundTopY + slabH + gravelH / 2 + 4) + '" font-family="sans-serif" font-size="10" fill="#333">' + L.gravel + ' ' + _dimNum(d.gravelDepthM) + ' ' + _dimUnit() + '</text>');
      svg.push('<line x1="' + (leftX + 20) + '" y1="' + (foundTopY + slabH * 0.5) + '" x2="' + (rightX - 20) + '" y2="' + (foundTopY + slabH * 0.5) + '" stroke="#2266cc" stroke-width="2" stroke-dasharray="3,3"/>');
      svg.push('<text x="' + (rightX - 130) + '" y="' + (foundTopY + slabH * 0.5 - 4) + '" font-family="sans-serif" font-size="9" fill="#2266cc">' + L.mesh + ' FFR30001</text>');
    } else if (vk === 'strip') {
      var slabH2 = d.slabThicknessM * 50;
      var stripH = d.stripDepthM * 50;
      var stripW = d.stripWidthM * s * 1.5;
      svg.push('<rect x="' + (leftX + 20) + '" y="' + foundTopY + '" width="' + (drawW - 40) + '" height="' + slabH2 + '" fill="#a8a8a8" stroke="#222" stroke-width="1.5"/>');
      svg.push('<text x="' + (leftX + 30) + '" y="' + (foundTopY + slabH2 / 2 + 4) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.topSlab + ' ' + _dimNum(d.slabThicknessM) + ' ' + _dimUnit() + '</text>');
      svg.push('<rect x="' + (leftX + 30) + '" y="' + (foundTopY + slabH2) + '" width="' + stripW + '" height="' + stripH + '" fill="#888" stroke="#222" stroke-width="1.5"/>');
      svg.push('<rect x="' + (rightX - 30 - stripW) + '" y="' + (foundTopY + slabH2) + '" width="' + stripW + '" height="' + stripH + '" fill="#888" stroke="#222" stroke-width="1.5"/>');
      svg.push('<text x="' + (leftX + 30) + '" y="' + (foundTopY + slabH2 + stripH + 18) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.strip + ' ' + _dimNum(d.stripWidthM) + '×' + _dimNum(d.stripDepthM) + ' ' + _dimUnit() + '</text>');
    } else if (vk === 'piers') {
      var pierH = d.pierDepthM * 50;
      var pierW = d.pierSideM * s * 1.5;
      var pierSpacing = d.pierSpacingM * s;
      var nPiers = Math.floor(drawW / pierSpacing) + 1;
      for (var pi = 0; pi < nPiers; pi++) {
        var px = leftX + 20 + pi * pierSpacing;
        if (px + pierW > rightX - 20) break;
        var extra = slopeRad > 0 ? ((nPiers - 1 - pi) * pierSpacing / s) * Math.tan(slopeRad) * 50 : 0;
        svg.push('<rect x="' + px + '" y="' + foundTopY + '" width="' + pierW + '" height="' + (pierH + extra) + '" fill="#888" stroke="#222" stroke-width="1.5"/>');
      }
      svg.push('<text x="' + (leftX + 20) + '" y="' + (foundTopY + pierH + 30) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.concretePiers + ' ' + _dimNum(d.pierSideM) + '×' + _dimNum(d.pierSideM) + '×' + _dimNum(d.pierDepthM) + ' ' + _dimUnit() + ' @ ' + _dimNum(d.pierSpacingM) + ' ' + _dimUnit() + '</text>');
    } else if (vk === 'precast') {
      var blockH = d.blockHeightM * 50;
      var blockW = d.blockBaseM * s * 1.5;
      var blockTopW = d.blockTopM * s * 1.5;
      var bSpacing = d.blockSpacingM * s;
      var nBlocks = Math.floor(drawW / bSpacing) + 1;
      for (var bi = 0; bi < nBlocks; bi++) {
        var bx = leftX + 20 + bi * bSpacing;
        if (bx + blockW > rightX - 20) break;
        var extra2 = slopeRad > 0 ? ((nBlocks - 1 - bi) * bSpacing / s) * Math.tan(slopeRad) * 50 : 0;
        var bTopY = foundTopY;
        var bBotY = bTopY + blockH + extra2;
        svg.push('<polygon points="' +
          (bx + (blockW - blockTopW) / 2) + ',' + bTopY + ' ' +
          (bx + (blockW + blockTopW) / 2) + ',' + bTopY + ' ' +
          (bx + blockW) + ',' + bBotY + ' ' +
          bx + ',' + bBotY +
          '" fill="#999" stroke="#222" stroke-width="1.5"/>');
      }
      svg.push('<text x="' + (leftX + 20) + '" y="' + (foundTopY + blockH + 30) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.precastBlocks + ' ' + _dimNum(d.blockBaseM) + '/' + _dimNum(d.blockTopM) + '×' + _dimNum(d.blockHeightM) + ' ' + _dimUnit() + ' @ ' + _dimNum(d.blockSpacingM) + ' ' + _dimUnit() + '</text>');
    } else if (vk === 'screws') {
      var screwH = d.screwLenM * 50;
      var screwSpacing = d.screwSpacingM * s;
      var nScrews = Math.floor(drawW / screwSpacing) + 1;
      for (var si = 0; si < nScrews; si++) {
        var sx = leftX + 20 + si * screwSpacing;
        if (sx > rightX - 20) break;
        svg.push('<rect x="' + (sx - 4) + '" y="' + foundTopY + '" width="8" height="' + screwH + '" fill="#444" stroke="#111" stroke-width="1"/>');
        svg.push('<rect x="' + (sx - 8) + '" y="' + (foundTopY - 6) + '" width="16" height="8" fill="#222" stroke="#111" stroke-width="1"/>');
      }
      svg.push('<text x="' + (leftX + 20) + '" y="' + (foundTopY + screwH + 24) + '" font-family="sans-serif" font-size="11" fill="#000">' + L.groundScrews + ' Ø' + _dimNumMM(d.screwDiameterMm || 76) + ' × ' + _dimNum(d.screwLenM) + ' ' + _dimUnit() + ' @ ' + _dimNum(d.screwSpacingM) + ' ' + _dimUnit() + '</text>');
    }

    svg.push('<text x="' + leftX + '" y="' + (groundY - 12) + '" font-family="sans-serif" font-size="12" fill="#5a4a30" font-weight="700">' + L.groundLevel + '</text>');

    if (slopeRad > 0) {
      svg.push('<text x="' + (rightX - 220) + '" y="' + (terrainRight - 8) + '" font-family="sans-serif" font-size="11" fill="#8a6e4a">' + L.slope + ' ' + STATE.slopeDeg + '° (Δ ' + _dimNum(maxDelta) + ' ' + _dimUnit() + ' ' + L.slopeOver + ' ' + _fmtLen(bbL) + ')</text>');
    }

    svg.push('</svg>');
    return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg.join(''))));
  }

  function _buildInstancePayload() {
    var poly = getFootprintPolygon();
    var bb = getBBox();
    return {
      polygon:    poly,
      bboxL:      bb.L,
      bboxW:      bb.W,
      area:       computeArea(),
      perimeter:  computePerimeter(),
      variant:    STATE.variant,
      variantKey: _currentVariantKey(),
      lvl:        STATE.lvl,
      slope:      { active: STATE.slopeActive, deg: STATE.slopeDeg },
      isMetric:   STATE.isMetric
    };
  }

  var CUT_LIST_DIM = {};

  function _swapDimToken(name, metricDim, imperialDim) {
    if (!name) return name;
    var esc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    var core = String(metricDim).replace(/\s*(mm|cm|m)\s*$/i, '').trim();
    var pat = esc(core).replace(/[×x]/gi, '[×x]').replace(/\s+/g, '\\s*');
    var re = new RegExp(pat + '(\\s*(?:mm|cm|m))?', 'i');
    if (re.test(name)) return name.replace(re, imperialDim).replace(/\s+/g, ' ').trim();
    return (name + ' ' + imperialDim).replace(/\s+/g, ' ').trim();
  }

  function _pdfSafeText(s) {
    if (s == null) return s;
    return String(s)
      .replace(/[×✕✖]/g, 'x')
      .replace(/[Øø]/g, 'dia ')
      .replace(/″/g, ' in.')
      .replace(/′/g, ' ft')
      .replace(/°/g, ' deg')
      .replace(/[Δ∆]/g, 'd')
      .replace(/[‘’]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function _cutListProfileName(code, rawName) {
    var name = rawName || code;
    var dm = CUT_LIST_DIM[code];
    if (!STATE.isMetric && dm) name = _swapDimToken(name, dm.metric, dm.imperial);
    return _pdfSafeText(name);
  }

  function _dimNum(m) {
    if (typeof m !== 'number' || isNaN(m)) return '';
    return STATE.isMetric ? String(Math.round(m * 1000)) : (m * 39.3701).toFixed(1);
  }
  function _dimNumMM(mm) {
    if (typeof mm !== 'number' || isNaN(mm)) return '';
    return STATE.isMetric ? String(Math.round(mm)) : (mm / 25.4).toFixed(1);
  }
  function _dimUnit() { return STATE.isMetric ? 'mm' : 'in.'; }
  function _fmtDim(m) {
    var n = _dimNum(m);
    return n === '' ? '' : (n + ' ' + _dimUnit());
  }
  function _fmtLen(m) {
    if (typeof m !== 'number' || isNaN(m)) return '';
    return STATE.isMetric ? (m.toFixed(1) + ' m') : ((m * 3.28084).toFixed(1) + ' ft');
  }

  function _cutListUnitFactor() { return STATE.isMetric ? 1 : (1 / 0.3048); }

  function _buildCutGroup(code, rawName, metricPieces) {
    var U = _cutListUnitFactor();
    var pieces = (metricPieces || []).map(function (p) {
      var out = { qty: (p && p.qty != null) ? p.qty : 1 };
      if (p && typeof p.length === 'number' && !isNaN(p.length)) out.length = +(p.length * U).toFixed(2);
      if (p && typeof p.width  === 'number' && !isNaN(p.width))  out.width  = +(p.width  * U).toFixed(2);
      if (p && p.label != null) out.label = _pdfSafeText(p.label);
      return out;
    });
    return {
      profile:     _cutListProfileName(code, rawName),
      profileCode: code || '',
      unit:        STATE.isMetric ? 'm' : 'ft',
      pieces:      pieces
    };
  }

  function _buildBoqNamesMap(bridge) {
    var rows = computeBoQ();
    var out = {};
    for (var i = 0; i < rows.length; i++) {
      var code = rows[i][0];
      if (!code) continue;
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
      out[code] = _cutListProfileName(code, item && item.name);
    }
    return out;
  }

  function _fetchImageAsDataUrl(url) {
    return new Promise(function (resolve) {
      if (!url) { resolve(null); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width  = img.naturalWidth  || img.width;
          c.height = img.naturalHeight || img.height;
          var cx = c.getContext('2d');
          cx.drawImage(img, 0, 0);
          resolve(c.toDataURL('image/jpeg', 0.92));
        } catch (e) {
          console.warn('[exportPdf] assembly image canvas tainted', e);
          resolve(null);
        }
      };
      img.onerror = function () {
        console.warn('[exportPdf] assembly image load failed', url);
        resolve(null);
      };
      img.src = url;
    });
  }

  async function _buildAssemblyPayload(boqRows) {
    var BOOT = global.BASE_BOOT || {};
    var images = BOOT.variantAssemblyImages || {};
    var variant = BOOT.variants && BOOT.variants[STATE.variant - 1];
    if (!variant) return null;
    var url = images[String(variant.id)] || images[variant.id];
    if (!url) {
      try { console.log('[exportPdf] assembly: no image for variant', variant.id); } catch (_) {}
      return null;
    }
    var dataUrl = await _fetchImageAsDataUrl(url);
    if (!dataUrl) return null;

    var legend = [];
    if (Array.isArray(boqRows)) {
      for (var i = 0; i < boqRows.length; i++) {
        var row = boqRows[i];
        if (!row || !row.name) continue;
        var qty = row.qty;
        var unit = row.unit || '';
        var qtyStr = '';
        if (typeof qty === 'number' && !isNaN(qty)) {
          qtyStr = ' — ' + (Math.abs(qty - Math.round(qty)) < 0.005 ? String(Math.round(qty)) : qty.toFixed(2)) + (unit ? ' ' + unit : '');
        }
        legend.push({ label: row.name + qtyStr, code: row.code });
      }
    }

    /* Dynamic dimension callouts — labelled a, b, … each carries
       a model-derived value that follows STATE.variant + STATE.lvl.
       The variant-specific picker below maps a clean engineering
       quantity ("thickness", "depth", "side", "length") to the
       VARIANT_DEFAULTS field for the current variant; values are
       in metres internally and rendered as mm rounded to the
       nearest integer for the typical foundation use case. */
    var dims = [];
    try {
      var vk = _currentVariantKey();
      var d  = getVariantDefaults(vk, STATE.lvl);
      var TT = (BOOT.i18n) || {};
      var fmtMM = function (m) {
        return _fmtDim(m);
      };
      var labelThickness = TT.assemblyDimSlabThickness || 'Slab thickness';
      var labelExcav     = TT.assemblyDimExcavation   || 'Excavation depth';
      var labelGravel    = TT.assemblyDimGravel       || 'Gravel layer';
      var labelStripW    = TT.assemblyDimStripWidth   || 'Strip width';
      var labelStripD    = TT.assemblyDimStripDepth   || 'Strip depth';
      var labelPierSide  = TT.assemblyDimPierSide     || 'Pier size';
      var labelPierDepth = TT.assemblyDimPierDepth    || 'Pier depth';
      var labelBlockH    = TT.assemblyDimBlockHeight  || 'Block height';
      var labelBlockBase = TT.assemblyDimBlockBase    || 'Block base width';
      var labelScrewLen  = TT.assemblyDimScrewLength  || 'Screw length';
      var labelScrewDia  = TT.assemblyDimScrewDia     || 'Screw diameter';

      if (vk === 'slab') {
        if (d.slabThicknessM)   dims.push({ label: labelThickness, value: fmtMM(d.slabThicknessM) });
        if (d.excavationDepthM) dims.push({ label: labelExcav,     value: fmtMM(d.excavationDepthM) });
      } else if (vk === 'strip') {
        if (d.slabThicknessM)   dims.push({ label: labelThickness, value: fmtMM(d.slabThicknessM) });
        if (d.stripDepthM)      dims.push({ label: labelStripD,    value: fmtMM(d.stripDepthM) });
      } else if (vk === 'piers') {
        if (d.pierSideM)        dims.push({ label: labelPierSide,  value: fmtMM(d.pierSideM) });
        if (d.pierDepthM)       dims.push({ label: labelPierDepth, value: fmtMM(d.pierDepthM) });
      } else if (vk === 'precast') {
        if (d.blockHeightM)     dims.push({ label: labelBlockH,    value: fmtMM(d.blockHeightM) });
        if (d.blockBaseM)       dims.push({ label: labelBlockBase, value: fmtMM(d.blockBaseM) });
      } else if (vk === 'screws') {
        if (d.screwLenM)        dims.push({ label: labelScrewLen,  value: fmtMM(d.screwLenM) });
        if (d.screwDiameterMm)  dims.push({ label: labelScrewDia,  value: _dimNumMM(d.screwDiameterMm) + ' ' + _dimUnit() });
      }
    } catch (e) { console.warn('[exportPdf] assembly dims failed', e); }

    return { imageDataUrl: dataUrl, legend: legend, dimensions: dims };
  }

  function _buildBoq(bridge) {
    var rows = computeBoQ();
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var code = rows[i][0];
      var qtyMetric = rows[i][1];
      if (qtyMetric == null) continue;
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
      var localUnit = item ? (STATE.isMetric ? item.unitMetric : item.unitImperial) : null;
      var displayQty = STATE.isMetric ? qtyMetric : (rows[i][2] != null ? rows[i][2] : qtyMetric);
      var userPrice = bridge && bridge.getUserPrice ? bridge.getUserPrice(code) : null;
      var unitPrice = userPrice && typeof userPrice.price === 'number' ? userPrice.price : null;
      var total = (unitPrice != null) ? unitPrice * displayQty : null;
      out.push({
        code:      code,
        name:      _cutListProfileName(code, item && item.name),
        qty:       displayQty,
        unit:      localUnit || (STATE.isMetric ? 'pcs' : 'pcs'),
        unitPrice: unitPrice,
        total:     total
      });
    }
    return out;
  }

  function _buildTotals(boqRows) {
    function $idText(id) {
      var el = document.getElementById(id);
      if (!el || !el.textContent) return '';
      var t = el.textContent.trim();
      if (!t || t === '—' || t === '-') return '';
      return t;
    }
    function $domText(selector) {
      var el = document.querySelector(selector);
      if (!el || !el.textContent) return '';
      var t = el.textContent.trim();
      if (!t || t === '—' || t === '-') return '';
      return t;
    }
    var fmtPrice = (typeof global.formatPrice === 'function')
      ? global.formatPrice
      : function (n) { return Math.round(+n || 0).toLocaleString() + ' ' +
            ((global.Shopify && global.Shopify.currency && global.Shopify.currency.active) || 'USD'); };

    var totalText    = $idText('cf-bw-total');
    var materialText = $idText('cf-bw-material');
    var execText     = $idText('cf-bw-execution');
    var timeText     = $idText('cf-bw-time');
    var capacityText = $idText('cf-bw-capacity');

    if (!totalText)    totalText    = $domText('[data-budget-total-cost]');
    if (!materialText) materialText = $domText('[data-budget-total-material]');
    if (!execText)     execText     = $domText('[data-budget-total-execution]');
    if (!timeText)     timeText     = $domText('[data-budget-total-time]');

    if (!materialText && typeof global.lastMaterialsTotal === 'number') {
      materialText = fmtPrice(global.lastMaterialsTotal);
    }
    if (!execText && typeof global.lastDeliveryTotal === 'number') {
      execText = fmtPrice(global.lastDeliveryTotal);
    }
    if (!totalText) {
      var mNum = (typeof global.lastMaterialsTotal === 'number') ? global.lastMaterialsTotal : 0;
      var eNum = (typeof global.lastDeliveryTotal  === 'number') ? global.lastDeliveryTotal  : 0;
      if (mNum || eNum) totalText = fmtPrice(mNum + eNum);
    }
    if (!timeText && typeof global.lastDurationTotal === 'number') {
      var mins = global.lastDurationTotal;
      timeText = (mins >= 60)
        ? (Math.round(mins / 60 * 10) / 10) + ' h'
        : Math.round(mins) + ' min';
    }

    if (!materialText) {
      var matSum = 0;
      if (Array.isArray(boqRows)) {
        boqRows.forEach(function (r) { if (r.total != null) matSum += r.total; });
      }
      if (matSum) materialText = fmtPrice(matSum);
    }
    if (!totalText && materialText) totalText = materialText;

    if (!capacityText) {
      try {
        var excavM3 = 0;
        if (Array.isArray(boqRows)) {
          for (var i = 0; i < boqRows.length; i++) {
            if (boqRows[i].code === 'FEE00001') { excavM3 = boqRows[i].qty || 0; break; }
          }
        }
        if (excavM3) {
          capacityText = STATE.isMetric
            ? excavM3.toFixed(1) + ' m³'
            : (excavM3 * 1.30795).toFixed(1) + ' yd³';
        }
      } catch (e) {}
    }

    return {
      texts: {
        total:    totalText    || '',
        material: materialText || '',
        execution: execText    || '',
        time:     timeText     || '',
        capacity: capacityText || ''
      },
      materials: { count: 0, value: 0 },
      execution: { count: 0, value: 0, hours: 0 },
      total:     0,
      area:      computeArea(),
      perimeter: computePerimeter(),
      currency:  (global.Shopify && global.Shopify.currency && global.Shopify.currency.active) || 'USD'
    };
  }

  function _buildBaseDimensions() {
    var poly = getFootprintPolygon();
    var bb = getBBox();
    var edges = [];
    for (var i = 0; i < poly.length; i++) {
      var a = poly[i], b = poly[(i + 1) % poly.length];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      edges.push({
        index: i,
        a: { x: a[0], z: a[1] },
        b: { x: b[0], z: b[1] },
        length: Math.sqrt(dx * dx + dz * dz)
      });
    }
    return {
      vertices: poly.map(function (p) { return { x: p[0], z: p[1] }; }),
      edges:    edges,
      bboxL:    bb.L,
      bboxW:    bb.W
    };
  }

  function _buildShareUrl() {
    var boot = global.BASE_BOOT || {};
    var handle = boot.productHandle || 'roof';
    var origin = (location && location.origin) || '';
    var url = origin + '/products/' + handle;
    if (boot.variants && boot.variants.length && STATE.variant) {
      var v = boot.variants[STATE.variant - 1];
      if (v && v.id) url += '?variant=' + v.id;
    }
    return url;
  }

  function _variantDisplayName() {
    var boot = global.BASE_BOOT || {};
    var T = boot.i18n || {};
    var key = 'roof_v' + STATE.variant;
    return T[key] || _currentVariantKey();
  }


  global.BaseLib = {
    __version:        VERSION,
    exportPdf:        exportPdf,
    STATE:            STATE,
    DEFAULTS:         DEFAULTS,
    VARIANT_DEFAULTS: VARIANT_DEFAULTS,
    boot:             boot,
    refreshUI:        refreshUI,
    reset:            reset,
    resetShapeToRect: resetShapeToRect,
    undo:             undo,
    cycleLvl:         cycleLvl,
    cycleAssembly:    cycleAssembly,
    UndoHistory:      _UndoHistory,
    toggleUnits:      toggleUnits,
    toggleView:       toggleView,
    selectVariant:    selectVariant,
    nextVariant:      nextVariant,
    prevVariant:      prevVariant,
    openBudgetDrawer: openBudgetDrawer,
    share:            share,
    publishBoQToBudget: publishBoQToBudget,
    computeBoQ:       computeBoQ,
    getFootprintPolygon: getFootprintPolygon,
    computeArea:      computeArea,
    computePerimeter: computePerimeter,
    VisualizationManager: _VisualizationManager,
    CornerInserter:   _CornerInserter,
    AssetDrawer:      _AssetDrawer,
    ProjectStore:     _ProjectStore
  };

})(window);